"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[790],{

/***/ 77679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _xprog_prensa__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["children", "isUppercase"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var GhostButton = function GhostButton(_ref) {
  var children = _ref.children,
      isUppercase = _ref.isUppercase,
      otherProps = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var styles = {
    button: {
      height: '20px',
      padding: '0px'
    },
    label: {
      color: '$basicBlack',
      fontFamily: '$primary',
      fontSize: '$caption3',
      fontWeight: '$caption3',
      lineHeight: '$caption3',
      textTransform: isUppercase ? 'uppercase' : 'none'
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_xprog_prensa__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, _objectSpread(_objectSpread({
    variant: "ghost",
    css: styles
  }, otherProps), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (GhostButton);

/***/ }),

/***/ 44312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var _xprog_prensa__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_Icon_Icon_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63234);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


var _excluded = ["href", "icon", "linkProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var IconButton = function IconButton(_ref) {
  var href = _ref.href,
      icon = _ref.icon,
      linkProps = _ref.linkProps,
      otherProps = (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_xprog_prensa__WEBPACK_IMPORTED_MODULE_1__/* .IconButton */ .hU, _objectSpread({
    variant: "ghost",
    size: "sm",
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_xprog_prensa__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, _objectSpread(_objectSpread({
      bypass: !href,
      href: href || ''
    }, linkProps), {}, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_Icon_Icon_index__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({}, icon))
    }))
  }, otherProps));
};

/* harmony default export */ __webpack_exports__["Z"] = (IconButton);

/***/ }),

/***/ 26454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _xprog_prensa__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72003);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_polopoly_sites_web_polopoly_sites_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Image = _xprog_prensa__WEBPACK_IMPORTED_MODULE_1__/* .PrensaEngine.styled */ .u7.styled('img', {});

var ClickableAsset = function ClickableAsset(_ref) {
  var css = _ref.css,
      alt = _ref.alt,
      height = _ref.height,
      href = _ref.href,
      id = _ref.id,
      src = _ref.src,
      target = _ref.target,
      width = _ref.width,
      hasH1 = _ref.hasH1;

  var handleClick = function handleClick() {
    console.log('ClickableAsset clicked', {
      href: href,
      target: target
    }); // If target is 'blank', open in a new tab, otherwise navigate to the href
    // If href is not provided, do nothing

    if (target === 'blank' && href) {
      window.open(href, '_blank');
    } else if (href) {
      window.location.assign(href);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_xprog_prensa__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
    id: id,
    onClick: handleClick,
    style: {
      border: 'none',
      backgroundColor: 'transparent'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_xprog_prensa__WEBPACK_IMPORTED_MODULE_1__/* .Block */ .gO, {
      css: _objectSpread({
        height: height,
        width: width
      }, css === null || css === void 0 ? void 0 : css.container),
      children: [hasH1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_xprog_prensa__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .ZT, {
        as: "h1",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Image, {
          alt: alt,
          height: height,
          src: src,
          width: width
        })
      }), !hasH1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Image, {
        alt: alt,
        height: height,
        src: src,
        width: width
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ClickableAsset);

/***/ }),

/***/ 63234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* eslint-disable @next/next/no-img-element */



var Icon = function Icon(_ref) {
  var alt = _ref.alt,
      height = _ref.height,
      src = _ref.src,
      width = _ref.width;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
    alt: alt,
    height: height,
    src: src,
    width: width
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 19936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; },
/* harmony export */   "_": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var _xprog_prensa__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72003);

var Input = _xprog_prensa__WEBPACK_IMPORTED_MODULE_0__/* .PrensaEngine.styled */ .u7.styled('input', {});
var Label = _xprog_prensa__WEBPACK_IMPORTED_MODULE_0__/* .PrensaEngine.styled */ .u7.styled('label', {});

/***/ }),

/***/ 64634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchInput_index; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@xprog/prensa/index.js
var prensa = __webpack_require__(72003);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Assets/SearchIcon.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "m15.708 14.297-3.097-3.098A7.004 7.004 0 1 0 11.2 12.61l3.098 3.098a.997.997 0 0 0 1.41-1.41v-.001ZM7.03 12.012a4.983 4.983 0 1 1 0-9.966 4.983 4.983 0 0 1 0 9.966Z",
      fill: "#000"
    })
  }));
};
// EXTERNAL MODULE: ./components/Input/Input.styles.tsx
var Input_styles = __webpack_require__(19936);
;// CONCATENATED MODULE: ./components/SearchInput/SearchInput.index.tsx


var _excluded = ["buttonId", "onSearch", "css"];

function SearchInput_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SearchInput_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SearchInput_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SearchInput_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







;

var SearchInput = function SearchInput(_ref) {
  var _css$icon;

  var buttonId = _ref.buttonId,
      onSearch = _ref.onSearch,
      css = _ref.css,
      otherProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: SearchInput_index_objectSpread({
      align: ['row', 'between', 'middle'],
      position: 'relative',
      width: '100%'
    }, css === null || css === void 0 ? void 0 : css.container),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input_styles/* Input */.I, SearchInput_index_objectSpread({
      placeholder: "Digite o que voc\xEA procura",
      type: "text",
      onKeyUp: handleKeyPress,
      css: SearchInput_index_objectSpread({
        borderColor: '#BFBFBF',
        borderRadius: '$default',
        borderStyle: 'solid',
        borderWidth: '1px',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'calc(100% - 16px)',
        backgroundPositionY: '50%',
        color: '#A0A0A0',
        fontFamily: '$primary',
        fontSize: '$headline6',
        fontWeight: '$headline6',
        lineHeight: '$headline6',
        height: '40px',
        px: '$4',
        pr: '$13',
        m: '$0',
        width: '100%'
      }, css === null || css === void 0 ? void 0 : css.input)
    }, otherProps)), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* IconButton */.hU, {
      color: "basicWhite",
      onClick: onSearch,
      icon: /*#__PURE__*/(0,jsx_runtime.jsx)(SearchIcon, {}),
      id: buttonId,
      roundedCorners: "unset",
      size: "sm",
      variant: "outlined",
      css: {
        button: SearchInput_index_objectSpread({
          position: 'absolute',
          borderLeft: '1px solid #e6e6e6',
          minWidth: '$8',
          pl: '$2',
          right: '$5'
        }, css === null || css === void 0 ? void 0 : (_css$icon = css.icon) === null || _css$icon === void 0 ? void 0 : _css$icon.button)
      }
    })]
  });
};

/* harmony default export */ var SearchInput_index = (SearchInput);

/***/ }),

/***/ 43090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _providers_Assets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28054);


function useIcon(icon) {
  var _context$assets;

  var isString = typeof icon === 'string';
  var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_Assets__WEBPACK_IMPORTED_MODULE_1__.AssetsContext);
  var icons = context === null || context === void 0 ? void 0 : (_context$assets = context.assets) === null || _context$assets === void 0 ? void 0 : _context$assets.icons;
  var iconSelected = icons.find(function (i) {
    return i.name === icon;
  });

  var filterArrayOfNames = function filterArrayOfNames(d) {
    return d.map(function (i) {
      return icons.find(function (s) {
        return s.name === i;
      });
    });
  };

  var iconsSelected = !isString && filterArrayOfNames(icon);

  if (isString) {
    return {
      alt: iconSelected === null || iconSelected === void 0 ? void 0 : iconSelected.name,
      src: iconSelected === null || iconSelected === void 0 ? void 0 : iconSelected.url,
      height: iconSelected === null || iconSelected === void 0 ? void 0 : iconSelected.height,
      width: iconSelected === null || iconSelected === void 0 ? void 0 : iconSelected.width
    };
  } else {
    return iconsSelected;
  }
}

/***/ }),

/***/ 28054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AssetsContext": function() { return /* binding */ AssetsContext; }
/* harmony export */ });
/* harmony import */ var providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57083);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var AssetsContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});

var AssetsProvider = function AssetsProvider(_ref) {
  var children = _ref.children;
  var serverSideContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(providers_ServerSideProps__WEBPACK_IMPORTED_MODULE_0__.ServerSidePropsContext);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(AssetsContext.Provider, {
    value: {
      assets: serverSideContext.siteConfig.assets
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (AssetsProvider);

/***/ }),

/***/ 43928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DrawersContext": function() { return /* binding */ DrawersContext; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* eslint-disable react-hooks/exhaustive-deps */



var DrawersContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});

var DrawersProvider = function DrawersProvider(_ref) {
  var children = _ref.children;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    open: false
  }),
      sideMenuLeftState = _useState[0],
      setSideMenuLeft = _useState[1];

  function handleSideMenuLeft(state) {
    setSideMenuLeft(state);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (sideMenuLeftState.open === true) {
      setSideMenuLeft({
        open: false
      });
    }
  }, [router.asPath]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(DrawersContext.Provider, {
    value: {
      sideMenuLeftState: sideMenuLeftState,
      handleSideMenuLeft: handleSideMenuLeft
    },
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (DrawersProvider);

/***/ }),

/***/ 57083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ServerSidePropsContext": function() { return /* binding */ ServerSidePropsContext; },
  "default": function() { return /* binding */ ServerSideProps; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./brands/cbn/indexes/banners.json
var banners_namespaceObject = JSON.parse('{"k":[{"fullName":"BannerPodcastCBN.svg","name":"BannerPodcastCBN","url":"/assets/cbn/banners/BannerPodcastCBN.svg","height":"34","width":"139"}]}');
;// CONCATENATED MODULE: ./brands/cbn/indexes/favicons.json
var favicons_namespaceObject = JSON.parse('{"k":[{"fullName":"128x128.png","name":"128x128","url":"/assets/cbn/favicons/128x128.png","height":"","width":""},{"fullName":"16x16.png","name":"16x16","url":"/assets/cbn/favicons/16x16.png","height":"","width":""},{"fullName":"192x192.png","name":"192x192","url":"/assets/cbn/favicons/192x192.png","height":"","width":""},{"fullName":"32x32.png","name":"32x32","url":"/assets/cbn/favicons/32x32.png","height":"","width":""},{"fullName":"48x48.png","name":"48x48","url":"/assets/cbn/favicons/48x48.png","height":"","width":""},{"fullName":"96x96.png","name":"96x96","url":"/assets/cbn/favicons/96x96.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/cbn/indexes/icons.json
var icons_namespaceObject = JSON.parse('{"k":[{"fullName":"IcAbrirAzul.svg","name":"IcAbrirAzul","url":"/assets/cbn/icons/IcAbrirAzul.svg","height":"16","width":"16"},{"fullName":"IcAbrirCinza.svg","name":"IcAbrirCinza","url":"/assets/cbn/icons/IcAbrirCinza.svg","height":"16","width":"16"},{"fullName":"IcAudio.svg","name":"IcAudio","url":"/assets/cbn/icons/IcAudio.svg","height":"13","width":"17"},{"fullName":"IcAudioDescricao.svg","name":"IcAudioDescricao","url":"/assets/cbn/icons/IcAudioDescricao.svg","height":"13","width":"18"},{"fullName":"IcAudioMobile.svg","name":"IcAudioMobile","url":"/assets/cbn/icons/IcAudioMobile.svg","height":"16","width":"20"},{"fullName":"IcAudiodescricaoCinza.svg","name":"IcAudiodescricaoCinza","url":"/assets/cbn/icons/IcAudiodescricaoCinza.svg","height":"15","width":"19"},{"fullName":"IcAvancarCinza.svg","name":"IcAvancarCinza","url":"/assets/cbn/icons/IcAvancarCinza.svg","height":"16","width":"8"},{"fullName":"IcBotaoFacebook.svg","name":"IcBotaoFacebook","url":"/assets/cbn/icons/IcBotaoFacebook.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookBranco.svg","name":"IcBotaoFacebookBranco","url":"/assets/cbn/icons/IcBotaoFacebookBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookCinza.svg","name":"IcBotaoFacebookCinza","url":"/assets/cbn/icons/IcBotaoFacebookCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoFacebookPreto.svg","name":"IcBotaoFacebookPreto","url":"/assets/cbn/icons/IcBotaoFacebookPreto.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagram.svg","name":"IcBotaoInstagram","url":"/assets/cbn/icons/IcBotaoInstagram.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramBranco.svg","name":"IcBotaoInstagramBranco","url":"/assets/cbn/icons/IcBotaoInstagramBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramCinza.svg","name":"IcBotaoInstagramCinza","url":"/assets/cbn/icons/IcBotaoInstagramCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagramPreto.svg","name":"IcBotaoInstagramPreto","url":"/assets/cbn/icons/IcBotaoInstagramPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoLinkedin.svg","name":"IcBotaoLinkedin","url":"/assets/cbn/icons/IcBotaoLinkedin.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinBranco.svg","name":"IcBotaoLinkedinBranco","url":"/assets/cbn/icons/IcBotaoLinkedinBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinCinza.svg","name":"IcBotaoLinkedinCinza","url":"/assets/cbn/icons/IcBotaoLinkedinCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoLinkedinPreto.svg","name":"IcBotaoLinkedinPreto","url":"/assets/cbn/icons/IcBotaoLinkedinPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoTwitter.svg","name":"IcBotaoTwitter","url":"/assets/cbn/icons/IcBotaoTwitter.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterBranco.svg","name":"IcBotaoTwitterBranco","url":"/assets/cbn/icons/IcBotaoTwitterBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterCinza.svg","name":"IcBotaoTwitterCinza","url":"/assets/cbn/icons/IcBotaoTwitterCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoTwitterPreto.svg","name":"IcBotaoTwitterPreto","url":"/assets/cbn/icons/IcBotaoTwitterPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoWhatsApp.svg","name":"IcBotaoWhatsApp","url":"/assets/cbn/icons/IcBotaoWhatsApp.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppBranco.svg","name":"IcBotaoWhatsAppBranco","url":"/assets/cbn/icons/IcBotaoWhatsAppBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppCinza.svg","name":"IcBotaoWhatsAppCinza","url":"/assets/cbn/icons/IcBotaoWhatsAppCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoWhatsAppPreto.svg","name":"IcBotaoWhatsAppPreto","url":"/assets/cbn/icons/IcBotaoWhatsAppPreto.svg","height":"33","width":"34"},{"fullName":"IcBuscar.svg","name":"IcBuscar","url":"/assets/cbn/icons/IcBuscar.svg","height":"15","width":"15"},{"fullName":"IcChave.svg","name":"IcChave","url":"/assets/cbn/icons/IcChave.svg","height":"14","width":"25"},{"fullName":"IcChaveAzul.svg","name":"IcChaveAzul","url":"/assets/cbn/icons/IcChaveAzul.svg","height":"14","width":"25"},{"fullName":"IcCheckAzul.svg","name":"IcCheckAzul","url":"/assets/cbn/icons/IcCheckAzul.svg","height":"10","width":"13"},{"fullName":"IcCidade.svg","name":"IcCidade","url":"/assets/cbn/icons/IcCidade.svg","height":"17","width":"10"},{"fullName":"IcComunicado.svg","name":"IcComunicado","url":"/assets/cbn/icons/IcComunicado.svg","height":"15","width":"18"},{"fullName":"IcEconomia.svg","name":"IcEconomia","url":"/assets/cbn/icons/IcEconomia.svg","height":"16","width":"14"},{"fullName":"IcEdital.svg","name":"IcEdital","url":"/assets/cbn/icons/IcEdital.svg","height":"16","width":"13"},{"fullName":"IcEspecial.svg","name":"IcEspecial","url":"/assets/cbn/icons/IcEspecial.svg","height":"14","width":"14"},{"fullName":"IcEsporte.svg","name":"IcEsporte","url":"/assets/cbn/icons/IcEsporte.svg","height":"16","width":"13"},{"fullName":"IcFecharBranco.svg","name":"IcFecharBranco","url":"/assets/cbn/icons/IcFecharBranco.svg","height":"16","width":"13"},{"fullName":"IcFecharPreto.svg","name":"IcFecharPreto","url":"/assets/cbn/icons/IcFecharPreto.svg","height":"15","width":"13"},{"fullName":"IcHamburger.svg","name":"IcHamburger","url":"/assets/cbn/icons/IcHamburger.svg","height":"15","width":"22"},{"fullName":"IcHamburguerMobile.svg","name":"IcHamburguerMobile","url":"/assets/cbn/icons/IcHamburguerMobile.svg","height":"13","width":"19"},{"fullName":"IcMagazine.svg","name":"IcMagazine","url":"/assets/cbn/icons/IcMagazine.svg","height":"16","width":"14"},{"fullName":"IcMundo.svg","name":"IcMundo","url":"/assets/cbn/icons/IcMundo.svg","height":"15","width":"15"},{"fullName":"IcOjc.svg","name":"IcOjc","url":"/assets/cbn/icons/IcOjc.svg","height":"17","width":"24"},{"fullName":"IcOpiniao.svg","name":"IcOpiniao","url":"/assets/cbn/icons/IcOpiniao.svg","height":"12","width":"13"},{"fullName":"IcOpiniaoGrande.svg","name":"IcOpiniaoGrande","url":"/assets/cbn/icons/IcOpiniaoGrande.svg","height":"19","width":"22"},{"fullName":"IcPlayAudioMateria.svg","name":"IcPlayAudioMateria","url":"/assets/cbn/icons/IcPlayAudioMateria.svg","height":"15","width":"15"},{"fullName":"IcPlayAudioMateriaAzul.svg","name":"IcPlayAudioMateriaAzul","url":"/assets/cbn/icons/IcPlayAudioMateriaAzul.svg","height":"23","width":"22"},{"fullName":"IcPodcast.svg","name":"IcPodcast","url":"/assets/cbn/icons/IcPodcast.svg","height":"19","width":"11"},{"fullName":"IcPolitica.svg","name":"IcPolitica","url":"/assets/cbn/icons/IcPolitica.svg","height":"16","width":"16"},{"fullName":"IcRadio.svg","name":"IcRadio","url":"/assets/cbn/icons/IcRadio.svg","height":"20","width":"18"},{"fullName":"IcSetaAbrir.svg","name":"IcSetaAbrir","url":"/assets/cbn/icons/IcSetaAbrir.svg","height":"6","width":"9"},{"fullName":"IcSetaCidade.svg","name":"IcSetaCidade","url":"/assets/cbn/icons/IcSetaCidade.svg","height":"9","width":"15"},{"fullName":"IcSetaEconomia.svg","name":"IcSetaEconomia","url":"/assets/cbn/icons/IcSetaEconomia.svg","height":"9","width":"15"},{"fullName":"IcSetaEspecial.svg","name":"IcSetaEspecial","url":"/assets/cbn/icons/IcSetaEspecial.svg","height":"9","width":"15"},{"fullName":"IcSetaEsporte.svg","name":"IcSetaEsporte","url":"/assets/cbn/icons/IcSetaEsporte.svg","height":"9","width":"15"},{"fullName":"IcSetaFechar.svg","name":"IcSetaFechar","url":"/assets/cbn/icons/IcSetaFechar.svg","height":"7","width":"10"},{"fullName":"IcSetaMagazine.svg","name":"IcSetaMagazine","url":"/assets/cbn/icons/IcSetaMagazine.svg","height":"9","width":"15"},{"fullName":"IcSetaMundo.svg","name":"IcSetaMundo","url":"/assets/cbn/icons/IcSetaMundo.svg","height":"9","width":"15"},{"fullName":"IcSetaOpiniao.svg","name":"IcSetaOpiniao","url":"/assets/cbn/icons/IcSetaOpiniao.svg","height":"9","width":"15"},{"fullName":"IcSetaPolitica.svg","name":"IcSetaPolitica","url":"/assets/cbn/icons/IcSetaPolitica.svg","height":"9","width":"15"},{"fullName":"IcSetaRosa.svg","name":"IcSetaRosa","url":"/assets/cbn/icons/IcSetaRosa.svg","height":"9","width":"15"},{"fullName":"IcStories.svg","name":"IcStories","url":"/assets/cbn/icons/IcStories.svg","height":"21","width":"17"},{"fullName":"IcVersaoDigital.svg","name":"IcVersaoDigital","url":"/assets/cbn/icons/IcVersaoDigital.svg","height":"14","width":"16"},{"fullName":"IcVersaoDigitalCinza.svg","name":"IcVersaoDigitalCinza","url":"/assets/cbn/icons/IcVersaoDigitalCinza.svg","height":"16","width":"18"},{"fullName":"IcVersaoDigitalCinzaClaro.svg","name":"IcVersaoDigitalCinzaClaro","url":"/assets/cbn/icons/IcVersaoDigitalCinzaClaro.svg","height":"15","width":"16"},{"fullName":"IcVoltarCinza.svg","name":"IcVoltarCinza","url":"/assets/cbn/icons/IcVoltarCinza.svg","height":"16","width":"8"},{"fullName":"IcWhatsAppCinza.svg","name":"IcWhatsAppCinza","url":"/assets/cbn/icons/IcWhatsAppCinza.svg","height":"18","width":"17"}]}');
;// CONCATENATED MODULE: ./brands/cbn/indexes/logos.json
var logos_namespaceObject = JSON.parse('{"k":[{"fullName":"LogoCBNDesktop.svg","name":"LogoCBNDesktop","url":"/assets/cbn/logos/LogoCBNDesktop.svg","height":"36","width":"284"},{"fullName":"LogoCBNMobile.svg","name":"LogoCBNMobile","url":"/assets/cbn/logos/LogoCBNMobile.svg","height":"17","width":"138"}]}');
;// CONCATENATED MODULE: ./brands/cbn/indexes/splashScreens.json
var splashScreens_namespaceObject = JSON.parse('{"k":[{"fullName":"ipad.png","name":"ipad","url":"/assets/cbn/splashScreens/ipad.png","height":"","width":""},{"fullName":"ipadpro1.png","name":"ipadpro1","url":"/assets/cbn/splashScreens/ipadpro1.png","height":"","width":""},{"fullName":"ipadpro2.png","name":"ipadpro2","url":"/assets/cbn/splashScreens/ipadpro2.png","height":"","width":""},{"fullName":"ipadpro3.png","name":"ipadpro3","url":"/assets/cbn/splashScreens/ipadpro3.png","height":"","width":""},{"fullName":"iphone5.png","name":"iphone5","url":"/assets/cbn/splashScreens/iphone5.png","height":"","width":""},{"fullName":"iphone6.png","name":"iphone6","url":"/assets/cbn/splashScreens/iphone6.png","height":"","width":""},{"fullName":"iphoneplus.png","name":"iphoneplus","url":"/assets/cbn/splashScreens/iphoneplus.png","height":"","width":""},{"fullName":"iphonex.png","name":"iphonex","url":"/assets/cbn/splashScreens/iphonex.png","height":"","width":""},{"fullName":"iphonexsmax.png","name":"iphonexsmax","url":"/assets/cbn/splashScreens/iphonexsmax.png","height":"","width":""}]}');
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@xprog/prensa/index.js
var prensa = __webpack_require__(72003);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-h5-audio-player/es/index.js + 8 modules
var es = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Buttons/OuvirMateriaButton.tsx

var _excluded = ["icon"];






var OuvirMateriaButton = function OuvirMateriaButton(_ref) {
  var icon = _ref.icon,
      otherProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['row', 'right', 'middle'],
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '$paragraph3',
      fontWeight: '$paragraph3',
      lineHeight: '$paragraph3',
      width: '100%',
      '.rhap_play-pause-button': {
        align: ['row', 'right', 'middle'],
        color: 'white',
        fontSize: '20px',
        svg: {
          backgroundColor: '$primaryMain'
        }
      },
      '.rhap_controls-section': {
        marginBottom: '0px'
      },
      '.rhap_container': {
        width: 'auto'
      }
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, {
      src: "https://www.appradio.app:8107/live",
      layout: "stacked-reverse",
      showSkipControls: false,
      showJumpControls: false,
      customVolumeControls: [],
      customAdditionalControls: [],
      customProgressBarSection: []
    }), "Ouvir Mat\xE9ria"]
  });
};

/* harmony default export */ var Buttons_OuvirMateriaButton = (OuvirMateriaButton);
// EXTERNAL MODULE: ./hooks/useIcon.tsx
var hooks_useIcon = __webpack_require__(43090);
;// CONCATENATED MODULE: ./brands/cbn/assets/article.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var BylineRightSectionComponent = function BylineRightSectionComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_OuvirMateriaButton, {
    icon: _objectSpread({}, (0,hooks_useIcon/* useIcon */.b)('IcPlayAudioMateriaAzul')),
    onClick: function onClick(e) {
      return console.log('play audio materia', e);
    }
  });
};

var bylineProps = {
  author: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 700,
      letterSpacing: 0.4,
      lineHeight: '18px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  authorImage: {
    enabled: true
  },
  customCss: {
    align: ['column', 'left', 'middle'],
    mb: '$6',
    width: '100%',
    '@lg': {
      align: ['row', 'between', 'middle'],
      mb: '$8',
      width: '100$'
    }
  },
  customCssLeft: {
    align: ['row', 'left', 'middle'],
    width: '100%',
    '@lg': {
      width: 'calc(100% - 320px)'
    }
  },
  customCssContent: {
    ml: '$3',
    width: 'calc(100% - 80px)',
    '@lg': {}
  },
  customCssRight: {
    align: ['row', 'between', 'middle'],
    mt: '$3',
    width: '100%',
    '@lg': {
      align: ['row', 'right', 'middle'],
      mt: '$0',
      width: '320px'
    }
  },
  publishedDate: {
    enabled: true,
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 400,
      letterSpacing: 0.2,
      lineHeight: '16px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '23px'
      }
    }
  },
  rightSlot: {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BylineRightSectionComponent, {})
  }
};
var article = {
  articleContainer: {
    customCss: {
      align: ['row', 'center', 'middle'],
      mt: '$8',
      width: '100%'
    }
  },
  articleContent: {
    customCss: {
      align: ['row', 'center', 'between'],
      my: '$4',
      width: 'calc(100% - calc($4 * 3))',
      maxWidth: '1278px'
    }
  },
  articleContentLeft: {
    customCss: {
      borderTop: '1px solid #E6E6E6',
      width: '100%',
      '@lg': {
        width: 'calc(100% - 332px)'
      }
    }
  },
  articleContentRight: {
    customCss: {
      background: '#707070',
      display: 'none',
      height: '600px',
      width: '300px',
      '@lg': {
        display: 'flex'
      }
    }
  },
  bylineProps: bylineProps,
  captionProps: {
    customCssWrap: {
      maxWidth: '960px',
      width: '100%',
      mb: '$4',
      mt: '$0'
    },
    customCss: {
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '12px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '14px',
      px: '$0',
      py: '$2',
      m: '$0',
      width: 'calc(100% - 32px)',
      '@lg': {
        fontSize: '14px',
        fontStyle: 'italic',
        lineHeight: '17px'
      }
    }
  },
  textProps: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '24px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      width: '100%',
      '@lg': {
        fontSize: '22px',
        fontWeight: 400,
        letterSpacing: 0.2,
        lineHeight: '35px'
      }
    }
  },
  titleProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '25px',
      fontWeight: 700,
      lineHeight: '28px',
      mt: '$0',
      mb: '$3',
      '@lg': {
        fontSize: '60px',
        lineHeight: '70px',
        letterSpacing: 0.4
      },
      textAlign: 'left'
    }
  },
  subjectProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '25px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      },
      textAlign: 'left'
    }
  },
  subtitleProps: {
    as: 'p',
    customCss: {
      color: '#4D4D4D',
      fontFamily: '$primary',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '19px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      '@lg': {
        fontSize: '22px',
        lineHeight: '35px',
        letterSpacing: 0.2,
        mb: '$6'
      }
    }
  },
  shareSection: {
    enabled: true,
    content: [{
      id: 'facebookShare',
      alt: 'Compartilhar no Facebook',
      icon: 'IcBotaoFacebook',
      href: 'https://www.facebook.com/sharer/sharer.php?u='
    }, {
      id: 'twitterShare',
      alt: 'Compartilhar no Twitter',
      icon: 'IcBotaoTwitter',
      href: 'https://twitter.com/intent/tweet?text='
    }, {
      id: 'whatsappShare',
      alt: 'Compartilhar no WhatsApp',
      icon: 'IcBotaoWhatsApp',
      href: 'https://api.whatsapp.com/send?text='
    }]
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/footer.tsx
var currentDate = new Date();
var currentYear = currentDate.getFullYear();
var FooterConfig = {
  css: {
    slotMiddleCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#262626',
      height: 'max-content',
      py: '$7',
      '@xl': {
        height: '82px'
      }
    },
    slotBottomCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#2E2E2E',
      height: '60px',
      '@xl': {
        display: 'none'
      }
    }
  },
  data: {
    leftText: 'Siga a CBN Goiânia:',
    navMenu: [{
      id: 'expediente',
      title: 'Expediente',
      href: '/expediente'
    }, {
      id: 'faleConosco',
      title: 'Fale conosco',
      href: '/fale-conosco',
      target: '_self'
    }, {
      id: 'anuncieEmOCbnGoiania',
      title: 'Anuncie na CBN Goiânia',
      href: 'https://uaiz.opopular.com.br/anuncie-radios'
    }],
    rightText: "Copyright 2001-".concat(currentYear, ", J. C\xE2mara e Irm\xE3os S/A."),
    socialNetworks: [{
      id: 'facebookPage',
      href: 'https://www.facebook.com/cbngoiania/',
      icon: 'IcBotaoFacebook',
      title: 'Abrir O CBN Goiânia no Facebook'
    }, {
      id: 'twitterPage',
      href: 'https://twitter.com/CBNGoiania',
      icon: 'IcBotaoTwitter',
      title: 'Abrir O CBN Goiânia no Twitter'
    }]
  }
};
// EXTERNAL MODULE: ./components/Buttons/IconButton.index.tsx
var IconButton_index = __webpack_require__(44312);
// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__(8400);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
// EXTERNAL MODULE: ./node_modules/lodash/map.js
var map = __webpack_require__(35161);
var map_default = /*#__PURE__*/__webpack_require__.n(map);
// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(48403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
// EXTERNAL MODULE: ./components/Icon/Icon.index.tsx
var Icon_index = __webpack_require__(63234);
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserRelated.tsx


function TeaserRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TeaserRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TeaserRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TeaserRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck





var handleUseIcon = function handleUseIcon(_ref) {
  var color = _ref.color,
      icon = _ref.icon;
  var iconConfig;
  var sectionSlug = capitalize_default()(color === null || color === void 0 ? void 0 : color.replace('Main', ''));

  if (sectionSlug) {
    var iconSlug = icon === null || icon === void 0 ? void 0 : icon.replace('Especial', sectionSlug);
    var iconParsed = (0,hooks_useIcon/* useIcon */.b)(iconSlug);

    if (iconParsed.src) {
      iconConfig = iconParsed;
    }
  }

  if (!iconConfig) {
    iconConfig = (0,hooks_useIcon/* useIcon */.b)(icon);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, TeaserRelated_objectSpread({}, iconConfig));
};

var TeaserRelated = {
  css: {
    p: 0,
    background: 'none !important',
    width: '100%',
    '.TeaserImageContainer': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none !important'
    },
    '.TeaserSubtitle': {
      display: 'none !important'
    },
    'div.TeaserTitle': {
      align: ['row', 'left', 'top'],
      pb: '$0',
      mb: '$0',
      'a': {
        pb: '$0',
        mb: '$0',
        width: '100%'
      },
      'img': {
        pt: '6px'
      },
      'p.TeaserTitleText': {
        align: ['row', 'left', 'top'],
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '19px',
        ml: '$3',
        mb: '$0',
        mt: '$0',
        textAlign: 'left',
        width: 'calc(100% - $3)'
      }
    },
    '.TeaserWrap': {
      background: 'none !important',
      pb: '$0',
      mb: '$0'
    }
  },
  className: 'TeaserRelated',
  relatedIcon: {
    enabled: true,
    name: 'IcSetaEspecial',
    useIcon: handleUseIcon
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserBackground.ts

var TeaserBackground = {
  className: 'TeaserBackground',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '580px'
    },
    '.TeaserImage img': {
      height: '580px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        mb: '$2'
      }
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 90%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserBackgroundLg.ts

var TeaserBackgroundLg = {
  className: 'TeaserBackgroundLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '360px'
    },
    '.TeaserImage img': {
      height: '360px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 500px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 500px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserBackgroundRelated.ts

var TeaserBackgroundRelated = {
  className: 'TeaserBackgroundRelated',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '780px'
    },
    '.TeaserImage img': {
      height: '680px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: 'black',
      position: 'static',
      pt: '$0',
      pb: '$4',
      px: '$4',
      my: '$0',
      'div.Teaser': {
        mb: '$3'
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 60%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserBackgroundRelatedLg.ts

var TeaserBackgroundRelatedLg = {
  className: 'TeaserBackgroundRelatedLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '536px'
    },
    '.TeaserImage img': {
      height: '536px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: '#282828',
      position: 'absolute',
      height: '536px',
      right: '0px',
      pt: '$0',
      pb: '$4',
      my: '$0',
      width: '328px',
      'div.Teaser': {
        background: 'transparent',
        px: '$8',
        mb: '$0'
      },
      '.TeaserImage': {
        display: 'none'
      },
      'p.TeaserTitleText': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        m: '$0 !important',
        p: '$0 !important',
        width: '100% !important'
      },
      '.TeaserWrap': {
        background: 'none',
        position: 'static',
        mt: '$0'
      },
      '@lg': {
        align: ['column', 'center', 'evenly'],
        '.TeaserTitle img': {
          display: 'none'
        }
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 360px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 360px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserColumnist.ts
var TeaserColumnist = {
  css: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderRadius: '$alternative',
    p: '$0',
    pt: '$0',
    mb: '$4',
    '.TeaserImage img': {
      borderRadius: '$circle'
    },
    '.TeaserImageContainer': {
      borderRadius: '$circle',
      maxWidth: '80px'
    },
    '.TeaserWrap': {
      pb: '$4',
      pl: '$4',
      pr: '$4'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubject': {
      width: '100%'
    },
    '.TeaserSubjectText': {
      textAlign: 'left',
      color: '#D72027',
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 500,
      mb: '$1'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      width: '100%'
    },
    '.TeaserTitleText': {
      fontSize: '16px',
      fontWeight: 400
    }
  },
  className: 'TeaserColumnist',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subjectTextVariant: 'subject-default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-sm'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserEditorial.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserEditorial = {
  css: {
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: '220px',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 220px - $3)'
    }
  },
  className: 'TeaserEditorial',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserEditorialSm.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserEditorialSm = {
  css: {
    padding: '$0',
    mb: '$8',
    minHeight: '80px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(88px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserEditorialSm',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserHeadlineSm.ts


function TeaserHeadlineSm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TeaserHeadlineSm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TeaserHeadlineSm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TeaserHeadlineSm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var TeaserHeadlineSm = TeaserHeadlineSm_objectSpread(TeaserHeadlineSm_objectSpread({}, T.TeaserHeadlineSm), {}, {
  css: {
    p: '$0',
    mb: '$6',
    textAlign: 'center',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineSm',
  relatedLayout: TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-3xl'
});
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserHeadlineLg.ts


var TeaserHeadlineLg_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var TeaserHeadlineLg = {
  css: {
    textAlign: 'center',
    my: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      align: ['row', 'center', 'top'],
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '18px',
          lineHeight: '23px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      maxWidth: '980px',
      mb: '$8'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineLg',
  relatedLayout: TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-6xl'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserImageLeft.ts
var TeaserImageLeft = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      maxWidth: '150px'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserImageLeftSm.ts
var TeaserImageLeftSm = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      maxWidth: '88px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserImageLeftSm',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserImageLeftLg.ts
var TeaserImageLeftLg = {
  css: {
    padding: '$0',
    mb: '$6',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '36px',
      lineHeight: '43px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserNoImage.ts

var TeaserNoImage = {
  css: {
    p: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      align: ['column', 'left', 'top'],
      display: 'none',
      mb: '$4'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      mb: '$4'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserNoImage',
  relatedLayout: TeaserRelated,
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserCard.ts
var TeaserCard = {
  css: {
    mb: '$3',
    p: '$0',
    '.TeaserImageContainer': {
      mb: '$0'
    },
    '.TeaserSubject': {
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCard',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserImageTop.ts

var TeaserImageTop = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserImageTopLg.ts

var TeaserImageTopLg = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserImageBottom.ts
var TeaserImageBottom = {
  css: {
    mb: '$3',
    padding: '$0',
    width: '100%',
    '.TeaserSubtitle': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$3'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase'
    },
    '.TeaserTitle': {
      mb: '$3'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    }
  },
  className: 'TeaserImageBottom',
  imageDerivative: '3x1',
  imageVariant: 'bottom',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subtitleVariant: 'subtitle-default',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  titleVariant: 'newstitle-5xl'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserImageLeftXl.ts
var TeaserImageLeftXl = {
  css: {
    padding: '$0',
    mb: '$5',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserMostRead.ts
var TeaserMostRead = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      borderRadius: '50%',
      height: '100%',
      width: '30px',
      pr: '$2'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserMostReadFixed.ts
var TeaserMostReadFixed = {
  css: {
    align: ['row', 'center', 'middle'],
    borderBottom: '1px solid #E6E6E6',
    borderLeft: '8px solid $basicWhite',
    p: '$0',
    minHeight: '92px',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      ml: '$4',
      mr: '$4',
      height: '100%',
      width: 'max-content'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '$widget5',
      fontWeight: '$widget5',
      lineHeight: '$widget5'
    },
    '.TeaserWrap': {
      mr: '$4',
      width: 'calc(100% - $4)'
    },
    '&:last-child': {
      borderBottom: 'unset'
    },
    '&[data-selected=true]': {
      borderLeft: '8px solid $primaryMain'
    },
    '&[data-viewed=true]': {
      borderLeft: '8px solid #E7E7E7'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserPodcast.ts
var TeaserPodcast = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$2',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      width: '160px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 5%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '124px',
      width: '124px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserTitleText': {
      display: 'none'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserRadio.ts
var TeaserRadio = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  customLinkProps: {
    bypass: 'true'
  },
  css: {
    backgroundColor: 'none',
    cursor: 'pointer',
    p: '$0',
    m: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      mx: '$4',
      width: '100px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 25%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '100px',
      width: '100px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserSubtitleText': {
      color: '#c6c6c6',
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: 400,
      mx: '$2',
      mb: '$2',
      textAlign: 'center',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    },
    '.TeaserTitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserTitleText': {
      color: '#7c7c7c',
      fontSize: '18px',
      letterSpacing: '0.4px',
      lineHeight: '25px',
      fontWeight: 500,
      mx: '$2',
      mb: '$1',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserStories.ts
var TeaserStories = {
  className: 'TeaserStories',
  imageDerivative: '1x3',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$4',
    width: 'calc(100% - $4)',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$0'
    },
    '.TeaserImage img': {
      borderRadius: '10px',
      height: '354px',
      width: '200px',
      objectFit: 'cover'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '19px',
      fontWeight: 500,
      px: '$4',
      mb: '$2',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      align: ['row', 'left', 'bottom']
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'bottom'],
      color: '$basicWhite',
      fontSize: '18px',
      letterSpacing: '0.2px',
      lineHeight: '23px',
      fontWeight: 400,
      px: '$4',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      'a': {
        textAlign: 'left'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      background: 'linear-gradient(rgba(0, 0, 0, 0) 50%, rgb(0, 0, 0) 100%)',
      borderRadius: '10px',
      position: 'absolute',
      height: '100%',
      width: '100%'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserVideoLeft.ts
var TeaserVideoLeft = {
  css: {
    backgroundColor: 'transparent',
    padding: '$0',
    mb: '$3',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubtitle': {
      display: 'none',
      '@lg': {
        display: 'flex'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      color: '#989898',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 400,
      '@lg': {
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: 400
      }
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers/TeaserVideoTop.ts
var TeaserVideoTop = {
  css: {
    backgroundColor: 'transparent',
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      color: '#FFFFFF !important',
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$0'
    },
    '.TeaserTitleText': {
      fontSize: '25px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '2x1',
  imageVariant: 'top',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbn/assets/teasers.ts


























var teasers = {
  TeaserBackground: TeaserBackground,
  TeaserBackgroundLg: TeaserBackgroundLg,
  TeaserBackgroundRelatedLg: TeaserBackgroundRelatedLg,
  TeaserBackgroundRelated: TeaserBackgroundRelated,
  TeaserEditorial: TeaserEditorial,
  TeaserEditorialSm: TeaserEditorialSm,
  TeaserImageBottom: TeaserImageBottom,
  TeaserImageLeft: TeaserImageLeft,
  TeaserImageLeftSm: TeaserImageLeftSm,
  TeaserImageLeftLg: TeaserImageLeftLg,
  TeaserImageLeftXl: TeaserImageLeftXl,
  TeaserImageTop: TeaserImageTop,
  TeaserImageTopLg: TeaserImageTopLg,
  TeaserCard: TeaserCard,
  TeaserColumnist: TeaserColumnist,
  TeaserRelated: TeaserRelated,
  TeaserHeadlineSm: TeaserHeadlineSm,
  TeaserHeadlineLg: TeaserHeadlineLg,
  TeaserNoImage: TeaserNoImage,
  TeaserMostRead: TeaserMostRead,
  TeaserMostReadFixed: TeaserMostReadFixed,
  TeaserPodcast: TeaserPodcast,
  TeaserRadio: TeaserRadio,
  TeaserStories: TeaserStories,
  TeaserVideoLeft: TeaserVideoLeft,
  TeaserVideoTop: TeaserVideoTop
};
var teasersArray = Object.keys(teasers);

;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/utils.ts


function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var addRelativeWidthToTeaser = function addRelativeWidthToTeaser(teaser, value) {
  var _teaser$css;

  return utils_objectSpread(utils_objectSpread({}, teaser), {}, {
    css: utils_objectSpread(utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : teaser.css), {}, {
      '@lg': utils_objectSpread(utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : (_teaser$css = teaser.css) === null || _teaser$css === void 0 ? void 0 : _teaser$css['@lg']), {}, {
        width: value
      })
    })
  });
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutColumnist.tsx
// @ts-nocheck







var LayoutColumnist_TeaserColumnist = addRelativeWidthToTeaser(teasers.TeaserColumnist, '100%');

var renderSlotMobileWrapComponent = function renderSlotMobileWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: data
  });
};

var renderSlotDesktopWrapComponent = function renderSlotDesktopWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel .slider-wrapper': {
          width: 'calc(100% - 64px)'
        }
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    renderArrowNext: function renderArrowNext(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcAvancarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            top: 'calc(50% - 20px)',
            right: '0px'
          }
        }
      });
    },
    renderArrowPrev: function renderArrowPrev(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcVoltarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            bottom: 'calc(50% - 10px)',
            left: '0px'
          }
        }
      });
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    children: map_default()(chunk_default()(data, 4), function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'middle'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'left', 'middle'],
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

var LayoutColumnist = {
  wrapperContent: {
    enabled: true,
    component: renderSlotMobileWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        pt: '$3',
        pb: '$5',
        maxWidth: 'calc(100% - $2)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [LayoutColumnist_TeaserColumnist, LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [LayoutColumnist_TeaserColumnist, LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [LayoutColumnist_TeaserColumnist, LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [LayoutColumnist_TeaserColumnist, LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
var LayoutColumnistDesktop = {
  wrapperContent: {
    enabled: true,
    component: renderSlotDesktopWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        py: '$6',
        maxWidth: 'calc(100% - 180px)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: 'calc(100% - $12)'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [LayoutColumnist_TeaserColumnist, LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [LayoutColumnist_TeaserColumnist, LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [LayoutColumnist_TeaserColumnist, LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [LayoutColumnist_TeaserColumnist, LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutColumnistSideBox.tsx
// @ts-nocheck






var renderSlotWrapComponent = function renderSlotWrapComponent(data) {
  var groupItems = chunk_default()(data, 3);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: map_default()(groupItems, function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['column', 'left', 'top'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'center', 'top'],
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

var LayoutColumnistSideBox = {
  wrapperContent: {
    enabled: true,
    component: renderSlotWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnContent': {
        pt: '$6',
        pb: '$6',
        maxWidth: 'calc(100% - $2)'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [teasers.TeaserColumnist, teasers.TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserRelated.tsx


function teasers_TeaserRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function teasers_TeaserRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? teasers_TeaserRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : teasers_TeaserRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck





var TeaserRelated_handleUseIcon = function handleUseIcon(_ref) {
  var color = _ref.color,
      icon = _ref.icon;
  var iconConfig;
  var sectionSlug = capitalize_default()(color === null || color === void 0 ? void 0 : color.replace('Main', ''));

  if (sectionSlug) {
    var iconSlug = icon === null || icon === void 0 ? void 0 : icon.replace('Especial', sectionSlug);
    var iconParsed = (0,hooks_useIcon/* useIcon */.b)(iconSlug);

    if (iconParsed.src) {
      iconConfig = iconParsed;
    }
  }

  if (!iconConfig) {
    iconConfig = (0,hooks_useIcon/* useIcon */.b)(icon);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, teasers_TeaserRelated_objectSpread({}, iconConfig));
};

var TeaserRelated_TeaserRelated = {
  css: {
    p: 0,
    background: 'none !important',
    width: '100%',
    '.TeaserImageContainer': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none !important'
    },
    '.TeaserSubtitle': {
      display: 'none !important'
    },
    'div.TeaserTitle': {
      align: ['row', 'left', 'top'],
      pb: '$0',
      mb: '$0',
      'a': {
        pb: '$0',
        mb: '$0',
        width: '100%'
      },
      'img': {
        pt: '6px',
        height: '15px'
      },
      'p.TeaserTitleText': {
        align: ['row', 'left', 'top'],
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '19px',
        ml: '$3',
        mb: '$0',
        mt: '$0',
        textAlign: 'left',
        width: 'calc(100% - $3)'
      }
    },
    '.TeaserWrap': {
      background: 'none !important',
      pb: '$0',
      mb: '$0'
    }
  },
  className: 'TeaserRelated',
  relatedIcon: {
    enabled: true,
    name: 'IcSetaEspecial',
    useIcon: TeaserRelated_handleUseIcon
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserBackground.ts

var TeaserBackground_TeaserBackground = {
  className: 'TeaserBackground',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '580px'
    },
    '.TeaserImage img': {
      height: '580px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        mb: '$2'
      }
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 90%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserBackgroundLg.ts

var TeaserBackgroundLg_TeaserBackgroundLg = {
  className: 'TeaserBackgroundLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '360px'
    },
    '.TeaserImage img': {
      height: '360px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 500px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 500px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserBackgroundRelated.ts

var TeaserBackgroundRelated_TeaserBackgroundRelated = {
  className: 'TeaserBackgroundRelated',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '780px'
    },
    '.TeaserImage img': {
      height: '680px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: 'black',
      position: 'static',
      pt: '$0',
      pb: '$4',
      px: '$4',
      my: '$0',
      'div.Teaser': {
        mb: '$3'
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 60%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserBackgroundRelatedLg.ts

var TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg = {
  className: 'TeaserBackgroundRelatedLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '536px'
    },
    '.TeaserImage img': {
      height: '536px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: '#282828',
      position: 'absolute',
      height: '536px',
      right: '0px',
      pt: '$0',
      pb: '$4',
      my: '$0',
      width: '328px',
      'div.Teaser': {
        background: 'transparent',
        px: '$8',
        mb: '$0'
      },
      '.TeaserImage': {
        display: 'none'
      },
      'p.TeaserTitleText': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        m: '$0 !important',
        p: '$0 !important',
        width: '100% !important'
      },
      '.TeaserWrap': {
        background: 'none',
        position: 'static',
        mt: '$0'
      },
      '@lg': {
        align: ['column', 'center', 'evenly'],
        '.TeaserTitle img': {
          display: 'none'
        }
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 360px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 360px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserChargeLg.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserChargeLg = {
  css: {
    flexDirection: 'column-reverse',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      my: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 500,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      width: '100%'
    }
  },
  className: 'TeaserChargeLg',
  imageDerivative: 'default',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserChargeMd.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserChargeMd = {
  css: {
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      mt: '$4',
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '25px',
      fontWeight: 600,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      width: '100%'
    }
  },
  className: 'TeaserChargeMd',
  imageDerivative: 'default',
  imageVariant: 'top',
  subjectVariant: 'filled',
  subjectColor: 'colunistaMain',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserChargeSm.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserChargeSm = {
  css: {
    // flexDirection: 'column',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      mt: '$4',
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 400,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '25px',
      width: '100%'
    }
  },
  className: 'TeaserChargeSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectVariant: 'filled',
  subjectColor: 'colunistaMain',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserColumnist.ts
var TeaserColumnist_TeaserColumnist = {
  css: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderRadius: '$alternative',
    p: '$0',
    pt: '$0',
    mb: '$4',
    '.TeaserImage img': {
      borderRadius: '$circle'
    },
    '.TeaserImageContainer': {
      borderRadius: '$circle',
      maxWidth: '80px'
    },
    '.TeaserWrap': {
      pb: '$4',
      pl: '$4',
      pr: '$4'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubject': {
      width: '100%'
    },
    '.TeaserSubjectText': {
      textAlign: 'left',
      color: '#4C362B',
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 500,
      mb: '$1'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      width: '100%'
    },
    '.TeaserTitleText': {
      fontSize: '16px',
      fontWeight: 400
    }
  },
  className: 'TeaserColumnist',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subjectTextVariant: 'subject-default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-sm'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserEditais.ts
var TeaserEditais = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserEditais'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserHeadlineSm.ts


function teasers_TeaserHeadlineSm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function teasers_TeaserHeadlineSm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? teasers_TeaserHeadlineSm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : teasers_TeaserHeadlineSm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var TeaserHeadlineSm_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var TeaserHeadlineSm_TeaserHeadlineSm = teasers_TeaserHeadlineSm_objectSpread(teasers_TeaserHeadlineSm_objectSpread({}, TeaserHeadlineSm_T.TeaserHeadlineSm), {}, {
  css: {
    p: '$0',
    mb: '$6',
    textAlign: 'center',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineSm',
  relatedLayout: TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-3xl'
});
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserHeadlineLg.ts


var teasers_TeaserHeadlineLg_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var TeaserHeadlineLg_TeaserHeadlineLg = {
  css: {
    textAlign: 'center',
    my: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      align: ['row', 'center', 'top'],
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '18px',
          lineHeight: '23px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      maxWidth: '980px',
      mb: '$8'
    },
    '.TeaserTitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineLg',
  relatedLayout: TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-6xl'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserImageLeft.ts

var TeaserImageLeft_TeaserImageLeft = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    },
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      textAlign: 'center',
      '.TeaserImageContainer': {
        backgroundColor: 'transparent',
        width: 'auto',
        'img': {
          pr: '$3'
        },
        '@lg': {
          maxWidth: '150px'
        }
      },
      '.TeaserSubjectText': {
        alignItems: 'center',
        align: ['column', 'center', 'top'],
        textTransform: 'uppercase',
        fontSize: '14px'
      },
      '.TeaserSubtitleText': {
        display: 'none'
      },
      '.TeaserSubtitle': {
        align: ['row', 'left', 'middle']
      },
      '.TeaserTitle': {
        my: '$2'
      },
      '.TeaserTitleText': {
        align: ['column', 'left', 'top'],
        color: 'black',
        fontSize: '26px',
        fontWeight: 400,
        letterSpacing: '0.2px',
        lineHeight: '23px',
        width: '100%'
      },
      '.TeaserWrap': {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0px !important',
        width: '100%',
        '.TeaserRelated': {
          'div.Teaser': {
            mb: '$4'
          },
          'div.TeaserTitle': {
            'p.TeaserTitleText': {
              fontSize: '16px',
              lineHeight: '19px',
              letterSpacing: '0.2px'
            }
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserImageLeftSq.ts
var TeaserImageLeftSq = {
  css: {
    padding: '$0',
    mb: '$3',
    minHeight: '75px',
    width: '100%',
    '@lg': {
      mb: '$3'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(75px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '75px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 75px - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeftSq',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserImageLeftSm.ts
var TeaserImageLeftSm_TeaserImageLeftSm = {
  css: {
    padding: '$0',
    mb: '$6',
    minHeight: '88px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(120px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 88px - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeftSm',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserImageLeftLg.ts

var TeaserImageLeftLg_TeaserImageLeftLg = {
  css: {
    padding: '$0',
    mb: '$6',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      mb: '$3'
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '36px',
      lineHeight: '43px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      minWidth: 'calc(50% - $3)',
      width: '100%',
      '.TeaserRelated': {
        flexFlow: 'column',
        width: '100%',
        'div.Teaser': {
          mb: '$4',
          width: 'auto'
        },
        'div.TeaserTitle': {
          'p.TeaserTitleText': {
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.2px'
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserNoImage.ts

var TeaserNoImage_TeaserNoImage = {
  css: {
    p: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      align: ['column', 'left', 'top'],
      display: 'none',
      mb: '$4'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      mb: '$4'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserNoImage',
  relatedLayout: TeaserRelated_TeaserRelated,
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserCard.ts
var TeaserCard_TeaserCard = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCard',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserCardBold.ts
var TeaserCardBold = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0',
      color: '#4D4D4D'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCardBold',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserImageTop.ts

var TeaserImageTop_TeaserImageTop = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserImageTopLg.ts

var TeaserImageTopLg_TeaserImageTopLg = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserImageBottom.ts
var TeaserImageBottom_TeaserImageBottom = {
  css: {
    mb: '$3',
    padding: '$0',
    width: '100%',
    '.TeaserSubtitle': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$3'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase'
    },
    '.TeaserTitle': {
      mb: '$3'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    }
  },
  className: 'TeaserImageBottom',
  imageDerivative: '3x1',
  imageVariant: 'bottom',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subtitleVariant: 'subtitle-default',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  titleVariant: 'newstitle-5xl'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserImageLeftXl.ts
var TeaserImageLeftXl_TeaserImageLeftXl = {
  css: {
    padding: '$0',
    mb: '$5',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserMostRead.ts
var TeaserMostRead_TeaserMostRead = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      borderRadius: '50%',
      height: '100%',
      width: '30px',
      pr: '$2'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserMostReadFixed.ts
var TeaserMostReadFixed_TeaserMostReadFixed = {
  css: {
    align: ['row', 'center', 'middle'],
    borderBottom: '1px solid #E6E6E6',
    borderLeft: '8px solid $basicWhite',
    p: '$0',
    minHeight: '92px',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      ml: '$4',
      mr: '$4',
      height: '100%',
      width: 'max-content'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '$widget5',
      fontWeight: '$widget5',
      lineHeight: '$widget5'
    },
    '.TeaserWrap': {
      mr: '$4',
      width: 'calc(100% - $4)'
    },
    '&:last-child': {
      borderBottom: 'unset'
    },
    '&[data-selected=true]': {
      borderLeft: '8px solid $primaryMain'
    },
    '&[data-viewed=true]': {
      borderLeft: '8px solid #E7E7E7'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserPodcast.ts
var TeaserPodcast_TeaserPodcast = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$2',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      width: '160px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 5%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '124px',
      width: '124px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserTitleText': {
      display: 'none'
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserRadio.ts
var TeaserRadio_TeaserRadio = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  customLinkProps: {
    bypass: 'true'
  },
  css: {
    backgroundColor: 'none',
    cursor: 'pointer',
    p: '$0',
    m: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      mx: '$4',
      width: '100px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 25%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '100px',
      width: '100px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserSubtitleText': {
      color: '#c6c6c6',
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: 400,
      mx: '$2',
      mb: '$2',
      textAlign: 'center',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    },
    '.TeaserTitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserTitleText': {
      color: '#7c7c7c',
      fontSize: '18px',
      letterSpacing: '0.4px',
      lineHeight: '25px',
      fontWeight: 500,
      mx: '$2',
      mb: '$1',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserStories.ts
var TeaserStories_TeaserStories = {
  className: 'TeaserStories',
  imageDerivative: '1x3',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$4',
    width: 'calc(100% - $4)',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$0'
    },
    '.TeaserImage img': {
      borderRadius: '10px',
      height: '354px',
      width: '200px',
      objectFit: 'cover'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '19px',
      fontWeight: 500,
      px: '$4',
      mb: '$2',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      align: ['row', 'left', 'bottom']
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'bottom'],
      color: '$basicWhite',
      fontSize: '18px',
      letterSpacing: '0.2px',
      lineHeight: '23px',
      fontWeight: 400,
      px: '$4',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      'a': {
        textAlign: 'left'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      background: 'linear-gradient(rgba(0, 0, 0, 0) 50%, rgb(0, 0, 0) 100%)',
      borderRadius: '10px',
      position: 'absolute',
      height: '100%',
      width: '100%'
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserVideoFeatured.ts

var TeaserVideoFeatured = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserVideoFeatured',
  imageDerivative: '2x1',
  imageVariant: 'top',
  relatedLayout: TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserVideoFeatSm.ts

var TeaserVideoFeatSm = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserVideoFeatSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserVideoFeatMd.ts

var TeaserVideoFeatMd = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        fontWeight: 600,
        letterSpacing: '0.2px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserVideoFeatMd',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserVideoFeatLg.ts

var TeaserVideoFeatLg = {
  className: 'TeaserVideoFeatLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'default',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    p: '$0',
    mb: '$6',
    ml: '-$3',
    mr: '-$3',
    width: 'calc(100% + $6)',
    '@lg': {
      ml: '$0',
      mr: '$0'
    },
    '.TeaserImage': {
      height: '535px'
    },
    '.TeaserImage img': {
      height: '535px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto',
      width: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '12px',
      ml: '$4',
      mb: '$4',
      textTransform: 'uppercase',
      '@lg': {
        fontSize: '16px',
        ml: '$10',
        mb: '$4'
      }
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      ml: '$4',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 400,
        ml: '$10',
        mb: '$10'
      }
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: '$basicWhite',
      fontSize: '28px',
      lineHeight: '33px',
      fontWeight: 700,
      ml: '$4',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        fontSize: '43px',
        lineHeight: '50px',
        fontWeight: 700,
        ml: '$10',
        mb: '$4'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 24px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 24px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserVideoLeft.ts
var TeaserVideoLeft_TeaserVideoLeft = {
  css: {
    backgroundColor: 'transparent',
    padding: '$0',
    mb: '$3',
    width: '100%',
    '@lg': {
      ml: '$8',
      mb: '$8',
      width: 'calc(100% - $8)'
    },
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubtitle': {
      display: 'none',
      '@lg': {
        display: 'flex'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      color: '#989898',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 400,
      '@lg': {
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: 400
      }
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      ml: '$3',
      maxWidth: 'calc(50% - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers/TeaserVideoTop.ts
var TeaserVideoTop_TeaserVideoTop = {
  css: {
    backgroundColor: 'transparent',
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      color: '#989898',
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$0'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '25px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '2x1',
  imageVariant: 'top',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/opopular/assets/teasers.ts




































var teasers_teasers = {
  TeaserBackground: TeaserBackground_TeaserBackground,
  TeaserBackgroundLg: TeaserBackgroundLg_TeaserBackgroundLg,
  TeaserBackgroundRelatedLg: TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg,
  TeaserBackgroundRelated: TeaserBackgroundRelated_TeaserBackgroundRelated,
  TeaserChargeLg: TeaserChargeLg,
  TeaserChargeMd: TeaserChargeMd,
  TeaserChargeSm: TeaserChargeSm,
  TeaserEditais: TeaserEditais,
  TeaserEditorial: TeaserEditorial,
  TeaserEditorialSm: TeaserEditorialSm,
  TeaserImageBottom: TeaserImageBottom_TeaserImageBottom,
  TeaserImageLeft: TeaserImageLeft_TeaserImageLeft,
  TeaserImageLeftSq: TeaserImageLeftSq,
  TeaserImageLeftSm: TeaserImageLeftSm_TeaserImageLeftSm,
  TeaserImageLeftLg: TeaserImageLeftLg_TeaserImageLeftLg,
  TeaserImageLeftXl: TeaserImageLeftXl_TeaserImageLeftXl,
  TeaserImageTop: TeaserImageTop_TeaserImageTop,
  TeaserImageTopLg: TeaserImageTopLg_TeaserImageTopLg,
  TeaserCard: TeaserCard_TeaserCard,
  TeaserCardBold: TeaserCardBold,
  TeaserColumnist: TeaserColumnist_TeaserColumnist,
  TeaserRelated: TeaserRelated_TeaserRelated,
  TeaserHeadlineSm: TeaserHeadlineSm_TeaserHeadlineSm,
  TeaserHeadlineLg: TeaserHeadlineLg_TeaserHeadlineLg,
  TeaserNoImage: TeaserNoImage_TeaserNoImage,
  TeaserMostRead: TeaserMostRead_TeaserMostRead,
  TeaserMostReadFixed: TeaserMostReadFixed_TeaserMostReadFixed,
  TeaserPodcast: TeaserPodcast_TeaserPodcast,
  TeaserRadio: TeaserRadio_TeaserRadio,
  TeaserStories: TeaserStories_TeaserStories,
  TeaserVideoFeatured: TeaserVideoFeatured,
  TeaserVideoFeatSm: TeaserVideoFeatSm,
  TeaserVideoFeatMd: TeaserVideoFeatMd,
  TeaserVideoFeatLg: TeaserVideoFeatLg,
  TeaserVideoLeft: TeaserVideoLeft_TeaserVideoLeft,
  TeaserVideoTop: TeaserVideoTop_TeaserVideoTop
};
var teasers_teasersArray = Object.keys(teasers_teasers);

;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutDefault.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutDefault = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserHeadlineSm, teasers_teasers.TeaserImageLeftXl]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageLeftLg]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserNoImage, teasers_teasers.TeaserNoImage]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageTopLg]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageTopLg]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      }
    },
    TemplateVideos: {
      slotLeft: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutFeatured.ts


function LayoutFeatured_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LayoutFeatured_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LayoutFeatured_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LayoutFeatured_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck



// MancheteComFoto
var LayoutFeatured = LayoutFeatured_objectSpread(LayoutFeatured_objectSpread({}, LayoutDefault), {}, {
  slotConfig: LayoutFeatured_objectSpread(LayoutFeatured_objectSpread({}, LayoutDefault === null || LayoutDefault === void 0 ? void 0 : LayoutDefault.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageLeft, teasers_teasers.TeaserImageLeftLg]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackground, teasers_teasers.TeaserBackgroundLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutFeaturedImage.ts


function LayoutFeaturedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LayoutFeaturedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LayoutFeaturedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LayoutFeaturedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var LayoutFeaturedImage = LayoutFeaturedImage_objectSpread(LayoutFeaturedImage_objectSpread({}, LayoutFeatured), {}, {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: LayoutFeaturedImage_objectSpread(LayoutFeaturedImage_objectSpread({}, LayoutFeatured === null || LayoutFeatured === void 0 ? void 0 : LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackgroundRelated, teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutFeaturedNoImage.ts


function LayoutFeaturedNoImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LayoutFeaturedNoImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LayoutFeaturedNoImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LayoutFeaturedNoImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var LayoutFeaturedNoImage = LayoutFeaturedNoImage_objectSpread(LayoutFeaturedNoImage_objectSpread({}, LayoutFeatured), {}, {
  slotConfig: LayoutFeaturedNoImage_objectSpread(LayoutFeaturedNoImage_objectSpread({}, LayoutFeatured === null || LayoutFeatured === void 0 ? void 0 : LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserHeadlineSm, teasers_teasers.TeaserHeadlineLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutFeaturedRelated.ts


function LayoutFeaturedRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LayoutFeaturedRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LayoutFeaturedRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LayoutFeaturedRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// SuperManchete
var LayoutFeaturedRelated = LayoutFeaturedRelated_objectSpread(LayoutFeaturedRelated_objectSpread({}, LayoutFeatured), {}, {
  slotConfig: LayoutFeaturedRelated_objectSpread(LayoutFeaturedRelated_objectSpread({}, LayoutFeatured === null || LayoutFeatured === void 0 ? void 0 : LayoutFeatured.slotConfig), {}, {
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackgroundRelated, teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutGrid3.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var LayoutGrid3_TeaserCard = addRelativeWidthToTeaser(teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 2)) / 3)');
var LayoutGrid3_TeaserImageTop = addRelativeWidthToTeaser(teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var LayoutGrid3 = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSq, LayoutGrid3_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, LayoutGrid3_TeaserCard]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutGrid4.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var LayoutGrid4_TeaserCard = addRelativeWidthToTeaser(teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 3)) / 4)');
var LayoutGrid4 = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserCard, LayoutGrid4_TeaserCard]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeftSm]
      }
    },
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [teasers_teasers.TeaserColumnist, teasers_teasers.TeaserColumnist]
      }
    },
    TemplateSideBoxNoTitle: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeftSm],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutPodcast.tsx
// @ts-nocheck




var renderWrapComponent = function renderWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '220px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

var LayoutPodcast = {
  wrapperContent: {
    enabled: true,
    component: renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxPodcast: {
      slotLeft: {
        "default": [teasers_teasers.TeaserPodcast, teasers_teasers.TeaserPodcast]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutRadio.tsx
// @ts-nocheck

var LayoutRadio = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      px: '$0',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxRadio: {
      slotLeft: {
        "default": [teasers.TeaserRadio, teasers.TeaserRadio]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutSearch.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutSearch = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [teasers.TeaserEditorialSm, teasers.TeaserEditorial]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutStories.tsx
// @ts-nocheck




var LayoutStories_renderWrapComponent = function renderWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '220px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

var LayoutStories = {
  wrapperContent: {
    enabled: true,
    component: LayoutStories_renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxStories: {
      slotLeft: {
        "default": [teasers_teasers.TeaserStories, teasers_teasers.TeaserStories]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutMostRead.ts
// eslint-disable-next-line
// @ts-nocheck

var LayoutMostRead = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [teasers.TeaserMostRead, teasers.TeaserMostRead]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [teasers.TeaserMostRead, teasers.TeaserMostRead]
      }
    },
    TemplateSideBoxFixed: {
      slotLeft: {
        "default": [teasers.TeaserMostReadFixed, teasers.TeaserMostReadFixed]
      },
      slotCenter: {
        "default": [teasers.TeaserMostReadFixed, teasers.TeaserMostReadFixed]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutVideoHome.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var LayoutVideoHome_TeaserVideoTop = addRelativeWidthToTeaser(teasers.TeaserVideoTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var LayoutVideoHome = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        width: '100%' // columnGap: '24px'

      }
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [teasers.TeaserVideoTop, LayoutVideoHome_TeaserVideoTop],
        '1': [teasers.TeaserVideoTop, teasers.TeaserVideoTop],
        '2': [teasers.TeaserVideoTop, teasers.TeaserVideoLeft],
        '0:1': [teasers.TeaserVideoTop, teasers.TeaserVideoTop],
        '0:2': [teasers.TeaserVideoTop, teasers.TeaserVideoLeft]
      },
      slotCenter: {
        "default": [teasers.TeaserVideoTop, LayoutVideoHome_TeaserVideoTop],
        '1': [teasers.TeaserVideoTop, teasers.TeaserVideoTop],
        '2': [teasers.TeaserVideoTop, teasers.TeaserVideoLeft],
        '0:1': [teasers.TeaserVideoTop, teasers.TeaserVideoTop],
        '0:2': [teasers.TeaserVideoTop, teasers.TeaserVideoLeft]
      },
      slotRight: {
        "default": [teasers.TeaserVideoTop, LayoutVideoHome_TeaserVideoTop],
        '1': [teasers.TeaserVideoTop, teasers.TeaserVideoTop],
        '2': [teasers.TeaserVideoTop, teasers.TeaserVideoLeft],
        '0:1': [teasers.TeaserVideoTop, teasers.TeaserVideoTop],
        '0:2': [teasers.TeaserVideoTop, teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbn/assets/layouts/LayoutVideoLive.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutVideoLive = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      }
    },
    TemplateVideoLive: {
      slotLeft: {
        "default": [teasers_teasers.TeaserMostRead, teasers_teasers.TeaserMostRead]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/layouts.ts
// @ts-nocheck

















var slotLayouts = {
  LayoutColumnist: LayoutColumnist,
  LayoutColumnistDesktop: LayoutColumnistDesktop,
  LayoutColumnistSideBox: LayoutColumnistSideBox,
  LayoutDefault: LayoutDefault,
  LayoutFeatured: LayoutFeatured,
  LayoutFeaturedImage: LayoutFeaturedImage,
  LayoutFeaturedNoImage: LayoutFeaturedNoImage,
  LayoutFeaturedRelated: LayoutFeaturedRelated,
  LayoutGrid3: LayoutGrid3,
  LayoutGrid4: LayoutGrid4,
  LayoutPodcast: LayoutPodcast,
  LayoutRadio: LayoutRadio,
  LayoutSearch: LayoutSearch,
  LayoutStories: LayoutStories,
  LayoutMostRead: LayoutMostRead,
  LayoutVideoHome: LayoutVideoHome,
  LayoutVideoLive: LayoutVideoLive
};
var slotLayoutsArray = Object.keys(slotLayouts);

;// CONCATENATED MODULE: ./brands/cbn/assets/menus.tsx
var accordionStyle = {
  accordionItemGroup: {
    accordionContent: {
      backgroundColor: '#EAEAEA',
      pl: '$8',
      pr: '$18'
    },
    accordionTitle: {
      title: {
        fontFamily: '$primary',
        fontSize: '$caption5',
        fontWeight: '$caption5',
        lineHeight: '$caption5',
        m: '0px',
        py: '$2',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px'
      },
      iconButton: {
        height: '24px',
        width: '24px'
      }
    }
  }
};
var sideMenuLeft = {
  sectionHeader: {
    enabled: true,
    subscriberInfo: {
      enabled: false,
      amountLeft: 0
    },
    advertiseSection: {
      enabled: true,
      color: '#938783',
      href: 'https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania',
      target: '_blank'
    },
    variants: {
      anonymous: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      DEGUSTADOR: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      ASSINANTE: {
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      advertiser_subscriber: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      club_subscriber: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      }
    }
  },
  sectionContent: {
    enabled: true,
    searchInput: {
      enabled: true
    },
    advertiseSection: {
      enabled: true,
      color: '#938783',
      href: 'https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania',
      target: '_blank'
    },
    serviceButtons: {
      enabled: false,
      items: []
    },
    navigationAccordions: {
      enabled: true,
      css: accordionStyle,
      items: [{
        id: 'sac',
        title: 'SAC',
        items: [{
          id: '1',
          title: 'Fale Conosco',
          href: '/fale-conosco'
        }, {
          id: '2',
          title: 'Expediente',
          href: '/expediente'
        }, {
          id: '3',
          title: 'Política de privacidade',
          href: '/politica-de-privacidade'
        }, {
          id: '4',
          title: 'Termos de uso',
          href: '/termos-de-uso'
        }],
        css: accordionStyle
      }, {
        id: 'grupoojc',
        title: 'Grupo Jaime Câmara',
        items: [{
          id: '1',
          title: 'Classi',
          href: 'https://www.classi.com.br'
        }, {
          id: '2',
          title: 'Jornal Daqui',
          href: 'https://daqui.opopular.com.br'
        }, {
          id: '3',
          title: 'Jornal O Popular',
          href: 'https://opopular.com.br/'
        }, {
          id: '4',
          title: 'Jornal do Tocantins',
          href: 'https://www.jornaldotocantins.com.br'
        }],
        css: accordionStyle
      }]
    }
  },
  sectionFooter: {
    enabled: true,
    advertiseSection: {
      enabled: false,
      color: '',
      href: ''
    },
    socialmediasSection: {
      enabled: true,
      color: '$secondaryMain',
      content: [{
        id: 'facebook',
        href: 'https://www.facebook.com/radiocbn',
        icon: 'IcBotaoFacebook'
      }, {
        id: 'twitter',
        href: 'https://twitter.com/CBNoficial',
        icon: 'IcBotaoTwitter'
      }]
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/Template100.ts
var Template100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/Template1005050.ts
var Template1005050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      '.Column.Left': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Center': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Right': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column.Left': {
          mb: '$0'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          borderBottom: 'none',
          gridColumn: 'span 2',
          width: '100%'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/Template5050.ts
var Template5050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/Template5050100.ts
var Template5050100 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          gridColumn: 'span 2',
          width: '100%'
        }
      }
    }
  },
  customProps: {
    container: {
      className: 'AlignToLeft'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateColumnist.ts
var TemplateColumnist = {
  css: {
    container: {
      backgroundColor: '#f4f4f4',
      pt: '$4',
      mb: '$4',
      '@lg': {
        pb: '$0',
        mb: '$4'
      }
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '.Column:nth-child(1)': {
        '@lg': {
          display: 'none'
        }
      },
      '.Column:nth-child(2)': {
        display: 'none',
        '@lg': {
          display: 'flex'
        }
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Teaser.mobile:not(:nth-child(1))': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%'
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSideBox.ts
var TemplateSideBox = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        px: '$3',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle'],
        borderBottom: '1px solid #e6e6e6',
        pt: '$4',
        pb: '$0',
        px: '$2',
        mb: '$5'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSideBoxFixed.ts
var TemplateSideBoxFixed = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      mt: '$6',
      '@lg': {
        pb: '$0',
        px: '$0',
        mt: '$6',
        mb: '$8',
        position: 'sticky',
        top: '200px'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ExtraTop .ColumnContent': {
        align: ['row', 'left', 'bottom'],
        mb: '0px',
        width: '100%',
        '.pds-Button-root': {
          backgroundColor: '#FFFFFF'
        }
      },
      '.Center .ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderTop: 'unset',
        borderBottomLeftRadius: '$alternative',
        borderBottomRightRadius: '$alternative',
        overflow: 'hidden',
        py: '$0',
        width: '100%'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSideBoxPodcast.ts
var TemplateSideBoxPodcast = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        borderRadius: '10px',
        mt: '$6',
        mx: '$3',
        width: '290px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        pl: '$11',
        pt: '$4'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .Teaser:nth-child(2),.Teaser:nth-child(1)': {
        position: 'relative',
        top: '-30px',
        'img': {
          height: '190px',
          width: '190px'
        },
        '.TeaserImage': {
          width: '180px'
        }
      },
      '.ColumnBottom': {
        mb: '$4',
        mx: '$4',
        width: 'calc(100% - $8)',
        'audio': {
          width: 'calc(100% - $8)'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '-$6',
        px: '$0',
        mt: '$1',
        overflowX: 'clip',
        py: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSideBoxRadio.ts
var TemplateSideBoxRadio = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        px: '$0'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .slide.selected .Teaser': {
        'img': {
          height: '124px',
          width: '124px'
        },
        '.TeaserSubtitleText': {
          maxWidth: '124px'
        },
        '.TeaserTitleText': {
          maxWidth: '124px'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        overflowY: 'inherit',
        overflowX: 'clip',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSideBoxStories.ts
var TemplateSideBoxStories = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      width: 'calc(100% - $4)',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8',
        width: '100%'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left': {
        overflowX: 'clip'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '$3',
        px: '$0',
        mt: '$1',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSideBoxColumnist.ts
var TemplateSideBoxColumnist = {
  css: {
    container: {
      pt: '$0',
      '@lg': {
        pb: '$0',
        mb: '$0'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        backgroundColor: '#f4f4f4',
        mb: '$4',
        px: '$2',
        py: '$8',
        width: '100%'
      },
      '.Extra .ColumnContent': {
        backgroundImage: 'none',
        px: '$3',
        py: '$0',
        mb: '$0',
        width: '100%'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.ExtraTop .ColumnContent': {
        backgroundImage: 'none',
        py: '$0',
        px: '$3',
        mt: '$1',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      }
    },
    item: {}
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSideBoxNoTitle.ts
var TemplateSideBoxNoTitle = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$3',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2',
        '.TeaserWrap': {
          py: '$3'
        },
        '.TeaserSubject': {
          px: '$6'
        },
        '.TeaserTitle': {
          px: '$6'
        },
        '.TeaserImage img': {
          borderRadius: '10px 10px 0px 0px'
        }
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$3',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSidebarLeft.ts
var TemplateSidebarLeft = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      flexDirection: 'column-reverse',
      marginTop: '$2',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none',
          marginTop: '24px',
          width: '300px'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          marginTop: '36px',
          width: 'calc(100% - 340px)'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          flexDirection: 'unset',
          align: ['row', 'between', 'middle']
        },
        '.Column.ExtraTop': {
          width: '100%'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateSuperManchete.ts
var TemplateSuperManchete = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateVideosLive.ts
var TemplateVideoLive = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$0',
        px: '$3',
        width: '100%'
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates/TemplateVideos.ts
var TemplateVideos = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['column', 'center', 'top'],
        mb: '$0',
        px: '$3',
        width: '100%'
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2) .ColumnContent': {
        align: ['column', 'center', 'top']
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column.Left': {
          width: '100%'
        },
        '.Column.Center': {
          display: 'none',
          width: 'calc(50% - $3)'
        },
        '.ColumnContent': {
          align: ['row', 'between', 'top'],
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbn/assets/templates.ts
















var templates = {
  Template100: Template100,
  Template1005050: Template1005050,
  Template5050: Template5050,
  Template5050100: Template5050100,
  TemplateColumnist: TemplateColumnist,
  TemplateSidebarLeft: TemplateSidebarLeft,
  TemplateSideBox: TemplateSideBox,
  TemplateSideBoxFixed: TemplateSideBoxFixed,
  TemplateSideBoxPodcast: TemplateSideBoxPodcast,
  TemplateSideBoxRadio: TemplateSideBoxRadio,
  TemplateSideBoxStories: TemplateSideBoxStories,
  TemplateSideBoxColumnist: TemplateSideBoxColumnist,
  TemplateSideBoxNoTitle: TemplateSideBoxNoTitle,
  TemplateSuperManchete: TemplateSuperManchete,
  TemplateVideoLive: TemplateVideoLive,
  TemplateVideos: TemplateVideos
};
var templatesArray = Object.keys(templates);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./components/Buttons/ItemButton/ItemButton.styled.tsx


function ItemButton_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ItemButton_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ItemButton_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ItemButton_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Container = function Container(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    css: ItemButton_styled_objectSpread(ItemButton_styled_objectSpread({}, props.defaultCss), props.customCss),
    children: props.children
  });
};

Container.defaultProps = {
  defaultCss: {
    align: ['row', 'center', 'middle']
  }
};

;// CONCATENATED MODULE: ./components/Buttons/ItemButton/ItemButton.index.tsx


function ItemButton_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ItemButton_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ItemButton_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ItemButton_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck





var ItemButton = function ItemButton(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container, {
    customCss: props.cssContainer,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: props.href,
      title: props.value,
      target: "_blank",
      rel: "noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Button */.zx, ItemButton_index_objectSpread(ItemButton_index_objectSpread(ItemButton_index_objectSpread({}, props["default"]), props.customProps), {}, {
        css: ItemButton_index_objectSpread(ItemButton_index_objectSpread(ItemButton_index_objectSpread(ItemButton_index_objectSpread({}, props.defaultCss), props.customCss), props.hideInMobile && {
          display: 'none',
          '@lg': {
            display: 'flex'
          }
        }), props.hideInDesktop && {
          '@lg': {
            display: 'none'
          }
        }),
        children: props.value || props.children
      }))
    })
  });
};

ItemButton.defaultProps = {
  "default": {
    onClick: function onClick(e) {
      return console.log(e);
    },
    size: 'xs',
    variant: 'ghost'
  },
  defaultCss: {
    button: {
      px: 0
    },
    label: {
      fontSize: '12px',
      fontWeight: 400,
      fontFamily: '$primary',
      px: '0',
      mr: '$6'
    }
  },
  hideInMobile: true
};
/* harmony default export */ var ItemButton_index = (ItemButton);
// EXTERNAL MODULE: ./components/Buttons/GhostButton.index.tsx
var GhostButton_index = __webpack_require__(77679);
// EXTERNAL MODULE: ./providers/Session/index.tsx + 2 modules
var Session = __webpack_require__(72236);
;// CONCATENATED MODULE: ./components/Topbar/SubscriberInfo/SubscriberInfo.index.tsx









var SubscriberInfo = function SubscriberInfo(_ref) {
  var type = _ref.type,
      amountLeft = _ref.amountLeft,
      onAnonymousClick = _ref.onAnonymousClick,
      onGuestClick = _ref.onGuestClick,
      onSubscriberClick = _ref.onSubscriberClick,
      onLogout = _ref.onLogout;
  var sessionData = (0,react.useContext)(Session.SessionDataContext);

  var renderAnonymous = function renderAnonymous() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(GhostButton_index/* default */.Z, {
      id: "entrar-menu",
      isUppercase: true,
      onClick: onAnonymousClick,
      children: "Entrar"
    });
  };

  var renderGuestSubscriber = function renderGuestSubscriber() {
    var _sessionData$emailUsu;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ["row", "center", "middle"]
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(GhostButton_index/* default */.Z, {
        onClick: onGuestClick,
        children: "Ol\xE1, ".concat((sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$emailUsu = sessionData.emailUsuario) === null || _sessionData$emailUsu === void 0 ? void 0 : _sessionData$emailUsu.split("@")[0]) || "Convidado")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(GhostButton_index/* default */.Z, {
        css: {
          button: {
            cursor: "pointer",
            height: "fit-content",
            padding: "0px" // mr: '$6'

          },
          label: {
            color: "$primaryMain",
            fontFamily: "$primary",
            fontSize: "$caption3",
            fontWeight: "$caption4",
            lineHeight: "$caption3"
          }
        },
        onClick: onLogout,
        children: "Sair"
      })]
    });
  };

  var renderSubscriber = function renderSubscriber() {
    var _sessionData$emailUsu2;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GhostButton_index/* default */.Z, {
        onClick: onSubscriberClick,
        children: "Ol\xE1, ".concat((sessionData === null || sessionData === void 0 ? void 0 : (_sessionData$emailUsu2 = sessionData.emailUsuario) === null || _sessionData$emailUsu2 === void 0 ? void 0 : _sessionData$emailUsu2.split("@")[0]) || "Convidado")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(GhostButton_index/* default */.Z, {
        css: {
          button: {
            cursor: "pointer",
            height: "fit-content",
            padding: "0px"
          },
          label: {
            color: "$primaryMain",
            fontFamily: "$primary",
            fontSize: "$caption2",
            fontWeight: "$caption4",
            lineHeight: "$caption3"
          }
        },
        onClick: onLogout,
        children: "Sair"
      })]
    });
  };

  switch (type) {
    case "anonymous":
      return renderAnonymous();

    case "DEGUSTADOR":
      return renderGuestSubscriber();

    case "advertiser_subscriber":
    case "club_subscriber":
    case "ASSINANTE":
      return renderSubscriber();
  }
};

/* harmony default export */ var SubscriberInfo_index = (SubscriberInfo);
// EXTERNAL MODULE: ./components/ClickableAsset/ClickableAsset.index.tsx
var ClickableAsset_index = __webpack_require__(26454);
;// CONCATENATED MODULE: ./components/Buttons/SubscribeNowBannerButton.index.tsx




var SubscribeNowBannerButton = function SubscribeNowBannerButton(_ref) {
  var alt = _ref.alt,
      colorSchema = _ref.colorSchema,
      href = _ref.href,
      imgSrc = _ref.imgSrc,
      imgHeight = _ref.imgHeight,
      imgWidth = _ref.imgWidth,
      isUnstyled = _ref.isUnstyled;
  var color = colorSchema === 'secondary' ? '$secondaryMain' : '$tertiaryMain';
  var styles = {
    align: ['row', 'center', 'middle'],
    backgroundColor: color,
    borderColor: color,
    borderRadius: '2px',
    height: '40px',
    px: '$2'
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClickableAsset_index/* default */.Z, {
    alt: alt,
    src: imgSrc,
    href: href,
    height: imgHeight,
    id: "assine-agora-menu",
    width: imgWidth,
    css: {
      container: isUnstyled ? {} : styles
    },
    target: "blank"
  });
};

/* harmony default export */ var SubscribeNowBannerButton_index = (SubscribeNowBannerButton);
;// CONCATENATED MODULE: ./components/Buttons/VersaoDigitalButton.index.tsx


var VersaoDigitalButton_index_excluded = ["icon"];

function VersaoDigitalButton_index_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function VersaoDigitalButton_index_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VersaoDigitalButton_index_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VersaoDigitalButton_index_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var VersaoDigitalButton = function VersaoDigitalButton(_ref) {
  var icon = _ref.icon,
      otherProps = (0,objectWithoutProperties/* default */.Z)(_ref, VersaoDigitalButton_index_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Button */.zx, VersaoDigitalButton_index_objectSpread(VersaoDigitalButton_index_objectSpread({
    variant: "ghost",
    iconLeft: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, VersaoDigitalButton_index_objectSpread({}, icon)),
    labelSpacing: 2,
    css: {
      button: {
        height: '18px',
        padding: '0px'
      },
      label: {
        color: '#202020',
        fontFamily: '$primary',
        fontSize: '$caption4',
        fontWeight: '$caption4',
        lineHeight: '$caption4',
        textTransform: 'uppercase'
      }
    }
  }, otherProps), {}, {
    children: "Digital"
  }));
};

/* harmony default export */ var VersaoDigitalButton_index = (VersaoDigitalButton);
// EXTERNAL MODULE: ./providers/Assets/index.tsx
var Assets = __webpack_require__(28054);
// EXTERNAL MODULE: ./providers/DrawersProvider/index.tsx
var DrawersProvider = __webpack_require__(43928);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/SearchInput/SearchInput.index.tsx + 1 modules
var SearchInput_index = __webpack_require__(64634);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/@react-keycloak/ssr/lib/index.js + 14 modules
var lib = __webpack_require__(85069);
// EXTERNAL MODULE: ./providers/Session/utils.ts
var utils = __webpack_require__(48717);
;// CONCATENATED MODULE: ./components/Buttons/AdvertiseBannerButton.tsx




var AdvertiseBannerButton = function AdvertiseBannerButton(_ref) {
  var alt = _ref.alt,
      colorSchema = _ref.colorSchema,
      href = _ref.href,
      imgSrc = _ref.imgSrc,
      imgHeight = _ref.imgHeight,
      imgWidth = _ref.imgWidth,
      isUnstyled = _ref.isUnstyled;
  var color = colorSchema === 'secondary' ? '$secondaryMain' : colorSchema;
  var styles = {
    align: ['row', 'center', 'middle'],
    backgroundColor: color,
    borderColor: color,
    borderRadius: '2px',
    height: '40px',
    px: '$2'
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClickableAsset_index/* default */.Z, {
    alt: alt,
    src: imgSrc,
    href: href,
    height: imgHeight,
    id: "anuncie-menu",
    width: imgWidth,
    css: {
      container: isUnstyled ? {} : styles
    },
    target: "blank"
  });
};

/* harmony default export */ var Buttons_AdvertiseBannerButton = (AdvertiseBannerButton);
;// CONCATENATED MODULE: ./brands/opopular/assets/topbar.styled.tsx




function topbar_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function topbar_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? topbar_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : topbar_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7'
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'DIGITAL',
    hideInMobile: false
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black'
    },
    cssContainer: {
      mr: '$4'
    },
    hideInMobile: false
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020'
    },
    hideInMobile: false
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'ÁUDIO',
    hideInMobile: false
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0'
      }
    },
    value: 'ENTRAR',
    hideInMobile: false
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800'
    },
    hideInMobile: false
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none'
      }
    },
    hideInMobile: false
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content'
    },
    hideInMobile: false
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#DAE5FB',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content'
      }
    },
    hideInMobile: false
  }
};
var TopbarMobileSlotLeft = function TopbarMobileSlotLeft() {
  var drawersContext = (0,react.useContext)(DrawersProvider.DrawersContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcHamburguerMobile'),
      onClick: function onClick() {
        return drawersContext.handleSideMenuLeft({
          open: !drawersContext.sideMenuLeftState.open
        });
      }
    })
  });
};
var TopbarMobileSlotRight = function TopbarMobileSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var TopbarTopSlotLeft = function TopbarTopSlotLeft() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "https://www.gjccorp.com.br/",
      title: "GJC",
      target: "_blank",
      rel: "noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        icon: (0,hooks_useIcon/* useIcon */.b)('IcOjc')
      })
    })
  });
};
var TopbarTopSlotRight = function TopbarTopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, topbar_styled_objectSpread({
      href: "https://www.classi.com.br",
      value: "Classi"
    }, buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, topbar_styled_objectSpread({
      href: "https://daqui.opopular.com.br",
      value: "Jornal Daqui"
    }, buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, topbar_styled_objectSpread({
      href: "https://www.jornaldotocantins.com.br",
      value: "Jornal do Tocantins"
    }, buttons.topbarTopItemsRight))]
  });
};
var TopbarDesktopSlotLeft = function TopbarDesktopSlotLeft() {
  var _assetsContext$assets;

  var router = (0,next_router.useRouter)();
  var drawersContext = (0,react.useContext)(DrawersProvider.DrawersContext);
  var urlParams = new URLSearchParams(window.location.search);
  var termParam = urlParams.get('term') || '';

  var _useState = (0,react.useState)(false),
      showSearch = _useState[0],
      setShowSearch = _useState[1];

  var _useState2 = (0,react.useState)(termParam),
      term = _useState2[0],
      setTerm = _useState2[1];

  var handleSearch = function handleSearch() {
    router.push("/pesquisa?term=".concat(term));
  };

  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var banners = assetsContext === null || assetsContext === void 0 ? void 0 : (_assetsContext$assets = assetsContext.assets) === null || _assetsContext$assets === void 0 ? void 0 : _assetsContext$assets.banners;
  var bannerAnuncie = banners.find(function (i) {
    return i.name === 'BannerAnuncieAqui';
  });

  var handleChange = function handleChange(event) {
    setTerm(event.target.value);
  };

  var handleBlur = function handleBlur() {
    if (!term) {
      setShowSearch(false);
    }
  };

  var searchIcon = (0,hooks_useIcon/* useIcon */.b)('IcBuscar');
  (0,react.useEffect)(function () {
    setTerm('');
    setShowSearch(false);
  }, [router.asPath]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcHamburger'),
      id: "menu-hamburguer",
      onClick: function onClick() {
        return drawersContext.handleSideMenuLeft({
          open: !drawersContext.sideMenuLeftState.open
        });
      }
    }), !showSearch ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: searchIcon,
      id: "busca-menu",
      onClick: function onClick() {
        return setShowSearch(!showSearch);
      }
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SearchInput_index/* default */.Z, {
      id: "ojc-search-input-topbar",
      onChange: handleChange,
      onSearch: handleSearch,
      onBlur: handleBlur,
      value: term,
      css: {
        container: {
          mt: '14px',
          mb: '$4',
          maxWidth: '320px'
        },
        input: {
          ml: '$2',
          width: 'calc(100% - $6)'
        },
        icon: {
          button: {
            mr: '$0'
          }
        }
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        align: ['row', 'right', 'middle'],
        width: '100%'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_AdvertiseBannerButton, {
        alt: "Anuncie",
        colorSchema:  false ? 0 : '$primaryMain',
        href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania" || 0,
        imgSrc: bannerAnuncie.url,
        imgHeight: "",
        imgWidth: ""
      })
    })]
  });
};
var TopbarDesktopSlotRight = function TopbarDesktopSlotRight() {
  var _assetsContext$assets2, _serverSideContext$si, _serverSideContext$si2, _keycloak$tokenParsed;

  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var serverSideContext = (0,react.useContext)(ServerSidePropsContext);
  var router = (0,next_router.useRouter)();
  var sessionData = (0,react.useContext)(Session.SessionDataContext);

  var _useKeycloak = (0,lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var banners = assetsContext === null || assetsContext === void 0 ? void 0 : (_assetsContext$assets2 = assetsContext.assets) === null || _assetsContext$assets2 === void 0 ? void 0 : _assetsContext$assets2.banners;
  var bannerAssine = banners.find(function (i) {
    return i.name === 'BannerAssineAgoraCondensado';
  });
  var routerRedirectUrl = window.location.href;
  var isPaywall = serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$si = serverSideContext.site) === null || _serverSideContext$si === void 0 ? void 0 : (_serverSideContext$si2 = _serverSideContext$si.pageConfig) === null || _serverSideContext$si2 === void 0 ? void 0 : _serverSideContext$si2.featureRadioSelectPaywall;

  function keycloakSessionLogOut(_x) {
    return _keycloakSessionLogOut.apply(this, arguments);
  }

  function _keycloakSessionLogOut() {
    _keycloakSessionLogOut = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(id) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return axios_default()["delete"]("/paywall/delete-sessao/".concat(id));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _keycloakSessionLogOut.apply(this, arguments);
  }

  var handleLogin = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return keycloak === null || keycloak === void 0 ? void 0 : keycloak.login({
                redirectUri: "".concat(window.location.href)
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error('Error during login:', _context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function handleLogin() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(prensa/* Block */.gO, {
    css: {
      align: ['row', 'right', 'middle'],
      width: '100%'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        align: ['row', 'right', 'middle'],
        width: '100%'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribeNowBannerButton_index, {
        alt: "Assine",
        colorSchema: "secondary",
        href: isPaywall === 'PIANO' ? '/assine' :  false || '',
        imgSrc: bannerAssine.url,
        imgHeight: "",
        imgWidth: ""
      })
    }), isPaywall !== 'DESATIVADO' && /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        align: ['row', 'right', 'middle'],
        ml: '$8'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriberInfo_index, {
        amountLeft: keycloak === null || keycloak === void 0 ? void 0 : (_keycloak$tokenParsed = keycloak.tokenParsed) === null || _keycloak$tokenParsed === void 0 ? void 0 : _keycloak$tokenParsed.exp,
        onAnonymousClick: handleLogin,
        onLogout: function onLogout() {
          if ((sessionData === null || sessionData === void 0 ? void 0 : sessionData.id) == undefined) {
            keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout();
          } else {
            keycloakSessionLogOut(sessionData === null || sessionData === void 0 ? void 0 : sessionData.id).then( /*#__PURE__*/function () {
              var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(res) {
                return regenerator_default().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (res.status == 200) {
                          keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout();
                          (0,utils/* removeSessionDataCookie */.pR)();
                        } else {
                          console.log('Erro ao fazer login');
                        }

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());
          }
        },
        onGuestClick: function onGuestClick() {
          var url = window.location.origin + '/perfil';
          window.location.assign(url);
        },
        onSubscriberClick: function onSubscriberClick() {
          var url = window.location.origin + '/perfil';
          window.location.assign(url);
        },
        type: sessionData ? 'ASSINANTE' : 'anonymous'
      })
    })]
  });
};
var TopbarExtraSlotRight = function TopbarExtraSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(VersaoDigitalButton_index, {
    onClick: function onClick() {
      return window.open('https://opopular.com.br/digital');
    },
    icon: (0,hooks_useIcon/* useIcon */.b)('IcVersaoDigitalCinzaClaro'),
    id: "digital-menu"
  });
};
;// CONCATENATED MODULE: ./brands/cbn/assets/topbar.styled.tsx


function assets_topbar_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_topbar_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_topbar_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_topbar_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var topbar_styled_buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7'
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'DIGITAL',
    hideInMobile: false
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black'
    },
    cssContainer: {
      mr: '$4'
    },
    hideInMobile: false
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020'
    },
    hideInMobile: false
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'ÁUDIO',
    hideInMobile: false
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0'
      }
    },
    value: 'ENTRAR',
    hideInMobile: false
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800'
    },
    hideInMobile: false
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none'
      }
    },
    hideInMobile: false
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content'
    },
    hideInMobile: false
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#FFF',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content'
      }
    },
    hideInMobile: false
  }
};
var topbar_styled_TopbarMobileSlotLeft = function TopbarMobileSlotLeft() {
  var drawersContext = (0,react.useContext)(DrawersProvider.DrawersContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcHamburguerMobile'),
      onClick: function onClick() {
        return drawersContext.handleSideMenuLeft({
          open: !drawersContext.sideMenuLeftState.open
        });
      }
    })
  });
};
var topbar_styled_TopbarMobileSlotRight = function TopbarMobileSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcAudioMobile')
    })
  });
};
var topbar_styled_TopbarTopSlotLeft = function TopbarTopSlotLeft() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "https://www.gjccorp.com.br/",
      title: "GJC",
      target: "_blank",
      rel: "noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        icon: (0,hooks_useIcon/* useIcon */.b)("IcOjc")
      })
    })
  });
};
var topbar_styled_TopbarTopSlotRight = function TopbarTopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, assets_topbar_styled_objectSpread({
      href: "https://classi.com.br",
      value: "Classi"
    }, topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, assets_topbar_styled_objectSpread({
      href: "https://daqui.opopular.com.br",
      value: "Jornal Daqui"
    }, topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, assets_topbar_styled_objectSpread({
      href: "https://opopular.com.br/",
      value: "Jornal O Popular"
    }, topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, assets_topbar_styled_objectSpread({
      href: "https://www.jornaldotocantins.com.br",
      value: "Jornal do Tocantins"
    }, topbar_styled_buttons.topbarTopItemsRight))]
  });
};
var topbar_styled_TopbarDesktopSlotRight = function TopbarDesktopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var topbar_styled_TopbarExtraSlotRight = function TopbarExtraSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
;// CONCATENATED MODULE: ./brands/cbn/assets/topbar.tsx


var topbar = {
  topbarMobile: {
    mainLogo: 'LogoCBNMobile',
    css: {
      cssContainer: {
        background: '#F7F7F7',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)',
        height: '52px',
        width: '100%'
      },
      cssContainerMiddleHolder: {
        height: '100%',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '100%',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        paddingLeft: '18px',
        width: '80px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'right', 'middle'],
        paddingRight: '18px',
        width: '80px'
      },
      cssContainerBottom: {
        display: 'none'
      }
    },
    slotMiddleLeft: topbar_styled_TopbarMobileSlotLeft,
    slotMiddleRight: topbar_styled_TopbarMobileSlotRight
  },
  topbarDesktop: {
    mainLogo: 'LogoCBNDesktop',
    css: {
      cssContainerTopHolder: {
        align: ['row', 'center', 'middle'],
        background: '$primaryMain',
        px: '$4',
        width: '100%'
      },
      cssContainerTop: {
        align: ['row', 'between', 'middle'],
        height: '32px',
        maxWidth: '1280px'
      },
      cssContainerTopSlotRight: {
        align: ['row', 'right', 'middle']
      },
      cssContainerMiddleHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '110px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        minWidth: '400px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'between', 'middle'],
        minWidth: '400px'
      },
      cssContainerBottomHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%',
        ' > div': {
          align: ['row', 'between', 'middle'],
          borderTop: '1px solid #E6E6E6'
        }
      },
      cssContainerBottom: {
        align: ['row', 'between', 'middle'],
        background: '#F7F7F7',
        height: '40px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerBottomLeft: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      cssContainerBottomRight: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      topbarItems: {
        item: {
          label: {
            color: '#202020',
            fontSize: '14px',
            fontFamily: '$primary',
            fontWeight: 500,
            textTransform: 'uppercase',
            width: 'max-content'
          },
          li: {
            mx: '$4'
          }
        }
      }
    },
    slotTopLeft: topbar_styled_TopbarTopSlotLeft,
    slotTopRight: topbar_styled_TopbarTopSlotRight,
    slotMiddleLeft: TopbarDesktopSlotLeft,
    slotMiddleRight: topbar_styled_TopbarDesktopSlotRight,
    slotBottomRight: topbar_styled_TopbarExtraSlotRight
  }
};
/* harmony default export */ var assets_topbar = ((/* unused pure expression or super */ null && (topbar)));
;// CONCATENATED MODULE: ./brands/cbn/assets/index.ts












var banners = banners_namespaceObject.k;
var favicons = favicons_namespaceObject.k;
var logos = logos_namespaceObject.k;
var icons = icons_namespaceObject.k;
var splashScreens = splashScreens_namespaceObject.k;
var CBNAssets = {
  article: article,
  banners: banners,
  favicons: favicons,
  footer: FooterConfig,
  logos: logos,
  icons: icons,
  menus: {
    sideMenuLeft: sideMenuLeft
  },
  slotLayouts: slotLayouts,
  splashScreens: splashScreens,
  teasers: teasers,
  templates: templates,
  topbar: topbar
};
;// CONCATENATED MODULE: ./brands/cbngo/indexes/banners.json
var cbngo_indexes_banners_namespaceObject = JSON.parse('{"k":[{"fullName":"BannerPodcastCBN.svg","name":"BannerAssineAgora","url":"/assets/cbngo/banners/BannerPodcastCBN.svg","height":"34","width":"139"},{"fullName":"BannerPodcastCBN.svg","name":"BannerPodcastCBN","url":"/assets/cbngo/banners/BannerPodcastCBN.svg","height":"34","width":"139","target":"blank"},{"fullName":"BannerAnuncie.svg","name":"BannerAnuncie","url":"/assets/cbngo/banners/BannerAnuncie.svg","height":"88","width":"250","target":"blank"},{"fullName":"BannerAnuncieAqui.svg","name":"BannerAnuncieAqui","url":"/assets/cbngo/banners/BannerAnuncieAqui.svg","height":"13","width":"96"}]}');
;// CONCATENATED MODULE: ./brands/cbngo/indexes/favicons.json
var cbngo_indexes_favicons_namespaceObject = JSON.parse('{"k":[{"fullName":"128x128.png","name":"128x128","url":"/assets/cbngo/favicons/128x128.png","height":"","width":""},{"fullName":"16x16.png","name":"16x16","url":"/assets/cbngo/favicons/16x16.png","height":"","width":""},{"fullName":"192x192.png","name":"192x192","url":"/assets/cbngo/favicons/192x192.png","height":"","width":""},{"fullName":"32x32.png","name":"32x32","url":"/assets/cbngo/favicons/32x32.png","height":"","width":""},{"fullName":"48x48.png","name":"48x48","url":"/assets/cbngo/favicons/48x48.png","height":"","width":""},{"fullName":"96x96.png","name":"96x96","url":"/assets/cbngo/favicons/96x96.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/cbngo/indexes/icons.json
var cbngo_indexes_icons_namespaceObject = JSON.parse('{"k":[{"fullName":"IcAbrirAzul.svg","name":"IcAbrirAzul","url":"/assets/cbngo/icons/IcAbrirAzul.svg","height":"16","width":"16"},{"fullName":"IcAbrirCinza.svg","name":"IcAbrirCinza","url":"/assets/cbngo/icons/IcAbrirCinza.svg","height":"16","width":"16"},{"fullName":"IcAudio.svg","name":"IcAudio","url":"/assets/cbngo/icons/IcAudio.svg","height":"13","width":"17"},{"fullName":"IcAudioDescricao.svg","name":"IcAudioDescricao","url":"/assets/cbngo/icons/IcAudioDescricao.svg","height":"13","width":"18"},{"fullName":"IcAudioMobile.svg","name":"IcAudioMobile","url":"/assets/cbngo/icons/IcAudioMobile.svg","height":"16","width":"20"},{"fullName":"IcAudiodescricaoCinza.svg","name":"IcAudiodescricaoCinza","url":"/assets/cbngo/icons/IcAudiodescricaoCinza.svg","height":"15","width":"19"},{"fullName":"IcAvancarCinza.svg","name":"IcAvancarCinza","url":"/assets/cbngo/icons/IcAvancarCinza.svg","height":"16","width":"8"},{"fullName":"IcBotaoFacebook.svg","name":"IcBotaoFacebook","url":"/assets/cbngo/icons/IcBotaoFacebook.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookBranco.svg","name":"IcBotaoFacebookBranco","url":"/assets/cbngo/icons/IcBotaoFacebookBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookCinza.svg","name":"IcBotaoFacebookCinza","url":"/assets/cbngo/icons/IcBotaoFacebookCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoFacebookPreto.svg","name":"IcBotaoFacebookPreto","url":"/assets/cbngo/icons/IcBotaoFacebookPreto.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagram.svg","name":"IcBotaoInstagram","url":"/assets/cbngo/icons/IcBotaoInstagram.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramBranco.svg","name":"IcBotaoInstagramBranco","url":"/assets/cbngo/icons/IcBotaoInstagramBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramCinza.svg","name":"IcBotaoInstagramCinza","url":"/assets/cbngo/icons/IcBotaoInstagramCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagramPreto.svg","name":"IcBotaoInstagramPreto","url":"/assets/cbngo/icons/IcBotaoInstagramPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoLinkedin.svg","name":"IcBotaoLinkedin","url":"/assets/cbngo/icons/IcBotaoLinkedin.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinBranco.svg","name":"IcBotaoLinkedinBranco","url":"/assets/cbngo/icons/IcBotaoLinkedinBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinCinza.svg","name":"IcBotaoLinkedinCinza","url":"/assets/cbngo/icons/IcBotaoLinkedinCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoLinkedinPreto.svg","name":"IcBotaoLinkedinPreto","url":"/assets/cbngo/icons/IcBotaoLinkedinPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoTwitter.svg","name":"IcBotaoTwitter","url":"/assets/cbngo/icons/IcBotaoTwitter.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterBranco.svg","name":"IcBotaoTwitterBranco","url":"/assets/cbngo/icons/IcBotaoTwitterBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterCinza.svg","name":"IcBotaoTwitterCinza","url":"/assets/cbngo/icons/IcBotaoTwitterCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoTwitterPreto.svg","name":"IcBotaoTwitterPreto","url":"/assets/cbngo/icons/IcBotaoTwitterPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoWhatsApp.svg","name":"IcBotaoWhatsApp","url":"/assets/cbngo/icons/IcBotaoWhatsApp.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppBranco.svg","name":"IcBotaoWhatsAppBranco","url":"/assets/cbngo/icons/IcBotaoWhatsAppBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppCinza.svg","name":"IcBotaoWhatsAppCinza","url":"/assets/cbngo/icons/IcBotaoWhatsAppCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoWhatsAppPreto.svg","name":"IcBotaoWhatsAppPreto","url":"/assets/cbngo/icons/IcBotaoWhatsAppPreto.svg","height":"33","width":"34"},{"fullName":"IcBuscar.svg","name":"IcBuscar","url":"/assets/cbngo/icons/IcBuscar.svg","height":"15","width":"15"},{"fullName":"IcChave.svg","name":"IcChave","url":"/assets/cbngo/icons/IcChave.svg","height":"14","width":"25"},{"fullName":"IcChaveAzul.svg","name":"IcChaveAzul","url":"/assets/cbngo/icons/IcChaveAzul.svg","height":"14","width":"25"},{"fullName":"IcCheckAzul.svg","name":"IcCheckAzul","url":"/assets/cbngo/icons/IcCheckAzul.svg","height":"10","width":"13"},{"fullName":"IcCidade.svg","name":"IcCidade","url":"/assets/cbngo/icons/IcCidade.svg","height":"17","width":"10"},{"fullName":"IcComunicado.svg","name":"IcComunicado","url":"/assets/cbngo/icons/IcComunicado.svg","height":"15","width":"18"},{"fullName":"IcEconomia.svg","name":"IcEconomia","url":"/assets/cbngo/icons/IcEconomia.svg","height":"16","width":"14"},{"fullName":"IcEdital.svg","name":"IcEdital","url":"/assets/cbngo/icons/IcEdital.svg","height":"16","width":"13"},{"fullName":"IcEspecial.svg","name":"IcEspecial","url":"/assets/cbngo/icons/IcEspecial.svg","height":"14","width":"14"},{"fullName":"IcEsporte.svg","name":"IcEsporte","url":"/assets/cbngo/icons/IcEsporte.svg","height":"16","width":"13"},{"fullName":"IcFecharBranco.svg","name":"IcFecharBranco","url":"/assets/cbngo/icons/IcFecharBranco.svg","height":"16","width":"13"},{"fullName":"IcFecharPreto.svg","name":"IcFecharPreto","url":"/assets/cbngo/icons/IcFecharPreto.svg","height":"15","width":"13"},{"fullName":"IcHamburger.svg","name":"IcHamburger","url":"/assets/cbngo/icons/IcHamburger.svg","height":"15","width":"22"},{"fullName":"IcHamburguerMobile.svg","name":"IcHamburguerMobile","url":"/assets/cbngo/icons/IcHamburguerMobile.svg","height":"13","width":"19"},{"fullName":"IcMagazine.svg","name":"IcMagazine","url":"/assets/cbngo/icons/IcMagazine.svg","height":"16","width":"14"},{"fullName":"IcMundo.svg","name":"IcMundo","url":"/assets/cbngo/icons/IcMundo.svg","height":"15","width":"15"},{"fullName":"IcOjc.svg","name":"IcOjc","url":"/assets/cbngo/icons/IcOjc.svg","height":"17","width":"24"},{"fullName":"IcOpiniao.svg","name":"IcOpiniao","url":"/assets/cbngo/icons/IcOpiniao.svg","height":"12","width":"13"},{"fullName":"IcOpiniaoGrande.svg","name":"IcOpiniaoGrande","url":"/assets/cbngo/icons/IcOpiniaoGrande.svg","height":"19","width":"22"},{"fullName":"IcPlayAudioMateria.svg","name":"IcPlayAudioMateria","url":"/assets/cbngo/icons/IcPlayAudioMateria.svg","height":"15","width":"15"},{"fullName":"IcPlayAudioMateriaAzul.svg","name":"IcPlayAudioMateriaAzul","url":"/assets/cbngo/icons/IcPlayAudioMateriaAzul.svg","height":"23","width":"22"},{"fullName":"IcPodcast.svg","name":"IcPodcast","url":"/assets/cbngo/icons/IcPodcast.svg","height":"19","width":"11"},{"fullName":"IcPolitica.svg","name":"IcPolitica","url":"/assets/cbngo/icons/IcPolitica.svg","height":"16","width":"16"},{"fullName":"IcRadio.svg","name":"IcRadio","url":"/assets/cbngo/icons/IcRadio.svg","height":"20","width":"18"},{"fullName":"IcSetaAbrir.svg","name":"IcSetaAbrir","url":"/assets/cbngo/icons/IcSetaAbrir.svg","height":"6","width":"9"},{"fullName":"IcSetaCidade.svg","name":"IcSetaCidade","url":"/assets/cbngo/icons/IcSetaCidade.svg","height":"9","width":"15"},{"fullName":"IcSetaEconomia.svg","name":"IcSetaEconomia","url":"/assets/cbngo/icons/IcSetaEconomia.svg","height":"9","width":"15"},{"fullName":"IcSetaEspecial.svg","name":"IcSetaEspecial","url":"/assets/cbngo/icons/IcSetaEspecial.svg","height":"9","width":"15"},{"fullName":"IcSetaEsporte.svg","name":"IcSetaEsporte","url":"/assets/cbngo/icons/IcSetaEsporte.svg","height":"9","width":"15"},{"fullName":"IcSetaFechar.svg","name":"IcSetaFechar","url":"/assets/cbngo/icons/IcSetaFechar.svg","height":"7","width":"10"},{"fullName":"IcSetaMagazine.svg","name":"IcSetaMagazine","url":"/assets/cbngo/icons/IcSetaMagazine.svg","height":"9","width":"15"},{"fullName":"IcSetaMundo.svg","name":"IcSetaMundo","url":"/assets/cbngo/icons/IcSetaMundo.svg","height":"9","width":"15"},{"fullName":"IcSetaOpiniao.svg","name":"IcSetaOpiniao","url":"/assets/cbngo/icons/IcSetaOpiniao.svg","height":"9","width":"15"},{"fullName":"IcSetaPolitica.svg","name":"IcSetaPolitica","url":"/assets/cbngo/icons/IcSetaPolitica.svg","height":"9","width":"15"},{"fullName":"IcSetaRosa.svg","name":"IcSetaRosa","url":"/assets/cbngo/icons/IcSetaRosa.svg","height":"9","width":"15"},{"fullName":"IcStories.svg","name":"IcStories","url":"/assets/cbngo/icons/IcStories.svg","height":"21","width":"17"},{"fullName":"IcVersaoDigital.svg","name":"IcVersaoDigital","url":"/assets/cbngo/icons/IcVersaoDigital.svg","height":"14","width":"16"},{"fullName":"IcVersaoDigitalCinza.svg","name":"IcVersaoDigitalCinza","url":"/assets/cbngo/icons/IcVersaoDigitalCinza.svg","height":"16","width":"18"},{"fullName":"IcVersaoDigitalCinzaClaro.svg","name":"IcVersaoDigitalCinzaClaro","url":"/assets/cbngo/icons/IcVersaoDigitalCinzaClaro.svg","height":"15","width":"16"},{"fullName":"IcVoltarCinza.svg","name":"IcVoltarCinza","url":"/assets/cbngo/icons/IcVoltarCinza.svg","height":"16","width":"8"},{"fullName":"IcWhatsAppCinza.svg","name":"IcWhatsAppCinza","url":"/assets/cbngo/icons/IcWhatsAppCinza.svg","height":"18","width":"17"}]}');
;// CONCATENATED MODULE: ./brands/cbngo/indexes/logos.json
var cbngo_indexes_logos_namespaceObject = JSON.parse('{"k":[{"fullName":"LogoCBNDesktop.svg","name":"LogoCBNDesktop","url":"/assets/cbngo/logos/LogoCBNDesktop.svg","height":"36","width":"284"},{"fullName":"LogoCBNMobile.svg","name":"LogoCBNMobile","url":"/assets/cbngo/logos/LogoCBNMobile.svg","height":"17","width":"138"}]}');
;// CONCATENATED MODULE: ./brands/cbngo/indexes/splashScreens.json
var cbngo_indexes_splashScreens_namespaceObject = JSON.parse('{"k":[{"fullName":"ipad.png","name":"ipad","url":"/assets/cbngo/splashScreens/ipad.png","height":"","width":""},{"fullName":"ipadpro1.png","name":"ipadpro1","url":"/assets/cbngo/splashScreens/ipadpro1.png","height":"","width":""},{"fullName":"ipadpro2.png","name":"ipadpro2","url":"/assets/cbngo/splashScreens/ipadpro2.png","height":"","width":""},{"fullName":"ipadpro3.png","name":"ipadpro3","url":"/assets/cbngo/splashScreens/ipadpro3.png","height":"","width":""},{"fullName":"iphone5.png","name":"iphone5","url":"/assets/cbngo/splashScreens/iphone5.png","height":"","width":""},{"fullName":"iphone6.png","name":"iphone6","url":"/assets/cbngo/splashScreens/iphone6.png","height":"","width":""},{"fullName":"iphoneplus.png","name":"iphoneplus","url":"/assets/cbngo/splashScreens/iphoneplus.png","height":"","width":""},{"fullName":"iphonex.png","name":"iphonex","url":"/assets/cbngo/splashScreens/iphonex.png","height":"","width":""},{"fullName":"iphonexsmax.png","name":"iphonexsmax","url":"/assets/cbngo/splashScreens/iphonexsmax.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/cbngo/assets/article.tsx


function article_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function article_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? article_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : article_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var article_BylineRightSectionComponent = function BylineRightSectionComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_OuvirMateriaButton, {
    icon: article_objectSpread({}, (0,hooks_useIcon/* useIcon */.b)('IcPlayAudioMateriaAzul')),
    onClick: function onClick(e) {
      return console.log('play audio materia', e);
    }
  });
};

var article_bylineProps = {
  author: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 700,
      letterSpacing: 0.4,
      lineHeight: '18px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  authorImage: {
    enabled: true,
    customCss: {
      mr: '$4'
    }
  },
  customCss: {
    align: ['column', 'left', 'middle'],
    mb: '$6',
    width: '100%',
    '@lg': {
      align: ['row', 'between', 'middle'],
      mb: '$8',
      width: '100$'
    }
  },
  customCssLeft: {
    align: ['row', 'left', 'middle'],
    width: '100%',
    '@lg': {
      width: 'calc(100% - 320px)'
    }
  },
  customCssContent: {
    width: 'calc(100% - 80px)',
    '@lg': {}
  },
  customCssRight: {
    align: ['row', 'between', 'middle'],
    mt: '$3',
    width: '100%',
    '@lg': {
      align: ['row', 'right', 'middle'],
      mt: '$0',
      width: '320px'
    }
  },
  publishedDate: {
    enabled: true,
    as: 'time',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 400,
      letterSpacing: 0.2,
      lineHeight: '16px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  rightSlot: {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(article_BylineRightSectionComponent, {})
  }
};
var article_article = {
  articleContainer: {
    customCss: {
      align: ['row', 'center', 'middle'],
      mt: '$8',
      width: '100%'
    }
  },
  articleContent: {
    customCss: {
      align: ['row', 'center', 'between'],
      my: '$4',
      width: 'calc(100% - calc($4 * 3))',
      maxWidth: '1278px'
    }
  },
  articleContentLeft: {
    customCss: {
      borderTop: '1px solid #E6E6E6',
      width: '100%',
      '@lg': {
        width: 'calc(100% - 332px)'
      }
    }
  },
  articleContentRight: {
    customCss: {
      background: '#707070',
      display: 'none',
      height: '600px',
      width: '300px',
      '@lg': {
        display: 'flex'
      }
    }
  },
  bylineProps: article_bylineProps,
  captionProps: {
    customCssWrap: {
      maxWidth: '960px',
      width: '100%',
      mb: '$4',
      mt: '$0'
    },
    customCss: {
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '12px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '14px',
      px: '$0',
      py: '$2',
      m: '$0',
      width: 'calc(100% - 32px)',
      '@lg': {
        fontSize: '14px',
        fontStyle: 'italic',
        lineHeight: '17px'
      }
    }
  },
  textProps: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '30px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      width: '100%',
      '@lg': {
        fontSize: '22px',
        fontWeight: 400,
        letterSpacing: 0.2,
        lineHeight: '35px'
      },
      'a': {
        color: '$primaryMain'
      }
    }
  },
  titleProps: {
    as: 'h1',
    customCss: {
      fontFamily: '$primary',
      fontSize: '25px',
      fontWeight: 700,
      lineHeight: '28px',
      mt: '$0',
      mb: '$3',
      '@lg': {
        fontSize: '60px',
        lineHeight: '70px',
        letterSpacing: 0.4
      },
      textAlign: 'left'
    }
  },
  subjectProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '25px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      },
      textAlign: 'left'
    }
  },
  subtitleProps: {
    as: 'h2',
    customCss: {
      color: '#4D4D4D',
      fontFamily: '$primary',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '19px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      '@lg': {
        fontSize: '22px',
        lineHeight: '35px',
        letterSpacing: 0.2,
        mb: '$6'
      }
    }
  },
  shareSection: {
    enabled: true,
    content: [{
      id: 'facebookShare',
      alt: 'Compartilhar no Facebook',
      icon: 'IcBotaoFacebook',
      href: 'https://www.facebook.com/sharer/sharer.php?u='
    }, {
      id: 'twitterShare',
      alt: 'Compartilhar no Twitter',
      icon: 'IcBotaoTwitter',
      href: 'https://twitter.com/intent/tweet?text='
    }, {
      id: 'whatsappShare',
      alt: 'Compartilhar no WhatsApp',
      icon: 'IcBotaoWhatsApp',
      href: 'https://api.whatsapp.com/send?text='
    }, {
      id: 'linkedinShare',
      alt: 'Compartilhar no LinkedIn',
      icon: 'IcBotaoLinkedin',
      href: 'https://www.linkedin.com/sharing/share-offsite/?url='
    }]
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/footer.tsx
var footer_currentDate = new Date();
var footer_currentYear = footer_currentDate.getFullYear();
var footer_FooterConfig = {
  css: {
    slotMiddleCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#262626',
      height: 'max-content',
      py: '$7',
      '@xl': {
        height: '82px'
      }
    },
    slotBottomCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#2E2E2E',
      height: '60px',
      '@xl': {
        display: 'none'
      }
    }
  },
  data: {
    leftText: 'Siga a cbngo Goiânia:',
    navMenu: [{
      id: 'expediente',
      title: 'Expediente',
      href: '/expediente'
    }, {
      id: 'faleConosco',
      title: 'Fale conosco',
      href: '/fale-conosco',
      target: '_self'
    }, {
      id: 'anuncieEmOCbnGoiania',
      title: 'Anuncie na cbngo Goiânia',
      href: 'https://uaiz.opopular.com.br/anuncie-radios'
    }],
    rightText: "Copyright 2001-".concat(footer_currentYear, ", J. C\xE2mara e Irm\xE3os S/A."),
    socialNetworks: [{
      id: 'facebookPage',
      href: 'https://www.facebook.com/cbngoiania/',
      icon: 'IcBotaoFacebook',
      title: 'Abrir O cbngo Goiânia no Facebook'
    }, {
      id: 'twitterPage',
      href: 'https://twitter.com/CBNGoiania',
      icon: 'IcBotaoTwitter',
      title: 'Abrir O cbngo Goiânia no Twitter'
    }]
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserRelated.tsx


function assets_teasers_TeaserRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_teasers_TeaserRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_teasers_TeaserRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_teasers_TeaserRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck





var teasers_TeaserRelated_handleUseIcon = function handleUseIcon(_ref) {
  var color = _ref.color,
      icon = _ref.icon;
  var iconConfig;
  var sectionSlug = capitalize_default()(color === null || color === void 0 ? void 0 : color.replace('Main', ''));

  if (sectionSlug) {
    var iconSlug = icon === null || icon === void 0 ? void 0 : icon.replace('Especial', sectionSlug);
    var iconParsed = (0,hooks_useIcon/* useIcon */.b)(iconSlug);

    if (iconParsed.src) {
      iconConfig = iconParsed;
    }
  }

  if (!iconConfig) {
    iconConfig = (0,hooks_useIcon/* useIcon */.b)(icon);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, assets_teasers_TeaserRelated_objectSpread({}, iconConfig));
};

var teasers_TeaserRelated_TeaserRelated = {
  css: {
    p: 0,
    background: 'none !important',
    width: '100%',
    '.TeaserImageContainer': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none !important'
    },
    '.TeaserSubtitle': {
      display: 'none !important'
    },
    'div.TeaserTitle': {
      align: ['row', 'left', 'top'],
      pb: '$0',
      mb: '$0',
      'a': {
        pb: '$0',
        mb: '$0',
        width: '100%'
      },
      'img': {
        pt: '6px',
        height: '15px'
      },
      'p.TeaserTitleText': {
        align: ['row', 'left', 'top'],
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '19px',
        ml: '$3',
        mb: '$0',
        mt: '$0',
        textAlign: 'left',
        width: 'calc(100% - $3)'
      }
    },
    '.TeaserWrap': {
      background: 'none !important',
      pb: '$0',
      mb: '$0'
    }
  },
  className: 'TeaserRelated',
  relatedIcon: {
    enabled: true,
    name: 'IcSetaEspecial',
    useIcon: teasers_TeaserRelated_handleUseIcon
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserBackground.ts

var teasers_TeaserBackground_TeaserBackground = {
  className: 'TeaserBackground',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '580px'
    },
    '.TeaserImage img': {
      height: '580px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        mb: '$2'
      }
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 90%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserBackgroundLg.ts

var teasers_TeaserBackgroundLg_TeaserBackgroundLg = {
  className: 'TeaserBackgroundLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '360px'
    },
    '.TeaserImage img': {
      height: '360px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 500px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 500px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserBackgroundRelated.ts

var teasers_TeaserBackgroundRelated_TeaserBackgroundRelated = {
  className: 'TeaserBackgroundRelated',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '780px'
    },
    '.TeaserImage img': {
      height: '680px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: 'black',
      position: 'static',
      pt: '$0',
      pb: '$4',
      px: '$4',
      my: '$0',
      'div.Teaser': {
        mb: '$3'
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 60%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserBackgroundRelatedLg.ts

var teasers_TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg = {
  className: 'TeaserBackgroundRelatedLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '536px'
    },
    '.TeaserImage img': {
      height: '536px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: '#282828',
      position: 'absolute',
      height: '536px',
      right: '0px',
      pt: '$0',
      pb: '$4',
      my: '$0',
      width: '328px',
      'div.Teaser': {
        background: 'transparent',
        px: '$8',
        mb: '$0'
      },
      '.TeaserImage': {
        display: 'none'
      },
      'p.TeaserTitleText': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        m: '$0 !important',
        p: '$0 !important',
        width: '100% !important'
      },
      '.TeaserWrap': {
        background: 'none',
        position: 'static',
        mt: '$0'
      },
      '@lg': {
        align: ['column', 'center', 'evenly'],
        '.TeaserTitle img': {
          display: 'none'
        }
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 360px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 360px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserChargeLg.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserChargeLg_TeaserChargeLg = {
  css: {
    flexDirection: 'column-reverse',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      my: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 500,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      width: '100%'
    }
  },
  className: 'TeaserChargeLg',
  imageDerivative: 'default',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserChargeMd.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserChargeMd_TeaserChargeMd = {
  css: {
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      mt: '$4',
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '25px',
      fontWeight: 600,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      width: '100%'
    }
  },
  className: 'TeaserChargeMd',
  imageDerivative: 'default',
  imageVariant: 'top',
  subjectVariant: 'filled',
  subjectColor: 'colunistaMain',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserChargeSm.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserChargeSm_TeaserChargeSm = {
  css: {
    // flexDirection: 'column',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      mt: '$4',
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 400,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '25px',
      width: '100%'
    }
  },
  className: 'TeaserChargeSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectVariant: 'filled',
  subjectColor: 'colunistaMain',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserColumnist.ts
var teasers_TeaserColumnist_TeaserColumnist = {
  css: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderRadius: '$alternative',
    p: '$0',
    pt: '$0',
    mb: '$4',
    '.TeaserImage img': {
      borderRadius: '$circle'
    },
    '.TeaserImageContainer': {
      borderRadius: '$circle',
      maxWidth: '80px'
    },
    '.TeaserWrap': {
      pb: '$4',
      pl: '$4',
      pr: '$4'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubject': {
      width: '100%'
    },
    '.TeaserSubjectText': {
      textAlign: 'left',
      color: '#4C362B',
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 500,
      mb: '$1'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      width: '100%'
    },
    '.TeaserTitleText': {
      fontSize: '16px',
      fontWeight: 400
    }
  },
  className: 'TeaserColumnist',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subjectTextVariant: 'subject-default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-sm'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserEditais.ts
var TeaserEditais_TeaserEditais = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserEditais'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserEditorial.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserEditorial_TeaserEditorial = {
  css: {
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: '220px',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 220px - $3)'
    }
  },
  className: 'TeaserEditorial',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserEditorialSm.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var TeaserEditorialSm_TeaserEditorialSm = {
  css: {
    padding: '$0',
    mb: '$8',
    minHeight: '80px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(88px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserEditorialSm',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserHeadlineSm.ts


function assets_teasers_TeaserHeadlineSm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_teasers_TeaserHeadlineSm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_teasers_TeaserHeadlineSm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_teasers_TeaserHeadlineSm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var teasers_TeaserHeadlineSm_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var teasers_TeaserHeadlineSm_TeaserHeadlineSm = assets_teasers_TeaserHeadlineSm_objectSpread(assets_teasers_TeaserHeadlineSm_objectSpread({}, teasers_TeaserHeadlineSm_T.TeaserHeadlineSm), {}, {
  css: {
    p: '$0',
    mb: '$6',
    textAlign: 'center',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineSm',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-3xl'
});
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserHeadlineLg.ts


var assets_teasers_TeaserHeadlineLg_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var teasers_TeaserHeadlineLg_TeaserHeadlineLg = {
  css: {
    textAlign: 'center',
    my: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      align: ['row', 'center', 'top'],
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '18px',
          lineHeight: '23px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      maxWidth: '980px',
      mb: '$8'
    },
    '.TeaserTitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineLg',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-6xl'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserImageLeft.ts

var teasers_TeaserImageLeft_TeaserImageLeft = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    },
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      textAlign: 'center',
      '.TeaserImageContainer': {
        backgroundColor: 'transparent',
        width: 'auto',
        'img': {
          pr: '$3'
        },
        '@lg': {
          maxWidth: '150px'
        }
      },
      '.TeaserSubjectText': {
        alignItems: 'center',
        align: ['column', 'center', 'top'],
        textTransform: 'uppercase',
        fontSize: '14px'
      },
      '.TeaserSubtitleText': {
        display: 'none'
      },
      '.TeaserSubtitle': {
        align: ['row', 'left', 'middle']
      },
      '.TeaserTitle': {
        my: '$2'
      },
      '.TeaserTitleText': {
        align: ['column', 'left', 'top'],
        color: 'black',
        fontSize: '26px',
        fontWeight: 400,
        letterSpacing: '0.2px',
        lineHeight: '23px',
        width: '100%'
      },
      '.TeaserWrap': {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0px !important',
        width: '100%',
        '.TeaserRelated': {
          'div.Teaser': {
            mb: '$4'
          },
          'div.TeaserTitle': {
            'p.TeaserTitleText': {
              fontSize: '16px',
              lineHeight: '19px',
              letterSpacing: '0.2px'
            }
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: teasers_TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserImageLeftSq.ts
var TeaserImageLeftSq_TeaserImageLeftSq = {
  css: {
    padding: '$0',
    mb: '$3',
    minHeight: '75px',
    width: '100%',
    '@lg': {
      mb: '$3'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(75px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '75px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 75px - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeftSq',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserImageLeftSm.ts
var teasers_TeaserImageLeftSm_TeaserImageLeftSm = {
  css: {
    padding: '$0',
    mb: '$6',
    minHeight: '88px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(120px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 88px - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeftSm',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserImageLeftLg.ts

var teasers_TeaserImageLeftLg_TeaserImageLeftLg = {
  css: {
    padding: '$0',
    mb: '$6',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      mb: '$3'
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '36px',
      lineHeight: '43px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      minWidth: 'calc(50% - $3)',
      width: '100%',
      '.TeaserRelated': {
        flexFlow: 'column',
        width: '100%',
        'div.Teaser': {
          mb: '$4',
          width: 'auto'
        },
        'div.TeaserTitle': {
          'p.TeaserTitleText': {
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.2px'
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: teasers_TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserNoImage.ts

var teasers_TeaserNoImage_TeaserNoImage = {
  css: {
    p: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      align: ['column', 'left', 'top'],
      display: 'none',
      mb: '$4'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      mb: '$4'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserNoImage',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserCard.ts
var teasers_TeaserCard_TeaserCard = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCard',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserCardBold.ts
var TeaserCardBold_TeaserCardBold = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0',
      color: '#4D4D4D'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCardBold',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserImageTop.ts

var teasers_TeaserImageTop_TeaserImageTop = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserImageTopLg.ts

var teasers_TeaserImageTopLg_TeaserImageTopLg = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserImageBottom.ts
var teasers_TeaserImageBottom_TeaserImageBottom = {
  css: {
    mb: '$3',
    padding: '$0',
    width: '100%',
    '.TeaserSubtitle': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$3'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase'
    },
    '.TeaserTitle': {
      mb: '$3'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    }
  },
  className: 'TeaserImageBottom',
  imageDerivative: '3x1',
  imageVariant: 'bottom',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subtitleVariant: 'subtitle-default',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  titleVariant: 'newstitle-5xl'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserImageLeftXl.ts
var teasers_TeaserImageLeftXl_TeaserImageLeftXl = {
  css: {
    padding: '$0',
    mb: '$5',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserMostRead.ts
var teasers_TeaserMostRead_TeaserMostRead = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      borderRadius: '50%',
      height: '100%',
      width: '30px',
      pr: '$2'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserMostReadFixed.ts
var teasers_TeaserMostReadFixed_TeaserMostReadFixed = {
  css: {
    align: ['row', 'center', 'middle'],
    borderBottom: '1px solid #E6E6E6',
    borderLeft: '8px solid $basicWhite',
    p: '$0',
    minHeight: '92px',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      ml: '$4',
      mr: '$4',
      height: '100%',
      width: 'max-content'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '$widget5',
      fontWeight: '$widget5',
      lineHeight: '$widget5'
    },
    '.TeaserWrap': {
      mr: '$4',
      width: 'calc(100% - $4)'
    },
    '&:last-child': {
      borderBottom: 'unset'
    },
    '&[data-selected=true]': {
      borderLeft: '8px solid $primaryMain'
    },
    '&[data-viewed=true]': {
      borderLeft: '8px solid #E7E7E7'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserPodcast.ts
var teasers_TeaserPodcast_TeaserPodcast = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$2',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      width: '160px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 5%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '124px',
      width: '124px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserTitleText': {
      display: 'none'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserRadio.ts
var teasers_TeaserRadio_TeaserRadio = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  customLinkProps: {
    bypass: 'true'
  },
  css: {
    backgroundColor: 'none',
    cursor: 'pointer',
    p: '$0',
    m: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      mx: '$4',
      width: '100px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 25%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '100px',
      width: '100px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserSubtitleText': {
      color: '#c6c6c6',
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: 400,
      mx: '$2',
      mb: '$2',
      textAlign: 'center',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    },
    '.TeaserTitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserTitleText': {
      color: '#7c7c7c',
      fontSize: '18px',
      letterSpacing: '0.4px',
      lineHeight: '25px',
      fontWeight: 500,
      mx: '$2',
      mb: '$1',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserStories.ts
var teasers_TeaserStories_TeaserStories = {
  className: 'TeaserStories',
  imageDerivative: '1x3',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$4',
    width: 'calc(100% - $4)',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$0'
    },
    '.TeaserImage img': {
      borderRadius: '10px',
      height: '354px',
      width: '200px',
      objectFit: 'cover'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '19px',
      fontWeight: 500,
      px: '$4',
      mb: '$2',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      align: ['row', 'left', 'bottom']
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'bottom'],
      color: '$basicWhite',
      fontSize: '18px',
      letterSpacing: '0.2px',
      lineHeight: '23px',
      fontWeight: 400,
      px: '$4',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      'a': {
        textAlign: 'left'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      background: 'linear-gradient(rgba(0, 0, 0, 0) 50%, rgb(0, 0, 0) 100%)',
      borderRadius: '10px',
      position: 'absolute',
      height: '100%',
      width: '100%'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserVideoFeatured.ts

var TeaserVideoFeatured_TeaserVideoFeatured = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserVideoFeatured',
  imageDerivative: '2x1',
  imageVariant: 'top',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserVideoFeatSm.ts

var TeaserVideoFeatSm_TeaserVideoFeatSm = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserVideoFeatSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserVideoFeatMd.ts

var TeaserVideoFeatMd_TeaserVideoFeatMd = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        fontWeight: 600,
        letterSpacing: '0.2px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserVideoFeatMd',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserVideoFeatLg.ts

var TeaserVideoFeatLg_TeaserVideoFeatLg = {
  className: 'TeaserVideoFeatLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'default',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    p: '$0',
    mb: '$6',
    ml: '-$3',
    mr: '-$3',
    width: 'calc(100% + $6)',
    '@lg': {
      ml: '$0',
      mr: '$0'
    },
    '.TeaserImage': {
      height: '535px'
    },
    '.TeaserImage img': {
      height: '535px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto',
      width: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '12px',
      ml: '$4',
      mb: '$4',
      textTransform: 'uppercase',
      '@lg': {
        fontSize: '16px',
        ml: '$10',
        mb: '$4'
      }
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      ml: '$4',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 400,
        ml: '$10',
        mb: '$10'
      }
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: '$basicWhite',
      fontSize: '28px',
      lineHeight: '33px',
      fontWeight: 700,
      ml: '$4',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        fontSize: '43px',
        lineHeight: '50px',
        fontWeight: 700,
        ml: '$10',
        mb: '$4'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 24px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 24px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserVideoLeft.ts
var teasers_TeaserVideoLeft_TeaserVideoLeft = {
  css: {
    backgroundColor: 'transparent',
    padding: '$0',
    mb: '$3',
    width: '100%',
    '@lg': {
      ml: '$8',
      mb: '$8',
      width: 'calc(100% - $8)'
    },
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubtitle': {
      display: 'none',
      '@lg': {
        display: 'flex'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      color: '#989898',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 400,
      '@lg': {
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: 400
      }
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      ml: '$3',
      maxWidth: 'calc(50% - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers/TeaserVideoTop.ts
var teasers_TeaserVideoTop_TeaserVideoTop = {
  css: {
    backgroundColor: 'transparent',
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      color: '#989898',
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$0'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '25px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '2x1',
  imageVariant: 'top',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/teasers.ts




































var assets_teasers_teasers = {
  TeaserBackground: teasers_TeaserBackground_TeaserBackground,
  TeaserBackgroundLg: teasers_TeaserBackgroundLg_TeaserBackgroundLg,
  TeaserBackgroundRelatedLg: teasers_TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg,
  TeaserBackgroundRelated: teasers_TeaserBackgroundRelated_TeaserBackgroundRelated,
  TeaserChargeLg: TeaserChargeLg_TeaserChargeLg,
  TeaserChargeMd: TeaserChargeMd_TeaserChargeMd,
  TeaserChargeSm: TeaserChargeSm_TeaserChargeSm,
  TeaserEditais: TeaserEditais_TeaserEditais,
  TeaserEditorial: TeaserEditorial_TeaserEditorial,
  TeaserEditorialSm: TeaserEditorialSm_TeaserEditorialSm,
  TeaserImageBottom: teasers_TeaserImageBottom_TeaserImageBottom,
  TeaserImageLeft: teasers_TeaserImageLeft_TeaserImageLeft,
  TeaserImageLeftSq: TeaserImageLeftSq_TeaserImageLeftSq,
  TeaserImageLeftSm: teasers_TeaserImageLeftSm_TeaserImageLeftSm,
  TeaserImageLeftLg: teasers_TeaserImageLeftLg_TeaserImageLeftLg,
  TeaserImageLeftXl: teasers_TeaserImageLeftXl_TeaserImageLeftXl,
  TeaserImageTop: teasers_TeaserImageTop_TeaserImageTop,
  TeaserImageTopLg: teasers_TeaserImageTopLg_TeaserImageTopLg,
  TeaserCard: teasers_TeaserCard_TeaserCard,
  TeaserCardBold: TeaserCardBold_TeaserCardBold,
  TeaserColumnist: teasers_TeaserColumnist_TeaserColumnist,
  TeaserRelated: teasers_TeaserRelated_TeaserRelated,
  TeaserHeadlineSm: teasers_TeaserHeadlineSm_TeaserHeadlineSm,
  TeaserHeadlineLg: teasers_TeaserHeadlineLg_TeaserHeadlineLg,
  TeaserNoImage: teasers_TeaserNoImage_TeaserNoImage,
  TeaserMostRead: teasers_TeaserMostRead_TeaserMostRead,
  TeaserMostReadFixed: teasers_TeaserMostReadFixed_TeaserMostReadFixed,
  TeaserPodcast: teasers_TeaserPodcast_TeaserPodcast,
  TeaserRadio: teasers_TeaserRadio_TeaserRadio,
  TeaserStories: teasers_TeaserStories_TeaserStories,
  TeaserVideoFeatured: TeaserVideoFeatured_TeaserVideoFeatured,
  TeaserVideoFeatSm: TeaserVideoFeatSm_TeaserVideoFeatSm,
  TeaserVideoFeatMd: TeaserVideoFeatMd_TeaserVideoFeatMd,
  TeaserVideoFeatLg: TeaserVideoFeatLg_TeaserVideoFeatLg,
  TeaserVideoLeft: teasers_TeaserVideoLeft_TeaserVideoLeft,
  TeaserVideoTop: teasers_TeaserVideoTop_TeaserVideoTop
};
var assets_teasers_teasersArray = Object.keys(assets_teasers_teasers);

;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutCharge.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutCharge = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserChargeSm, assets_teasers_teasers.TeaserChargeSm],
        '0:1': [assets_teasers_teasers.TeaserChargeLg, assets_teasers_teasers.TeaserChargeLg],
        '0:2': [assets_teasers_teasers.TeaserChargeMd, assets_teasers_teasers.TeaserChargeMd],
        '0:3': [assets_teasers_teasers.TeaserChargeMd, assets_teasers_teasers.TeaserChargeMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/utils.ts


function layouts_utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function layouts_utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? layouts_utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : layouts_utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var utils_addRelativeWidthToTeaser = function addRelativeWidthToTeaser(teaser, value) {
  var _teaser$css;

  return layouts_utils_objectSpread(layouts_utils_objectSpread({}, teaser), {}, {
    css: layouts_utils_objectSpread(layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : teaser.css), {}, {
      '@lg': layouts_utils_objectSpread(layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : (_teaser$css = teaser.css) === null || _teaser$css === void 0 ? void 0 : _teaser$css['@lg']), {}, {
        width: value
      })
    })
  });
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutColumnist.tsx
// @ts-nocheck







var layouts_LayoutColumnist_TeaserColumnist = utils_addRelativeWidthToTeaser(teasers_teasers.TeaserColumnist, '100%');

var LayoutColumnist_renderSlotMobileWrapComponent = function renderSlotMobileWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: data
  });
};

var LayoutColumnist_renderSlotDesktopWrapComponent = function renderSlotDesktopWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel .slider-wrapper': {
          width: 'calc(100% - 64px)'
        }
      },
      controlDots: {
        mt: '$2',
        mb: '$0',
        visibility: 'hidden'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    renderArrowNext: function renderArrowNext(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcAvancarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            top: 'calc(50% - 20px)',
            right: '0px'
          }
        }
      });
    },
    renderArrowPrev: function renderArrowPrev(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcVoltarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            bottom: 'calc(50% - 10px)',
            left: '0px'
          }
        }
      });
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    children: map_default()(chunk_default()(data, 4), function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'middle'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'left', 'middle'],
              minWidth: '25%',
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

var LayoutColumnist_LayoutColumnist = {
  wrapperContent: {
    enabled: true,
    component: LayoutColumnist_renderSlotMobileWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        pt: '$3',
        pb: '$5',
        maxWidth: 'calc(100% - $2)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [layouts_LayoutColumnist_TeaserColumnist, layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [layouts_LayoutColumnist_TeaserColumnist, layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [layouts_LayoutColumnist_TeaserColumnist, layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [layouts_LayoutColumnist_TeaserColumnist, layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
var LayoutColumnist_LayoutColumnistDesktop = {
  wrapperContent: {
    enabled: true,
    component: LayoutColumnist_renderSlotDesktopWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        py: '$6',
        maxWidth: 'calc(100% - 180px)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: 'calc(100% - $12)'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [layouts_LayoutColumnist_TeaserColumnist, layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [layouts_LayoutColumnist_TeaserColumnist, layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [layouts_LayoutColumnist_TeaserColumnist, layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [layouts_LayoutColumnist_TeaserColumnist, layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutColumnistSideBox.tsx
// @ts-nocheck

var LayoutColumnistSideBox_LayoutColumnistSideBox = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnContent': {
        pt: '$6',
        pb: '$6',
        maxWidth: 'calc(100% - $2)'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [teasers_teasers.TeaserColumnist, teasers_teasers.TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutDefault.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutDefault_LayoutDefault = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft],
        '0': [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft],
        '1': [assets_teasers_teasers.TeaserHeadlineSm, assets_teasers_teasers.TeaserImageLeftXl]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageTopLg, assets_teasers_teasers.TeaserImageLeftLg]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserNoImage, assets_teasers_teasers.TeaserNoImage]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageTopLg, assets_teasers_teasers.TeaserImageLeft],
        '0:1': [assets_teasers_teasers.TeaserImageTopLg, assets_teasers_teasers.TeaserImageTopLg],
        '1': [assets_teasers_teasers.TeaserImageTopLg, assets_teasers_teasers.TeaserImageTopLg]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft],
        '0:1': [assets_teasers_teasers.TeaserImageTopLg, assets_teasers_teasers.TeaserImageTopLg],
        '1': [assets_teasers_teasers.TeaserImageTopLg, assets_teasers_teasers.TeaserImageTopLg]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft],
        '0:1': [assets_teasers_teasers.TeaserImageLeft, assets_teasers_teasers.TeaserImageTop],
        '1': [assets_teasers_teasers.TeaserImageTop, assets_teasers_teasers.TeaserImageTop]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft],
        '0:1': [assets_teasers_teasers.TeaserImageLeft, assets_teasers_teasers.TeaserImageLeft],
        '1': [assets_teasers_teasers.TeaserImageTop, assets_teasers_teasers.TeaserImageTop]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageTop, assets_teasers_teasers.TeaserImageTop]
      }
    },
    TemplateVideos: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutEditais.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutEditais = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserEditais, assets_teasers_teasers.TeaserEditais]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserEditais, assets_teasers_teasers.TeaserEditais]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutEditorial.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutEditorial = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserEditorialSm, assets_teasers_teasers.TeaserEditorial],
        '0:1': [assets_teasers_teasers.TeaserImageTopLg, assets_teasers_teasers.TeaserImageLeftLg]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutFeatured.ts


function layouts_LayoutFeatured_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function layouts_LayoutFeatured_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? layouts_LayoutFeatured_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : layouts_LayoutFeatured_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// MancheteComFoto
var LayoutFeatured_LayoutFeatured = layouts_LayoutFeatured_objectSpread(layouts_LayoutFeatured_objectSpread({}, LayoutDefault_LayoutDefault), {}, {
  slotConfig: layouts_LayoutFeatured_objectSpread(layouts_LayoutFeatured_objectSpread({}, LayoutDefault_LayoutDefault === null || LayoutDefault_LayoutDefault === void 0 ? void 0 : LayoutDefault_LayoutDefault.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSq, assets_teasers_teasers.TeaserImageLeft],
        '0:1': [assets_teasers_teasers.TeaserImageLeft, assets_teasers_teasers.TeaserImageLeftLg],
        '1': [assets_teasers_teasers.TeaserImageLeft, assets_teasers_teasers.TeaserImageLeftLg]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserBackground, assets_teasers_teasers.TeaserBackgroundLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutFeaturedImage.ts


function layouts_LayoutFeaturedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function layouts_LayoutFeaturedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? layouts_LayoutFeaturedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : layouts_LayoutFeaturedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var LayoutFeaturedImage_LayoutFeaturedImage = layouts_LayoutFeaturedImage_objectSpread(layouts_LayoutFeaturedImage_objectSpread({}, LayoutFeatured_LayoutFeatured), {}, {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: layouts_LayoutFeaturedImage_objectSpread(layouts_LayoutFeaturedImage_objectSpread({}, LayoutFeatured_LayoutFeatured === null || LayoutFeatured_LayoutFeatured === void 0 ? void 0 : LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserBackgroundRelated, assets_teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutFeaturedNoImage.ts


function layouts_LayoutFeaturedNoImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function layouts_LayoutFeaturedNoImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? layouts_LayoutFeaturedNoImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : layouts_LayoutFeaturedNoImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var LayoutFeaturedNoImage_LayoutFeaturedNoImage = layouts_LayoutFeaturedNoImage_objectSpread(layouts_LayoutFeaturedNoImage_objectSpread({}, LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: layouts_LayoutFeaturedNoImage_objectSpread(layouts_LayoutFeaturedNoImage_objectSpread({}, LayoutFeatured_LayoutFeatured === null || LayoutFeatured_LayoutFeatured === void 0 ? void 0 : LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, assets_teasers_teasers.TeaserImageLeft],
        '0:1': [assets_teasers_teasers.TeaserHeadlineSm, assets_teasers_teasers.TeaserHeadlineLg],
        '1': [assets_teasers_teasers.TeaserHeadlineSm, assets_teasers_teasers.TeaserHeadlineLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutFeaturedRelated.ts


function layouts_LayoutFeaturedRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function layouts_LayoutFeaturedRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? layouts_LayoutFeaturedRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : layouts_LayoutFeaturedRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// SuperManchete
var LayoutFeaturedRelated_LayoutFeaturedRelated = layouts_LayoutFeaturedRelated_objectSpread(layouts_LayoutFeaturedRelated_objectSpread({}, LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: layouts_LayoutFeaturedRelated_objectSpread(layouts_LayoutFeaturedRelated_objectSpread({}, LayoutFeatured_LayoutFeatured === null || LayoutFeatured_LayoutFeatured === void 0 ? void 0 : LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    TemplateSuperManchete: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserBackgroundRelated, assets_teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutGrid3.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var layouts_LayoutGrid3_TeaserCard = utils_addRelativeWidthToTeaser(assets_teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 2)) / 3)');
var layouts_LayoutGrid3_TeaserImageTop = utils_addRelativeWidthToTeaser(assets_teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var LayoutGrid3_LayoutGrid3 = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard],
        '0:1': [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard],
        '0:1': [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template100100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard],
        '0:1': [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGrid3_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageTop, layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageTop, layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageTop, layouts_LayoutGrid3_TeaserCard]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutGrid4.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var layouts_LayoutGrid4_TeaserCard = utils_addRelativeWidthToTeaser(assets_teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 3)) / 4)');
var LayoutGrid4_LayoutGrid4 = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserCard, layouts_LayoutGrid4_TeaserCard]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSq, assets_teasers_teasers.TeaserImageLeftSq],
        '0:1': [assets_teasers_teasers.TeaserImageLeftSq, assets_teasers_teasers.TeaserImageLeftSq]
      }
    },
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserColumnist, assets_teasers_teasers.TeaserColumnist],
        '0:1': [assets_teasers_teasers.TeaserColumnist, assets_teasers_teasers.TeaserColumnist]
      }
    },
    TemplateSideBoxNoTitle: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSq, assets_teasers_teasers.TeaserImageLeftSm],
        '0:1': [assets_teasers_teasers.TeaserImageLeftSq, assets_teasers_teasers.TeaserImageLeftSm],
        '1': [assets_teasers_teasers.TeaserImageTop, assets_teasers_teasers.TeaserImageTop]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutGridInfocom.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var LayoutGridInfocom_TeaserCardBold = utils_addRelativeWidthToTeaser(assets_teasers_teasers.TeaserCardBold, 'calc(calc(100% - calc(24px * 2)) / 3)');
var LayoutGridInfocom_TeaserImageTop = utils_addRelativeWidthToTeaser(assets_teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var LayoutGridInfocom = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold],
        '0:1': [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold],
        '0:1': [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template100100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold],
        '0:1': [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageLeftSm, LayoutGridInfocom_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserImageTop, LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserImageTop, LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserImageTop, LayoutGridInfocom_TeaserCardBold]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutPodcast.tsx
// @ts-nocheck




var LayoutPodcast_renderWrapComponent = function renderWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '200px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

var LayoutPodcast_LayoutPodcast = {
  wrapperContent: {
    enabled: true,
    component: LayoutPodcast_renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxPodcast: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserPodcast, assets_teasers_teasers.TeaserPodcast]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutRadio.tsx
// @ts-nocheck

var LayoutRadio_LayoutRadio = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      px: '$0',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxRadio: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserRadio, assets_teasers_teasers.TeaserRadio]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutSearch.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutSearch_LayoutSearch = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserEditorialSm, assets_teasers_teasers.TeaserEditorial]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutStories.tsx
// @ts-nocheck

var LayoutStories_LayoutStories = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxStories: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserStories, assets_teasers_teasers.TeaserStories]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutMostRead.ts
// eslint-disable-next-line
// @ts-nocheck

var LayoutMostRead_LayoutMostRead = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserMostRead, assets_teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserMostRead, assets_teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBoxFixed: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserMostReadFixed, assets_teasers_teasers.TeaserMostReadFixed]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserMostReadFixed, assets_teasers_teasers.TeaserMostReadFixed]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutVideoFeatured.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutVideoFeatured = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserVideoFeatured, assets_teasers_teasers.TeaserVideoFeatSm],
        '0:1': [assets_teasers_teasers.TeaserVideoFeatLg, assets_teasers_teasers.TeaserVideoFeatLg],
        '0:2': [assets_teasers_teasers.TeaserVideoFeatured, assets_teasers_teasers.TeaserVideoFeatMd],
        '0:3': [assets_teasers_teasers.TeaserVideoFeatured, assets_teasers_teasers.TeaserVideoFeatMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutVideoHome.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var layouts_LayoutVideoHome_TeaserVideoTop = utils_addRelativeWidthToTeaser(assets_teasers_teasers.TeaserVideoTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var LayoutVideoHome_LayoutVideoHome = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        width: '100%' // columnGap: '24px'

      }
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserVideoTop, layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoTop],
        '2': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoTop],
        '0:2': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoLeft]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserVideoTop, layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoTop],
        '2': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoTop],
        '0:2': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoLeft]
      },
      slotRight: {
        "default": [assets_teasers_teasers.TeaserVideoTop, layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoTop],
        '2': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoTop],
        '0:2': [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts/LayoutVideoLive.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutVideoLive_LayoutVideoLive = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [assets_teasers_teasers.TeaserVideoTop, assets_teasers_teasers.TeaserVideoLeft]
      }
    },
    TemplateVideoLive: {
      slotLeft: {
        "default": [assets_teasers_teasers.TeaserMostRead, assets_teasers_teasers.TeaserMostRead],
        '0:1': [assets_teasers_teasers.TeaserMostRead, assets_teasers_teasers.TeaserMostRead]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/layouts.ts

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck























var layouts_slotLayouts = (0,defineProperty/* default */.Z)({
  LayoutCharge: LayoutCharge,
  LayoutColumnist: LayoutColumnist_LayoutColumnist,
  LayoutColumnistDesktop: LayoutColumnist_LayoutColumnistDesktop,
  LayoutColumnistSideBox: LayoutColumnistSideBox_LayoutColumnistSideBox,
  LayoutDefault: LayoutDefault_LayoutDefault,
  LayoutEditais: LayoutEditais,
  LayoutEditorial: LayoutEditorial,
  LayoutFeatured: LayoutFeatured_LayoutFeatured,
  LayoutFeaturedImage: LayoutFeaturedImage_LayoutFeaturedImage,
  LayoutFeaturedNoImage: LayoutFeaturedNoImage_LayoutFeaturedNoImage,
  LayoutFeaturedRelated: LayoutFeaturedRelated_LayoutFeaturedRelated,
  LayoutGrid3: LayoutGrid3_LayoutGrid3,
  LayoutGrid4: LayoutGrid4_LayoutGrid4,
  LayoutGridInfocom: LayoutGridInfocom,
  LayoutPodcast: LayoutPodcast_LayoutPodcast,
  LayoutRadio: LayoutRadio_LayoutRadio,
  LayoutSearch: LayoutSearch_LayoutSearch,
  LayoutStories: LayoutStories_LayoutStories,
  LayoutMostRead: LayoutMostRead_LayoutMostRead,
  LayoutVideoFeatured: LayoutVideoFeatured,
  LayoutVideoHome: LayoutVideoHome_LayoutVideoHome,
  LayoutVideoLive: LayoutVideoLive_LayoutVideoLive
}, "LayoutVideoFeatured", LayoutVideoFeatured);

var layouts_slotLayoutsArray = Object.keys(layouts_slotLayouts);

;// CONCATENATED MODULE: ./brands/cbngo/assets/menus.tsx
var menus_accordionStyle = {
  accordionItemGroup: {
    accordionContent: {
      backgroundColor: '#EAEAEA',
      pl: '$8',
      pr: '$18'
    },
    accordionTitle: {
      title: {
        fontFamily: '$primary',
        fontSize: '$caption5',
        fontWeight: '$caption5',
        lineHeight: '$caption5',
        m: '0px',
        py: '$2',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px'
      },
      iconButton: {
        height: '24px',
        width: '24px'
      }
    }
  }
};
var menus_sideMenuLeft = {
  sectionHeader: {
    enabled: true,
    subscriberInfo: {
      enabled: false,
      amountLeft: 0
    },
    advertiseSection: {
      enabled: true,
      color: '#938783',
      href: '/podcasts',
      target: '_blank'
    },
    variants: {
      anonymous: {
        logo: {
          name: 'BannerAnuncie',
          href: 'https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      DEGUSTADOR: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      ASSINANTE: {
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      advertiser_subscriber: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      club_subscriber: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      }
    }
  },
  sectionContent: {
    enabled: true,
    searchInput: {
      enabled: true
    },
    advertiseSection: {
      enabled: true,
      color: '#938783',
      href: '/podcasts',
      target: '_blank'
    },
    serviceButtons: {
      enabled: false,
      items: []
    },
    navigationAccordions: {
      enabled: true,
      css: menus_accordionStyle,
      items: [{
        id: 'sac',
        title: 'SAC',
        items: [{
          id: '1',
          title: 'Fale Conosco',
          href: '/fale-conosco'
        }, {
          id: '2',
          title: 'Expediente',
          href: '/expediente'
        }, {
          id: '3',
          title: 'Política de privacidade',
          href: '/politica-de-privacidade'
        }, {
          id: '4',
          title: 'Termos de uso',
          href: '/termos-de-uso'
        }],
        css: menus_accordionStyle
      }, {
        id: 'grupoojc',
        title: 'Grupo Jaime Câmara',
        items: [// FIXME rm classi
        {
          id: '1',
          title: 'Classi',
          href: 'https://www.classi.com.br'
        }, {
          id: '2',
          title: 'Jornal Daqui',
          href: 'https://daqui.opopular.com.br'
        }, {
          id: '3',
          title: 'Jornal O Popular',
          href: 'https://opopular.com.br/'
        }, {
          id: '4',
          title: 'Jornal do Tocantins',
          href: 'https://www.jornaldotocantins.com.br'
        }],
        css: menus_accordionStyle
      }]
    }
  },
  sectionFooter: {
    enabled: true,
    advertiseSection: {
      enabled: false,
      color: '',
      href: ''
    },
    socialmediasSection: {
      enabled: true,
      color: '$secondaryMain',
      content: [{
        id: 'facebook',
        href: 'https://www.facebook.com/radiocbn',
        icon: 'IcBotaoFacebook'
      }, {
        id: 'twitter',
        href: 'https://twitter.com/CBNoficial',
        icon: 'IcBotaoTwitter'
      }]
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/Template100.ts
var Template100_Template100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/Template100100.ts
var Template100100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['column', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/Template1005050.ts
var Template1005050_Template1005050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      '.Column.Left': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Center': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Right': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column.Left': {
          mb: '$0'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          borderBottom: 'none',
          gridColumn: 'span 2',
          width: '100%'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/Template5050.ts
var Template5050_Template5050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/Template5050100.ts
var Template5050100_Template5050100 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          gridColumn: 'span 2',
          width: '100%'
        }
      }
    }
  },
  customProps: {
    container: {
      className: 'AlignToLeft'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateColumnist.ts
var TemplateColumnist_TemplateColumnist = {
  css: {
    container: {
      backgroundColor: '#f4f4f4',
      pt: '$4',
      mb: '$4',
      '@lg': {
        pb: '$0',
        mb: '$4'
      }
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '.Column:nth-child(1)': {
        '@lg': {
          display: 'none'
        }
      },
      '.Column:nth-child(2)': {
        display: 'none',
        '@lg': {
          display: 'flex'
        }
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Teaser.mobile:not(:nth-child(1))': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%'
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSideBox.ts
var TemplateSideBox_TemplateSideBox = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        px: '$3',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle'],
        borderBottom: '1px solid #e6e6e6',
        pt: '$4',
        pb: '$0',
        px: '$2',
        mb: '$5'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSideBoxGeneric.ts
var TemplateSideBoxGeneric = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSideBoxFixed.ts
var TemplateSideBoxFixed_TemplateSideBoxFixed = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      mt: '$6',
      '@lg': {
        pb: '$0',
        px: '$0',
        mt: '$6',
        mb: '$8',
        position: 'sticky',
        top: '200px'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ExtraTop .ColumnContent': {
        align: ['row', 'left', 'bottom'],
        mb: '0px',
        width: '100%',
        '.pds-Button-root': {
          backgroundColor: '#FFFFFF'
        }
      },
      '.Center .ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderTop: 'unset',
        borderBottomLeftRadius: '$alternative',
        borderBottomRightRadius: '$alternative',
        overflow: 'hidden',
        py: '$0',
        width: '100%'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSideBoxPodcast.ts
var TemplateSideBoxPodcast_TemplateSideBoxPodcast = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        borderRadius: '10px',
        mt: '$6',
        mx: '$3',
        width: '290px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .Teaser:nth-child(2),.Teaser:nth-child(1)': {
        position: 'relative',
        top: '-30px',
        'img': {
          height: '190px',
          width: '190px'
        },
        '.TeaserImage': {
          width: '180px'
        }
      },
      '.ColumnBottom': {
        mb: '$4',
        mx: '$4',
        width: 'calc(100% - $8)',
        'audio': {
          width: 'calc(100% - $8)'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '-$6',
        px: '$0',
        mt: '$1',
        overflowX: 'clip',
        py: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSideBoxRadio.ts
var TemplateSideBoxRadio_TemplateSideBoxRadio = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        px: '$0'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .slide.selected .Teaser': {
        'img': {
          height: '124px',
          width: '124px'
        },
        '.TeaserSubtitleText': {
          maxWidth: '124px'
        },
        '.TeaserTitleText': {
          maxWidth: '124px'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        overflowY: 'inherit',
        overflowX: 'clip',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSideBoxStories.ts
var TemplateSideBoxStories_TemplateSideBoxStories = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      width: 'calc(100% - $4)',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8',
        width: '100%'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left': {
        overflowX: 'clip'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '$3',
        px: '$0',
        mt: '$1',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSideBoxColumnist.ts
var TemplateSideBoxColumnist_TemplateSideBoxColumnist = {
  css: {
    container: {
      pt: '$0',
      '@lg': {
        pb: '$0',
        mb: '$0'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        backgroundColor: '#f4f4f4',
        mb: '$4',
        px: '$2',
        py: '$8',
        width: '100%'
      },
      '.Extra .ColumnContent': {
        backgroundImage: 'none',
        px: '$3',
        py: '$0',
        mb: '$0',
        width: '100%'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.ExtraTop .ColumnContent': {
        backgroundImage: 'none',
        py: '$0',
        px: '$3',
        mt: '$1',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      }
    },
    item: {}
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSideBoxNoTitle.ts
var TemplateSideBoxNoTitle_TemplateSideBoxNoTitle = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$3',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2',
        '.TeaserWrap': {
          py: '$3'
        },
        '.TeaserSubject': {
          px: '$6'
        },
        '.TeaserTitle': {
          px: '$6'
        },
        '.TeaserImage img': {
          borderRadius: '10px 10px 0px 0px'
        }
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$3',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSidebarLeft.ts
var TemplateSidebarLeft_TemplateSidebarLeft = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      flexDirection: 'column-reverse',
      marginTop: '$2',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none',
          marginTop: '24px',
          width: '300px'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          marginTop: '36px',
          width: 'calc(100% - 340px)'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          flexDirection: 'unset',
          align: ['row', 'between', 'middle']
        },
        '.Column.ExtraTop': {
          width: '100%'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateSuperManchete.ts
var TemplateSuperManchete_TemplateSuperManchete = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateVideosLive.ts
var TemplateVideosLive_TemplateVideoLive = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$0',
        px: '$3',
        width: '100%'
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates/TemplateVideos.ts
var TemplateVideos_TemplateVideos = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        mb: '$0',
        px: '$3',
        width: '100%',
        '@lg': {
          align: ['row', 'between', 'top']
        }
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2) .ColumnContent': {
        align: ['column', 'center', 'top']
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column.Left': {
          minWidth: 'calc(50% - $3)',
          width: 'auto'
        },
        '.Column.Center': {
          maxWidth: 'calc(50% - $3)',
          width: 'auto'
        },
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/templates.ts


















var templates_templates = {
  Template100: Template100_Template100,
  Template100100: Template100100,
  Template1005050: Template1005050_Template1005050,
  Template5050: Template5050_Template5050,
  Template5050100: Template5050100_Template5050100,
  TemplateColumnist: TemplateColumnist_TemplateColumnist,
  TemplateSideBox: TemplateSideBox_TemplateSideBox,
  TemplateSideBoxGeneric: TemplateSideBoxGeneric,
  TemplateSideBoxFixed: TemplateSideBoxFixed_TemplateSideBoxFixed,
  TemplateSideBoxPodcast: TemplateSideBoxPodcast_TemplateSideBoxPodcast,
  TemplateSideBoxRadio: TemplateSideBoxRadio_TemplateSideBoxRadio,
  TemplateSideBoxStories: TemplateSideBoxStories_TemplateSideBoxStories,
  TemplateSideBoxColumnist: TemplateSideBoxColumnist_TemplateSideBoxColumnist,
  TemplateSideBoxNoTitle: TemplateSideBoxNoTitle_TemplateSideBoxNoTitle,
  TemplateSidebarLeft: TemplateSidebarLeft_TemplateSidebarLeft,
  TemplateSuperManchete: TemplateSuperManchete_TemplateSuperManchete,
  TemplateVideoLive: TemplateVideosLive_TemplateVideoLive,
  TemplateVideos: TemplateVideos_TemplateVideos
};
var templates_templatesArray = Object.keys(templates_templates);

;// CONCATENATED MODULE: ./brands/cbngo/assets/topbar.styled.tsx


function cbngo_assets_topbar_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cbngo_assets_topbar_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cbngo_assets_topbar_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cbngo_assets_topbar_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var assets_topbar_styled_buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7'
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'DIGITAL',
    hideInMobile: false
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black'
    },
    cssContainer: {
      mr: '$4'
    },
    hideInMobile: false
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020'
    },
    hideInMobile: false
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'ÁUDIO',
    hideInMobile: false
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0'
      }
    },
    value: 'ENTRAR',
    hideInMobile: false
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800'
    },
    hideInMobile: false
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none'
      }
    },
    hideInMobile: false
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content'
    },
    hideInMobile: false
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#FFF',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content'
      }
    },
    hideInMobile: false
  }
};
var assets_topbar_styled_TopbarMobileSlotLeft = function TopbarMobileSlotLeft() {
  var drawersContext = (0,react.useContext)(DrawersProvider.DrawersContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcHamburguerMobile'),
      onClick: function onClick() {
        return drawersContext.handleSideMenuLeft({
          open: !drawersContext.sideMenuLeftState.open
        });
      }
    })
  });
};
var assets_topbar_styled_TopbarMobileSlotRight = function TopbarMobileSlotRight() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(IconButton, {
      icon: useIcon('IcAudioMobile')
    })
  });
};
var assets_topbar_styled_TopbarTopSlotLeft = function TopbarTopSlotLeft() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "https://www.gjccorp.com.br/",
      title: "GJC",
      target: "_blank",
      rel: "noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        icon: (0,hooks_useIcon/* useIcon */.b)("IcOjc")
      })
    })
  });
};
var assets_topbar_styled_TopbarTopSlotRight = function TopbarTopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, cbngo_assets_topbar_styled_objectSpread({
      href: "https://classi.com.br",
      value: "Classi"
    }, assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, cbngo_assets_topbar_styled_objectSpread({
      href: "https://daqui.opopular.com.br",
      value: "Jornal Daqui"
    }, assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, cbngo_assets_topbar_styled_objectSpread({
      href: "https://opopular.com.br/",
      value: "Jornal O Popular"
    }, assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, cbngo_assets_topbar_styled_objectSpread({
      href: "https://www.jornaldotocantins.com.br",
      value: "Jornal do Tocantins"
    }, assets_topbar_styled_buttons.topbarTopItemsRight))]
  });
};
var assets_topbar_styled_TopbarDesktopSlotRight = function TopbarDesktopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var assets_topbar_styled_TopbarExtraSlotRight = function TopbarExtraSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
;// CONCATENATED MODULE: ./brands/cbngo/assets/topbar.tsx


var topbar_topbar = {
  topbarMobile: {
    mainLogo: 'LogoCBNMobile',
    css: {
      cssContainer: {
        background: '#F7F7F7',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)',
        height: '52px',
        width: '100%'
      },
      cssContainerMiddleHolder: {
        height: '100%',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '100%',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        paddingLeft: '18px',
        width: '80px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'right', 'middle'],
        paddingRight: '18px',
        width: '80px'
      },
      cssContainerBottom: {
        display: 'none'
      }
    },
    slotMiddleLeft: assets_topbar_styled_TopbarMobileSlotLeft
  },
  topbarDesktop: {
    mainLogo: 'LogoCBNDesktop',
    css: {
      cssContainerTopHolder: {
        align: ['row', 'center', 'middle'],
        background: '$primaryMain',
        px: '$4',
        width: '100%'
      },
      cssContainerTop: {
        align: ['row', 'between', 'middle'],
        height: '32px',
        maxWidth: '1280px'
      },
      cssContainerTopSlotRight: {
        align: ['row', 'right', 'middle']
      },
      cssContainerMiddleHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '110px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        minWidth: '400px',
        ' > div': {
          align: ['row', 'center', 'middle']
        }
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'between', 'middle'],
        minWidth: '400px'
      },
      cssContainerBottomHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%',
        ' > div': {
          align: ['row', 'between', 'middle'],
          borderTop: '1px solid #E6E6E6'
        }
      },
      cssContainerBottom: {
        align: ['row', 'between', 'middle'],
        background: '#F7F7F7',
        height: '40px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerBottomLeft: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      cssContainerBottomRight: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      topbarItems: {
        item: {
          label: {
            color: '#202020',
            fontSize: '14px',
            fontFamily: '$primary',
            fontWeight: 500,
            textTransform: 'uppercase',
            width: 'max-content'
          },
          li: {
            'a': {
              borderBottom: '4px solid transparent',
              cursor: 'pointer',
              display: 'block',
              height: '100%',
              width: '100%',
              pb: '6px',
              pr: '$4',
              pt: '10px'
            }
          }
        }
      }
    },
    slotTopLeft: assets_topbar_styled_TopbarTopSlotLeft,
    slotTopRight: assets_topbar_styled_TopbarTopSlotRight,
    slotMiddleLeft: TopbarDesktopSlotLeft,
    slotMiddleRight: assets_topbar_styled_TopbarDesktopSlotRight,
    slotBottomRight: assets_topbar_styled_TopbarExtraSlotRight
  }
};
/* harmony default export */ var cbngo_assets_topbar = ((/* unused pure expression or super */ null && (topbar_topbar)));
;// CONCATENATED MODULE: ./brands/cbngo/assets/index.ts












var assets_banners = cbngo_indexes_banners_namespaceObject.k;
var assets_favicons = cbngo_indexes_favicons_namespaceObject.k;
var assets_logos = cbngo_indexes_logos_namespaceObject.k;
var assets_icons = cbngo_indexes_icons_namespaceObject.k;
var assets_splashScreens = cbngo_indexes_splashScreens_namespaceObject.k;
var CBNGOAssets = {
  article: article_article,
  banners: assets_banners,
  favicons: assets_favicons,
  footer: footer_FooterConfig,
  logos: assets_logos,
  icons: assets_icons,
  menus: {
    sideMenuLeft: menus_sideMenuLeft
  },
  slotLayouts: layouts_slotLayouts,
  splashScreens: assets_splashScreens,
  teasers: assets_teasers_teasers,
  templates: templates_templates,
  topbar: topbar_topbar
};
;// CONCATENATED MODULE: ./brands/cbnto/indexes/banners.json
var cbnto_indexes_banners_namespaceObject = JSON.parse('{"k":[{"fullName":"BannerPodcastCBN.svg","name":"BannerPodcastCBN","url":"/assets/cbnto/banners/BannerPodcastCBN.svg","height":"34","width":"139"}]}');
;// CONCATENATED MODULE: ./brands/cbnto/indexes/favicons.json
var cbnto_indexes_favicons_namespaceObject = JSON.parse('{"k":[{"fullName":"128x128.png","name":"128x128","url":"/assets/cbnto/favicons/128x128.png","height":"","width":""},{"fullName":"16x16.png","name":"16x16","url":"/assets/cbnto/favicons/16x16.png","height":"","width":""},{"fullName":"192x192.png","name":"192x192","url":"/assets/cbnto/favicons/192x192.png","height":"","width":""},{"fullName":"32x32.png","name":"32x32","url":"/assets/cbnto/favicons/32x32.png","height":"","width":""},{"fullName":"48x48.png","name":"48x48","url":"/assets/cbnto/favicons/48x48.png","height":"","width":""},{"fullName":"96x96.png","name":"96x96","url":"/assets/cbnto/favicons/96x96.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/cbnto/indexes/icons.json
var cbnto_indexes_icons_namespaceObject = JSON.parse('{"k":[{"fullName":"IcAbrirAzul.svg","name":"IcAbrirAzul","url":"/assets/cbnto/icons/IcAbrirAzul.svg","height":"16","width":"16"},{"fullName":"IcAbrirCinza.svg","name":"IcAbrirCinza","url":"/assets/cbnto/icons/IcAbrirCinza.svg","height":"16","width":"16"},{"fullName":"IcAudio.svg","name":"IcAudio","url":"/assets/cbnto/icons/IcAudio.svg","height":"13","width":"17"},{"fullName":"IcAudioDescricao.svg","name":"IcAudioDescricao","url":"/assets/cbnto/icons/IcAudioDescricao.svg","height":"13","width":"18"},{"fullName":"IcAudioMobile.svg","name":"IcAudioMobile","url":"/assets/cbnto/icons/IcAudioMobile.svg","height":"16","width":"20"},{"fullName":"IcAudiodescricaoCinza.svg","name":"IcAudiodescricaoCinza","url":"/assets/cbnto/icons/IcAudiodescricaoCinza.svg","height":"15","width":"19"},{"fullName":"IcAvancarCinza.svg","name":"IcAvancarCinza","url":"/assets/cbnto/icons/IcAvancarCinza.svg","height":"16","width":"8"},{"fullName":"IcBotaoFacebook.svg","name":"IcBotaoFacebook","url":"/assets/cbnto/icons/IcBotaoFacebook.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookBranco.svg","name":"IcBotaoFacebookBranco","url":"/assets/cbnto/icons/IcBotaoFacebookBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookCinza.svg","name":"IcBotaoFacebookCinza","url":"/assets/cbnto/icons/IcBotaoFacebookCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoFacebookPreto.svg","name":"IcBotaoFacebookPreto","url":"/assets/cbnto/icons/IcBotaoFacebookPreto.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagram.svg","name":"IcBotaoInstagram","url":"/assets/cbnto/icons/IcBotaoInstagram.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramBranco.svg","name":"IcBotaoInstagramBranco","url":"/assets/cbnto/icons/IcBotaoInstagramBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramCinza.svg","name":"IcBotaoInstagramCinza","url":"/assets/cbnto/icons/IcBotaoInstagramCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagramPreto.svg","name":"IcBotaoInstagramPreto","url":"/assets/cbnto/icons/IcBotaoInstagramPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoLinkedin.svg","name":"IcBotaoLinkedin","url":"/assets/cbnto/icons/IcBotaoLinkedin.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinBranco.svg","name":"IcBotaoLinkedinBranco","url":"/assets/cbnto/icons/IcBotaoLinkedinBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinCinza.svg","name":"IcBotaoLinkedinCinza","url":"/assets/cbnto/icons/IcBotaoLinkedinCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoLinkedinPreto.svg","name":"IcBotaoLinkedinPreto","url":"/assets/cbnto/icons/IcBotaoLinkedinPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoTwitter.svg","name":"IcBotaoTwitter","url":"/assets/cbnto/icons/IcBotaoTwitter.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterBranco.svg","name":"IcBotaoTwitterBranco","url":"/assets/cbnto/icons/IcBotaoTwitterBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterCinza.svg","name":"IcBotaoTwitterCinza","url":"/assets/cbnto/icons/IcBotaoTwitterCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoTwitterPreto.svg","name":"IcBotaoTwitterPreto","url":"/assets/cbnto/icons/IcBotaoTwitterPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoWhatsApp.svg","name":"IcBotaoWhatsApp","url":"/assets/cbnto/icons/IcBotaoWhatsApp.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppBranco.svg","name":"IcBotaoWhatsAppBranco","url":"/assets/cbnto/icons/IcBotaoWhatsAppBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppCinza.svg","name":"IcBotaoWhatsAppCinza","url":"/assets/cbnto/icons/IcBotaoWhatsAppCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoWhatsAppPreto.svg","name":"IcBotaoWhatsAppPreto","url":"/assets/cbnto/icons/IcBotaoWhatsAppPreto.svg","height":"33","width":"34"},{"fullName":"IcBuscar.svg","name":"IcBuscar","url":"/assets/cbnto/icons/IcBuscar.svg","height":"15","width":"15"},{"fullName":"IcChave.svg","name":"IcChave","url":"/assets/cbnto/icons/IcChave.svg","height":"14","width":"25"},{"fullName":"IcChaveAzul.svg","name":"IcChaveAzul","url":"/assets/cbnto/icons/IcChaveAzul.svg","height":"14","width":"25"},{"fullName":"IcCheckAzul.svg","name":"IcCheckAzul","url":"/assets/cbnto/icons/IcCheckAzul.svg","height":"10","width":"13"},{"fullName":"IcCidade.svg","name":"IcCidade","url":"/assets/cbnto/icons/IcCidade.svg","height":"17","width":"10"},{"fullName":"IcComunicado.svg","name":"IcComunicado","url":"/assets/cbnto/icons/IcComunicado.svg","height":"15","width":"18"},{"fullName":"IcEconomia.svg","name":"IcEconomia","url":"/assets/cbnto/icons/IcEconomia.svg","height":"16","width":"14"},{"fullName":"IcEdital.svg","name":"IcEdital","url":"/assets/cbnto/icons/IcEdital.svg","height":"16","width":"13"},{"fullName":"IcEspecial.svg","name":"IcEspecial","url":"/assets/cbnto/icons/IcEspecial.svg","height":"14","width":"14"},{"fullName":"IcEsporte.svg","name":"IcEsporte","url":"/assets/cbnto/icons/IcEsporte.svg","height":"16","width":"13"},{"fullName":"IcFecharBranco.svg","name":"IcFecharBranco","url":"/assets/cbnto/icons/IcFecharBranco.svg","height":"16","width":"13"},{"fullName":"IcFecharPreto.svg","name":"IcFecharPreto","url":"/assets/cbnto/icons/IcFecharPreto.svg","height":"15","width":"13"},{"fullName":"IcHamburger.svg","name":"IcHamburger","url":"/assets/cbnto/icons/IcHamburger.svg","height":"15","width":"22"},{"fullName":"IcHamburguerMobile.svg","name":"IcHamburguerMobile","url":"/assets/cbnto/icons/IcHamburguerMobile.svg","height":"13","width":"19"},{"fullName":"IcMagazine.svg","name":"IcMagazine","url":"/assets/cbnto/icons/IcMagazine.svg","height":"16","width":"14"},{"fullName":"IcMundo.svg","name":"IcMundo","url":"/assets/cbnto/icons/IcMundo.svg","height":"15","width":"15"},{"fullName":"IcOjc.svg","name":"IcOjc","url":"/assets/cbnto/icons/IcOjc.svg","height":"17","width":"24"},{"fullName":"IcOpiniao.svg","name":"IcOpiniao","url":"/assets/cbnto/icons/IcOpiniao.svg","height":"12","width":"13"},{"fullName":"IcOpiniaoGrande.svg","name":"IcOpiniaoGrande","url":"/assets/cbnto/icons/IcOpiniaoGrande.svg","height":"19","width":"22"},{"fullName":"IcPlayAudioMateria.svg","name":"IcPlayAudioMateria","url":"/assets/cbnto/icons/IcPlayAudioMateria.svg","height":"15","width":"15"},{"fullName":"IcPlayAudioMateriaAzul.svg","name":"IcPlayAudioMateriaAzul","url":"/assets/cbnto/icons/IcPlayAudioMateriaAzul.svg","height":"23","width":"22"},{"fullName":"IcPodcast.svg","name":"IcPodcast","url":"/assets/cbnto/icons/IcPodcast.svg","height":"19","width":"11"},{"fullName":"IcPolitica.svg","name":"IcPolitica","url":"/assets/cbnto/icons/IcPolitica.svg","height":"16","width":"16"},{"fullName":"IcRadio.svg","name":"IcRadio","url":"/assets/cbnto/icons/IcRadio.svg","height":"20","width":"18"},{"fullName":"IcSetaAbrir.svg","name":"IcSetaAbrir","url":"/assets/cbnto/icons/IcSetaAbrir.svg","height":"6","width":"9"},{"fullName":"IcSetaCidade.svg","name":"IcSetaCidade","url":"/assets/cbnto/icons/IcSetaCidade.svg","height":"9","width":"15"},{"fullName":"IcSetaEconomia.svg","name":"IcSetaEconomia","url":"/assets/cbnto/icons/IcSetaEconomia.svg","height":"9","width":"15"},{"fullName":"IcSetaEspecial.svg","name":"IcSetaEspecial","url":"/assets/cbnto/icons/IcSetaEspecial.svg","height":"9","width":"15"},{"fullName":"IcSetaEsporte.svg","name":"IcSetaEsporte","url":"/assets/cbnto/icons/IcSetaEsporte.svg","height":"9","width":"15"},{"fullName":"IcSetaFechar.svg","name":"IcSetaFechar","url":"/assets/cbnto/icons/IcSetaFechar.svg","height":"7","width":"10"},{"fullName":"IcSetaMagazine.svg","name":"IcSetaMagazine","url":"/assets/cbnto/icons/IcSetaMagazine.svg","height":"9","width":"15"},{"fullName":"IcSetaMundo.svg","name":"IcSetaMundo","url":"/assets/cbnto/icons/IcSetaMundo.svg","height":"9","width":"15"},{"fullName":"IcSetaOpiniao.svg","name":"IcSetaOpiniao","url":"/assets/cbnto/icons/IcSetaOpiniao.svg","height":"9","width":"15"},{"fullName":"IcSetaPolitica.svg","name":"IcSetaPolitica","url":"/assets/cbnto/icons/IcSetaPolitica.svg","height":"9","width":"15"},{"fullName":"IcSetaRosa.svg","name":"IcSetaRosa","url":"/assets/cbnto/icons/IcSetaRosa.svg","height":"9","width":"15"},{"fullName":"IcStories.svg","name":"IcStories","url":"/assets/cbnto/icons/IcStories.svg","height":"21","width":"17"},{"fullName":"IcVersaoDigital.svg","name":"IcVersaoDigital","url":"/assets/cbnto/icons/IcVersaoDigital.svg","height":"14","width":"16"},{"fullName":"IcVersaoDigitalCinza.svg","name":"IcVersaoDigitalCinza","url":"/assets/cbnto/icons/IcVersaoDigitalCinza.svg","height":"16","width":"18"},{"fullName":"IcVersaoDigitalCinzaClaro.svg","name":"IcVersaoDigitalCinzaClaro","url":"/assets/cbnto/icons/IcVersaoDigitalCinzaClaro.svg","height":"15","width":"16"},{"fullName":"IcVoltarCinza.svg","name":"IcVoltarCinza","url":"/assets/cbnto/icons/IcVoltarCinza.svg","height":"16","width":"8"},{"fullName":"IcWhatsAppCinza.svg","name":"IcWhatsAppCinza","url":"/assets/cbnto/icons/IcWhatsAppCinza.svg","height":"18","width":"17"}]}');
;// CONCATENATED MODULE: ./brands/cbnto/indexes/logos.json
var cbnto_indexes_logos_namespaceObject = JSON.parse('{"k":[{"fullName":"LogoCBNDesktop.svg","name":"LogoCBNDesktop","url":"/assets/cbnto/logos/LogoCBNDesktop.svg","height":"36","width":"284"},{"fullName":"LogoCBNMobile.svg","name":"LogoCBNMobile","url":"/assets/cbnto/logos/LogoCBNMobile.svg","height":"17","width":"138"}]}');
;// CONCATENATED MODULE: ./brands/cbnto/indexes/splashScreens.json
var cbnto_indexes_splashScreens_namespaceObject = JSON.parse('{"k":[{"fullName":"ipad.png","name":"ipad","url":"/assets/cbnto/splashScreens/ipad.png","height":"","width":""},{"fullName":"ipadpro1.png","name":"ipadpro1","url":"/assets/cbnto/splashScreens/ipadpro1.png","height":"","width":""},{"fullName":"ipadpro2.png","name":"ipadpro2","url":"/assets/cbnto/splashScreens/ipadpro2.png","height":"","width":""},{"fullName":"ipadpro3.png","name":"ipadpro3","url":"/assets/cbnto/splashScreens/ipadpro3.png","height":"","width":""},{"fullName":"iphone5.png","name":"iphone5","url":"/assets/cbnto/splashScreens/iphone5.png","height":"","width":""},{"fullName":"iphone6.png","name":"iphone6","url":"/assets/cbnto/splashScreens/iphone6.png","height":"","width":""},{"fullName":"iphoneplus.png","name":"iphoneplus","url":"/assets/cbnto/splashScreens/iphoneplus.png","height":"","width":""},{"fullName":"iphonex.png","name":"iphonex","url":"/assets/cbnto/splashScreens/iphonex.png","height":"","width":""},{"fullName":"iphonexsmax.png","name":"iphonexsmax","url":"/assets/cbnto/splashScreens/iphonexsmax.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/cbnto/assets/article.tsx


function assets_article_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_article_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_article_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_article_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var assets_article_BylineRightSectionComponent = function BylineRightSectionComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_OuvirMateriaButton, {
    icon: assets_article_objectSpread({}, (0,hooks_useIcon/* useIcon */.b)('IcPlayAudioMateriaAzul')),
    onClick: function onClick(e) {
      return console.log('play audio materia', e);
    }
  });
};

var assets_article_bylineProps = {
  author: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 700,
      letterSpacing: 0.4,
      lineHeight: '18px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  authorImage: {
    enabled: true,
    customCss: {
      mr: '$4'
    }
  },
  customCss: {
    align: ['column', 'left', 'middle'],
    mb: '$6',
    width: '100%',
    '@lg': {
      align: ['row', 'between', 'middle'],
      mb: '$8',
      width: '100$'
    }
  },
  customCssLeft: {
    align: ['row', 'left', 'middle'],
    width: '100%',
    '@lg': {
      width: 'calc(100% - 320px)'
    }
  },
  customCssContent: {
    width: 'calc(100% - 80px)',
    '@lg': {}
  },
  customCssRight: {
    align: ['row', 'between', 'middle'],
    mt: '$3',
    width: '100%',
    '@lg': {
      align: ['row', 'right', 'middle'],
      mt: '$0',
      width: '320px'
    }
  },
  publishedDate: {
    enabled: true,
    as: 'time',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 400,
      letterSpacing: 0.2,
      lineHeight: '16px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  rightSlot: {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(assets_article_BylineRightSectionComponent, {})
  }
};
var assets_article_article = {
  articleContainer: {
    customCss: {
      align: ['row', 'center', 'middle'],
      mt: '$8',
      width: '100%'
    }
  },
  articleContent: {
    customCss: {
      align: ['row', 'center', 'between'],
      my: '$4',
      width: 'calc(100% - calc($4 * 3))',
      maxWidth: '1278px'
    }
  },
  articleContentLeft: {
    customCss: {
      borderTop: '1px solid #E6E6E6',
      width: '100%',
      '@lg': {
        width: 'calc(100% - 332px)'
      }
    }
  },
  articleContentRight: {
    customCss: {
      background: '#707070',
      display: 'none',
      height: '600px',
      width: '300px',
      '@lg': {
        display: 'flex'
      }
    }
  },
  bylineProps: assets_article_bylineProps,
  captionProps: {
    customCssWrap: {
      maxWidth: '960px',
      width: '100%',
      mb: '$4',
      mt: '$0'
    },
    customCss: {
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '12px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '14px',
      px: '$0',
      py: '$2',
      m: '$0',
      width: 'calc(100% - 32px)',
      '@lg': {
        fontSize: '14px',
        fontStyle: 'italic',
        lineHeight: '17px'
      }
    }
  },
  textProps: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '30px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      width: '100%',
      '@lg': {
        fontSize: '22px',
        fontWeight: 400,
        letterSpacing: 0.2,
        lineHeight: '35px'
      },
      'a': {
        color: '#194392'
      }
    }
  },
  titleProps: {
    as: 'h1',
    customCss: {
      fontFamily: '$primary',
      fontSize: '25px',
      fontWeight: 700,
      lineHeight: '28px',
      mt: '$0',
      mb: '$3',
      '@lg': {
        fontSize: '60px',
        lineHeight: '70px',
        letterSpacing: 0.4
      },
      textAlign: 'left'
    }
  },
  subjectProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '25px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      },
      textAlign: 'left'
    }
  },
  subtitleProps: {
    as: 'h2',
    customCss: {
      color: '#4D4D4D',
      fontFamily: '$primary',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '19px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      '@lg': {
        fontSize: '22px',
        lineHeight: '35px',
        letterSpacing: 0.2,
        mb: '$6'
      }
    }
  },
  shareSection: {
    enabled: true,
    content: [{
      id: 'facebookShare',
      alt: 'Compartilhar no Facebook',
      icon: 'IcBotaoFacebook',
      href: 'https://www.facebook.com/sharer/sharer.php?u='
    }, {
      id: 'twitterShare',
      alt: 'Compartilhar no Twitter',
      icon: 'IcBotaoTwitter',
      href: 'https://twitter.com/intent/tweet?text='
    }, {
      id: 'whatsappShare',
      alt: 'Compartilhar no WhatsApp',
      icon: 'IcBotaoWhatsApp',
      href: 'https://api.whatsapp.com/send?text='
    }, {
      id: 'linkedinShare',
      alt: 'Compartilhar no LinkedIn',
      icon: 'IcBotaoLinkedin',
      href: 'https://www.linkedin.com/sharing/share-offsite/?url='
    }]
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/footer.tsx
var assets_footer_currentDate = new Date();
var assets_footer_currentYear = assets_footer_currentDate.getFullYear();
var assets_footer_FooterConfig = {
  css: {
    slotMiddleCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#262626',
      height: 'max-content',
      py: '$7',
      '@xl': {
        height: '82px'
      }
    },
    slotBottomCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#2E2E2E',
      height: '60px',
      '@xl': {
        display: 'none'
      }
    }
  },
  data: {
    leftText: 'Siga a cbn Tocantins:',
    navMenu: [{
      id: 'expediente',
      title: 'Expediente',
      href: '/expediente'
    }, {
      id: 'faleConosco',
      title: 'Fale conosco',
      href: '/fale-conosco',
      target: '_self'
    }, {
      id: 'anuncieEmOCbnGoiania',
      title: 'Anuncie na cbn Tocantins',
      href: 'https://uaiz.opopular.com.br/anuncie-radios'
    }],
    rightText: "Copyright 2001-".concat(assets_footer_currentYear, ", J. C\xE2mara e Irm\xE3os S/A."),
    socialNetworks: [{
      id: 'facebookPage',
      href: 'https://www.facebook.com/cbntocantins/',
      icon: 'IcBotaoFacebook',
      title: 'Abrir O cbn Tocantins no Facebook'
    }, {
      id: 'twitterPage',
      href: 'https://twitter.com/CBNGoiania',
      icon: 'IcBotaoTwitter',
      title: 'Abrir O cbn Tocantins no Twitter'
    }]
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserRelated.tsx


function cbnto_assets_teasers_TeaserRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cbnto_assets_teasers_TeaserRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cbnto_assets_teasers_TeaserRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cbnto_assets_teasers_TeaserRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck





var assets_teasers_TeaserRelated_handleUseIcon = function handleUseIcon(_ref) {
  var color = _ref.color,
      icon = _ref.icon;
  var iconConfig;
  var sectionSlug = capitalize_default()(color === null || color === void 0 ? void 0 : color.replace('Main', ''));

  if (sectionSlug) {
    var iconSlug = icon === null || icon === void 0 ? void 0 : icon.replace('Especial', sectionSlug);
    var iconParsed = (0,hooks_useIcon/* useIcon */.b)(iconSlug);

    if (iconParsed.src) {
      iconConfig = iconParsed;
    }
  }

  if (!iconConfig) {
    iconConfig = (0,hooks_useIcon/* useIcon */.b)(icon);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, cbnto_assets_teasers_TeaserRelated_objectSpread({}, iconConfig));
};

var assets_teasers_TeaserRelated_TeaserRelated = {
  css: {
    p: 0,
    background: 'none !important',
    width: '100%',
    '.TeaserImageContainer': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none !important'
    },
    '.TeaserSubtitle': {
      display: 'none !important'
    },
    'div.TeaserTitle': {
      align: ['row', 'left', 'top'],
      pb: '$0',
      mb: '$0',
      'a': {
        pb: '$0',
        mb: '$0',
        width: '100%'
      },
      'img': {
        pt: '6px',
        height: '15px'
      },
      'p.TeaserTitleText': {
        align: ['row', 'left', 'top'],
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '19px',
        ml: '$3',
        mb: '$0',
        mt: '$0',
        textAlign: 'left',
        width: 'calc(100% - $3)'
      }
    },
    '.TeaserWrap': {
      background: 'none !important',
      pb: '$0',
      mb: '$0'
    }
  },
  className: 'TeaserRelated',
  relatedIcon: {
    enabled: true,
    name: 'IcSetaEspecial',
    useIcon: assets_teasers_TeaserRelated_handleUseIcon
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserBackground.ts

var assets_teasers_TeaserBackground_TeaserBackground = {
  className: 'TeaserBackground',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '580px'
    },
    '.TeaserImage img': {
      height: '580px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        mb: '$2'
      }
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 90%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserBackgroundLg.ts

var assets_teasers_TeaserBackgroundLg_TeaserBackgroundLg = {
  className: 'TeaserBackgroundLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '360px'
    },
    '.TeaserImage img': {
      height: '360px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 500px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 500px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserBackgroundRelated.ts

var assets_teasers_TeaserBackgroundRelated_TeaserBackgroundRelated = {
  className: 'TeaserBackgroundRelated',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '780px'
    },
    '.TeaserImage img': {
      height: '680px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: 'black',
      position: 'static',
      pt: '$0',
      pb: '$4',
      px: '$4',
      my: '$0',
      'div.Teaser': {
        mb: '$3'
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 60%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserBackgroundRelatedLg.ts

var assets_teasers_TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg = {
  className: 'TeaserBackgroundRelatedLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '536px'
    },
    '.TeaserImage img': {
      height: '536px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: '#282828',
      position: 'absolute',
      height: '536px',
      right: '0px',
      pt: '$0',
      pb: '$4',
      my: '$0',
      width: '328px',
      'div.Teaser': {
        background: 'transparent',
        px: '$8',
        mb: '$0'
      },
      '.TeaserImage': {
        display: 'none'
      },
      'p.TeaserTitleText': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        m: '$0 !important',
        p: '$0 !important',
        width: '100% !important'
      },
      '.TeaserWrap': {
        background: 'none',
        position: 'static',
        mt: '$0'
      },
      '@lg': {
        align: ['column', 'center', 'evenly'],
        '.TeaserTitle img': {
          display: 'none'
        }
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 360px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 360px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserChargeLg.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var teasers_TeaserChargeLg_TeaserChargeLg = {
  css: {
    flexDirection: 'column-reverse',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      my: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 500,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      width: '100%'
    }
  },
  className: 'TeaserChargeLg',
  imageDerivative: 'default',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserChargeMd.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var teasers_TeaserChargeMd_TeaserChargeMd = {
  css: {
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      mt: '$4',
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '25px',
      fontWeight: 600,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      width: '100%'
    }
  },
  className: 'TeaserChargeMd',
  imageDerivative: 'default',
  imageVariant: 'top',
  subjectVariant: 'filled',
  subjectColor: 'colunistaMain',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserChargeSm.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var teasers_TeaserChargeSm_TeaserChargeSm = {
  css: {
    // flexDirection: 'column',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      mt: '$4',
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 400,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '25px',
      width: '100%'
    }
  },
  className: 'TeaserChargeSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectVariant: 'filled',
  subjectColor: 'colunistaMain',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserColumnist.ts
var assets_teasers_TeaserColumnist_TeaserColumnist = {
  css: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderRadius: '$alternative',
    p: '$0',
    pt: '$0',
    mb: '$4',
    '.TeaserImage img': {
      borderRadius: '$circle'
    },
    '.TeaserImageContainer': {
      borderRadius: '$circle',
      maxWidth: '80px'
    },
    '.TeaserWrap': {
      pb: '$4',
      pl: '$4',
      pr: '$4'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubject': {
      width: '100%'
    },
    '.TeaserSubjectText': {
      textAlign: 'left',
      color: '#4C362B',
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 500,
      mb: '$1'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      width: '100%'
    },
    '.TeaserTitleText': {
      fontSize: '16px',
      fontWeight: 400
    }
  },
  className: 'TeaserColumnist',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subjectTextVariant: 'subject-default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-sm'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserEditais.ts
var teasers_TeaserEditais_TeaserEditais = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserEditais'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserEditorial.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var teasers_TeaserEditorial_TeaserEditorial = {
  css: {
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: '220px',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 220px - $3)'
    }
  },
  className: 'TeaserEditorial',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserEditorialSm.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var teasers_TeaserEditorialSm_TeaserEditorialSm = {
  css: {
    padding: '$0',
    mb: '$8',
    minHeight: '80px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(88px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserEditorialSm',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserHeadlineSm.ts


function cbnto_assets_teasers_TeaserHeadlineSm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cbnto_assets_teasers_TeaserHeadlineSm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cbnto_assets_teasers_TeaserHeadlineSm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cbnto_assets_teasers_TeaserHeadlineSm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var assets_teasers_TeaserHeadlineSm_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var assets_teasers_TeaserHeadlineSm_TeaserHeadlineSm = cbnto_assets_teasers_TeaserHeadlineSm_objectSpread(cbnto_assets_teasers_TeaserHeadlineSm_objectSpread({}, assets_teasers_TeaserHeadlineSm_T.TeaserHeadlineSm), {}, {
  css: {
    p: '$0',
    mb: '$6',
    textAlign: 'center',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineSm',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-3xl'
});
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserHeadlineLg.ts


var cbnto_assets_teasers_TeaserHeadlineLg_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var assets_teasers_TeaserHeadlineLg_TeaserHeadlineLg = {
  css: {
    textAlign: 'center',
    my: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      align: ['row', 'center', 'top'],
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '18px',
          lineHeight: '23px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      maxWidth: '980px',
      mb: '$8'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineLg',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-6xl'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserImageLeft.ts

var assets_teasers_TeaserImageLeft_TeaserImageLeft = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    },
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      textAlign: 'center',
      '.TeaserImageContainer': {
        backgroundColor: 'transparent',
        width: 'auto',
        'img': {
          pr: '$3'
        },
        '@lg': {
          maxWidth: '150px'
        }
      },
      '.TeaserSubjectText': {
        alignItems: 'center',
        align: ['column', 'center', 'top'],
        textTransform: 'uppercase',
        fontSize: '14px'
      },
      '.TeaserSubtitleText': {
        display: 'none'
      },
      '.TeaserSubtitle': {
        align: ['row', 'left', 'middle']
      },
      '.TeaserTitle': {
        my: '$2'
      },
      '.TeaserTitleText': {
        align: ['column', 'left', 'top'],
        color: 'black',
        fontSize: '26px',
        fontWeight: 400,
        letterSpacing: '0.2px',
        lineHeight: '23px',
        width: '100%'
      },
      '.TeaserWrap': {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0px !important',
        width: '100%',
        '.TeaserRelated': {
          'div.Teaser': {
            mb: '$4'
          },
          'div.TeaserTitle': {
            'p.TeaserTitleText': {
              fontSize: '16px',
              lineHeight: '19px',
              letterSpacing: '0.2px'
            }
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserImageLeftSq.ts
var teasers_TeaserImageLeftSq_TeaserImageLeftSq = {
  css: {
    padding: '$0',
    mb: '$3',
    minHeight: '75px',
    width: '100%',
    '@lg': {
      mb: '$3'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(75px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '75px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 75px - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeftSq',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserImageLeftSm.ts
var assets_teasers_TeaserImageLeftSm_TeaserImageLeftSm = {
  css: {
    padding: '$0',
    mb: '$6',
    minHeight: '88px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(120px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 88px - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeftSm',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserImageLeftLg.ts

var assets_teasers_TeaserImageLeftLg_TeaserImageLeftLg = {
  css: {
    padding: '$0',
    mb: '$6',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      mb: '$3'
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '36px',
      lineHeight: '43px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      minWidth: 'calc(50% - $3)',
      width: '100%',
      '.TeaserRelated': {
        flexFlow: 'column',
        width: '100%',
        'div.Teaser': {
          mb: '$4',
          width: 'auto'
        },
        'div.TeaserTitle': {
          'p.TeaserTitleText': {
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.2px'
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserNoImage.ts

var assets_teasers_TeaserNoImage_TeaserNoImage = {
  css: {
    p: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      align: ['column', 'left', 'top'],
      display: 'none',
      mb: '$4'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      mb: '$4'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserNoImage',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserCard.ts
var assets_teasers_TeaserCard_TeaserCard = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCard',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserCardBold.ts
var teasers_TeaserCardBold_TeaserCardBold = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0',
      color: '#4D4D4D'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCardBold',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserImageTop.ts

var assets_teasers_TeaserImageTop_TeaserImageTop = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserImageTopLg.ts

var assets_teasers_TeaserImageTopLg_TeaserImageTopLg = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserImageBottom.ts
var assets_teasers_TeaserImageBottom_TeaserImageBottom = {
  css: {
    mb: '$3',
    padding: '$0',
    width: '100%',
    '.TeaserSubtitle': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$3'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase'
    },
    '.TeaserTitle': {
      mb: '$3'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    }
  },
  className: 'TeaserImageBottom',
  imageDerivative: '3x1',
  imageVariant: 'bottom',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subtitleVariant: 'subtitle-default',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  titleVariant: 'newstitle-5xl'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserImageLeftXl.ts
var assets_teasers_TeaserImageLeftXl_TeaserImageLeftXl = {
  css: {
    padding: '$0',
    mb: '$5',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserMostRead.ts
var assets_teasers_TeaserMostRead_TeaserMostRead = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      borderRadius: '50%',
      height: '100%',
      width: '30px',
      pr: '$2'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserMostReadFixed.ts
var assets_teasers_TeaserMostReadFixed_TeaserMostReadFixed = {
  css: {
    align: ['row', 'center', 'middle'],
    borderBottom: '1px solid #E6E6E6',
    borderLeft: '8px solid $basicWhite',
    p: '$0',
    minHeight: '92px',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      ml: '$4',
      mr: '$4',
      height: '100%',
      width: 'max-content'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '$widget5',
      fontWeight: '$widget5',
      lineHeight: '$widget5'
    },
    '.TeaserWrap': {
      mr: '$4',
      width: 'calc(100% - $4)'
    },
    '&:last-child': {
      borderBottom: 'unset'
    },
    '&[data-selected=true]': {
      borderLeft: '8px solid $primaryMain'
    },
    '&[data-viewed=true]': {
      borderLeft: '8px solid #E7E7E7'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserPodcast.ts
var assets_teasers_TeaserPodcast_TeaserPodcast = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$2',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      width: '160px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 5%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '124px',
      width: '124px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserTitleText': {
      display: 'none'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserRadio.ts
var assets_teasers_TeaserRadio_TeaserRadio = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  customLinkProps: {
    bypass: 'true'
  },
  css: {
    backgroundColor: 'none',
    cursor: 'pointer',
    p: '$0',
    m: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      mx: '$4',
      width: '100px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 25%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '100px',
      width: '100px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserSubtitleText': {
      color: '#c6c6c6',
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: 400,
      mx: '$2',
      mb: '$2',
      textAlign: 'center',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    },
    '.TeaserTitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserTitleText': {
      color: '#7c7c7c',
      fontSize: '18px',
      letterSpacing: '0.4px',
      lineHeight: '25px',
      fontWeight: 500,
      mx: '$2',
      mb: '$1',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserStories.ts
var assets_teasers_TeaserStories_TeaserStories = {
  className: 'TeaserStories',
  imageDerivative: '1x3',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$4',
    width: 'calc(100% - $4)',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$0'
    },
    '.TeaserImage img': {
      borderRadius: '10px',
      height: '354px',
      width: '200px',
      objectFit: 'cover'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '19px',
      fontWeight: 500,
      px: '$4',
      mb: '$2',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      align: ['row', 'left', 'bottom']
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'bottom'],
      color: '$basicWhite',
      fontSize: '18px',
      letterSpacing: '0.2px',
      lineHeight: '23px',
      fontWeight: 400,
      px: '$4',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      'a': {
        textAlign: 'left'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      background: 'linear-gradient(rgba(0, 0, 0, 0) 50%, rgb(0, 0, 0) 100%)',
      borderRadius: '10px',
      position: 'absolute',
      height: '100%',
      width: '100%'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserVideoFeatured.ts

var teasers_TeaserVideoFeatured_TeaserVideoFeatured = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserVideoFeatured',
  imageDerivative: '2x1',
  imageVariant: 'top',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserVideoFeatSm.ts

var teasers_TeaserVideoFeatSm_TeaserVideoFeatSm = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserVideoFeatSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserVideoFeatMd.ts

var teasers_TeaserVideoFeatMd_TeaserVideoFeatMd = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        fontWeight: 600,
        letterSpacing: '0.2px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserVideoFeatMd',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserVideoFeatLg.ts

var teasers_TeaserVideoFeatLg_TeaserVideoFeatLg = {
  className: 'TeaserVideoFeatLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'default',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    p: '$0',
    mb: '$6',
    ml: '-$3',
    mr: '-$3',
    width: 'calc(100% + $6)',
    '@lg': {
      ml: '$0',
      mr: '$0'
    },
    '.TeaserImage': {
      height: '535px'
    },
    '.TeaserImage img': {
      height: '535px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto',
      width: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '12px',
      ml: '$4',
      mb: '$4',
      textTransform: 'uppercase',
      '@lg': {
        fontSize: '16px',
        ml: '$10',
        mb: '$4'
      }
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      ml: '$4',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 400,
        ml: '$10',
        mb: '$10'
      }
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: '$basicWhite',
      fontSize: '28px',
      lineHeight: '33px',
      fontWeight: 700,
      ml: '$4',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        fontSize: '43px',
        lineHeight: '50px',
        fontWeight: 700,
        ml: '$10',
        mb: '$4'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 24px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 24px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserVideoLeft.ts
var assets_teasers_TeaserVideoLeft_TeaserVideoLeft = {
  css: {
    backgroundColor: 'transparent',
    padding: '$0',
    mb: '$3',
    width: '100%',
    '@lg': {
      ml: '$8',
      mb: '$8',
      width: 'calc(100% - $8)'
    },
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubtitle': {
      display: 'none',
      '@lg': {
        display: 'flex'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      color: '#989898',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 400,
      '@lg': {
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: 400
      }
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      ml: '$3',
      maxWidth: 'calc(50% - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers/TeaserVideoTop.ts
var assets_teasers_TeaserVideoTop_TeaserVideoTop = {
  css: {
    backgroundColor: 'transparent',
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      color: '#989898',
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$0'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '25px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '2x1',
  imageVariant: 'top',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/teasers.ts




































var cbnto_assets_teasers_teasers = {
  TeaserBackground: assets_teasers_TeaserBackground_TeaserBackground,
  TeaserBackgroundLg: assets_teasers_TeaserBackgroundLg_TeaserBackgroundLg,
  TeaserBackgroundRelatedLg: assets_teasers_TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg,
  TeaserBackgroundRelated: assets_teasers_TeaserBackgroundRelated_TeaserBackgroundRelated,
  TeaserChargeLg: teasers_TeaserChargeLg_TeaserChargeLg,
  TeaserChargeMd: teasers_TeaserChargeMd_TeaserChargeMd,
  TeaserChargeSm: teasers_TeaserChargeSm_TeaserChargeSm,
  TeaserEditais: teasers_TeaserEditais_TeaserEditais,
  TeaserEditorial: teasers_TeaserEditorial_TeaserEditorial,
  TeaserEditorialSm: teasers_TeaserEditorialSm_TeaserEditorialSm,
  TeaserImageBottom: assets_teasers_TeaserImageBottom_TeaserImageBottom,
  TeaserImageLeft: assets_teasers_TeaserImageLeft_TeaserImageLeft,
  TeaserImageLeftSq: teasers_TeaserImageLeftSq_TeaserImageLeftSq,
  TeaserImageLeftSm: assets_teasers_TeaserImageLeftSm_TeaserImageLeftSm,
  TeaserImageLeftLg: assets_teasers_TeaserImageLeftLg_TeaserImageLeftLg,
  TeaserImageLeftXl: assets_teasers_TeaserImageLeftXl_TeaserImageLeftXl,
  TeaserImageTop: assets_teasers_TeaserImageTop_TeaserImageTop,
  TeaserImageTopLg: assets_teasers_TeaserImageTopLg_TeaserImageTopLg,
  TeaserCard: assets_teasers_TeaserCard_TeaserCard,
  TeaserCardBold: teasers_TeaserCardBold_TeaserCardBold,
  TeaserColumnist: assets_teasers_TeaserColumnist_TeaserColumnist,
  TeaserRelated: assets_teasers_TeaserRelated_TeaserRelated,
  TeaserHeadlineSm: assets_teasers_TeaserHeadlineSm_TeaserHeadlineSm,
  TeaserHeadlineLg: assets_teasers_TeaserHeadlineLg_TeaserHeadlineLg,
  TeaserNoImage: assets_teasers_TeaserNoImage_TeaserNoImage,
  TeaserMostRead: assets_teasers_TeaserMostRead_TeaserMostRead,
  TeaserMostReadFixed: assets_teasers_TeaserMostReadFixed_TeaserMostReadFixed,
  TeaserPodcast: assets_teasers_TeaserPodcast_TeaserPodcast,
  TeaserRadio: assets_teasers_TeaserRadio_TeaserRadio,
  TeaserStories: assets_teasers_TeaserStories_TeaserStories,
  TeaserVideoFeatured: teasers_TeaserVideoFeatured_TeaserVideoFeatured,
  TeaserVideoFeatSm: teasers_TeaserVideoFeatSm_TeaserVideoFeatSm,
  TeaserVideoFeatMd: teasers_TeaserVideoFeatMd_TeaserVideoFeatMd,
  TeaserVideoFeatLg: teasers_TeaserVideoFeatLg_TeaserVideoFeatLg,
  TeaserVideoLeft: assets_teasers_TeaserVideoLeft_TeaserVideoLeft,
  TeaserVideoTop: assets_teasers_TeaserVideoTop_TeaserVideoTop
};
var cbnto_assets_teasers_teasersArray = Object.keys(cbnto_assets_teasers_teasers);

;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutCharge.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutCharge_LayoutCharge = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserChargeSm, cbnto_assets_teasers_teasers.TeaserChargeSm],
        '0:1': [cbnto_assets_teasers_teasers.TeaserChargeLg, cbnto_assets_teasers_teasers.TeaserChargeLg],
        '0:2': [cbnto_assets_teasers_teasers.TeaserChargeMd, cbnto_assets_teasers_teasers.TeaserChargeMd],
        '0:3': [cbnto_assets_teasers_teasers.TeaserChargeMd, cbnto_assets_teasers_teasers.TeaserChargeMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/utils.ts


function assets_layouts_utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_layouts_utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_layouts_utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_layouts_utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var layouts_utils_addRelativeWidthToTeaser = function addRelativeWidthToTeaser(teaser, value) {
  var _teaser$css;

  return assets_layouts_utils_objectSpread(assets_layouts_utils_objectSpread({}, teaser), {}, {
    css: assets_layouts_utils_objectSpread(assets_layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : teaser.css), {}, {
      '@lg': assets_layouts_utils_objectSpread(assets_layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : (_teaser$css = teaser.css) === null || _teaser$css === void 0 ? void 0 : _teaser$css['@lg']), {}, {
        width: value
      })
    })
  });
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutColumnist.tsx
// @ts-nocheck







var assets_layouts_LayoutColumnist_TeaserColumnist = layouts_utils_addRelativeWidthToTeaser(cbnto_assets_teasers_teasers.TeaserColumnist, '100%');

var layouts_LayoutColumnist_renderSlotMobileWrapComponent = function renderSlotMobileWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: data
  });
};

var layouts_LayoutColumnist_renderSlotDesktopWrapComponent = function renderSlotDesktopWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel .slider-wrapper': {
          width: 'calc(100% - 64px)'
        }
      },
      controlDots: {
        mt: '$2',
        mb: '$0',
        visibility: 'hidden'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    renderArrowNext: function renderArrowNext(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcAvancarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            top: 'calc(50% - 20px)',
            right: '0px'
          }
        }
      });
    },
    renderArrowPrev: function renderArrowPrev(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcVoltarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            bottom: 'calc(50% - 10px)',
            left: '0px'
          }
        }
      });
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    children: map_default()(chunk_default()(data, 4), function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'middle'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'left', 'middle'],
              minWidth: '25%',
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

var layouts_LayoutColumnist_LayoutColumnist = {
  wrapperContent: {
    enabled: true,
    component: layouts_LayoutColumnist_renderSlotMobileWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        pt: '$3',
        pb: '$5',
        maxWidth: 'calc(100% - $2)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_layouts_LayoutColumnist_TeaserColumnist, assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [assets_layouts_LayoutColumnist_TeaserColumnist, assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [assets_layouts_LayoutColumnist_TeaserColumnist, assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [assets_layouts_LayoutColumnist_TeaserColumnist, assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
var layouts_LayoutColumnist_LayoutColumnistDesktop = {
  wrapperContent: {
    enabled: true,
    component: layouts_LayoutColumnist_renderSlotDesktopWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        py: '$6',
        maxWidth: 'calc(100% - 180px)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: 'calc(100% - $12)'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [assets_layouts_LayoutColumnist_TeaserColumnist, assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [assets_layouts_LayoutColumnist_TeaserColumnist, assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [assets_layouts_LayoutColumnist_TeaserColumnist, assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [assets_layouts_LayoutColumnist_TeaserColumnist, assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutColumnistSideBox.tsx
// @ts-nocheck

var layouts_LayoutColumnistSideBox_LayoutColumnistSideBox = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnContent': {
        pt: '$6',
        pb: '$6',
        maxWidth: 'calc(100% - $2)'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserColumnist, cbnto_assets_teasers_teasers.TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutDefault.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var layouts_LayoutDefault_LayoutDefault = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '0': [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '1': [cbnto_assets_teasers_teasers.TeaserHeadlineSm, cbnto_assets_teasers_teasers.TeaserImageLeftXl]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTopLg, cbnto_assets_teasers_teasers.TeaserImageLeftLg]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserNoImage, cbnto_assets_teasers_teasers.TeaserNoImage]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTopLg, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageTopLg, cbnto_assets_teasers_teasers.TeaserImageTopLg],
        '1': [cbnto_assets_teasers_teasers.TeaserImageTopLg, cbnto_assets_teasers_teasers.TeaserImageTopLg]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageTopLg, cbnto_assets_teasers_teasers.TeaserImageTopLg],
        '1': [cbnto_assets_teasers_teasers.TeaserImageTopLg, cbnto_assets_teasers_teasers.TeaserImageTopLg]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeft, cbnto_assets_teasers_teasers.TeaserImageTop],
        '1': [cbnto_assets_teasers_teasers.TeaserImageTop, cbnto_assets_teasers_teasers.TeaserImageTop]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeft, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '1': [cbnto_assets_teasers_teasers.TeaserImageTop, cbnto_assets_teasers_teasers.TeaserImageTop]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTop, cbnto_assets_teasers_teasers.TeaserImageTop]
      }
    },
    TemplateVideos: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutEditais.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutEditais_LayoutEditais = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserEditais, cbnto_assets_teasers_teasers.TeaserEditais]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserEditais, cbnto_assets_teasers_teasers.TeaserEditais]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutEditorial.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutEditorial_LayoutEditorial = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserEditorialSm, cbnto_assets_teasers_teasers.TeaserEditorial],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageTopLg, cbnto_assets_teasers_teasers.TeaserImageLeftLg]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutFeatured.ts


function assets_layouts_LayoutFeatured_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_layouts_LayoutFeatured_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_layouts_LayoutFeatured_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_layouts_LayoutFeatured_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// MancheteComFoto
var layouts_LayoutFeatured_LayoutFeatured = assets_layouts_LayoutFeatured_objectSpread(assets_layouts_LayoutFeatured_objectSpread({}, layouts_LayoutDefault_LayoutDefault), {}, {
  slotConfig: assets_layouts_LayoutFeatured_objectSpread(assets_layouts_LayoutFeatured_objectSpread({}, layouts_LayoutDefault_LayoutDefault === null || layouts_LayoutDefault_LayoutDefault === void 0 ? void 0 : layouts_LayoutDefault_LayoutDefault.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSq, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeft, cbnto_assets_teasers_teasers.TeaserImageLeftLg],
        '1': [cbnto_assets_teasers_teasers.TeaserImageLeft, cbnto_assets_teasers_teasers.TeaserImageLeftLg]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserBackground, cbnto_assets_teasers_teasers.TeaserBackgroundLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutFeaturedImage.ts


function assets_layouts_LayoutFeaturedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_layouts_LayoutFeaturedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_layouts_LayoutFeaturedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_layouts_LayoutFeaturedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var layouts_LayoutFeaturedImage_LayoutFeaturedImage = assets_layouts_LayoutFeaturedImage_objectSpread(assets_layouts_LayoutFeaturedImage_objectSpread({}, layouts_LayoutFeatured_LayoutFeatured), {}, {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: assets_layouts_LayoutFeaturedImage_objectSpread(assets_layouts_LayoutFeaturedImage_objectSpread({}, layouts_LayoutFeatured_LayoutFeatured === null || layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserBackgroundRelated, cbnto_assets_teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutFeaturedNoImage.ts


function assets_layouts_LayoutFeaturedNoImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_layouts_LayoutFeaturedNoImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_layouts_LayoutFeaturedNoImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_layouts_LayoutFeaturedNoImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var layouts_LayoutFeaturedNoImage_LayoutFeaturedNoImage = assets_layouts_LayoutFeaturedNoImage_objectSpread(assets_layouts_LayoutFeaturedNoImage_objectSpread({}, layouts_LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: assets_layouts_LayoutFeaturedNoImage_objectSpread(assets_layouts_LayoutFeaturedNoImage_objectSpread({}, layouts_LayoutFeatured_LayoutFeatured === null || layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, cbnto_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserHeadlineSm, cbnto_assets_teasers_teasers.TeaserHeadlineLg],
        '1': [cbnto_assets_teasers_teasers.TeaserHeadlineSm, cbnto_assets_teasers_teasers.TeaserHeadlineLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutFeaturedRelated.ts


function assets_layouts_LayoutFeaturedRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_layouts_LayoutFeaturedRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_layouts_LayoutFeaturedRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_layouts_LayoutFeaturedRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// SuperManchete
var layouts_LayoutFeaturedRelated_LayoutFeaturedRelated = assets_layouts_LayoutFeaturedRelated_objectSpread(assets_layouts_LayoutFeaturedRelated_objectSpread({}, layouts_LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: assets_layouts_LayoutFeaturedRelated_objectSpread(assets_layouts_LayoutFeaturedRelated_objectSpread({}, layouts_LayoutFeatured_LayoutFeatured === null || layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    TemplateSuperManchete: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserBackgroundRelated, cbnto_assets_teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutGrid3.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var assets_layouts_LayoutGrid3_TeaserCard = layouts_utils_addRelativeWidthToTeaser(cbnto_assets_teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 2)) / 3)');
var assets_layouts_LayoutGrid3_TeaserImageTop = layouts_utils_addRelativeWidthToTeaser(cbnto_assets_teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var layouts_LayoutGrid3_LayoutGrid3 = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template100100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGrid3_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTop, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTop, assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTop, assets_layouts_LayoutGrid3_TeaserCard]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutGrid4.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var assets_layouts_LayoutGrid4_TeaserCard = layouts_utils_addRelativeWidthToTeaser(cbnto_assets_teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 3)) / 4)');
var layouts_LayoutGrid4_LayoutGrid4 = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserCard, assets_layouts_LayoutGrid4_TeaserCard]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSq, cbnto_assets_teasers_teasers.TeaserImageLeftSq],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeftSq, cbnto_assets_teasers_teasers.TeaserImageLeftSq]
      }
    },
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserColumnist, cbnto_assets_teasers_teasers.TeaserColumnist],
        '0:1': [cbnto_assets_teasers_teasers.TeaserColumnist, cbnto_assets_teasers_teasers.TeaserColumnist]
      }
    },
    TemplateSideBoxNoTitle: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSq, cbnto_assets_teasers_teasers.TeaserImageLeftSm],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeftSq, cbnto_assets_teasers_teasers.TeaserImageLeftSm],
        '1': [cbnto_assets_teasers_teasers.TeaserImageTop, cbnto_assets_teasers_teasers.TeaserImageTop]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutGridInfocom.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var layouts_LayoutGridInfocom_TeaserCardBold = layouts_utils_addRelativeWidthToTeaser(cbnto_assets_teasers_teasers.TeaserCardBold, 'calc(calc(100% - calc(24px * 2)) / 3)');
var layouts_LayoutGridInfocom_TeaserImageTop = layouts_utils_addRelativeWidthToTeaser(cbnto_assets_teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var LayoutGridInfocom_LayoutGridInfocom = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template100100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageLeftSm, layouts_LayoutGridInfocom_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTop, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTop, layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserImageTop, layouts_LayoutGridInfocom_TeaserCardBold]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutPodcast.tsx
// @ts-nocheck




var layouts_LayoutPodcast_renderWrapComponent = function renderWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '200px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

var layouts_LayoutPodcast_LayoutPodcast = {
  wrapperContent: {
    enabled: true,
    component: layouts_LayoutPodcast_renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxPodcast: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserPodcast, cbnto_assets_teasers_teasers.TeaserPodcast]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutRadio.tsx
// @ts-nocheck

var layouts_LayoutRadio_LayoutRadio = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      px: '$0',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxRadio: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserRadio, cbnto_assets_teasers_teasers.TeaserRadio]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutSearch.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var layouts_LayoutSearch_LayoutSearch = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserEditorialSm, cbnto_assets_teasers_teasers.TeaserEditorial]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutStories.tsx
// @ts-nocheck

var layouts_LayoutStories_LayoutStories = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxStories: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserStories, cbnto_assets_teasers_teasers.TeaserStories]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutMostRead.ts
// eslint-disable-next-line
// @ts-nocheck

var layouts_LayoutMostRead_LayoutMostRead = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserMostRead, cbnto_assets_teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserMostRead, cbnto_assets_teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBoxFixed: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserMostReadFixed, cbnto_assets_teasers_teasers.TeaserMostReadFixed]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserMostReadFixed, cbnto_assets_teasers_teasers.TeaserMostReadFixed]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutVideoFeatured.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var LayoutVideoFeatured_LayoutVideoFeatured = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserVideoFeatured, cbnto_assets_teasers_teasers.TeaserVideoFeatSm],
        '0:1': [cbnto_assets_teasers_teasers.TeaserVideoFeatLg, cbnto_assets_teasers_teasers.TeaserVideoFeatLg],
        '0:2': [cbnto_assets_teasers_teasers.TeaserVideoFeatured, cbnto_assets_teasers_teasers.TeaserVideoFeatMd],
        '0:3': [cbnto_assets_teasers_teasers.TeaserVideoFeatured, cbnto_assets_teasers_teasers.TeaserVideoFeatMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutVideoHome.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var assets_layouts_LayoutVideoHome_TeaserVideoTop = layouts_utils_addRelativeWidthToTeaser(cbnto_assets_teasers_teasers.TeaserVideoTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var layouts_LayoutVideoHome_LayoutVideoHome = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        width: '100%' // columnGap: '24px'

      }
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserVideoTop, assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoTop],
        '2': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoLeft]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserVideoTop, assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoTop],
        '2': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoLeft]
      },
      slotRight: {
        "default": [cbnto_assets_teasers_teasers.TeaserVideoTop, assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoTop],
        '2': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts/LayoutVideoLive.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var layouts_LayoutVideoLive_LayoutVideoLive = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [cbnto_assets_teasers_teasers.TeaserVideoTop, cbnto_assets_teasers_teasers.TeaserVideoLeft]
      }
    },
    TemplateVideoLive: {
      slotLeft: {
        "default": [cbnto_assets_teasers_teasers.TeaserMostRead, cbnto_assets_teasers_teasers.TeaserMostRead],
        '0:1': [cbnto_assets_teasers_teasers.TeaserMostRead, cbnto_assets_teasers_teasers.TeaserMostRead]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/layouts.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck






















var assets_layouts_slotLayouts = {
  LayoutCharge: LayoutCharge_LayoutCharge,
  LayoutColumnist: layouts_LayoutColumnist_LayoutColumnist,
  LayoutColumnistDesktop: layouts_LayoutColumnist_LayoutColumnistDesktop,
  LayoutColumnistSideBox: layouts_LayoutColumnistSideBox_LayoutColumnistSideBox,
  LayoutDefault: layouts_LayoutDefault_LayoutDefault,
  LayoutEditais: LayoutEditais_LayoutEditais,
  LayoutEditorial: LayoutEditorial_LayoutEditorial,
  LayoutFeatured: layouts_LayoutFeatured_LayoutFeatured,
  LayoutFeaturedImage: layouts_LayoutFeaturedImage_LayoutFeaturedImage,
  LayoutFeaturedNoImage: layouts_LayoutFeaturedNoImage_LayoutFeaturedNoImage,
  LayoutFeaturedRelated: layouts_LayoutFeaturedRelated_LayoutFeaturedRelated,
  LayoutGrid3: layouts_LayoutGrid3_LayoutGrid3,
  LayoutGrid4: layouts_LayoutGrid4_LayoutGrid4,
  LayoutGridInfocom: LayoutGridInfocom_LayoutGridInfocom,
  LayoutPodcast: layouts_LayoutPodcast_LayoutPodcast,
  LayoutRadio: layouts_LayoutRadio_LayoutRadio,
  LayoutSearch: layouts_LayoutSearch_LayoutSearch,
  LayoutStories: layouts_LayoutStories_LayoutStories,
  LayoutMostRead: layouts_LayoutMostRead_LayoutMostRead,
  LayoutVideoFeatured: LayoutVideoFeatured_LayoutVideoFeatured,
  LayoutVideoHome: layouts_LayoutVideoHome_LayoutVideoHome,
  LayoutVideoLive: layouts_LayoutVideoLive_LayoutVideoLive
};
var assets_layouts_slotLayoutsArray = Object.keys(assets_layouts_slotLayouts);

;// CONCATENATED MODULE: ./brands/cbnto/assets/menus.tsx
var assets_menus_accordionStyle = {
  accordionItemGroup: {
    accordionContent: {
      backgroundColor: '#EAEAEA',
      pl: '$8',
      pr: '$18'
    },
    accordionTitle: {
      title: {
        fontFamily: '$primary',
        fontSize: '$caption5',
        fontWeight: '$caption5',
        lineHeight: '$caption5',
        m: '0px',
        py: '$2',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px'
      },
      iconButton: {
        height: '24px',
        width: '24px'
      }
    }
  }
};
var assets_menus_sideMenuLeft = {
  sectionHeader: {
    enabled: true,
    subscriberInfo: {
      enabled: false,
      amountLeft: 0
    },
    advertiseSection: {
      enabled: true,
      color: '#938783',
      href: 'https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania',
      target: '_blank'
    },
    variants: {
      anonymous: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      DEGUSTADOR: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      ASSINANTE: {
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      advertiser_subscriber: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      club_subscriber: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      }
    }
  },
  sectionContent: {
    enabled: true,
    searchInput: {
      enabled: true
    },
    advertiseSection: {
      enabled: true,
      color: '#938783',
      href: 'https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania',
      target: '_blank'
    },
    serviceButtons: {
      enabled: false,
      items: []
    },
    navigationAccordions: {
      enabled: true,
      css: assets_menus_accordionStyle,
      items: [{
        id: 'sac',
        title: 'SAC',
        items: [{
          id: '1',
          title: 'Fale Conosco',
          href: '/fale-conosco'
        }, {
          id: '2',
          title: 'Expediente',
          href: '/expediente'
        }, {
          id: '3',
          title: 'Política de privacidade',
          href: '/politica-de-privacidade'
        }, {
          id: '4',
          title: 'Termos de uso',
          href: '/termos-de-uso'
        }],
        css: assets_menus_accordionStyle
      }, {
        id: 'grupoojc',
        title: 'Grupo Jaime Câmara',
        items: [{
          id: '1',
          title: 'Classi',
          href: 'https://www.classi.com.br'
        }, {
          id: '2',
          title: 'Jornal Daqui',
          href: 'https://daqui.opopular.com.br'
        }, {
          id: '3',
          title: 'Jornal O Popular',
          href: 'https://opopular.com.br/'
        }, {
          id: '4',
          title: 'Jornal do Tocantins',
          href: 'https://www.jornaldotocantins.com.br'
        }],
        css: assets_menus_accordionStyle
      }]
    }
  },
  sectionFooter: {
    enabled: true,
    advertiseSection: {
      enabled: false,
      color: '',
      href: ''
    },
    socialmediasSection: {
      enabled: true,
      color: '$secondaryMain',
      content: [{
        id: 'facebook',
        href: 'https://www.facebook.com/radiocbn',
        icon: 'IcBotaoFacebook'
      }, {
        id: 'twitter',
        href: 'https://twitter.com/CBNoficial',
        icon: 'IcBotaoTwitter'
      }]
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/Template100.ts
var templates_Template100_Template100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/Template100100.ts
var Template100100_Template100100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['column', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/Template1005050.ts
var templates_Template1005050_Template1005050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      '.Column.Left': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Center': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Right': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column.Left': {
          mb: '$0'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          borderBottom: 'none',
          gridColumn: 'span 2',
          width: '100%'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/Template5050.ts
var templates_Template5050_Template5050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/Template5050100.ts
var templates_Template5050100_Template5050100 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          gridColumn: 'span 2',
          width: '100%'
        }
      }
    }
  },
  customProps: {
    container: {
      className: 'AlignToLeft'
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateColumnist.ts
var templates_TemplateColumnist_TemplateColumnist = {
  css: {
    container: {
      backgroundColor: '#f4f4f4',
      pt: '$4',
      mb: '$4',
      '@lg': {
        pb: '$0',
        mb: '$4'
      }
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '.Column:nth-child(1)': {
        '@lg': {
          display: 'none'
        }
      },
      '.Column:nth-child(2)': {
        display: 'none',
        '@lg': {
          display: 'flex'
        }
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Teaser.mobile:not(:nth-child(1))': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%'
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSideBox.ts
var templates_TemplateSideBox_TemplateSideBox = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        px: '$3',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle'],
        borderBottom: '1px solid #e6e6e6',
        pt: '$4',
        pb: '$0',
        px: '$2',
        mb: '$5'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSideBoxGeneric.ts
var TemplateSideBoxGeneric_TemplateSideBoxGeneric = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSideBoxFixed.ts
var templates_TemplateSideBoxFixed_TemplateSideBoxFixed = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      mt: '$6',
      '@lg': {
        pb: '$0',
        px: '$0',
        mt: '$6',
        mb: '$8',
        position: 'sticky',
        top: '200px'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ExtraTop .ColumnContent': {
        align: ['row', 'left', 'bottom'],
        mb: '0px',
        width: '100%',
        '.pds-Button-root': {
          backgroundColor: '#FFFFFF'
        }
      },
      '.Center .ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderTop: 'unset',
        borderBottomLeftRadius: '$alternative',
        borderBottomRightRadius: '$alternative',
        overflow: 'hidden',
        py: '$0',
        width: '100%'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSideBoxPodcast.ts
var templates_TemplateSideBoxPodcast_TemplateSideBoxPodcast = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        borderRadius: '10px',
        mt: '$6',
        mx: '$3',
        width: '290px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .Teaser:nth-child(2),.Teaser:nth-child(1)': {
        position: 'relative',
        top: '-30px',
        'img': {
          height: '190px',
          width: '190px'
        },
        '.TeaserImage': {
          width: '180px'
        }
      },
      '.ColumnBottom': {
        mb: '$4',
        mx: '$4',
        width: 'calc(100% - $8)',
        'audio': {
          width: 'calc(100% - $8)'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '-$6',
        px: '$0',
        mt: '$1',
        overflowX: 'clip',
        py: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSideBoxRadio.ts
var templates_TemplateSideBoxRadio_TemplateSideBoxRadio = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        px: '$0'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .slide.selected .Teaser': {
        'img': {
          height: '124px',
          width: '124px'
        },
        '.TeaserSubtitleText': {
          maxWidth: '124px'
        },
        '.TeaserTitleText': {
          maxWidth: '124px'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        overflowY: 'inherit',
        overflowX: 'clip',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSideBoxStories.ts
var templates_TemplateSideBoxStories_TemplateSideBoxStories = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      width: 'calc(100% - $4)',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8',
        width: '100%'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left': {
        overflowX: 'clip'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '$3',
        px: '$0',
        mt: '$1',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSideBoxColumnist.ts
var templates_TemplateSideBoxColumnist_TemplateSideBoxColumnist = {
  css: {
    container: {
      pt: '$0',
      '@lg': {
        pb: '$0',
        mb: '$0'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        backgroundColor: '#f4f4f4',
        mb: '$4',
        px: '$2',
        py: '$8',
        width: '100%'
      },
      '.Extra .ColumnContent': {
        backgroundImage: 'none',
        px: '$3',
        py: '$0',
        mb: '$0',
        width: '100%'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.ExtraTop .ColumnContent': {
        backgroundImage: 'none',
        py: '$0',
        px: '$3',
        mt: '$1',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      }
    },
    item: {}
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSideBoxNoTitle.ts
var templates_TemplateSideBoxNoTitle_TemplateSideBoxNoTitle = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$3',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2',
        '.TeaserWrap': {
          py: '$3'
        },
        '.TeaserSubject': {
          px: '$6'
        },
        '.TeaserTitle': {
          px: '$6'
        },
        '.TeaserImage img': {
          borderRadius: '10px 10px 0px 0px'
        }
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$3',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSidebarLeft.ts
var templates_TemplateSidebarLeft_TemplateSidebarLeft = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      flexDirection: 'column-reverse',
      marginTop: '$2',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none',
          marginTop: '24px',
          width: '300px'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          marginTop: '36px',
          width: 'calc(100% - 340px)'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          flexDirection: 'unset',
          align: ['row', 'between', 'middle']
        },
        '.Column.ExtraTop': {
          width: '100%'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateSuperManchete.ts
var templates_TemplateSuperManchete_TemplateSuperManchete = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateVideosLive.ts
var templates_TemplateVideosLive_TemplateVideoLive = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$0',
        px: '$3',
        width: '100%'
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates/TemplateVideos.ts
var templates_TemplateVideos_TemplateVideos = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        mb: '$0',
        px: '$3',
        width: '100%',
        '@lg': {
          align: ['row', 'between', 'top']
        }
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2) .ColumnContent': {
        align: ['column', 'center', 'top']
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column.Left': {
          minWidth: 'calc(50% - $3)',
          width: 'auto'
        },
        '.Column.Center': {
          maxWidth: 'calc(50% - $3)',
          width: 'auto'
        },
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/templates.ts


















var assets_templates_templates = {
  Template100: templates_Template100_Template100,
  Template100100: Template100100_Template100100,
  Template1005050: templates_Template1005050_Template1005050,
  Template5050: templates_Template5050_Template5050,
  Template5050100: templates_Template5050100_Template5050100,
  TemplateColumnist: templates_TemplateColumnist_TemplateColumnist,
  TemplateSideBox: templates_TemplateSideBox_TemplateSideBox,
  TemplateSideBoxGeneric: TemplateSideBoxGeneric_TemplateSideBoxGeneric,
  TemplateSideBoxFixed: templates_TemplateSideBoxFixed_TemplateSideBoxFixed,
  TemplateSideBoxPodcast: templates_TemplateSideBoxPodcast_TemplateSideBoxPodcast,
  TemplateSideBoxRadio: templates_TemplateSideBoxRadio_TemplateSideBoxRadio,
  TemplateSideBoxStories: templates_TemplateSideBoxStories_TemplateSideBoxStories,
  TemplateSideBoxColumnist: templates_TemplateSideBoxColumnist_TemplateSideBoxColumnist,
  TemplateSideBoxNoTitle: templates_TemplateSideBoxNoTitle_TemplateSideBoxNoTitle,
  TemplateSidebarLeft: templates_TemplateSidebarLeft_TemplateSidebarLeft,
  TemplateSuperManchete: templates_TemplateSuperManchete_TemplateSuperManchete,
  TemplateVideoLive: templates_TemplateVideosLive_TemplateVideoLive,
  TemplateVideos: templates_TemplateVideos_TemplateVideos
};
var assets_templates_templatesArray = Object.keys(assets_templates_templates);

;// CONCATENATED MODULE: ./brands/cbnto/assets/topbar.styled.tsx


function cbnto_assets_topbar_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cbnto_assets_topbar_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cbnto_assets_topbar_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cbnto_assets_topbar_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var cbnto_assets_topbar_styled_buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7'
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'DIGITAL',
    hideInMobile: false
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black'
    },
    cssContainer: {
      mr: '$4'
    },
    hideInMobile: false
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020'
    },
    hideInMobile: false
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'ÁUDIO',
    hideInMobile: false
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0'
      }
    },
    value: 'ENTRAR',
    hideInMobile: false
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800'
    },
    hideInMobile: false
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none'
      }
    },
    hideInMobile: false
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content'
    },
    hideInMobile: false
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#FFF',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content'
      }
    },
    hideInMobile: false
  }
};
var cbnto_assets_topbar_styled_TopbarMobileSlotLeft = function TopbarMobileSlotLeft() {
  var drawersContext = (0,react.useContext)(DrawersProvider.DrawersContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcHamburguerMobile'),
      onClick: function onClick() {
        return drawersContext.handleSideMenuLeft({
          open: !drawersContext.sideMenuLeftState.open
        });
      }
    })
  });
};
var cbnto_assets_topbar_styled_TopbarMobileSlotRight = function TopbarMobileSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcAudioMobile')
    })
  });
};
var cbnto_assets_topbar_styled_TopbarTopSlotLeft = function TopbarTopSlotLeft() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "https://www.gjccorp.com.br/",
      title: "GJC",
      target: "_blank",
      rel: "noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        icon: (0,hooks_useIcon/* useIcon */.b)("IcOjc")
      })
    })
  });
};
var cbnto_assets_topbar_styled_TopbarTopSlotRight = function TopbarTopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, cbnto_assets_topbar_styled_objectSpread({
      href: "https://classi.com.br",
      value: "Classi"
    }, cbnto_assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, cbnto_assets_topbar_styled_objectSpread({
      href: "https://daqui.opopular.com.br",
      value: "Jornal Daqui"
    }, cbnto_assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, cbnto_assets_topbar_styled_objectSpread({
      href: "https://opopular.com.br/",
      value: "Jornal O Popular"
    }, cbnto_assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, cbnto_assets_topbar_styled_objectSpread({
      href: "https://www.jornaldotocantins.com.br",
      value: "Jornal do Tocantins"
    }, cbnto_assets_topbar_styled_buttons.topbarTopItemsRight))]
  });
};
var cbnto_assets_topbar_styled_TopbarDesktopSlotRight = function TopbarDesktopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var cbnto_assets_topbar_styled_TopbarExtraSlotRight = function TopbarExtraSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
;// CONCATENATED MODULE: ./brands/cbnto/assets/topbar.tsx


var assets_topbar_topbar = {
  topbarMobile: {
    mainLogo: 'LogoCBNMobile',
    css: {
      cssContainer: {
        background: '#F7F7F7',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)',
        height: '52px',
        width: '100%'
      },
      cssContainerMiddleHolder: {
        height: '100%',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '100%',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        paddingLeft: '18px',
        width: '80px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'right', 'middle'],
        paddingRight: '18px',
        width: '80px'
      },
      cssContainerBottom: {
        display: 'none'
      }
    },
    slotMiddleLeft: cbnto_assets_topbar_styled_TopbarMobileSlotLeft,
    slotMiddleRight: cbnto_assets_topbar_styled_TopbarMobileSlotRight
  },
  topbarDesktop: {
    mainLogo: 'LogoCBNDesktop',
    css: {
      cssContainerTopHolder: {
        align: ['row', 'center', 'middle'],
        background: '$primaryMain',
        px: '$4',
        width: '100%'
      },
      cssContainerTop: {
        align: ['row', 'between', 'middle'],
        height: '32px',
        maxWidth: '1280px'
      },
      cssContainerTopSlotRight: {
        align: ['row', 'right', 'middle']
      },
      cssContainerMiddleHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '110px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        minWidth: '400px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'between', 'middle'],
        minWidth: '400px'
      },
      cssContainerBottomHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%',
        ' > div': {
          align: ['row', 'between', 'middle'],
          borderTop: '1px solid #E6E6E6'
        }
      },
      cssContainerBottom: {
        align: ['row', 'between', 'middle'],
        background: '#F7F7F7',
        height: '40px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerBottomLeft: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      cssContainerBottomRight: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      topbarItems: {
        item: {
          label: {
            color: '#202020',
            fontSize: '14px',
            fontFamily: '$primary',
            fontWeight: 500,
            textTransform: 'uppercase',
            width: 'max-content'
          },
          li: {
            'a': {
              borderBottom: '4px solid transparent',
              cursor: 'pointer',
              display: 'block',
              height: '100%',
              width: '100%',
              pb: '6px',
              pr: '$4',
              pt: '10px'
            }
          }
        }
      }
    },
    slotTopLeft: cbnto_assets_topbar_styled_TopbarTopSlotLeft,
    slotTopRight: cbnto_assets_topbar_styled_TopbarTopSlotRight,
    slotMiddleLeft: TopbarDesktopSlotLeft,
    slotMiddleRight: cbnto_assets_topbar_styled_TopbarDesktopSlotRight,
    slotBottomRight: cbnto_assets_topbar_styled_TopbarExtraSlotRight
  }
};
/* harmony default export */ var cbnto_assets_topbar = ((/* unused pure expression or super */ null && (assets_topbar_topbar)));
;// CONCATENATED MODULE: ./brands/cbnto/assets/index.ts












var cbnto_assets_banners = cbnto_indexes_banners_namespaceObject.k;
var cbnto_assets_favicons = cbnto_indexes_favicons_namespaceObject.k;
var cbnto_assets_logos = cbnto_indexes_logos_namespaceObject.k;
var cbnto_assets_icons = cbnto_indexes_icons_namespaceObject.k;
var cbnto_assets_splashScreens = cbnto_indexes_splashScreens_namespaceObject.k;
var CBNTOAssets = {
  article: assets_article_article,
  banners: cbnto_assets_banners,
  favicons: cbnto_assets_favicons,
  footer: assets_footer_FooterConfig,
  logos: cbnto_assets_logos,
  icons: cbnto_assets_icons,
  menus: {
    sideMenuLeft: assets_menus_sideMenuLeft
  },
  slotLayouts: assets_layouts_slotLayouts,
  splashScreens: cbnto_assets_splashScreens,
  teasers: cbnto_assets_teasers_teasers,
  templates: assets_templates_templates,
  topbar: assets_topbar_topbar
};
;// CONCATENATED MODULE: ./brands/cbn/indexes/colors.json
var colors_namespaceObject = JSON.parse('{"vU":{"primaryMain":"#D72027","primary900":"#194392","primary800":"#235FB1","primary700":"#2970C2","primary600":"#2F82D5","primary500":"#338FE3","primary400":"#4C9FE7","primary300":"#68AFEB","primary200":"#92C6F0","primary100":"#BBDCF6","primary50":"#E4F1FC","secondaryMain":"#938783","secondary900":"#787A1B","secondary800":"#90A12D","secondary700":"#9FB936","secondary600":"#AECF41","secondary500":"#B9E048","secondary400":"#C2E561","secondary300":"#CDEB7C","secondary200":"#DBF1A1","secondary100":"#E9F5C6","secondary50":"#F6FCE8","tertiaryMain":"#F5CE5E","tertiary900":"#EA6F2C","tertiary800":"#EC8C34","tertiary700":"#ED9C38","tertiary600":"#EFAC3C","tertiary500":"#F0B941","tertiary400":"#F2C34F","tertiary300":"#F4CE67","tertiary200":"#F7DB8F","tertiary100":"#FAE9BA","tertiary50":"#FDF7E4"},"T9":{"headlineTextMain":"#000000","paragraphTextMain":"#333333","backgroundMain":"#F7F7F7"},"Dh":{"politicaMain":"#4597BC","politica900":"#2A5574","politica800":"#367497","politica700":"#3B85AA","politica600":"#4597BC","politica500":"#4CA5C9","politica400":"#59B1D0","politica300":"#6DBED7","politica200":"#8FD0E2","politica100":"#B9E3ED","politica50":"#E3F4F8","mundoMain":"#8BCAC8","mundo900":"#174D45","mundo800":"#206961","mundo700":"#247971","mundo600":"#288981","mundo500":"#2C968F","mundo400":"#40A5A0","mundo300":"#5FB5B1","mundo200":"#8BCAC8","mundo100":"#B8DEDD","mundo50":"#E3F2F2","economiaMain":"#589B72","economia900":"#2A5E26","economia800":"#4A8039","economia700":"#5C9443","economia600":"#6EA84E","economia500":"#7CB856","economia400":"#8FC26E","economia300":"#A2CC86","economia200":"#BCDAA8","economia100":"#D7EAC9","economia50":"#EFF7EA","cidadeMain":"#8FC26E","cidade900":"#3E5847","cidade800":"#49785B","cidade700":"#4F8966","cidade600":"#589B72","cidade500":"#60AA7E","cidade400":"#75B690","cidade300":"#8BC3A3","cidade200":"#ABD4BC","cidade100":"#CBE5D6","cidade50":"#EAF4EE","especiaisMain":"#AFAC83","especiais900":"#8A877A","especiais800":"#AFAC83","especiais700":"#C3C28A","especiais600":"#D7D895","especiais500":"#E3E89B","especiais400":"#E8EDA6","especiais300":"#ECF1B3","especiais200":"#F1F5C5","especiais100":"#F6F9DC","especiais50":"#FBFDF1","colunistaMain":"#AF8F7F","colunista900":"#4D2D25","colunista800":"#5D3B30","colunista700":"#6B4839","colunista600":"#7B5443","colunista500":"#875E4A","colunista400":"#9B7665","colunista300":"#AF8F7F","colunista200":"#CAAEA2","colunista100":"#E3CEC4","colunista50":"#F9EBE2","esporteMain":"#FB814C","esporte900":"#BC4D1B","esporte800":"#D45A23","esporte700":"#E26126","esporte600":"#F0682B","esporte500":"#FB6F2F","esporte400":"#FB814C","esporte300":"#FC976B","esporte200":"#FDB395","esporte100":"#FDD1BF","esporte50":"#FBEBE8","videoMain":"#EE6D6F","video900":"#BE071A","video800":"#CE1525","video700":"#DB1E2C","video600":"#ED2B32","video500":"#FB3733","video400":"#F9484C","video300":"#EE6D6F","video200":"#F69797","video100":"#FECCD1","video50":"#FFEAED","vida-urbanaMain":"#69a840","magazineMain":"#E982B0","magazine900":"#760649","magazine800":"#9A0952","magazine700":"#AF0B58","magazine600":"#C50D5D","magazine500":"#D50F60","magazine400":"#DB1B78","magazine300":"#E14D90","magazine200":"#E982B0","magazine100":"#F1B4D0","magazine50":"#FAE1EC"},"yT":{"semanticError":"#F9484C","semanticSuccess":"#A2CC86"}}');
;// CONCATENATED MODULE: ./brands/cbn/assets/colors.ts


function colors_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function colors_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? colors_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : colors_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var colors = colors_objectSpread(colors_objectSpread(colors_objectSpread(colors_objectSpread({}, colors_namespaceObject.vU), colors_namespaceObject.Dh), colors_namespaceObject.yT), colors_namespaceObject.T9);
;// CONCATENATED MODULE: ./brands/cbn/indexes/type-system.json
var type_system_namespaceObject = JSON.parse('{"CH":{"caption3":"16px","headline3":"36px","caption1":"14px","headline6":"20px","headline2":"43px","paragraph4":"18px","paragraph3":"18px","headline4":"25px","paragraphPaywall":"14px","widget5":"18px","headline5":"20px","retrancaWidget":"18px","widgetMaisLidas":"18px","widgetEsporteDestaque":"12px","widgetEsporte":"12px","headlineDestaqueEditoria2":"22px","caption4":"14px","retrancaHamburger":"18px","caption5":"14px","headlineStories":"16px","headlineDestaqueEditoria1":"28px","destaquePaywall":"14px","subtitle":"24px","caption2":"14px","paragraph2":"22px","paragraph2Link":"22px","paragraph1":"22px","headline1":"60px","retrancaEBook":"20px","headlinePaywall":"30px","preOAssinatura":"75px","widgetUdioTime":"14px","paragraph5":"16px","paragraph6":"20px"},"vC":{"caption3":500,"headline3":700,"caption1":700,"headline6":400,"headline2":700,"paragraph4":400,"paragraph3":500,"headline4":600,"paragraphPaywall":400,"widget5":400,"headline5":500,"retrancaWidget":500,"widgetMaisLidas":500,"widgetEsporteDestaque":600,"widgetEsporte":400,"headlineDestaqueEditoria2":700,"caption4":500,"retrancaHamburger":600,"caption5":400,"headlineStories":500,"headlineDestaqueEditoria1":600,"destaquePaywall":700,"subtitle":400,"caption2":400,"paragraph2":400,"paragraph2Link":400,"paragraph1":500,"headline1":700,"retrancaEBook":700,"headlinePaywall":700,"preOAssinatura":700,"widgetUdioTime":300,"paragraph5":400,"paragraph6":400},"tO":{"caption3":"19.2px","headline3":"43px","caption1":"20.8px","headline6":"25px","headline2":"50px","paragraph4":"23px","paragraph3":"25px","headline4":"30px","paragraphPaywall":"16.4px","widget5":"21.6px","headline5":"24px","retrancaWidget":"32.5px","widgetMaisLidas":"21.6px","widgetEsporteDestaque":"14.4px","widgetEsporte":"14.4px","headlineDestaqueEditoria2":"24px","caption4":"16.8px","retrancaHamburger":"21.6px","caption5":"16.8px","headlineStories":"19.2px","headlineDestaqueEditoria1":"30px","destaquePaywall":"16.4px","subtitle":"30px","caption2":"16.8px","paragraph2":"35px","paragraph2Link":"35px","paragraph1":"35px","headline1":"70px","retrancaEBook":"20px","headlinePaywall":"43px","preOAssinatura":"90px","widgetUdioTime":"16.94px","paragraph5":"22px","paragraph6":"23.4px"}}');
;// CONCATENATED MODULE: ./brands/cbn/theme.ts


function theme_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function theme_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? theme_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : theme_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck



var fontSizes = type_system_namespaceObject.CH,
    fontWeights = type_system_namespaceObject.vC,
    lineHeights = type_system_namespaceObject.tO;
var CBNTheme = prensa/* PrensaEngine.createTheme */.u7.createTheme('cbn', {
  colors: theme_objectSpread({}, colors),
  fonts: {
    primary: 'Roboto Slab',
    secondary: 'Fira Sans Condensed'
  },
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  radii: {
    unset: '0px',
    "default": '4px',
    alternative: '10px',
    rounded: '99px',
    circle: '50%'
  }
});
;// CONCATENATED MODULE: ./brands/cbngo/indexes/colors.json
var cbngo_indexes_colors_namespaceObject = JSON.parse('{"vU":{"primaryMain":"#D72027","primary900":"#194392","primary800":"#235FB1","primary700":"#2970C2","primary600":"#2F82D5","primary500":"#338FE3","primary400":"#4C9FE7","primary300":"#68AFEB","primary200":"#92C6F0","primary100":"#BBDCF6","primary50":"#E4F1FC","secondaryMain":"#938783","secondary900":"#787A1B","secondary800":"#90A12D","secondary700":"#9FB936","secondary600":"#AECF41","secondary500":"#B9E048","secondary400":"#C2E561","secondary300":"#CDEB7C","secondary200":"#DBF1A1","secondary100":"#E9F5C6","secondary50":"#F6FCE8","tertiaryMain":"#F5CE5E","tertiary900":"#EA6F2C","tertiary800":"#EC8C34","tertiary700":"#ED9C38","tertiary600":"#EFAC3C","tertiary500":"#F0B941","tertiary400":"#F2C34F","tertiary300":"#F4CE67","tertiary200":"#F7DB8F","tertiary100":"#FAE9BA","tertiary50":"#FDF7E4"},"T9":{"headlineTextMain":"#000000","paragraphTextMain":"#333333","backgroundMain":"#F7F7F7"},"Dh":{"politicaMain":"#4597BC","politica900":"#2A5574","politica800":"#367497","politica700":"#3B85AA","politica600":"#4597BC","politica500":"#4CA5C9","politica400":"#59B1D0","politica300":"#6DBED7","politica200":"#8FD0E2","politica100":"#B9E3ED","politica50":"#E3F4F8","mundoMain":"#8BCAC8","mundo900":"#174D45","mundo800":"#206961","mundo700":"#247971","mundo600":"#288981","mundo500":"#2C968F","mundo400":"#40A5A0","mundo300":"#5FB5B1","mundo200":"#8BCAC8","mundo100":"#B8DEDD","mundo50":"#E3F2F2","economiaMain":"#589B72","economia900":"#2A5E26","economia800":"#4A8039","economia700":"#5C9443","economia600":"#6EA84E","economia500":"#7CB856","economia400":"#8FC26E","economia300":"#A2CC86","economia200":"#BCDAA8","economia100":"#D7EAC9","economia50":"#EFF7EA","cidadeMain":"#8FC26E","cidade900":"#3E5847","cidade800":"#49785B","cidade700":"#4F8966","cidade600":"#589B72","cidade500":"#60AA7E","cidade400":"#75B690","cidade300":"#8BC3A3","cidade200":"#ABD4BC","cidade100":"#CBE5D6","cidade50":"#EAF4EE","especiaisMain":"#AFAC83","especiais900":"#8A877A","especiais800":"#AFAC83","especiais700":"#C3C28A","especiais600":"#D7D895","especiais500":"#E3E89B","especiais400":"#E8EDA6","especiais300":"#ECF1B3","especiais200":"#F1F5C5","especiais100":"#F6F9DC","especiais50":"#FBFDF1","colunistaMain":"#AF8F7F","colunista900":"#4D2D25","colunista800":"#5D3B30","colunista700":"#6B4839","colunista600":"#7B5443","colunista500":"#875E4A","colunista400":"#9B7665","colunista300":"#AF8F7F","colunista200":"#CAAEA2","colunista100":"#E3CEC4","colunista50":"#F9EBE2","esporteMain":"#FB814C","esporte900":"#BC4D1B","esporte800":"#D45A23","esporte700":"#E26126","esporte600":"#F0682B","esporte500":"#FB6F2F","esporte400":"#FB814C","esporte300":"#FC976B","esporte200":"#FDB395","esporte100":"#FDD1BF","esporte50":"#FBEBE8","videoMain":"#EE6D6F","video900":"#BE071A","video800":"#CE1525","video700":"#DB1E2C","video600":"#ED2B32","video500":"#FB3733","video400":"#F9484C","video300":"#EE6D6F","video200":"#F69797","video100":"#FECCD1","video50":"#FFEAED","magazineMain":"#E982B0","magazine900":"#760649","magazine800":"#9A0952","magazine700":"#AF0B58","magazine600":"#C50D5D","magazine500":"#D50F60","magazine400":"#DB1B78","magazine300":"#E14D90","magazine200":"#E982B0","magazine100":"#F1B4D0","magazine50":"#FAE1EC"},"yT":{"semanticError":"#F9484C","semanticSuccess":"#A2CC86"}}');
;// CONCATENATED MODULE: ./brands/cbngo/assets/colors.ts


function assets_colors_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function assets_colors_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? assets_colors_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : assets_colors_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var colors_colors = assets_colors_objectSpread(assets_colors_objectSpread(assets_colors_objectSpread(assets_colors_objectSpread({}, cbngo_indexes_colors_namespaceObject.vU), cbngo_indexes_colors_namespaceObject.Dh), cbngo_indexes_colors_namespaceObject.yT), cbngo_indexes_colors_namespaceObject.T9);
;// CONCATENATED MODULE: ./brands/cbngo/indexes/type-system.json
var cbngo_indexes_type_system_namespaceObject = JSON.parse('{"CH":{"caption3":"16px","headline3":"36px","caption1":"14px","headline6":"20px","headline2":"43px","paragraph4":"18px","paragraph3":"18px","headline4":"25px","paragraphPaywall":"14px","widget5":"18px","headline5":"20px","retrancaWidget":"18px","widgetMaisLidas":"18px","widgetEsporteDestaque":"12px","widgetEsporte":"12px","headlineDestaqueEditoria2":"22px","caption4":"14px","retrancaHamburger":"18px","caption5":"14px","headlineStories":"16px","headlineDestaqueEditoria1":"28px","destaquePaywall":"14px","subtitle":"24px","caption2":"14px","paragraph2":"22px","paragraph2Link":"22px","paragraph1":"22px","headline1":"60px","retrancaEBook":"20px","headlinePaywall":"30px","preOAssinatura":"75px","widgetUdioTime":"14px","paragraph5":"16px","paragraph6":"20px"},"vC":{"caption3":500,"headline3":700,"caption1":700,"headline6":400,"headline2":700,"paragraph4":400,"paragraph3":500,"headline4":600,"paragraphPaywall":400,"widget5":400,"headline5":500,"retrancaWidget":500,"widgetMaisLidas":500,"widgetEsporteDestaque":600,"widgetEsporte":400,"headlineDestaqueEditoria2":700,"caption4":500,"retrancaHamburger":600,"caption5":400,"headlineStories":500,"headlineDestaqueEditoria1":600,"destaquePaywall":700,"subtitle":400,"caption2":400,"paragraph2":400,"paragraph2Link":400,"paragraph1":500,"headline1":700,"retrancaEBook":700,"headlinePaywall":700,"preOAssinatura":700,"widgetUdioTime":300,"paragraph5":400,"paragraph6":400},"tO":{"caption3":"19.2px","headline3":"43px","caption1":"20.8px","headline6":"25px","headline2":"50px","paragraph4":"23px","paragraph3":"25px","headline4":"30px","paragraphPaywall":"16.4px","widget5":"21.6px","headline5":"24px","retrancaWidget":"32.5px","widgetMaisLidas":"21.6px","widgetEsporteDestaque":"14.4px","widgetEsporte":"14.4px","headlineDestaqueEditoria2":"24px","caption4":"16.8px","retrancaHamburger":"21.6px","caption5":"16.8px","headlineStories":"19.2px","headlineDestaqueEditoria1":"30px","destaquePaywall":"16.4px","subtitle":"30px","caption2":"16.8px","paragraph2":"35px","paragraph2Link":"35px","paragraph1":"35px","headline1":"70px","retrancaEBook":"20px","headlinePaywall":"43px","preOAssinatura":"90px","widgetUdioTime":"16.94px","paragraph5":"22px","paragraph6":"23.4px"}}');
;// CONCATENATED MODULE: ./brands/cbngo/theme.ts


function cbngo_theme_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cbngo_theme_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cbngo_theme_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cbngo_theme_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck



var theme_fontSizes = cbngo_indexes_type_system_namespaceObject.CH,
    theme_fontWeights = cbngo_indexes_type_system_namespaceObject.vC,
    theme_lineHeights = cbngo_indexes_type_system_namespaceObject.tO;
var CBNGOTheme = prensa/* PrensaEngine.createTheme */.u7.createTheme('cbngo', {
  colors: cbngo_theme_objectSpread({}, colors_colors),
  fonts: {
    primary: 'Roboto Slab',
    secondary: 'Fira Sans Condensed'
  },
  fontSizes: theme_fontSizes,
  fontWeights: theme_fontWeights,
  lineHeights: theme_lineHeights,
  radii: {
    unset: '0px',
    "default": '4px',
    alternative: '10px',
    rounded: '99px',
    circle: '50%'
  }
});
;// CONCATENATED MODULE: ./brands/cbnto/indexes/colors.json
var cbnto_indexes_colors_namespaceObject = JSON.parse('{"vU":{"primaryMain":"#D72027","primary900":"#194392","primary800":"#235FB1","primary700":"#2970C2","primary600":"#2F82D5","primary500":"#338FE3","primary400":"#4C9FE7","primary300":"#68AFEB","primary200":"#92C6F0","primary100":"#BBDCF6","primary50":"#E4F1FC","secondaryMain":"#938783","secondary900":"#787A1B","secondary800":"#90A12D","secondary700":"#9FB936","secondary600":"#AECF41","secondary500":"#B9E048","secondary400":"#C2E561","secondary300":"#CDEB7C","secondary200":"#DBF1A1","secondary100":"#E9F5C6","secondary50":"#F6FCE8","tertiaryMain":"#F5CE5E","tertiary900":"#EA6F2C","tertiary800":"#EC8C34","tertiary700":"#ED9C38","tertiary600":"#EFAC3C","tertiary500":"#F0B941","tertiary400":"#F2C34F","tertiary300":"#F4CE67","tertiary200":"#F7DB8F","tertiary100":"#FAE9BA","tertiary50":"#FDF7E4"},"T9":{"headlineTextMain":"#000000","paragraphTextMain":"#333333","backgroundMain":"#F7F7F7"},"Dh":{"politicaMain":"#4597BC","politica900":"#2A5574","politica800":"#367497","politica700":"#3B85AA","politica600":"#4597BC","politica500":"#4CA5C9","politica400":"#59B1D0","politica300":"#6DBED7","politica200":"#8FD0E2","politica100":"#B9E3ED","politica50":"#E3F4F8","mundoMain":"#8BCAC8","mundo900":"#174D45","mundo800":"#206961","mundo700":"#247971","mundo600":"#288981","mundo500":"#2C968F","mundo400":"#40A5A0","mundo300":"#5FB5B1","mundo200":"#8BCAC8","mundo100":"#B8DEDD","mundo50":"#E3F2F2","economiaMain":"#589B72","economia900":"#2A5E26","economia800":"#4A8039","economia700":"#5C9443","economia600":"#6EA84E","economia500":"#7CB856","economia400":"#8FC26E","economia300":"#A2CC86","economia200":"#BCDAA8","economia100":"#D7EAC9","economia50":"#EFF7EA","cidadeMain":"#8FC26E","cidade900":"#3E5847","cidade800":"#49785B","cidade700":"#4F8966","cidade600":"#589B72","cidade500":"#60AA7E","cidade400":"#75B690","cidade300":"#8BC3A3","cidade200":"#ABD4BC","cidade100":"#CBE5D6","cidade50":"#EAF4EE","especiaisMain":"#AFAC83","especiais900":"#8A877A","especiais800":"#AFAC83","especiais700":"#C3C28A","especiais600":"#D7D895","especiais500":"#E3E89B","especiais400":"#E8EDA6","especiais300":"#ECF1B3","especiais200":"#F1F5C5","especiais100":"#F6F9DC","especiais50":"#FBFDF1","colunistaMain":"#AF8F7F","colunista900":"#4D2D25","colunista800":"#5D3B30","colunista700":"#6B4839","colunista600":"#7B5443","colunista500":"#875E4A","colunista400":"#9B7665","colunista300":"#AF8F7F","colunista200":"#CAAEA2","colunista100":"#E3CEC4","colunista50":"#F9EBE2","esporteMain":"#FB814C","esporte900":"#BC4D1B","esporte800":"#D45A23","esporte700":"#E26126","esporte600":"#F0682B","esporte500":"#FB6F2F","esporte400":"#FB814C","esporte300":"#FC976B","esporte200":"#FDB395","esporte100":"#FDD1BF","esporte50":"#FBEBE8","videoMain":"#EE6D6F","video900":"#BE071A","video800":"#CE1525","video700":"#DB1E2C","video600":"#ED2B32","video500":"#FB3733","video400":"#F9484C","video300":"#EE6D6F","video200":"#F69797","video100":"#FECCD1","video50":"#FFEAED","magazineMain":"#E982B0","magazine900":"#760649","magazine800":"#9A0952","magazine700":"#AF0B58","magazine600":"#C50D5D","magazine500":"#D50F60","magazine400":"#DB1B78","magazine300":"#E14D90","magazine200":"#E982B0","magazine100":"#F1B4D0","magazine50":"#FAE1EC"},"yT":{"semanticError":"#F9484C","semanticSuccess":"#A2CC86"}}');
;// CONCATENATED MODULE: ./brands/cbnto/assets/colors.ts


function cbnto_assets_colors_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cbnto_assets_colors_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cbnto_assets_colors_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cbnto_assets_colors_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var assets_colors_colors = cbnto_assets_colors_objectSpread(cbnto_assets_colors_objectSpread(cbnto_assets_colors_objectSpread(cbnto_assets_colors_objectSpread({}, cbnto_indexes_colors_namespaceObject.vU), cbnto_indexes_colors_namespaceObject.Dh), cbnto_indexes_colors_namespaceObject.yT), cbnto_indexes_colors_namespaceObject.T9);
;// CONCATENATED MODULE: ./brands/cbnto/indexes/type-system.json
var cbnto_indexes_type_system_namespaceObject = JSON.parse('{"CH":{"caption3":"16px","headline3":"36px","caption1":"14px","headline6":"20px","headline2":"43px","paragraph4":"18px","paragraph3":"18px","headline4":"25px","paragraphPaywall":"14px","widget5":"18px","headline5":"20px","retrancaWidget":"18px","widgetMaisLidas":"18px","widgetEsporteDestaque":"12px","widgetEsporte":"12px","headlineDestaqueEditoria2":"22px","caption4":"14px","retrancaHamburger":"18px","caption5":"14px","headlineStories":"16px","headlineDestaqueEditoria1":"28px","destaquePaywall":"14px","subtitle":"24px","caption2":"14px","paragraph2":"22px","paragraph2Link":"22px","paragraph1":"22px","headline1":"60px","retrancaEBook":"20px","headlinePaywall":"30px","preOAssinatura":"75px","widgetUdioTime":"14px","paragraph5":"16px","paragraph6":"20px"},"vC":{"caption3":500,"headline3":700,"caption1":700,"headline6":400,"headline2":700,"paragraph4":400,"paragraph3":500,"headline4":600,"paragraphPaywall":400,"widget5":400,"headline5":500,"retrancaWidget":500,"widgetMaisLidas":500,"widgetEsporteDestaque":600,"widgetEsporte":400,"headlineDestaqueEditoria2":700,"caption4":500,"retrancaHamburger":600,"caption5":400,"headlineStories":500,"headlineDestaqueEditoria1":600,"destaquePaywall":700,"subtitle":400,"caption2":400,"paragraph2":400,"paragraph2Link":400,"paragraph1":500,"headline1":700,"retrancaEBook":700,"headlinePaywall":700,"preOAssinatura":700,"widgetUdioTime":300,"paragraph5":400,"paragraph6":400},"tO":{"caption3":"19.2px","headline3":"43px","caption1":"20.8px","headline6":"25px","headline2":"50px","paragraph4":"23px","paragraph3":"25px","headline4":"30px","paragraphPaywall":"16.4px","widget5":"21.6px","headline5":"24px","retrancaWidget":"32.5px","widgetMaisLidas":"21.6px","widgetEsporteDestaque":"14.4px","widgetEsporte":"14.4px","headlineDestaqueEditoria2":"24px","caption4":"16.8px","retrancaHamburger":"21.6px","caption5":"16.8px","headlineStories":"19.2px","headlineDestaqueEditoria1":"30px","destaquePaywall":"16.4px","subtitle":"30px","caption2":"16.8px","paragraph2":"35px","paragraph2Link":"35px","paragraph1":"35px","headline1":"70px","retrancaEBook":"20px","headlinePaywall":"43px","preOAssinatura":"90px","widgetUdioTime":"16.94px","paragraph5":"22px","paragraph6":"23.4px"}}');
;// CONCATENATED MODULE: ./brands/cbnto/theme.ts


function cbnto_theme_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cbnto_theme_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cbnto_theme_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cbnto_theme_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck



var cbnto_theme_fontSizes = cbnto_indexes_type_system_namespaceObject.CH,
    cbnto_theme_fontWeights = cbnto_indexes_type_system_namespaceObject.vC,
    cbnto_theme_lineHeights = cbnto_indexes_type_system_namespaceObject.tO;
var CBNTOTheme = prensa/* PrensaEngine.createTheme */.u7.createTheme('cbnto', {
  colors: cbnto_theme_objectSpread({}, assets_colors_colors),
  fonts: {
    primary: 'Roboto Slab',
    secondary: 'Fira Sans Condensed'
  },
  fontSizes: cbnto_theme_fontSizes,
  fontWeights: cbnto_theme_fontWeights,
  lineHeights: cbnto_theme_lineHeights,
  radii: {
    unset: '0px',
    "default": '4px',
    alternative: '10px',
    rounded: '99px',
    circle: '50%'
  }
});
;// CONCATENATED MODULE: ./brands/daqui/indexes/banners.json
var daqui_indexes_banners_namespaceObject = JSON.parse('{"k":[{"fullName":"BannerAnuncie.svg","name":"BannerAnuncie","url":"/assets/daqui/banners/BannerAnuncie.svg","height":"68","width":"200"},{"fullName":"BannerAnuncieAqui.svg","name":"BannerAnuncieAqui","url":"/assets/daqui/banners/BannerAnuncieAqui.svg","height":"13","width":"96"},{"fullName":"BannerAssineAgora.svg","name":"BannerAssineAgora","url":"/assets/daqui/banners/BannerAssineAgora.svg","height":"62","width":"232","target":"blank"},{"fullName":"BannerAssineAgoraCondensado.svg","name":"BannerAssineAgoraCondensado","url":"/assets/daqui/banners/BannerAssineAgoraCondensado.svg","height":"32","width":"165"},{"fullName":"BannerClube.svg","name":"BannerClube","url":"/assets/daqui/banners/BannerClube.svg","height":"50","width":"84"},{"fullName":"BannerClubeBackground.png","name":"BannerClubeBackground","url":"/assets/daqui/banners/BannerClubeBackground.png","height":"","width":""},{"fullName":"BannerWhatsApp.svg","name":"BannerWhatsApp","url":"/assets/daqui/banners/BannerWhatsApp.svg","height":"150","width":"301"}]}');
;// CONCATENATED MODULE: ./brands/daqui/indexes/favicons.json
var daqui_indexes_favicons_namespaceObject = JSON.parse('{"k":[{"fullName":"128x128.png","name":"128x128","url":"/assets/daqui/favicons/128x128.png","height":"","width":""},{"fullName":"150x150.png","name":"150x150","url":"/assets/daqui/favicons/150x150.png","height":"","width":""},{"fullName":"192x192.png","name":"192x192","url":"/assets/daqui/favicons/192x192.png","height":"","width":""},{"fullName":"310x310.png","name":"310x310","url":"/assets/daqui/favicons/310x310.png","height":"","width":""},{"fullName":"70x70.png","name":"70x70","url":"/assets/daqui/favicons/70x70.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/daqui/indexes/icons.json
var daqui_indexes_icons_namespaceObject = JSON.parse('{"k":[{"fullName":"IcAbrirAzul.svg","name":"IcAbrirAzul","url":"/assets/daqui/icons/IcAbrirAzul.svg","height":"16","width":"16"},{"fullName":"IcAbrirCinza.svg","name":"IcAbrirCinza","url":"/assets/daqui/icons/IcAbrirCinza.svg","height":"16","width":"16"},{"fullName":"IcAudio.svg","name":"IcAudio","url":"/assets/daqui/icons/IcAudio.svg","height":"13","width":"17"},{"fullName":"IcAudioDescricao.svg","name":"IcAudioDescricao","url":"/assets/daqui/icons/IcAudioDescricao.svg","height":"13","width":"18"},{"fullName":"IcAudioMobile.svg","name":"IcAudioMobile","url":"/assets/daqui/icons/IcAudioMobile.svg","height":"16","width":"20"},{"fullName":"IcAudiodescricaoCinza.svg","name":"IcAudiodescricaoCinza","url":"/assets/daqui/icons/IcAudiodescricaoCinza.svg","height":"15","width":"19"},{"fullName":"IcAvancarCinza.svg","name":"IcAvancarCinza","url":"/assets/daqui/icons/IcAvancarCinza.svg","height":"16","width":"8"},{"fullName":"IcBotaoFacebook.svg","name":"IcBotaoFacebook","url":"/assets/daqui/icons/IcBotaoFacebook.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookBranco.svg","name":"IcBotaoFacebookBranco","url":"/assets/daqui/icons/IcBotaoFacebookBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookCinza.svg","name":"IcBotaoFacebookCinza","url":"/assets/daqui/icons/IcBotaoFacebookCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoFacebookPreto.svg","name":"IcBotaoFacebookPreto","url":"/assets/daqui/icons/IcBotaoFacebookPreto.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagram.svg","name":"IcBotaoInstagram","url":"/assets/daqui/icons/IcBotaoInstagram.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramBranco.svg","name":"IcBotaoInstagramBranco","url":"/assets/daqui/icons/IcBotaoInstagramBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramCinza.svg","name":"IcBotaoInstagramCinza","url":"/assets/daqui/icons/IcBotaoInstagramCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagramPreto.svg","name":"IcBotaoInstagramPreto","url":"/assets/daqui/icons/IcBotaoInstagramPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoLinkedin.svg","name":"IcBotaoLinkedin","url":"/assets/daqui/icons/IcBotaoLinkedin.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinBranco.svg","name":"IcBotaoLinkedinBranco","url":"/assets/daqui/icons/IcBotaoLinkedinBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinCinza.svg","name":"IcBotaoLinkedinCinza","url":"/assets/daqui/icons/IcBotaoLinkedinCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoLinkedinPreto.svg","name":"IcBotaoLinkedinPreto","url":"/assets/daqui/icons/IcBotaoLinkedinPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoTwitter.svg","name":"IcBotaoTwitter","url":"/assets/daqui/icons/IcBotaoTwitter.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterBranco.svg","name":"IcBotaoTwitterBranco","url":"/assets/daqui/icons/IcBotaoTwitterBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterCinza.svg","name":"IcBotaoTwitterCinza","url":"/assets/daqui/icons/IcBotaoTwitterCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoTwitterPreto.svg","name":"IcBotaoTwitterPreto","url":"/assets/daqui/icons/IcBotaoTwitterPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoWhatsApp.svg","name":"IcBotaoWhatsApp","url":"/assets/daqui/icons/IcBotaoWhatsApp.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppBranco.svg","name":"IcBotaoWhatsAppBranco","url":"/assets/daqui/icons/IcBotaoWhatsAppBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppCinza.svg","name":"IcBotaoWhatsAppCinza","url":"/assets/daqui/icons/IcBotaoWhatsAppCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoWhatsAppPreto.svg","name":"IcBotaoWhatsAppPreto","url":"/assets/daqui/icons/IcBotaoWhatsAppPreto.svg","height":"33","width":"34"},{"fullName":"IcBuscar.svg","name":"IcBuscar","url":"/assets/daqui/icons/IcBuscar.svg","height":"15","width":"15"},{"fullName":"IcChave.svg","name":"IcChave","url":"/assets/daqui/icons/IcChave.svg","height":"14","width":"25"},{"fullName":"IcChaveAzul.svg","name":"IcChaveAzul","url":"/assets/daqui/icons/IcChaveAzul.svg","height":"14","width":"25"},{"fullName":"IcCheckAzul.svg","name":"IcCheckAzul","url":"/assets/daqui/icons/IcCheckAzul.svg","height":"10","width":"13"},{"fullName":"IcCidade.svg","name":"IcCidade","url":"/assets/daqui/icons/IcCidade.svg","height":"17","width":"10"},{"fullName":"IcComunicado.svg","name":"IcComunicado","url":"/assets/daqui/icons/IcComunicado.svg","height":"15","width":"18"},{"fullName":"IcEconomia.svg","name":"IcEconomia","url":"/assets/daqui/icons/IcEconomia.svg","height":"16","width":"14"},{"fullName":"IcEdital.svg","name":"IcEdital","url":"/assets/daqui/icons/IcEdital.svg","height":"16","width":"13"},{"fullName":"IcEspecial.svg","name":"IcEspecial","url":"/assets/daqui/icons/IcEspecial.svg","height":"14","width":"14"},{"fullName":"IcEsporte.svg","name":"IcEsporte","url":"/assets/daqui/icons/IcEsporte.svg","height":"16","width":"13"},{"fullName":"IcFecharBranco.svg","name":"IcFecharBranco","url":"/assets/daqui/icons/IcFecharBranco.svg","height":"16","width":"13"},{"fullName":"IcFecharPreto.svg","name":"IcFecharPreto","url":"/assets/daqui/icons/IcFecharPreto.svg","height":"15","width":"13"},{"fullName":"IcHamburger.svg","name":"IcHamburger","url":"/assets/daqui/icons/IcHamburger.svg","height":"15","width":"22"},{"fullName":"IcHamburguerMobile.svg","name":"IcHamburguerMobile","url":"/assets/daqui/icons/IcHamburguerMobile.svg","height":"13","width":"19"},{"fullName":"IcMagazine.svg","name":"IcMagazine","url":"/assets/daqui/icons/IcMagazine.svg","height":"16","width":"14"},{"fullName":"IcMundo.svg","name":"IcMundo","url":"/assets/daqui/icons/IcMundo.svg","height":"15","width":"15"},{"fullName":"IcOjc.svg","name":"IcOjc","url":"/assets/daqui/icons/IcOjc.svg","height":"17","width":"24"},{"fullName":"IcOpiniao.svg","name":"IcOpiniao","url":"/assets/daqui/icons/IcOpiniao.svg","height":"12","width":"13"},{"fullName":"IcOpiniaoGrande.svg","name":"IcOpiniaoGrande","url":"/assets/daqui/icons/IcOpiniaoGrande.svg","height":"19","width":"22"},{"fullName":"IcPlayAudioMateria.svg","name":"IcPlayAudioMateria","url":"/assets/daqui/icons/IcPlayAudioMateria.svg","height":"15","width":"15"},{"fullName":"IcPlayAudioMateriaAzul.svg","name":"IcPlayAudioMateriaAzul","url":"/assets/daqui/icons/IcPlayAudioMateriaAzul.svg","height":"23","width":"22"},{"fullName":"IcPodcast.svg","name":"IcPodcast","url":"/assets/daqui/icons/IcPodcast.svg","height":"19","width":"11"},{"fullName":"IcPolitica.svg","name":"IcPolitica","url":"/assets/daqui/icons/IcPolitica.svg","height":"16","width":"16"},{"fullName":"IcRadio.svg","name":"IcRadio","url":"/assets/daqui/icons/IcRadio.svg","height":"20","width":"18"},{"fullName":"IcSetaAbrir.svg","name":"IcSetaAbrir","url":"/assets/daqui/icons/IcSetaAbrir.svg","height":"6","width":"9"},{"fullName":"IcSetaCidade.svg","name":"IcSetaCidade","url":"/assets/daqui/icons/IcSetaCidade.svg","height":"9","width":"15"},{"fullName":"IcSetaEconomia.svg","name":"IcSetaEconomia","url":"/assets/daqui/icons/IcSetaEconomia.svg","height":"9","width":"15"},{"fullName":"IcSetaEspecial.svg","name":"IcSetaEspecial","url":"/assets/daqui/icons/IcSetaEspecial.svg","height":"9","width":"15"},{"fullName":"IcSetaEsporte.svg","name":"IcSetaEsporte","url":"/assets/daqui/icons/IcSetaEsporte.svg","height":"9","width":"15"},{"fullName":"IcSetaFechar.svg","name":"IcSetaFechar","url":"/assets/daqui/icons/IcSetaFechar.svg","height":"7","width":"10"},{"fullName":"IcSetaMagazine.svg","name":"IcSetaMagazine","url":"/assets/daqui/icons/IcSetaMagazine.svg","height":"9","width":"15"},{"fullName":"IcSetaMundo.svg","name":"IcSetaMundo","url":"/assets/daqui/icons/IcSetaMundo.svg","height":"9","width":"15"},{"fullName":"IcSetaOpiniao.svg","name":"IcSetaOpiniao","url":"/assets/daqui/icons/IcSetaOpiniao.svg","height":"9","width":"15"},{"fullName":"IcSetaPolitica.svg","name":"IcSetaPolitica","url":"/assets/daqui/icons/IcSetaPolitica.svg","height":"9","width":"15"},{"fullName":"IcSetaRosa.svg","name":"IcSetaRosa","url":"/assets/daqui/icons/IcSetaRosa.svg","height":"9","width":"15"},{"fullName":"IcStories.svg","name":"IcStories","url":"/assets/daqui/icons/IcStories.svg","height":"21","width":"17"},{"fullName":"IcVersaoDigital.svg","name":"IcVersaoDigital","url":"/assets/daqui/icons/IcVersaoDigital.svg","height":"14","width":"16"},{"fullName":"IcVersaoDigitalCinza.svg","name":"IcVersaoDigitalCinza","url":"/assets/daqui/icons/IcVersaoDigitalCinza.svg","height":"16","width":"18"},{"fullName":"IcVersaoDigitalCinzaClaro.svg","name":"IcVersaoDigitalCinzaClaro","url":"/assets/daqui/icons/IcVersaoDigitalCinzaClaro.svg","height":"15","width":"16"},{"fullName":"IcVoltarCinza.svg","name":"IcVoltarCinza","url":"/assets/daqui/icons/IcVoltarCinza.svg","height":"16","width":"8"},{"fullName":"IcWhatsAppCinza.svg","name":"IcWhatsAppCinza","url":"/assets/daqui/icons/IcWhatsAppCinza.svg","height":"18","width":"17"}]}');
;// CONCATENATED MODULE: ./brands/daqui/indexes/logos.json
var daqui_indexes_logos_namespaceObject = JSON.parse('{"k":[{"fullName":"LogoDaquiDesktop.svg","name":"LogoDaquiDesktop","url":"/assets/daqui/logos/LogoDaquiDesktop.svg","height":"67","width":"118"},{"fullName":"LogoDaquiMobile.svg","name":"LogoDaquiMobile","url":"/assets/daqui/logos/LogoDaquiMobile.svg","height":"37","width":"64"}]}');
;// CONCATENATED MODULE: ./brands/daqui/indexes/splashScreens.json
var daqui_indexes_splashScreens_namespaceObject = JSON.parse('{"k":[{"fullName":"ipad.png","name":"ipad","url":"/assets/daqui/splashScreens/ipad.png","height":"","width":""},{"fullName":"ipadpro1.png","name":"ipadpro1","url":"/assets/daqui/splashScreens/ipadpro1.png","height":"","width":""},{"fullName":"ipadpro2.png","name":"ipadpro2","url":"/assets/daqui/splashScreens/ipadpro2.png","height":"","width":""},{"fullName":"ipadpro3.png","name":"ipadpro3","url":"/assets/daqui/splashScreens/ipadpro3.png","height":"","width":""},{"fullName":"iphone5.png","name":"iphone5","url":"/assets/daqui/splashScreens/iphone5.png","height":"","width":""},{"fullName":"iphone6.png","name":"iphone6","url":"/assets/daqui/splashScreens/iphone6.png","height":"","width":""},{"fullName":"iphoneplus.png","name":"iphoneplus","url":"/assets/daqui/splashScreens/iphoneplus.png","height":"","width":""},{"fullName":"iphonex.png","name":"iphonex","url":"/assets/daqui/splashScreens/iphonex.png","height":"","width":""},{"fullName":"iphonexsmax.png","name":"iphonexsmax","url":"/assets/daqui/splashScreens/iphonexsmax.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/daqui/assets/article.tsx


function daqui_assets_article_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_article_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_article_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_article_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var daqui_assets_article_BylineRightSectionComponent = function BylineRightSectionComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_OuvirMateriaButton, {
    icon: daqui_assets_article_objectSpread({}, (0,hooks_useIcon/* useIcon */.b)('IcPlayAudioMateriaAzul')),
    onClick: function onClick(e) {
      return console.log('play audio materia', e);
    }
  });
};

var daqui_assets_article_bylineProps = {
  author: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 700,
      letterSpacing: 0.4,
      lineHeight: '18px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  authorImage: {
    enabled: true
  },
  customCss: {
    align: ['column', 'left', 'middle'],
    mb: '$6',
    width: '100%',
    '@lg': {
      align: ['row', 'between', 'middle'],
      mb: '$8',
      width: '100$'
    }
  },
  customCssLeft: {
    align: ['row', 'left', 'middle'],
    width: '100%',
    '@lg': {
      width: 'calc(100% - 320px)'
    }
  },
  customCssContent: {
    ml: '$3',
    width: 'calc(100% - 80px)',
    '@lg': {}
  },
  customCssRight: {
    align: ['row', 'between', 'middle'],
    mt: '$3',
    width: '100%',
    '@lg': {
      align: ['row', 'right', 'middle'],
      mt: '$0',
      width: '320px'
    }
  },
  publishedDate: {
    enabled: true,
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 400,
      letterSpacing: 0.2,
      lineHeight: '16px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '23px'
      }
    }
  },
  rightSlot: {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(daqui_assets_article_BylineRightSectionComponent, {})
  }
};
var daqui_assets_article_article = {
  articleContainer: {
    customCss: {
      align: ['row', 'center', 'middle'],
      mt: '$8',
      width: '100%'
    }
  },
  articleContent: {
    customCss: {
      align: ['row', 'center', 'between'],
      my: '$4',
      width: 'calc(100% - calc($4 * 3))',
      maxWidth: '1278px'
    }
  },
  articleContentLeft: {
    customCss: {
      borderTop: '1px solid #E6E6E6',
      width: '100%',
      '@lg': {
        width: 'calc(100% - 332px)'
      }
    }
  },
  articleContentRight: {
    customCss: {
      background: '#707070',
      display: 'none',
      height: '600px',
      width: '300px',
      '@lg': {
        display: 'flex'
      }
    }
  },
  bylineProps: daqui_assets_article_bylineProps,
  captionProps: {
    customCssWrap: {
      maxWidth: '960px',
      width: '100%',
      mb: '$4',
      mt: '$0'
    },
    customCss: {
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '12px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '14px',
      px: '$0',
      py: '$2',
      m: '$0',
      width: 'calc(100% - 32px)',
      '@lg': {
        fontSize: '14px',
        fontStyle: 'italic',
        lineHeight: '17px'
      }
    }
  },
  textProps: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '24px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      width: '100%',
      '@lg': {
        fontSize: '22px',
        fontWeight: 400,
        letterSpacing: 0.2,
        lineHeight: '35px'
      },
      'a': {
        color: '$secondaryMain'
      }
    }
  },
  titleProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '25px',
      fontWeight: 700,
      lineHeight: '28px',
      mt: '$0',
      mb: '$3',
      '@lg': {
        fontSize: '60px',
        lineHeight: '70px',
        letterSpacing: 0.4
      },
      textAlign: 'left'
    }
  },
  subjectProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '25px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      },
      textAlign: 'left'
    }
  },
  subtitleProps: {
    as: 'p',
    customCss: {
      color: '#4D4D4D',
      fontFamily: '$primary',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '19px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      '@lg': {
        fontSize: '22px',
        lineHeight: '35px',
        letterSpacing: 0.2,
        mb: '$6'
      }
    }
  },
  shareSection: {
    enabled: true,
    content: [{
      id: 'facebookShare',
      alt: 'Compartilhar no Facebook',
      icon: 'IcBotaoFacebook',
      href: 'https://www.facebook.com/sharer/sharer.php?u='
    }, {
      id: 'twitterShare',
      alt: 'Compartilhar no Twitter',
      icon: 'IcBotaoTwitter',
      href: 'https://twitter.com/intent/tweet?text='
    }, {
      id: 'whatsappShare',
      alt: 'Compartilhar no WhatsApp',
      icon: 'IcBotaoWhatsApp',
      href: 'https://api.whatsapp.com/send?text='
    }]
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/footer.tsx
var daqui_assets_footer_currentDate = new Date();
var daqui_assets_footer_currentYear = daqui_assets_footer_currentDate.getFullYear();
var daqui_assets_footer_FooterConfig = {
  css: {
    slotMiddleCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#262626',
      height: 'max-content',
      py: '$7',
      '@xl': {
        height: '82px'
      }
    },
    slotBottomCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#2E2E2E',
      height: '60px',
      '@xl': {
        display: 'none'
      }
    }
  },
  data: {
    leftText: 'Siga O Jornal Daqui:',
    navMenu: [{
      id: 'expediente',
      title: 'Expediente',
      href: '/expediente'
    }, {
      id: 'faleConosco',
      title: 'Fale conosco',
      href: '/fale-conosco',
      target: '_self'
    }, {
      id: 'anuncieEmJornalDaqui',
      title: 'Anuncie no Jornal Daqui',
      href: 'https://estrategia.negociosjaimecamara.com.br/jornal-daqui-goias'
    }],
    rightText: "Copyright 2001-".concat(daqui_assets_footer_currentYear, ", J. C\xE2mara e Irm\xE3os S/A."),
    socialNetworks: [{
      id: 'facebookPage',
      href: 'https://www.facebook.com/meudaqui',
      icon: 'IcBotaoFacebook',
      title: 'Abrir O Daqui no Facebook'
    }, {
      id: 'twitterPage',
      href: 'https://twitter.com/meudaqui',
      icon: 'IcBotaoTwitter',
      title: 'Abrir O Daqui no Twitter'
    }]
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/utils.ts


function daqui_assets_layouts_utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_layouts_utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_layouts_utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_layouts_utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var assets_layouts_utils_addRelativeWidthToTeaser = function addRelativeWidthToTeaser(teaser, value) {
  var _teaser$css;

  return daqui_assets_layouts_utils_objectSpread(daqui_assets_layouts_utils_objectSpread({}, teaser), {}, {
    css: daqui_assets_layouts_utils_objectSpread(daqui_assets_layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : teaser.css), {}, {
      '@lg': daqui_assets_layouts_utils_objectSpread(daqui_assets_layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : (_teaser$css = teaser.css) === null || _teaser$css === void 0 ? void 0 : _teaser$css['@lg']), {}, {
        width: value
      })
    })
  });
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutColumnist.tsx
// @ts-nocheck







var daqui_assets_layouts_LayoutColumnist_TeaserColumnist = assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserColumnist, '100%');

var assets_layouts_LayoutColumnist_renderSlotMobileWrapComponent = function renderSlotMobileWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: data
  });
};

var assets_layouts_LayoutColumnist_renderSlotDesktopWrapComponent = function renderSlotDesktopWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel .slider-wrapper': {
          width: 'calc(100% - 64px)'
        }
      },
      controlDots: {
        mt: '$2',
        mb: '$0',
        visibility: 'hidden'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    renderArrowNext: function renderArrowNext(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcAvancarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            top: 'calc(50% - 20px)',
            right: '0px'
          }
        }
      });
    },
    renderArrowPrev: function renderArrowPrev(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcVoltarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            bottom: 'calc(50% - 10px)',
            left: '0px'
          }
        }
      });
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    children: map_default()(chunk_default()(data, 4), function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'middle'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'left', 'middle'],
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

var assets_layouts_LayoutColumnist_LayoutColumnist = {
  wrapperContent: {
    enabled: true,
    component: assets_layouts_LayoutColumnist_renderSlotMobileWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        pt: '$3',
        pb: '$5',
        maxWidth: 'calc(100% - $2)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [daqui_assets_layouts_LayoutColumnist_TeaserColumnist, daqui_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [daqui_assets_layouts_LayoutColumnist_TeaserColumnist, daqui_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [daqui_assets_layouts_LayoutColumnist_TeaserColumnist, daqui_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [daqui_assets_layouts_LayoutColumnist_TeaserColumnist, daqui_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
var assets_layouts_LayoutColumnist_LayoutColumnistDesktop = {
  wrapperContent: {
    enabled: true,
    component: assets_layouts_LayoutColumnist_renderSlotDesktopWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        py: '$6',
        maxWidth: 'calc(100% - 180px)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: 'calc(100% - $12)'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [daqui_assets_layouts_LayoutColumnist_TeaserColumnist, daqui_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [daqui_assets_layouts_LayoutColumnist_TeaserColumnist, daqui_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [daqui_assets_layouts_LayoutColumnist_TeaserColumnist, daqui_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [daqui_assets_layouts_LayoutColumnist_TeaserColumnist, daqui_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutColumnistSideBox.tsx
// @ts-nocheck






var LayoutColumnistSideBox_renderSlotWrapComponent = function renderSlotWrapComponent(data) {
  var groupItems = chunk_default()(data, 3);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: map_default()(groupItems, function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['column', 'left', 'top'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'center', 'top'],
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

var assets_layouts_LayoutColumnistSideBox_LayoutColumnistSideBox = {
  wrapperContent: {
    enabled: true,
    component: LayoutColumnistSideBox_renderSlotWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnContent': {
        pt: '$6',
        pb: '$6',
        maxWidth: 'calc(100% - $2)'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [teasers_teasers.TeaserColumnist, teasers_teasers.TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutDefault.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var assets_layouts_LayoutDefault_LayoutDefault = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserHeadlineSm, teasers_teasers.TeaserImageLeftXl]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageLeftLg]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserNoImage, teasers_teasers.TeaserNoImage]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageTopLg]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageTopLg]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      }
    },
    TemplateVideos: {
      slotLeft: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserRelated.tsx


function daqui_assets_teasers_TeaserRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_teasers_TeaserRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_teasers_TeaserRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_teasers_TeaserRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck





var daqui_assets_teasers_TeaserRelated_handleUseIcon = function handleUseIcon(_ref) {
  var color = _ref.color,
      icon = _ref.icon;
  var iconConfig;
  var sectionSlug = capitalize_default()(color === null || color === void 0 ? void 0 : color.replace('Main', ''));

  if (sectionSlug) {
    var iconSlug = icon === null || icon === void 0 ? void 0 : icon.replace('Especial', sectionSlug);
    var iconParsed = (0,hooks_useIcon/* useIcon */.b)(iconSlug);

    if (iconParsed.src) {
      iconConfig = iconParsed;
    }
  }

  if (!iconConfig) {
    iconConfig = (0,hooks_useIcon/* useIcon */.b)(icon);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, daqui_assets_teasers_TeaserRelated_objectSpread({}, iconConfig));
};

var daqui_assets_teasers_TeaserRelated_TeaserRelated = {
  css: {
    p: 0,
    background: 'none !important',
    width: '100%',
    '.TeaserImageContainer': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none !important'
    },
    '.TeaserSubtitle': {
      display: 'none !important'
    },
    'div.TeaserTitle': {
      align: ['row', 'left', 'top'],
      pb: '$0',
      mb: '$0',
      'a': {
        pb: '$0',
        mb: '$0',
        width: '100%'
      },
      'img': {
        pt: '6px',
        height: '15px'
      },
      'p.TeaserTitleText': {
        align: ['row', 'left', 'top'],
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '19px',
        ml: '$3',
        mb: '$0',
        mt: '$0',
        textAlign: 'left',
        width: 'calc(100% - $3)'
      }
    },
    '.TeaserWrap': {
      background: 'none !important',
      pb: '$0',
      mb: '$0'
    }
  },
  className: 'TeaserRelated',
  relatedIcon: {
    enabled: true,
    name: 'IcSetaEspecial',
    useIcon: daqui_assets_teasers_TeaserRelated_handleUseIcon
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserBackground.ts

var daqui_assets_teasers_TeaserBackground_TeaserBackground = {
  className: 'TeaserBackground',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '580px'
    },
    '.TeaserImage img': {
      height: '580px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        mb: '$2'
      }
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 90%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserBackgroundLg.ts

var daqui_assets_teasers_TeaserBackgroundLg_TeaserBackgroundLg = {
  className: 'TeaserBackgroundLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '360px'
    },
    '.TeaserImage img': {
      height: '360px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 500px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 500px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserBackgroundRelated.ts

var daqui_assets_teasers_TeaserBackgroundRelated_TeaserBackgroundRelated = {
  className: 'TeaserBackgroundRelated',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '780px'
    },
    '.TeaserImage img': {
      height: '680px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: 'black',
      position: 'static',
      pt: '$0',
      pb: '$4',
      px: '$4',
      my: '$0',
      'div.Teaser': {
        mb: '$3'
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 60%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserBackgroundRelatedLg.ts

var daqui_assets_teasers_TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg = {
  className: 'TeaserBackgroundRelatedLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '536px'
    },
    '.TeaserImage img': {
      height: '536px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: '#282828',
      position: 'absolute',
      height: '536px',
      right: '0px',
      pt: '$0',
      pb: '$4',
      my: '$0',
      width: '328px',
      'div.Teaser': {
        background: 'transparent',
        px: '$8',
        mb: '$0'
      },
      '.TeaserImage': {
        display: 'none'
      },
      'p.TeaserTitleText': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        m: '$0 !important',
        p: '$0 !important',
        width: '100% !important'
      },
      '.TeaserWrap': {
        background: 'none',
        position: 'static',
        mt: '$0'
      },
      '@lg': {
        align: ['column', 'center', 'evenly'],
        '.TeaserTitle img': {
          display: 'none'
        }
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 360px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 360px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserColumnist.ts
var daqui_assets_teasers_TeaserColumnist_TeaserColumnist = {
  css: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderRadius: '$alternative',
    p: '$0',
    pt: '$0',
    mb: '$4',
    '.TeaserImage img': {
      borderRadius: '$circle'
    },
    '.TeaserImageContainer': {
      borderRadius: '$circle',
      maxWidth: '80px'
    },
    '.TeaserWrap': {
      pb: '$4',
      pl: '$4',
      pr: '$4'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubject': {
      width: '100%'
    },
    '.TeaserSubjectText': {
      textAlign: 'left',
      color: '#D72027',
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 500,
      mb: '$1'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      width: '100%'
    },
    '.TeaserTitleText': {
      fontSize: '16px',
      fontWeight: 400
    }
  },
  className: 'TeaserColumnist',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subjectTextVariant: 'subject-default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-sm'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserEditais.ts
var assets_teasers_TeaserEditais_TeaserEditais = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserEditais'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserHeadlineSm.ts


function daqui_assets_teasers_TeaserHeadlineSm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_teasers_TeaserHeadlineSm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_teasers_TeaserHeadlineSm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_teasers_TeaserHeadlineSm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var daqui_assets_teasers_TeaserHeadlineSm_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var daqui_assets_teasers_TeaserHeadlineSm_TeaserHeadlineSm = daqui_assets_teasers_TeaserHeadlineSm_objectSpread(daqui_assets_teasers_TeaserHeadlineSm_objectSpread({}, daqui_assets_teasers_TeaserHeadlineSm_T.TeaserHeadlineSm), {}, {
  css: {
    p: '$0',
    mb: '$6',
    textAlign: 'center',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineSm',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-3xl'
});
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserHeadlineLg.ts


var daqui_assets_teasers_TeaserHeadlineLg_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var daqui_assets_teasers_TeaserHeadlineLg_TeaserHeadlineLg = {
  css: {
    textAlign: 'center',
    my: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      align: ['row', 'center', 'top'],
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '18px',
          lineHeight: '23px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      maxWidth: '980px',
      mb: '$8'
    },
    '.TeaserTitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineLg',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-6xl'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserImageLeft.ts
var daqui_assets_teasers_TeaserImageLeft_TeaserImageLeft = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      maxWidth: '150px'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserImageLeftSm.ts
var daqui_assets_teasers_TeaserImageLeftSm_TeaserImageLeftSm = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      maxWidth: '88px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserImageLeftSm',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserImageLeftLg.ts

var daqui_assets_teasers_TeaserImageLeftLg_TeaserImageLeftLg = {
  css: {
    padding: '$0',
    mb: '$6',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      mb: '$3'
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '36px',
      lineHeight: '43px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      minWidth: 'calc(50% - $3)',
      width: '100%',
      '.TeaserRelated': {
        flexFlow: 'column',
        width: '100%',
        'div.Teaser': {
          mb: '$4',
          width: 'auto'
        },
        'div.TeaserTitle': {
          'p.TeaserTitleText': {
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.2px'
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserNoImage.ts

var daqui_assets_teasers_TeaserNoImage_TeaserNoImage = {
  css: {
    p: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      align: ['column', 'left', 'top'],
      display: 'none',
      mb: '$4'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      mb: '$4'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserNoImage',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserCard.ts
var daqui_assets_teasers_TeaserCard_TeaserCard = {
  css: {
    mb: '$3',
    p: '$0',
    '.TeaserImageContainer': {
      mb: '$0'
    },
    '.TeaserSubject': {
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCard',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserImageTop.ts

var daqui_assets_teasers_TeaserImageTop_TeaserImageTop = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserImageTopLg.ts

var daqui_assets_teasers_TeaserImageTopLg_TeaserImageTopLg = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserImageBottom.ts
var daqui_assets_teasers_TeaserImageBottom_TeaserImageBottom = {
  css: {
    mb: '$3',
    padding: '$0',
    width: '100%',
    '.TeaserSubtitle': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$3'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase'
    },
    '.TeaserTitle': {
      mb: '$3'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    }
  },
  className: 'TeaserImageBottom',
  imageDerivative: '3x1',
  imageVariant: 'bottom',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subtitleVariant: 'subtitle-default',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  titleVariant: 'newstitle-5xl'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserImageLeftXl.ts
var daqui_assets_teasers_TeaserImageLeftXl_TeaserImageLeftXl = {
  css: {
    padding: '$0',
    mb: '$5',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserMostRead.ts
var daqui_assets_teasers_TeaserMostRead_TeaserMostRead = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      borderRadius: '50%',
      height: '100%',
      width: '30px',
      pr: '$2'
    },
    '.TeaserNumberText': {
      color: '#FC008F',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserMostReadFixed.ts
var daqui_assets_teasers_TeaserMostReadFixed_TeaserMostReadFixed = {
  css: {
    align: ['row', 'center', 'middle'],
    borderBottom: '1px solid #E6E6E6',
    borderLeft: '8px solid $basicWhite',
    p: '$0',
    minHeight: '92px',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      ml: '$4',
      mr: '$4',
      height: '100%',
      width: 'max-content'
    },
    '.TeaserNumberText': {
      color: '#FC008F',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '$widget5',
      fontWeight: '$widget5',
      lineHeight: '$widget5'
    },
    '.TeaserWrap': {
      mr: '$4',
      width: 'calc(100% - $4)'
    },
    '&:last-child': {
      borderBottom: 'unset'
    },
    '&[data-selected=true]': {
      borderLeft: '8px solid #FC008F'
    },
    '&[data-viewed=true]': {
      borderLeft: '8px solid #E7E7E7'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserPodcast.ts
var daqui_assets_teasers_TeaserPodcast_TeaserPodcast = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$2',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      width: '160px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 5%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '124px',
      width: '124px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserTitleText': {
      display: 'none'
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserRadio.ts
var daqui_assets_teasers_TeaserRadio_TeaserRadio = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  customLinkProps: {
    bypass: 'true'
  },
  css: {
    backgroundColor: 'none',
    cursor: 'pointer',
    p: '$0',
    m: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      mx: '$4',
      width: '100px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 25%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '100px',
      width: '100px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserSubtitleText': {
      color: '#c6c6c6',
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: 400,
      mx: '$2',
      mb: '$2',
      textAlign: 'center',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    },
    '.TeaserTitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserTitleText': {
      color: '#7c7c7c',
      fontSize: '18px',
      letterSpacing: '0.4px',
      lineHeight: '25px',
      fontWeight: 500,
      mx: '$2',
      mb: '$1',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserStories.ts
var daqui_assets_teasers_TeaserStories_TeaserStories = {
  className: 'TeaserStories',
  imageDerivative: '1x3',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$4',
    width: 'calc(100% - $4)',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$0'
    },
    '.TeaserImage img': {
      borderRadius: '10px',
      height: '354px',
      width: '200px',
      objectFit: 'cover'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '19px',
      fontWeight: 500,
      px: '$4',
      mb: '$2',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      align: ['row', 'left', 'bottom']
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'bottom'],
      color: '$basicWhite',
      fontSize: '18px',
      letterSpacing: '0.2px',
      lineHeight: '23px',
      fontWeight: 400,
      px: '$4',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      'a': {
        textAlign: 'left'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      background: 'linear-gradient(rgba(0, 0, 0, 0) 50%, rgb(0, 0, 0) 100%)',
      borderRadius: '10px',
      position: 'absolute',
      height: '100%',
      width: '100%'
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserVideoLeft.ts
var daqui_assets_teasers_TeaserVideoLeft_TeaserVideoLeft = {
  css: {
    backgroundColor: 'transparent',
    padding: '$0',
    mb: '$3',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubtitle': {
      display: 'none',
      '@lg': {
        display: 'flex'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      color: '#989898',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 400,
      '@lg': {
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: 400
      }
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserVideoTop.ts
var daqui_assets_teasers_TeaserVideoTop_TeaserVideoTop = {
  css: {
    backgroundColor: 'transparent',
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      color: '#FFFFFF !important',
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$0'
    },
    '.TeaserTitleText': {
      fontSize: '25px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '2x1',
  imageVariant: 'top',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers/TeaserVideoFeatSm.ts

var assets_teasers_TeaserVideoFeatSm_TeaserVideoFeatSm = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserVideoFeatSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/daqui/assets/teasers.ts




























var daqui_assets_teasers_teasers = {
  TeaserBackground: daqui_assets_teasers_TeaserBackground_TeaserBackground,
  TeaserBackgroundLg: daqui_assets_teasers_TeaserBackgroundLg_TeaserBackgroundLg,
  TeaserBackgroundRelatedLg: daqui_assets_teasers_TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg,
  TeaserBackgroundRelated: daqui_assets_teasers_TeaserBackgroundRelated_TeaserBackgroundRelated,
  TeaserEditorial: TeaserEditorial,
  TeaserEditorialSm: TeaserEditorialSm,
  TeaserImageBottom: daqui_assets_teasers_TeaserImageBottom_TeaserImageBottom,
  TeaserImageLeft: daqui_assets_teasers_TeaserImageLeft_TeaserImageLeft,
  TeaserImageLeftSm: daqui_assets_teasers_TeaserImageLeftSm_TeaserImageLeftSm,
  TeaserImageLeftLg: daqui_assets_teasers_TeaserImageLeftLg_TeaserImageLeftLg,
  TeaserImageLeftXl: daqui_assets_teasers_TeaserImageLeftXl_TeaserImageLeftXl,
  TeaserImageTop: daqui_assets_teasers_TeaserImageTop_TeaserImageTop,
  TeaserImageTopLg: daqui_assets_teasers_TeaserImageTopLg_TeaserImageTopLg,
  TeaserCard: daqui_assets_teasers_TeaserCard_TeaserCard,
  TeaserColumnist: daqui_assets_teasers_TeaserColumnist_TeaserColumnist,
  TeaserEditais: assets_teasers_TeaserEditais_TeaserEditais,
  TeaserRelated: daqui_assets_teasers_TeaserRelated_TeaserRelated,
  TeaserHeadlineSm: daqui_assets_teasers_TeaserHeadlineSm_TeaserHeadlineSm,
  TeaserHeadlineLg: daqui_assets_teasers_TeaserHeadlineLg_TeaserHeadlineLg,
  TeaserNoImage: daqui_assets_teasers_TeaserNoImage_TeaserNoImage,
  TeaserMostRead: daqui_assets_teasers_TeaserMostRead_TeaserMostRead,
  TeaserMostReadFixed: daqui_assets_teasers_TeaserMostReadFixed_TeaserMostReadFixed,
  TeaserPodcast: daqui_assets_teasers_TeaserPodcast_TeaserPodcast,
  TeaserRadio: daqui_assets_teasers_TeaserRadio_TeaserRadio,
  TeaserStories: daqui_assets_teasers_TeaserStories_TeaserStories,
  TeaserVideoLeft: daqui_assets_teasers_TeaserVideoLeft_TeaserVideoLeft,
  TeaserVideoTop: daqui_assets_teasers_TeaserVideoTop_TeaserVideoTop,
  TeaserVideoFeatSm: assets_teasers_TeaserVideoFeatSm_TeaserVideoFeatSm
};
var daqui_assets_teasers_teasersArray = Object.keys(daqui_assets_teasers_teasers);

;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutEditais.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var layouts_LayoutEditais_LayoutEditais = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotLeft: {
        "default": [daqui_assets_teasers_teasers.TeaserEditais, daqui_assets_teasers_teasers.TeaserEditais]
      },
      slotCenter: {
        "default": [daqui_assets_teasers_teasers.TeaserEditais, daqui_assets_teasers_teasers.TeaserEditais]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutFeatured.ts


function daqui_assets_layouts_LayoutFeatured_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_layouts_LayoutFeatured_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_layouts_LayoutFeatured_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_layouts_LayoutFeatured_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck



// MancheteComFoto
var assets_layouts_LayoutFeatured_LayoutFeatured = daqui_assets_layouts_LayoutFeatured_objectSpread(daqui_assets_layouts_LayoutFeatured_objectSpread({}, assets_layouts_LayoutDefault_LayoutDefault), {}, {
  slotConfig: daqui_assets_layouts_LayoutFeatured_objectSpread(daqui_assets_layouts_LayoutFeatured_objectSpread({}, assets_layouts_LayoutDefault_LayoutDefault === null || assets_layouts_LayoutDefault_LayoutDefault === void 0 ? void 0 : assets_layouts_LayoutDefault_LayoutDefault.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageLeft, teasers_teasers.TeaserImageLeftLg]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackground, teasers_teasers.TeaserBackgroundLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutFeaturedImage.ts


function daqui_assets_layouts_LayoutFeaturedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_layouts_LayoutFeaturedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_layouts_LayoutFeaturedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_layouts_LayoutFeaturedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var assets_layouts_LayoutFeaturedImage_LayoutFeaturedImage = daqui_assets_layouts_LayoutFeaturedImage_objectSpread(daqui_assets_layouts_LayoutFeaturedImage_objectSpread({}, assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: daqui_assets_layouts_LayoutFeaturedImage_objectSpread(daqui_assets_layouts_LayoutFeaturedImage_objectSpread({}, assets_layouts_LayoutFeatured_LayoutFeatured === null || assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackgroundRelated, teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutFeaturedNoImage.ts


function daqui_assets_layouts_LayoutFeaturedNoImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_layouts_LayoutFeaturedNoImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_layouts_LayoutFeaturedNoImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_layouts_LayoutFeaturedNoImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var assets_layouts_LayoutFeaturedNoImage_LayoutFeaturedNoImage = daqui_assets_layouts_LayoutFeaturedNoImage_objectSpread(daqui_assets_layouts_LayoutFeaturedNoImage_objectSpread({}, assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: daqui_assets_layouts_LayoutFeaturedNoImage_objectSpread(daqui_assets_layouts_LayoutFeaturedNoImage_objectSpread({}, assets_layouts_LayoutFeatured_LayoutFeatured === null || assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserHeadlineSm, teasers_teasers.TeaserHeadlineLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutFeaturedRelated.ts


function daqui_assets_layouts_LayoutFeaturedRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_layouts_LayoutFeaturedRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_layouts_LayoutFeaturedRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_layouts_LayoutFeaturedRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// SuperManchete
var assets_layouts_LayoutFeaturedRelated_LayoutFeaturedRelated = daqui_assets_layouts_LayoutFeaturedRelated_objectSpread(daqui_assets_layouts_LayoutFeaturedRelated_objectSpread({}, assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: daqui_assets_layouts_LayoutFeaturedRelated_objectSpread(daqui_assets_layouts_LayoutFeaturedRelated_objectSpread({}, assets_layouts_LayoutFeatured_LayoutFeatured === null || assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackgroundRelated, teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutGrid3.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var daqui_assets_layouts_LayoutGrid3_TeaserCard = assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 2)) / 3)');
var daqui_assets_layouts_LayoutGrid3_TeaserImageTop = assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var assets_layouts_LayoutGrid3_LayoutGrid3 = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSq, daqui_assets_layouts_LayoutGrid3_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, daqui_assets_layouts_LayoutGrid3_TeaserCard]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutGrid4.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var daqui_assets_layouts_LayoutGrid4_TeaserCard = assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 3)) / 4)');
var assets_layouts_LayoutGrid4_LayoutGrid4 = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserCard, daqui_assets_layouts_LayoutGrid4_TeaserCard]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeftSm]
      }
    },
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [teasers_teasers.TeaserColumnist, teasers_teasers.TeaserColumnist]
      }
    },
    TemplateSideBoxNoTitle: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeftSm],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutPodcast.tsx
// @ts-nocheck




var assets_layouts_LayoutPodcast_renderWrapComponent = function renderWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '220px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

var assets_layouts_LayoutPodcast_LayoutPodcast = {
  wrapperContent: {
    enabled: true,
    component: assets_layouts_LayoutPodcast_renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxPodcast: {
      slotLeft: {
        "default": [teasers_teasers.TeaserPodcast, teasers_teasers.TeaserPodcast]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutRadio.tsx
// @ts-nocheck

var assets_layouts_LayoutRadio_LayoutRadio = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      px: '$0',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxRadio: {
      slotLeft: {
        "default": [daqui_assets_teasers_teasers.TeaserRadio, daqui_assets_teasers_teasers.TeaserRadio]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutSearch.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var assets_layouts_LayoutSearch_LayoutSearch = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [daqui_assets_teasers_teasers.TeaserEditorialSm, daqui_assets_teasers_teasers.TeaserEditorial]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutStories.tsx
// @ts-nocheck




var layouts_LayoutStories_renderWrapComponent = function renderWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '220px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

var assets_layouts_LayoutStories_LayoutStories = {
  wrapperContent: {
    enabled: true,
    component: layouts_LayoutStories_renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxStories: {
      slotLeft: {
        "default": [teasers_teasers.TeaserStories, teasers_teasers.TeaserStories]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutMostRead.ts
// eslint-disable-next-line
// @ts-nocheck

var assets_layouts_LayoutMostRead_LayoutMostRead = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [daqui_assets_teasers_teasers.TeaserMostRead, daqui_assets_teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [daqui_assets_teasers_teasers.TeaserMostRead, daqui_assets_teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBoxFixed: {
      slotLeft: {
        "default": [daqui_assets_teasers_teasers.TeaserMostReadFixed, daqui_assets_teasers_teasers.TeaserMostReadFixed]
      },
      slotCenter: {
        "default": [daqui_assets_teasers_teasers.TeaserMostReadFixed, daqui_assets_teasers_teasers.TeaserMostReadFixed]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutVideoHome.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var daqui_assets_layouts_LayoutVideoHome_TeaserVideoTop = assets_layouts_utils_addRelativeWidthToTeaser(daqui_assets_teasers_teasers.TeaserVideoTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var assets_layouts_LayoutVideoHome_LayoutVideoHome = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        width: '100%' // columnGap: '24px'

      }
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoTop],
        '2': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoLeft]
      },
      slotCenter: {
        "default": [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoTop],
        '2': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoLeft]
      },
      slotRight: {
        "default": [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoTop],
        '2': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [daqui_assets_teasers_teasers.TeaserVideoTop, daqui_assets_teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutVideoLive.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var assets_layouts_LayoutVideoLive_LayoutVideoLive = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      }
    },
    TemplateVideoLive: {
      slotLeft: {
        "default": [teasers_teasers.TeaserMostRead, teasers_teasers.TeaserMostRead]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/layouts/LayoutVideoFeatured.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var layouts_LayoutVideoFeatured_LayoutVideoFeatured = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [daqui_assets_teasers_teasers.TeaserVideoFeatured, daqui_assets_teasers_teasers.TeaserVideoFeatSm],
        '0:1': [daqui_assets_teasers_teasers.TeaserVideoFeatLg, daqui_assets_teasers_teasers.TeaserVideoFeatLg],
        '0:2': [daqui_assets_teasers_teasers.TeaserVideoFeatured, daqui_assets_teasers_teasers.TeaserVideoFeatMd],
        '0:3': [daqui_assets_teasers_teasers.TeaserVideoFeatured, daqui_assets_teasers_teasers.TeaserVideoFeatMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/daqui/assets/layouts.ts
// @ts-nocheck



















var daqui_assets_layouts_slotLayouts = {
  LayoutColumnist: assets_layouts_LayoutColumnist_LayoutColumnist,
  LayoutColumnistDesktop: assets_layouts_LayoutColumnist_LayoutColumnistDesktop,
  LayoutColumnistSideBox: assets_layouts_LayoutColumnistSideBox_LayoutColumnistSideBox,
  LayoutDefault: assets_layouts_LayoutDefault_LayoutDefault,
  LayoutEditais: layouts_LayoutEditais_LayoutEditais,
  LayoutFeatured: assets_layouts_LayoutFeatured_LayoutFeatured,
  LayoutFeaturedImage: assets_layouts_LayoutFeaturedImage_LayoutFeaturedImage,
  LayoutFeaturedNoImage: assets_layouts_LayoutFeaturedNoImage_LayoutFeaturedNoImage,
  LayoutFeaturedRelated: assets_layouts_LayoutFeaturedRelated_LayoutFeaturedRelated,
  LayoutGrid3: assets_layouts_LayoutGrid3_LayoutGrid3,
  LayoutGrid4: assets_layouts_LayoutGrid4_LayoutGrid4,
  LayoutPodcast: assets_layouts_LayoutPodcast_LayoutPodcast,
  LayoutRadio: assets_layouts_LayoutRadio_LayoutRadio,
  LayoutSearch: assets_layouts_LayoutSearch_LayoutSearch,
  LayoutStories: assets_layouts_LayoutStories_LayoutStories,
  LayoutMostRead: assets_layouts_LayoutMostRead_LayoutMostRead,
  LayoutVideoHome: assets_layouts_LayoutVideoHome_LayoutVideoHome,
  LayoutVideoLive: assets_layouts_LayoutVideoLive_LayoutVideoLive,
  LayoutVideoFeatured: layouts_LayoutVideoFeatured_LayoutVideoFeatured
};
var daqui_assets_layouts_slotLayoutsArray = Object.keys(daqui_assets_layouts_slotLayouts);

;// CONCATENATED MODULE: ./brands/daqui/assets/menus.tsx
var daqui_assets_menus_accordionStyle = {
  accordionItemGroup: {
    accordionContent: {
      backgroundColor: '#EAEAEA',
      pl: '$8',
      pr: '$18'
    },
    accordionTitle: {
      title: {
        fontFamily: '$primary',
        fontSize: '$caption5',
        fontWeight: '$caption5',
        lineHeight: '$caption5',
        m: '0px',
        py: '$2',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px'
      },
      iconButton: {
        height: '24px',
        width: '24px'
      }
    }
  }
};
var daqui_assets_menus_sideMenuLeft = {
  sectionHeader: {
    enabled: true,
    subscriberInfo: {
      enabled: true,
      amountLeft: 5
    },
    advertiseSection: {
      enabled: true,
      color: '#FFDC00',
      href: 'https://daqui.opopular.com.br/lojadodaqui',
      target: '_blank'
    },
    variants: {
      anonymous: {
        logo: {
          name: 'BannerAnuncie',
          href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania"
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$primaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$3',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      DEGUSTADOR: {
        logo: {
          name: 'BannerAnuncie',
          href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania"
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#FFDC00',
            height: '149px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      ASSINANTE: {
        css: {
          container: {
            align: ['column', 'center', 'top'],
            height: 'max-content',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      advertiser_subscriber: {
        logo: {
          name: 'BannerAnuncie',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#FC008F',
            height: '149px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      club_subscriber: {
        logo: {
          name: 'BannerClube',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundImage: 'url(assets/opopular/banners/BannerClubeBackground.png)',
            height: '149px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicWhite'
        }
      }
    }
  },
  sectionContent: {
    enabled: true,
    searchInput: {
      enabled: true
    },
    advertiseSection: {
      enabled: true,
      color: '#FFDC00',
      href: 'https://daqui.opopular.com.br/lojadodaqui',
      target: '_blank'
    },
    serviceButtons: {
      enabled: true,
      items: [{
        id: 'whatsapp',
        href: '',
        variant: 'WhatsApp'
      }, {
        id: 'jornaldigital',
        href: 'https://daqui.opopular.com.br/digital',
        variant: 'JornalDigital'
      }]
    },
    navigationAccordions: {
      enabled: true,
      css: daqui_assets_menus_accordionStyle,
      sectionTitleColor: '#FC008F',
      items: [
      /*         {
                id: 'publicidade',
                title: 'Publicidade',
                items: [
                  {
                    id: '2',
                    title: 'Publicidade Legal',
                    href: '/publicidade-legal',
                  },
                ],
                css: accordionStyle,
              }, */
      {
        id: 'sac',
        title: 'SAC',
        items: [{
          id: '1',
          title: 'Fale Conosco',
          href: '/fale-conosco'
        }, {
          id: '2',
          title: 'Expediente',
          href: '/expediente'
        }, {
          id: '3',
          title: 'Política de privacidade',
          href: '/politica-de-privacidade'
        }],
        css: daqui_assets_menus_accordionStyle
      }, {
        id: 'grupoojc',
        title: 'Grupo Jaime Câmara',
        items: [// FIXME rm classi
        {
          id: '1',
          title: 'Classi',
          href: 'https://www.classi.com.br'
        }, {
          id: '2',
          title: 'Jornal O Popular',
          href: 'https://opopular.com.br/'
        }, {
          id: '3',
          title: 'Jornal do Tocantins',
          href: 'https://www.jornaldotocantins.com.br'
        }],
        css: daqui_assets_menus_accordionStyle
      }]
    }
  },
  sectionFooter: {
    enabled: true,
    advertiseSection: {
      enabled: true,
      color: '#FC008F',
      href: 'https://estrategia.negociosjaimecamara.com.br/jornal-daqui-goias'
    },
    socialmediasSection: {
      enabled: true,
      color: '#F7F7F7',
      content: [{
        id: 'facebook',
        href: 'https://www.facebook.com/meudaqui/',
        icon: 'IcBotaoFacebook'
      }, {
        id: 'twitter',
        href: 'https://twitter.com/meudaqui',
        icon: 'IcBotaoTwitter'
      }]
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/Template100.ts
var assets_templates_Template100_Template100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/Template1005050.ts
var assets_templates_Template1005050_Template1005050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      '.Column.Left': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Center': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Right': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column.Left': {
          mb: '$0'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          borderBottom: 'none',
          gridColumn: 'span 2',
          width: '100%'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/Template5050.ts
var assets_templates_Template5050_Template5050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/Template5050100.ts
var assets_templates_Template5050100_Template5050100 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          gridColumn: 'span 2',
          width: '100%'
        }
      }
    }
  },
  customProps: {
    container: {
      className: 'AlignToLeft'
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateColumnist.ts
var assets_templates_TemplateColumnist_TemplateColumnist = {
  css: {
    container: {
      backgroundColor: '#f4f4f4',
      pt: '$4',
      mb: '$4',
      '@lg': {
        pb: '$0',
        mb: '$4'
      }
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '.Column:nth-child(1)': {
        '@lg': {
          display: 'none'
        }
      },
      '.Column:nth-child(2)': {
        display: 'none',
        '@lg': {
          display: 'flex'
        }
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Teaser.mobile:not(:nth-child(1))': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%'
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSideBox.ts
var assets_templates_TemplateSideBox_TemplateSideBox = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        px: '$3',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle'],
        borderBottom: '1px solid #e6e6e6',
        pt: '$4',
        pb: '$0',
        px: '$2',
        mb: '$5'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSideBoxGeneric.ts
var templates_TemplateSideBoxGeneric_TemplateSideBoxGeneric = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSideBoxFixed.ts
var assets_templates_TemplateSideBoxFixed_TemplateSideBoxFixed = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      mt: '$6',
      '@lg': {
        pb: '$0',
        px: '$0',
        mt: '$6',
        mb: '$8',
        position: 'sticky',
        top: '200px'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ExtraTop .ColumnContent': {
        align: ['row', 'left', 'bottom'],
        mb: '0px',
        width: '100%',
        '.pds-Button-root': {
          backgroundColor: '#FFFFFF'
        }
      },
      '.Center .ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderTop: 'unset',
        borderBottomLeftRadius: '$alternative',
        borderBottomRightRadius: '$alternative',
        overflow: 'hidden',
        py: '$0',
        width: '100%'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSideBoxPodcast.ts
var assets_templates_TemplateSideBoxPodcast_TemplateSideBoxPodcast = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        borderRadius: '10px',
        mt: '$6',
        mx: '$3',
        width: '290px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        pl: '$11',
        pt: '$4'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .Teaser:nth-child(2),.Teaser:nth-child(1)': {
        position: 'relative',
        top: '-30px',
        'img': {
          height: '190px',
          width: '190px'
        },
        '.TeaserImage': {
          width: '180px'
        }
      },
      '.ColumnBottom': {
        mb: '$4',
        mx: '$4',
        width: 'calc(100% - $8)',
        'audio': {
          width: 'calc(100% - $8)'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '-$6',
        px: '$0',
        mt: '$1',
        overflowX: 'clip',
        py: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSideBoxRadio.ts
var assets_templates_TemplateSideBoxRadio_TemplateSideBoxRadio = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        px: '$0'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .slide.selected .Teaser': {
        'img': {
          height: '124px',
          width: '124px'
        },
        '.TeaserSubtitleText': {
          maxWidth: '124px'
        },
        '.TeaserTitleText': {
          maxWidth: '124px'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        overflowY: 'inherit',
        overflowX: 'clip',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSideBoxStories.ts
var assets_templates_TemplateSideBoxStories_TemplateSideBoxStories = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      width: 'calc(100% - $4)',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8',
        width: '100%'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left': {
        overflowX: 'clip'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '$3',
        px: '$0',
        mt: '$1',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSideBoxColumnist.ts
var assets_templates_TemplateSideBoxColumnist_TemplateSideBoxColumnist = {
  css: {
    container: {
      pt: '$0',
      '@lg': {
        pb: '$0',
        mb: '$0'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        backgroundColor: '#f4f4f4',
        mb: '$4',
        px: '$2',
        py: '$8',
        width: '100%'
      },
      '.Extra .ColumnContent': {
        backgroundImage: 'none',
        px: '$3',
        py: '$0',
        mb: '$0',
        width: '100%'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.ExtraTop .ColumnContent': {
        backgroundImage: 'none',
        py: '$0',
        px: '$3',
        mt: '$1',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      }
    },
    item: {}
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSideBoxNoTitle.ts
var assets_templates_TemplateSideBoxNoTitle_TemplateSideBoxNoTitle = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$3',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2',
        '.TeaserWrap': {
          py: '$3'
        },
        '.TeaserSubject': {
          px: '$6'
        },
        '.TeaserTitle': {
          px: '$6'
        },
        '.TeaserImage img': {
          borderRadius: '10px 10px 0px 0px'
        }
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$3',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSidebarLeft.ts
var assets_templates_TemplateSidebarLeft_TemplateSidebarLeft = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      flexDirection: 'column-reverse',
      marginTop: '$2',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none',
          marginTop: '24px',
          width: '300px'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          marginTop: '36px',
          width: 'calc(100% - 340px)'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          flexDirection: 'unset',
          align: ['row', 'between', 'middle']
        },
        '.Column.ExtraTop': {
          width: '100%'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateSuperManchete.ts
var assets_templates_TemplateSuperManchete_TemplateSuperManchete = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateVideosLive.ts
var assets_templates_TemplateVideosLive_TemplateVideoLive = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$0',
        px: '$3',
        width: '100%'
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates/TemplateVideos.ts
var assets_templates_TemplateVideos_TemplateVideos = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'between', 'top'],
        mb: '$0',
        px: '$3',
        width: '100%'
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2) .ColumnContent': {
        align: ['column', 'center', 'top']
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column.Left': {
          width: '100%'
        },
        '.Column.Center': {
          display: 'none'
        },
        '.Column.Right': {
          display: 'none'
        },
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/daqui/assets/templates.ts

















var daqui_assets_templates_templates = {
  Template100: assets_templates_Template100_Template100,
  Template1005050: assets_templates_Template1005050_Template1005050,
  Template5050: assets_templates_Template5050_Template5050,
  Template5050100: assets_templates_Template5050100_Template5050100,
  TemplateColumnist: assets_templates_TemplateColumnist_TemplateColumnist,
  TemplateSidebarLeft: assets_templates_TemplateSidebarLeft_TemplateSidebarLeft,
  TemplateSideBox: assets_templates_TemplateSideBox_TemplateSideBox,
  TemplateSideBoxGeneric: templates_TemplateSideBoxGeneric_TemplateSideBoxGeneric,
  TemplateSideBoxFixed: assets_templates_TemplateSideBoxFixed_TemplateSideBoxFixed,
  TemplateSideBoxPodcast: assets_templates_TemplateSideBoxPodcast_TemplateSideBoxPodcast,
  TemplateSideBoxRadio: assets_templates_TemplateSideBoxRadio_TemplateSideBoxRadio,
  TemplateSideBoxStories: assets_templates_TemplateSideBoxStories_TemplateSideBoxStories,
  TemplateSideBoxColumnist: assets_templates_TemplateSideBoxColumnist_TemplateSideBoxColumnist,
  TemplateSideBoxNoTitle: assets_templates_TemplateSideBoxNoTitle_TemplateSideBoxNoTitle,
  TemplateSuperManchete: assets_templates_TemplateSuperManchete_TemplateSuperManchete,
  TemplateVideoLive: assets_templates_TemplateVideosLive_TemplateVideoLive,
  TemplateVideos: assets_templates_TemplateVideos_TemplateVideos
};
var daqui_assets_templates_templatesArray = Object.keys(daqui_assets_templates_templates);

;// CONCATENATED MODULE: ./brands/daqui/assets/topbar.styled.tsx


function daqui_assets_topbar_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_topbar_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_topbar_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_topbar_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var daqui_assets_topbar_styled_buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7'
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'DIGITAL',
    hideInMobile: false
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black'
    },
    cssContainer: {
      mr: '$4'
    },
    hideInMobile: false
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020'
    },
    hideInMobile: false
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'ÁUDIO',
    hideInMobile: false
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0'
      }
    },
    value: 'ENTRAR',
    hideInMobile: false
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800'
    },
    hideInMobile: false
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none'
      }
    },
    hideInMobile: false
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content'
    },
    hideInMobile: false
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#202020',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content'
      }
    },
    hideInMobile: false
  }
};
var daqui_assets_topbar_styled_TopbarMobileSlotLeft = function TopbarMobileSlotLeft() {
  var drawersContext = (0,react.useContext)(DrawersProvider.DrawersContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcHamburguerMobile'),
      onClick: function onClick() {
        return drawersContext.handleSideMenuLeft({
          open: !drawersContext.sideMenuLeftState.open
        });
      }
    })
  });
};
var daqui_assets_topbar_styled_TopbarMobileSlotRight = function TopbarMobileSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var daqui_assets_topbar_styled_TopbarTopSlotLeft = function TopbarTopSlotLeft() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var daqui_assets_topbar_styled_TopbarTopSlotRight = function TopbarTopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, daqui_assets_topbar_styled_objectSpread({
      href: "https://classi.com.br",
      value: "Classi"
    }, daqui_assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, daqui_assets_topbar_styled_objectSpread({
      href: "https://opopular.com.br/",
      value: "Jornal O Popular"
    }, daqui_assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, daqui_assets_topbar_styled_objectSpread({
      href: "https://www.jornaldotocantins.com.br",
      value: "Jornal do Tocantins"
    }, daqui_assets_topbar_styled_buttons.topbarTopItemsRight))]
  });
};
var daqui_assets_topbar_styled_TopbarDesktopSlotRight = function TopbarDesktopSlotRight() {
  var _assetsContext$assets;

  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var sessionData = (0,react.useContext)(Session.SessionDataContext);
  var router = (0,next_router.useRouter)();

  var _useKeycloak = (0,lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var banners = assetsContext === null || assetsContext === void 0 ? void 0 : (_assetsContext$assets = assetsContext.assets) === null || _assetsContext$assets === void 0 ? void 0 : _assetsContext$assets.banners;
  var bannerAssine = banners.find(function (i) {
    return i.name === 'BannerAssineAgora';
  });
  var routerRedirectUrl = window.location.href;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SubscribeNowBannerButton_index, {
      alt: "Assine",
      colorSchema: "secondary",
      href:  false || '',
      imgSrc: bannerAssine.url,
      imgHeight: bannerAssine.height,
      imgWidth: bannerAssine.width,
      isUnstyled: true
    })
  });
};
var daqui_assets_topbar_styled_TopbarExtraSlotRight = function TopbarExtraSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(VersaoDigitalButton_index, {
      onClick: function onClick() {
        return window.open('https://daqui.opopular.com.br/digital');
      },
      icon: (0,hooks_useIcon/* useIcon */.b)('IcVersaoDigitalCinzaClaro'),
      id: "digital-menu"
    })
  });
};
;// CONCATENATED MODULE: ./brands/daqui/assets/topbar.tsx


var daqui_assets_topbar_topbar = {
  topbarMobile: {
    mainLogo: 'LogoDaquiMobile',
    css: {
      cssContainer: {
        background: '#F7F7F7',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)',
        height: '52px',
        width: '100%'
      },
      cssContainerMiddleHolder: {
        height: '100%',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '100%',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        paddingLeft: '18px',
        width: '80px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'right', 'middle'],
        paddingRight: '18px',
        width: '80px'
      },
      cssContainerBottom: {
        display: 'none'
      }
    },
    slotMiddleLeft: daqui_assets_topbar_styled_TopbarMobileSlotLeft,
    slotMiddleRight: daqui_assets_topbar_styled_TopbarMobileSlotRight
  },
  topbarDesktop: {
    mainLogo: 'LogoDaquiDesktop',
    css: {
      cssContainerTopHolder: {
        align: ['row', 'center', 'middle'],
        background: '$primaryMain',
        px: '$4',
        width: '100%'
      },
      cssContainerTop: {
        align: ['row', 'between', 'middle'],
        height: '35px',
        maxWidth: '1280px'
      },
      cssContainerTopSlotRight: {
        align: ['row', 'right', 'middle']
      },
      cssContainerMiddleHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '110px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        minWidth: '400px',
        ' > div': {
          align: ['row', 'center', 'middle']
        }
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'between', 'middle'],
        minWidth: '400px'
      },
      cssContainerBottomHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%',
        ' > div': {
          align: ['row', 'between', 'middle'],
          borderTop: '1px solid #E6E6E6'
        }
      },
      cssContainerBottom: {
        align: ['row', 'between', 'middle'],
        background: '#F7F7F7',
        height: '40px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerBottomLeft: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      cssContainerBottomRight: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      topbarItems: {
        item: {
          label: {
            color: '#202020',
            fontSize: '14px',
            fontFamily: '$primary',
            fontWeight: 500,
            textTransform: 'uppercase',
            width: 'max-content'
          },
          li: {
            mx: '$4'
          }
        }
      }
    },
    slotTopLeft: daqui_assets_topbar_styled_TopbarTopSlotLeft,
    slotTopRight: daqui_assets_topbar_styled_TopbarTopSlotRight,
    slotMiddleLeft: TopbarDesktopSlotLeft,
    slotMiddleRight: daqui_assets_topbar_styled_TopbarDesktopSlotRight,
    slotBottomRight: daqui_assets_topbar_styled_TopbarExtraSlotRight
  }
};
/* harmony default export */ var daqui_assets_topbar = ((/* unused pure expression or super */ null && (daqui_assets_topbar_topbar)));
;// CONCATENATED MODULE: ./brands/daqui/assets/index.ts












var daqui_assets_banners = daqui_indexes_banners_namespaceObject.k;
var daqui_assets_favicons = daqui_indexes_favicons_namespaceObject.k;
var daqui_assets_logos = daqui_indexes_logos_namespaceObject.k;
var daqui_assets_icons = daqui_indexes_icons_namespaceObject.k;
var daqui_assets_splashScreens = daqui_indexes_splashScreens_namespaceObject.k;
var DaquiAssets = {
  article: daqui_assets_article_article,
  banners: daqui_assets_banners,
  favicons: daqui_assets_favicons,
  footer: daqui_assets_footer_FooterConfig,
  logos: daqui_assets_logos,
  icons: daqui_assets_icons,
  menus: {
    sideMenuLeft: daqui_assets_menus_sideMenuLeft
  },
  slotLayouts: daqui_assets_layouts_slotLayouts,
  splashScreens: daqui_assets_splashScreens,
  teasers: daqui_assets_teasers_teasers,
  templates: daqui_assets_templates_templates,
  topbar: daqui_assets_topbar_topbar
};
;// CONCATENATED MODULE: ./brands/daqui/indexes/colors.json
var daqui_indexes_colors_namespaceObject = JSON.parse('{"vU":{"primaryMain":"#FFDC00","primary900":"#194392","primary800":"#235FB1","primary700":"#2970C2","primary600":"#2F82D5","primary500":"#338FE3","primary400":"#4C9FE7","primary300":"#68AFEB","primary200":"#92C6F0","primary100":"#BBDCF6","primary50":"#E4F1FC","secondaryMain":"#FC008F","secondary900":"#787A1B","secondary800":"#90A12D","secondary700":"#9FB936","secondary600":"#AECF41","secondary500":"#B9E048","secondary400":"#C2E561","secondary300":"#CDEB7C","secondary200":"#DBF1A1","secondary100":"#E9F5C6","secondary50":"#F6FCE8","tertiaryMain":"#F5CE5E","tertiary900":"#EA6F2C","tertiary800":"#EC8C34","tertiary700":"#ED9C38","tertiary600":"#EFAC3C","tertiary500":"#F0B941","tertiary400":"#F2C34F","tertiary300":"#F4CE67","tertiary200":"#F7DB8F","tertiary100":"#FAE9BA","tertiary50":"#FDF7E4"},"T9":{"headlineTextMain":"#000000","paragraphTextMain":"#333333","backgroundMain":"#F7F7F7"},"Dh":{"politicaMain":"#4597BC","politica900":"#2A5574","politica800":"#367497","politica700":"#3B85AA","politica600":"#4597BC","politica500":"#4CA5C9","politica400":"#59B1D0","politica300":"#6DBED7","politica200":"#8FD0E2","politica100":"#B9E3ED","politica50":"#E3F4F8","mundoMain":"#8BCAC8","mundo900":"#174D45","mundo800":"#206961","mundo700":"#247971","mundo600":"#288981","mundo500":"#2C968F","mundo400":"#40A5A0","mundo300":"#5FB5B1","mundo200":"#8BCAC8","mundo100":"#B8DEDD","mundo50":"#E3F2F2","economiaMain":"#589B72","economia900":"#2A5E26","economia800":"#4A8039","economia700":"#5C9443","economia600":"#6EA84E","economia500":"#7CB856","economia400":"#8FC26E","economia300":"#A2CC86","economia200":"#BCDAA8","economia100":"#D7EAC9","economia50":"#EFF7EA","cidadeMain":"#8FC26E","cidade900":"#3E5847","cidade800":"#49785B","cidade700":"#4F8966","cidade600":"#589B72","cidade500":"#60AA7E","cidade400":"#75B690","cidade300":"#8BC3A3","cidade200":"#ABD4BC","cidade100":"#CBE5D6","cidade50":"#EAF4EE","especiaisMain":"#AFAC83","especiais900":"#8A877A","especiais800":"#AFAC83","especiais700":"#C3C28A","especiais600":"#D7D895","especiais500":"#E3E89B","especiais400":"#E8EDA6","especiais300":"#ECF1B3","especiais200":"#F1F5C5","especiais100":"#F6F9DC","especiais50":"#FBFDF1","colunistaMain":"#AF8F7F","colunista900":"#4D2D25","colunista800":"#5D3B30","colunista700":"#6B4839","colunista600":"#7B5443","colunista500":"#875E4A","colunista400":"#9B7665","colunista300":"#AF8F7F","colunista200":"#CAAEA2","colunista100":"#E3CEC4","colunista50":"#F9EBE2","esporteMain":"#FB814C","esporte900":"#BC4D1B","esporte800":"#D45A23","esporte700":"#E26126","esporte600":"#F0682B","esporte500":"#FB6F2F","esporte400":"#FB814C","esporte300":"#FC976B","esporte200":"#FDB395","esporte100":"#FDD1BF","esporte50":"#FBEBE8","videoMain":"#EE6D6F","video900":"#BE071A","video800":"#CE1525","video700":"#DB1E2C","video600":"#ED2B32","video500":"#FB3733","video400":"#F9484C","video300":"#EE6D6F","video200":"#F69797","video100":"#FECCD1","video50":"#FFEAED","vida-urbanaMain":"#69a840","magazineMain":"#E982B0","magazine900":"#760649","magazine800":"#9A0952","magazine700":"#AF0B58","magazine600":"#C50D5D","magazine500":"#D50F60","magazine400":"#DB1B78","magazine300":"#E14D90","magazine200":"#E982B0","magazine100":"#F1B4D0","magazine50":"#FAE1EC"},"yT":{"semanticError":"#F9484C","semanticSuccess":"#A2CC86"}}');
;// CONCATENATED MODULE: ./brands/daqui/assets/colors.ts


function daqui_assets_colors_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_assets_colors_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_assets_colors_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_assets_colors_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var daqui_assets_colors_colors = daqui_assets_colors_objectSpread(daqui_assets_colors_objectSpread(daqui_assets_colors_objectSpread(daqui_assets_colors_objectSpread({}, daqui_indexes_colors_namespaceObject.vU), daqui_indexes_colors_namespaceObject.Dh), daqui_indexes_colors_namespaceObject.yT), daqui_indexes_colors_namespaceObject.T9);
;// CONCATENATED MODULE: ./brands/daqui/indexes/type-system.json
var daqui_indexes_type_system_namespaceObject = JSON.parse('{"CH":{"caption3":"16px","headline3":"36px","caption1":"14px","headline6":"20px","headline2":"43px","paragraph4":"18px","paragraph3":"18px","headline4":"25px","paragraphPaywall":"14px","widget5":"18px","headline5":"20px","retrancaWidget":"18px","widgetMaisLidas":"18px","widgetEsporteDestaque":"12px","widgetEsporte":"12px","headlineDestaqueEditoria2":"22px","caption4":"14px","retrancaHamburger":"18px","caption5":"14px","headlineStories":"16px","headlineDestaqueEditoria1":"28px","destaquePaywall":"14px","subtitle":"24px","caption2":"14px","paragraph2":"22px","paragraph2Link":"22px","paragraph1":"22px","headline1":"60px","retrancaEBook":"20px","headlinePaywall":"30px","preOAssinatura":"75px","widgetUdioTime":"14px","paragraph5":"16px","paragraph6":"20px"},"vC":{"caption3":500,"headline3":700,"caption1":700,"headline6":400,"headline2":700,"paragraph4":400,"paragraph3":500,"headline4":600,"paragraphPaywall":400,"widget5":400,"headline5":500,"retrancaWidget":500,"widgetMaisLidas":500,"widgetEsporteDestaque":600,"widgetEsporte":400,"headlineDestaqueEditoria2":700,"caption4":500,"retrancaHamburger":600,"caption5":400,"headlineStories":500,"headlineDestaqueEditoria1":600,"destaquePaywall":700,"subtitle":400,"caption2":400,"paragraph2":400,"paragraph2Link":400,"paragraph1":500,"headline1":700,"retrancaEBook":700,"headlinePaywall":700,"preOAssinatura":700,"widgetUdioTime":300,"paragraph5":400,"paragraph6":400},"tO":{"caption3":"19.2px","headline3":"43px","caption1":"20.8px","headline6":"25px","headline2":"50px","paragraph4":"23px","paragraph3":"25px","headline4":"30px","paragraphPaywall":"16.4px","widget5":"21.6px","headline5":"24px","retrancaWidget":"32.5px","widgetMaisLidas":"21.6px","widgetEsporteDestaque":"14.4px","widgetEsporte":"14.4px","headlineDestaqueEditoria2":"24px","caption4":"16.8px","retrancaHamburger":"21.6px","caption5":"16.8px","headlineStories":"19.2px","headlineDestaqueEditoria1":"30px","destaquePaywall":"16.4px","subtitle":"30px","caption2":"16.8px","paragraph2":"35px","paragraph2Link":"35px","paragraph1":"35px","headline1":"70px","retrancaEBook":"20px","headlinePaywall":"43px","preOAssinatura":"90px","widgetUdioTime":"16.94px","paragraph5":"22px","paragraph6":"23.4px"}}');
;// CONCATENATED MODULE: ./brands/daqui/theme.ts


function daqui_theme_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function daqui_theme_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? daqui_theme_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : daqui_theme_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck



var daqui_theme_fontSizes = daqui_indexes_type_system_namespaceObject.CH,
    daqui_theme_fontWeights = daqui_indexes_type_system_namespaceObject.vC,
    daqui_theme_lineHeights = daqui_indexes_type_system_namespaceObject.tO;
var DaquiTheme = prensa/* PrensaEngine.createTheme */.u7.createTheme('daqui', {
  colors: daqui_theme_objectSpread({}, daqui_assets_colors_colors),
  fonts: {
    primary: 'Roboto Condensed',
    secondary: 'Fira Sans Condensed'
  },
  fontSizes: daqui_theme_fontSizes,
  fontWeights: daqui_theme_fontWeights,
  lineHeights: daqui_theme_lineHeights,
  radii: {
    unset: '0px',
    "default": '4px',
    alternative: '10px',
    rounded: '99px',
    circle: '50%'
  }
});
;// CONCATENATED MODULE: ./brands/opopular/indexes/banners.json
var opopular_indexes_banners_namespaceObject = JSON.parse('{"k":[{"fullName":"BannerAnuncie.svg","name":"BannerAnuncie","url":"/assets/opopular/banners/BannerAnuncie.svg","height":"68","width":"200"},{"fullName":"BannerAssineAgora.svg","name":"BannerAssineAgora","url":"/assets/opopular/banners/BannerAssineAgora.svg","height":"13","width":"96","target":"blank"},{"fullName":"BannerAnuncieAqui.svg","name":"BannerAnuncieAqui","url":"/assets/opopular/banners/BannerAnuncieAqui.svg","height":"13","width":"96"},{"fullName":"BannerAssineAgoraCondensado.svg","name":"BannerAssineAgoraCondensado","url":"/assets/opopular/banners/BannerAssineAgoraCondensado.svg","height":"11","width":"85"},{"fullName":"BannerClube.svg","name":"BannerClube","url":"/assets/opopular/banners/BannerClube.svg","height":"50","width":"84"},{"fullName":"BannerClubeBackground.png","name":"BannerClubeBackground","url":"/assets/opopular/banners/BannerClubeBackground.png","height":"","width":""},{"fullName":"BannerSocialShare.png","name":"BannerSocialShare","url":"/assets/opopular/banners/BannerSocialShare.png","height":"","width":""},{"fullName":"BannerWhatsApp.svg","name":"BannerWhatsApp","url":"/assets/opopular/banners/BannerWhatsApp.svg","height":"150","width":"301"}]}');
;// CONCATENATED MODULE: ./brands/opopular/indexes/favicons.json
var opopular_indexes_favicons_namespaceObject = JSON.parse('{"k":[{"fullName":"128x128.png","name":"128x128","url":"/assets/opopular/favicons/128x128.png","height":"","width":""},{"fullName":"16x16.png","name":"16x16","url":"/assets/opopular/favicons/16x16.png","height":"","width":""},{"fullName":"192x192.png","name":"192x192","url":"/assets/opopular/favicons/192x192.png","height":"","width":""},{"fullName":"32x32.png","name":"32x32","url":"/assets/opopular/favicons/32x32.png","height":"","width":""},{"fullName":"48x48.png","name":"48x48","url":"/assets/opopular/favicons/48x48.png","height":"","width":""},{"fullName":"96x96.png","name":"96x96","url":"/assets/opopular/favicons/96x96.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/opopular/indexes/icons.json
var opopular_indexes_icons_namespaceObject = JSON.parse('{"k":[{"fullName":"IcAbrirAzul.svg","name":"IcAbrirAzul","url":"/assets/opopular/icons/IcAbrirAzul.svg","height":"16","width":"16"},{"fullName":"IcAbrirCinza.svg","name":"IcAbrirCinza","url":"/assets/opopular/icons/IcAbrirCinza.svg","height":"16","width":"16"},{"fullName":"IcAbrirPreto.svg","name":"IcAbrirPreto","url":"/assets/opopular/icons/IcAbrirPreto.svg","height":"16","width":"16"},{"fullName":"IcArrowDown.svg","name":"IcArrowDown","url":"/assets/opopular/icons/IcArrowDown.svg","height":"24","width":"24"},{"fullName":"IcArrowUp.svg","name":"IcArrowUp","url":"/assets/opopular/icons/IcArrowUp.svg","height":"24","width":"24"},{"fullName":"IcAudio.svg","name":"IcAudio","url":"/assets/opopular/icons/IcAudio.svg","height":"13","width":"17"},{"fullName":"IcAudioDescricao.svg","name":"IcAudioDescricao","url":"/assets/opopular/icons/IcAudioDescricao.svg","height":"13","width":"18"},{"fullName":"IcAudioMobile.svg","name":"IcAudioMobile","url":"/assets/opopular/icons/IcAudioMobile.svg","height":"16","width":"20"},{"fullName":"IcAudiodescricaoCinza.svg","name":"IcAudiodescricaoCinza","url":"/assets/opopular/icons/IcAudiodescricaoCinza.svg","height":"15","width":"19"},{"fullName":"IcAvancarCinza.svg","name":"IcAvancarCinza","url":"/assets/opopular/icons/IcAvancarCinza.svg","height":"16","width":"8"},{"fullName":"IcBotaoFacebook.svg","name":"IcBotaoFacebook","url":"/assets/opopular/icons/IcBotaoFacebook.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookBranco.svg","name":"IcBotaoFacebookBranco","url":"/assets/opopular/icons/IcBotaoFacebookBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookCinza.svg","name":"IcBotaoFacebookCinza","url":"/assets/opopular/icons/IcBotaoFacebookCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoFacebookPreto.svg","name":"IcBotaoFacebookPreto","url":"/assets/opopular/icons/IcBotaoFacebookPreto.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagram.svg","name":"IcBotaoInstagram","url":"/assets/opopular/icons/IcBotaoInstagram.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramBranco.svg","name":"IcBotaoInstagramBranco","url":"/assets/opopular/icons/IcBotaoInstagramBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramCinza.svg","name":"IcBotaoInstagramCinza","url":"/assets/opopular/icons/IcBotaoInstagramCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagramPreto.svg","name":"IcBotaoInstagramPreto","url":"/assets/opopular/icons/IcBotaoInstagramPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoLinkedin.svg","name":"IcBotaoLinkedin","url":"/assets/opopular/icons/IcBotaoLinkedin.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinBranco.svg","name":"IcBotaoLinkedinBranco","url":"/assets/opopular/icons/IcBotaoLinkedinBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinCinza.svg","name":"IcBotaoLinkedinCinza","url":"/assets/opopular/icons/IcBotaoLinkedinCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoLinkedinPreto.svg","name":"IcBotaoLinkedinPreto","url":"/assets/opopular/icons/IcBotaoLinkedinPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoTwitter.svg","name":"IcBotaoTwitter","url":"/assets/opopular/icons/IcBotaoTwitter.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterBranco.svg","name":"IcBotaoTwitterBranco","url":"/assets/opopular/icons/IcBotaoTwitterBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterCinza.svg","name":"IcBotaoTwitterCinza","url":"/assets/opopular/icons/IcBotaoTwitterCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoTwitterPreto.svg","name":"IcBotaoTwitterPreto","url":"/assets/opopular/icons/IcBotaoTwitterPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoWhatsApp.svg","name":"IcBotaoWhatsApp","url":"/assets/opopular/icons/IcBotaoWhatsApp.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppBranco.svg","name":"IcBotaoWhatsAppBranco","url":"/assets/opopular/icons/IcBotaoWhatsAppBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppCinza.svg","name":"IcBotaoWhatsAppCinza","url":"/assets/opopular/icons/IcBotaoWhatsAppCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoWhatsAppPreto.svg","name":"IcBotaoWhatsAppPreto","url":"/assets/opopular/icons/IcBotaoWhatsAppPreto.svg","height":"33","width":"34"},{"fullName":"IcBuscar.svg","name":"IcBuscar","url":"/assets/opopular/icons/IcBuscar.svg","height":"15","width":"15"},{"fullName":"IcChave.svg","name":"IcChave","url":"/assets/opopular/icons/IcChave.svg","height":"14","width":"25"},{"fullName":"IcChaveAzul.svg","name":"IcChaveAzul","url":"/assets/opopular/icons/IcChaveAzul.svg","height":"14","width":"25"},{"fullName":"IcCheckAzul.svg","name":"IcCheckAzul","url":"/assets/opopular/icons/IcCheckAzul.svg","height":"10","width":"13"},{"fullName":"IcCidade.svg","name":"IcCidade","url":"/assets/opopular/icons/IcCidade.svg","height":"17","width":"10"},{"fullName":"IcComunicado.svg","name":"IcComunicado","url":"/assets/opopular/icons/IcComunicado.svg","height":"15","width":"18"},{"fullName":"IcEconomia.svg","name":"IcEconomia","url":"/assets/opopular/icons/IcEconomia.svg","height":"16","width":"14"},{"fullName":"IcEdital.svg","name":"IcEdital","url":"/assets/opopular/icons/IcEdital.svg","height":"16","width":"13"},{"fullName":"IcEspecial.svg","name":"IcEspecial","url":"/assets/opopular/icons/IcEspecial.svg","height":"14","width":"14"},{"fullName":"IcEsporte.svg","name":"IcEsporte","url":"/assets/opopular/icons/IcEsporte.svg","height":"16","width":"13"},{"fullName":"IcFecharBranco.svg","name":"IcFecharBranco","url":"/assets/opopular/icons/IcFecharBranco.svg","height":"16","width":"13"},{"fullName":"IcFecharPreto.svg","name":"IcFecharPreto","url":"/assets/opopular/icons/IcFecharPreto.svg","height":"15","width":"13"},{"fullName":"IcHamburger.svg","name":"IcHamburger","url":"/assets/opopular/icons/IcHamburger.svg","height":"15","width":"22"},{"fullName":"IcHamburguerMobile.svg","name":"IcHamburguerMobile","url":"/assets/opopular/icons/IcHamburguerMobile.svg","height":"13","width":"19"},{"fullName":"IcMagazine.svg","name":"IcMagazine","url":"/assets/opopular/icons/IcMagazine.svg","height":"16","width":"14"},{"fullName":"IcMundo.svg","name":"IcMundo","url":"/assets/opopular/icons/IcMundo.svg","height":"15","width":"15"},{"fullName":"IcNewsletter.svg","name":"IcNewsletter","url":"/assets/opopular/icons/IcNewsletter.svg","height":"32","width":"32"},{"fullName":"IcOjc.svg","name":"IcOjc","url":"/assets/opopular/icons/IcOjc.svg","height":"17","width":"24"},{"fullName":"IcOpiniao.svg","name":"IcOpiniao","url":"/assets/opopular/icons/IcOpiniao.svg","height":"12","width":"13"},{"fullName":"IcOpiniaoGrande.svg","name":"IcOpiniaoGrande","url":"/assets/opopular/icons/IcOpiniaoGrande.svg","height":"19","width":"22"},{"fullName":"IcPlayAudioMateria.svg","name":"IcPlayAudioMateria","url":"/assets/opopular/icons/IcPlayAudioMateria.svg","height":"15","width":"15"},{"fullName":"IcPlayAudioMateriaAzul.svg","name":"IcPlayAudioMateriaAzul","url":"/assets/opopular/icons/IcPlayAudioMateriaAzul.svg","height":"23","width":"22"},{"fullName":"IcPodcast.svg","name":"IcPodcast","url":"/assets/opopular/icons/IcPodcast.svg","height":"19","width":"11"},{"fullName":"IcPolitica.svg","name":"IcPolitica","url":"/assets/opopular/icons/IcPolitica.svg","height":"16","width":"16"},{"fullName":"IcRadio.svg","name":"IcRadio","url":"/assets/opopular/icons/IcRadio.svg","height":"20","width":"18"},{"fullName":"IcRadioNext.svg","name":"IcRadioNext","url":"/assets/opopular/icons/IcRadioNext.svg","height":"","width":""},{"fullName":"IcRadioPause.svg","name":"IcRadioPause","url":"/assets/opopular/icons/IcRadioPause.svg","height":"","width":""},{"fullName":"IcRadioPlay.svg","name":"IcRadioPlay","url":"/assets/opopular/icons/IcRadioPlay.svg","height":"","width":""},{"fullName":"IcRadioPrevious.svg","name":"IcRadioPrevious","url":"/assets/opopular/icons/IcRadioPrevious.svg","height":"","width":""},{"fullName":"IcRadioStop.svg","name":"IcRadioStop","url":"/assets/opopular/icons/IcRadioStop.svg","height":"120","width":"120"},{"fullName":"IcRadioVolMax.svg","name":"IcRadioVolMax","url":"/assets/opopular/icons/IcRadioVolMax.svg","height":"","width":""},{"fullName":"IcRadioVolMin.svg","name":"IcRadioVolMin","url":"/assets/opopular/icons/IcRadioVolMin.svg","height":"","width":""},{"fullName":"IcSetaAbrir.svg","name":"IcSetaAbrir","url":"/assets/opopular/icons/IcSetaAbrir.svg","height":"6","width":"9"},{"fullName":"IcSetaCidade.svg","name":"IcSetaCidade","url":"/assets/opopular/icons/IcSetaCidade.svg","height":"9","width":"15"},{"fullName":"IcSetaEconomia.svg","name":"IcSetaEconomia","url":"/assets/opopular/icons/IcSetaEconomia.svg","height":"9","width":"15"},{"fullName":"IcSetaEspecial.svg","name":"IcSetaEspecial","url":"/assets/opopular/icons/IcSetaEspecial.svg","height":"9","width":"15"},{"fullName":"IcSetaEsporte.svg","name":"IcSetaEsporte","url":"/assets/opopular/icons/IcSetaEsporte.svg","height":"9","width":"15"},{"fullName":"IcSetaFechar.svg","name":"IcSetaFechar","url":"/assets/opopular/icons/IcSetaFechar.svg","height":"7","width":"10"},{"fullName":"IcSetaMagazine.svg","name":"IcSetaMagazine","url":"/assets/opopular/icons/IcSetaMagazine.svg","height":"9","width":"15"},{"fullName":"IcSetaMundo.svg","name":"IcSetaMundo","url":"/assets/opopular/icons/IcSetaMundo.svg","height":"9","width":"15"},{"fullName":"IcSetaOpiniao.svg","name":"IcSetaOpiniao","url":"/assets/opopular/icons/IcSetaOpiniao.svg","height":"9","width":"15"},{"fullName":"IcSetaPolitica.svg","name":"IcSetaPolitica","url":"/assets/opopular/icons/IcSetaPolitica.svg","height":"9","width":"15"},{"fullName":"IcSetaRosa.svg","name":"IcSetaRosa","url":"/assets/opopular/icons/IcSetaRosa.svg","height":"9","width":"15"},{"fullName":"IcStories.svg","name":"IcStories","url":"/assets/opopular/icons/IcStories.svg","height":"21","width":"17"},{"fullName":"IcVersaoDigital.svg","name":"IcVersaoDigital","url":"/assets/opopular/icons/IcVersaoDigital.svg","height":"14","width":"16"},{"fullName":"IcVersaoDigitalCinza.svg","name":"IcVersaoDigitalCinza","url":"/assets/opopular/icons/IcVersaoDigitalCinza.svg","height":"16","width":"18"},{"fullName":"IcVersaoDigitalCinzaClaro.svg","name":"IcVersaoDigitalCinzaClaro","url":"/assets/opopular/icons/IcVersaoDigitalCinzaClaro.svg","height":"15","width":"16"},{"fullName":"IcVoltarCinza.svg","name":"IcVoltarCinza","url":"/assets/opopular/icons/IcVoltarCinza.svg","height":"16","width":"8"},{"fullName":"IcWhatsAppCinza.svg","name":"IcWhatsAppCinza","url":"/assets/opopular/icons/IcWhatsAppCinza.svg","height":"18","width":"17"}]}');
;// CONCATENATED MODULE: ./brands/opopular/indexes/logos.json
var opopular_indexes_logos_namespaceObject = JSON.parse('{"k":[{"fullName":"LogoClassi.svg","name":"LogoClassi","url":"/assets/opopular/logos/LogoClassi.svg","height":"30","width":"30"},{"fullName":"LogoClassiAgro.svg","name":"LogoClassiAgro","url":"/assets/opopular/logos/LogoClassiAgro.svg","height":"369","width":"388"},{"fullName":"LogoClassiCarros.svg","name":"LogoClassiCarros","url":"/assets/opopular/logos/LogoClassiCarros.svg","height":"","width":""},{"fullName":"LogoClassiComBr.svg","name":"LogoClassiComBr","url":"/assets/opopular/logos/LogoClassiComBr.svg","height":"61","width":"200"},{"fullName":"LogoClassiEmpregos.svg","name":"LogoClassiEmpregos","url":"/assets/opopular/logos/LogoClassiEmpregos.svg","height":"","width":""},{"fullName":"LogoClassiImoveis.svg","name":"LogoClassiImoveis","url":"/assets/opopular/logos/LogoClassiImoveis.svg","height":"","width":""},{"fullName":"LogoClassiMotos.svg","name":"LogoClassiMotos","url":"/assets/opopular/logos/LogoClassiMotos.svg","height":"135","width":"255"},{"fullName":"LogoClassiNegocios.svg","name":"LogoClassiNegocios","url":"/assets/opopular/logos/LogoClassiNegocios.svg","height":"","width":""},{"fullName":"LogoGrupoJaimeCamara.svg","name":"LogoGrupoJaimeCamara","url":"/assets/opopular/logos/LogoGrupoJaimeCamara.svg","height":"33","width":"111"},{"fullName":"LogoOPopularDesktop.svg","name":"LogoOPopularDesktop","url":"/assets/opopular/logos/LogoOPopularDesktop.svg","height":"45","width":"282"},{"fullName":"LogoOPopularMobile.svg","name":"LogoOPopularMobile","url":"/assets/opopular/logos/LogoOPopularMobile.svg","height":"22","width":"130"}]}');
;// CONCATENATED MODULE: ./brands/opopular/indexes/splashScreens.json
var opopular_indexes_splashScreens_namespaceObject = JSON.parse('{"k":[{"fullName":"ipad.png","name":"ipad","url":"/assets/opopular/splashScreens/ipad.png","height":"","width":""},{"fullName":"ipadpro1.png","name":"ipadpro1","url":"/assets/opopular/splashScreens/ipadpro1.png","height":"","width":""},{"fullName":"ipadpro2.png","name":"ipadpro2","url":"/assets/opopular/splashScreens/ipadpro2.png","height":"","width":""},{"fullName":"ipadpro3.png","name":"ipadpro3","url":"/assets/opopular/splashScreens/ipadpro3.png","height":"","width":""},{"fullName":"iphone5.png","name":"iphone5","url":"/assets/opopular/splashScreens/iphone5.png","height":"","width":""},{"fullName":"iphone6.png","name":"iphone6","url":"/assets/opopular/splashScreens/iphone6.png","height":"","width":""},{"fullName":"iphoneplus.png","name":"iphoneplus","url":"/assets/opopular/splashScreens/iphoneplus.png","height":"","width":""},{"fullName":"iphonex.png","name":"iphonex","url":"/assets/opopular/splashScreens/iphonex.png","height":"","width":""},{"fullName":"iphonexsmax.png","name":"iphonexsmax","url":"/assets/opopular/splashScreens/iphonexsmax.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/opopular/assets/article.tsx


function opopular_assets_article_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function opopular_assets_article_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? opopular_assets_article_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : opopular_assets_article_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var opopular_assets_article_BylineRightSectionComponent = function BylineRightSectionComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_OuvirMateriaButton, {
    icon: opopular_assets_article_objectSpread({}, (0,hooks_useIcon/* useIcon */.b)('IcPlayAudioMateriaAzul')),
    onClick: function onClick(e) {
      return console.log('play audio materia', e);
    }
  });
};

var opopular_assets_article_bylineProps = {
  author: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 700,
      letterSpacing: 0.4,
      lineHeight: '18px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  authorImage: {
    enabled: true,
    customCss: {
      mr: '$4'
    }
  },
  customCss: {
    align: ['column', 'left', 'middle'],
    mb: '$6',
    width: '100%',
    '@lg': {
      align: ['row', 'between', 'middle'],
      mb: '$8',
      width: '100$'
    }
  },
  customCssLeft: {
    align: ['row', 'left', 'middle'],
    width: '100%',
    '@lg': {
      width: 'calc(100% - 320px)'
    }
  },
  customCssContent: {
    width: 'calc(100% - 80px)',
    '@lg': {}
  },
  customCssRight: {
    align: ['row', 'between', 'middle'],
    mt: '$3',
    width: '100%',
    '@lg': {
      align: ['row', 'right', 'middle'],
      mt: '$0',
      width: '320px'
    }
  },
  publishedDate: {
    enabled: true,
    as: 'time',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 400,
      letterSpacing: 0.2,
      lineHeight: '16px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  rightSlot: {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(opopular_assets_article_BylineRightSectionComponent, {})
  }
};
var opopular_assets_article_article = {
  articleContainer: {
    customCss: {
      align: ['row', 'center', 'middle'],
      mt: '$8',
      width: '100%'
    }
  },
  articleContent: {
    customCss: {
      align: ['row', 'center', 'between'],
      my: '$4',
      width: 'calc(100% - calc($4 * 3))',
      maxWidth: '1278px'
    }
  },
  articleContentLeft: {
    customCss: {
      borderTop: '1px solid #E6E6E6',
      width: '100%',
      '@lg': {
        width: 'calc(100% - 332px)'
      }
    }
  },
  articleContentRight: {
    customCss: {
      background: '#707070',
      display: 'none',
      height: '600px',
      width: '300px',
      '@lg': {
        display: 'flex'
      }
    }
  },
  bylineProps: opopular_assets_article_bylineProps,
  captionProps: {
    customCssWrap: {
      maxWidth: '960px',
      width: '100%',
      mb: '$4',
      mt: '$0'
    },
    customCss: {
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '12px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '14px',
      px: '$0',
      py: '$2',
      m: '$0',
      width: 'calc(100% - 32px)',
      '@lg': {
        fontSize: '14px',
        fontStyle: 'italic',
        lineHeight: '17px'
      }
    }
  },
  textProps: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '30px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      width: '100%',
      '@lg': {
        fontSize: '22px',
        fontWeight: 400,
        letterSpacing: 0.2,
        lineHeight: '35px'
      },
      'a': {
        color: '#194392'
      }
    }
  },
  titleProps: {
    as: 'h1',
    customCss: {
      fontFamily: '$primary',
      fontSize: '25px',
      fontWeight: 700,
      lineHeight: '28px',
      mt: '$0',
      mb: '$3',
      '@lg': {
        fontSize: '60px',
        lineHeight: '70px',
        letterSpacing: 0.4
      },
      textAlign: 'left'
    }
  },
  subjectProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '25px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      },
      textAlign: 'left'
    }
  },
  subtitleProps: {
    as: 'h2',
    customCss: {
      color: '#4D4D4D',
      fontFamily: '$primary',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '19px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      '@lg': {
        fontSize: '22px',
        lineHeight: '35px',
        letterSpacing: 0.2,
        mb: '$6'
      }
    }
  },
  shareSection: {
    enabled: true,
    content: [{
      id: 'facebookShare',
      alt: 'Compartilhar no Facebook',
      icon: 'IcBotaoFacebook',
      href: 'https://www.facebook.com/sharer/sharer.php?u='
    }, {
      id: 'twitterShare',
      alt: 'Compartilhar no Twitter',
      icon: 'IcBotaoTwitter',
      href: 'https://twitter.com/intent/tweet?text='
    }, {
      id: 'whatsappShare',
      alt: 'Compartilhar no WhatsApp',
      icon: 'IcBotaoWhatsApp',
      href: 'https://api.whatsapp.com/send?text='
    }, {
      id: 'linkedinShare',
      alt: 'Compartilhar no LinkedIn',
      icon: 'IcBotaoLinkedin',
      href: 'https://www.linkedin.com/sharing/share-offsite/?url='
    }]
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/footer.tsx
var opopular_assets_footer_currentDate = new Date();
var opopular_assets_footer_currentYear = opopular_assets_footer_currentDate.getFullYear();
var opopular_assets_footer_FooterConfig = {
  css: {
    slotMiddleCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#262626',
      height: 'max-content',
      py: '$7',
      '@xl': {
        height: '82px'
      }
    },
    slotBottomCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#2E2E2E',
      height: '60px',
      '@xl': {
        display: 'none'
      }
    }
  },
  data: {
    leftText: 'Siga O Popular:',
    navMenu: [{
      id: 'politicaDePrivacidade',
      title: 'Política de Privacidade',
      href: '/politica-de-privacidade',
      target: '_self'
    }, {
      id: 'termosDeUso',
      title: 'Termos de uso',
      href: '/termos-de-uso',
      target: '_self'
    }, {
      id: 'expediente',
      title: 'Expediente',
      href: '/expediente',
      target: '_self'
    }, {
      id: 'faleConosco',
      title: 'Fale conosco',
      href: '/fale-conosco',
      target: '_self'
    }, {
      id: 'anuncieEmOPopular',
      title: 'Anuncie em O Popular',
      href: 'https://https://estrategia.negociosjaimecamara.com.br/anuncie-o-popular.opopular.com.br/anuncie-pop',
      target: '_blank'
    }],
    rightText: "Copyright 2001-".concat(opopular_assets_footer_currentYear, ", J. C\xE2mara e Irm\xE3os S/A."),
    socialNetworks: [{
      id: 'facebookPage',
      href: 'https://www.facebook.com/opopular',
      icon: 'IcBotaoFacebook',
      title: 'Abrir O Popular no Facebook',
      target: '_blank'
    }, {
      id: 'twitterPage',
      href: 'https://twitter.com/jornal_opopular',
      icon: 'IcBotaoTwitter',
      title: 'Abrir O Popular no Twitter',
      target: '_blank'
    }, {
      id: 'instagramPage',
      href: 'https://instagram.com/jornal_opopular',
      icon: 'IcBotaoInstagram',
      title: 'Abrir O Popular no Instagram',
      target: '_blank'
    }, {
      id: 'whatsappPage',
      href: 'https://api.whatsapp.com/send?phone=5562999952795',
      icon: 'IcBotaoWhatsApp',
      title: 'Entrar em contato com O Popular no WhatsApp',
      target: '_blank'
    }]
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutCharge.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var layouts_LayoutCharge_LayoutCharge = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserChargeSm, teasers_teasers.TeaserChargeSm],
        '0:1': [teasers_teasers.TeaserChargeLg, teasers_teasers.TeaserChargeLg],
        '0:2': [teasers_teasers.TeaserChargeMd, teasers_teasers.TeaserChargeMd],
        '0:3': [teasers_teasers.TeaserChargeMd, teasers_teasers.TeaserChargeMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/utils.ts


function opopular_assets_layouts_utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function opopular_assets_layouts_utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? opopular_assets_layouts_utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : opopular_assets_layouts_utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var opopular_assets_layouts_utils_addRelativeWidthToTeaser = function addRelativeWidthToTeaser(teaser, value) {
  var _teaser$css;

  return opopular_assets_layouts_utils_objectSpread(opopular_assets_layouts_utils_objectSpread({}, teaser), {}, {
    css: opopular_assets_layouts_utils_objectSpread(opopular_assets_layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : teaser.css), {}, {
      '@lg': opopular_assets_layouts_utils_objectSpread(opopular_assets_layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : (_teaser$css = teaser.css) === null || _teaser$css === void 0 ? void 0 : _teaser$css['@lg']), {}, {
        width: value
      })
    })
  });
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutColumnist.tsx
// @ts-nocheck







var opopular_assets_layouts_LayoutColumnist_TeaserColumnist = opopular_assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserColumnist, '100%');

var opopular_assets_layouts_LayoutColumnist_renderSlotMobileWrapComponent = function renderSlotMobileWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: data
  });
};

var opopular_assets_layouts_LayoutColumnist_renderSlotDesktopWrapComponent = function renderSlotDesktopWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel .slider-wrapper': {
          width: 'calc(100% - 64px)'
        }
      },
      controlDots: {
        mt: '$2',
        mb: '$0',
        visibility: 'hidden'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    renderArrowNext: function renderArrowNext(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcAvancarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            top: 'calc(50% - 20px)',
            right: '0px'
          }
        }
      });
    },
    renderArrowPrev: function renderArrowPrev(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcVoltarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            bottom: 'calc(50% - 10px)',
            left: '0px'
          }
        }
      });
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    children: map_default()(chunk_default()(data, 4), function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'middle'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'left', 'middle'],
              minWidth: '25%',
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

var opopular_assets_layouts_LayoutColumnist_LayoutColumnist = {
  wrapperContent: {
    enabled: true,
    component: opopular_assets_layouts_LayoutColumnist_renderSlotMobileWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        pt: '$3',
        pb: '$5',
        maxWidth: 'calc(100% - $2)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [opopular_assets_layouts_LayoutColumnist_TeaserColumnist, opopular_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [opopular_assets_layouts_LayoutColumnist_TeaserColumnist, opopular_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [opopular_assets_layouts_LayoutColumnist_TeaserColumnist, opopular_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [opopular_assets_layouts_LayoutColumnist_TeaserColumnist, opopular_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
var opopular_assets_layouts_LayoutColumnist_LayoutColumnistDesktop = {
  wrapperContent: {
    enabled: true,
    component: opopular_assets_layouts_LayoutColumnist_renderSlotDesktopWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        py: '$6',
        maxWidth: 'calc(100% - 180px)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: 'calc(100% - $12)'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [opopular_assets_layouts_LayoutColumnist_TeaserColumnist, opopular_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [opopular_assets_layouts_LayoutColumnist_TeaserColumnist, opopular_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [opopular_assets_layouts_LayoutColumnist_TeaserColumnist, opopular_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [opopular_assets_layouts_LayoutColumnist_TeaserColumnist, opopular_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutColumnistSideBox.tsx
// @ts-nocheck

var opopular_assets_layouts_LayoutColumnistSideBox_LayoutColumnistSideBox = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnContent': {
        pt: '$6',
        pb: '$6',
        maxWidth: 'calc(100% - $2)'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [teasers_teasers.TeaserColumnist, teasers_teasers.TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutDefault.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var opopular_assets_layouts_LayoutDefault_LayoutDefault = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft],
        '0': [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserHeadlineSm, teasers_teasers.TeaserImageLeftXl]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageLeftLg]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserNoImage, teasers_teasers.TeaserNoImage]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageLeft],
        '0:1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageTopLg],
        '1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageTopLg]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft],
        '0:1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageTopLg],
        '1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageTopLg]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft],
        '0:1': [teasers_teasers.TeaserImageLeft, teasers_teasers.TeaserImageTop],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft],
        '0:1': [teasers_teasers.TeaserImageLeft, teasers_teasers.TeaserImageLeft],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      }
    },
    TemplateVideos: {
      slotLeft: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutEditais.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var assets_layouts_LayoutEditais_LayoutEditais = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotLeft: {
        "default": [teasers_teasers.TeaserEditais, teasers_teasers.TeaserEditais]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserEditais, teasers_teasers.TeaserEditais]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutEditorial.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var layouts_LayoutEditorial_LayoutEditorial = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserEditorialSm, teasers_teasers.TeaserEditorial],
        '0:1': [teasers_teasers.TeaserImageTopLg, teasers_teasers.TeaserImageLeftLg]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutFeatured.ts


function opopular_assets_layouts_LayoutFeatured_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function opopular_assets_layouts_LayoutFeatured_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? opopular_assets_layouts_LayoutFeatured_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : opopular_assets_layouts_LayoutFeatured_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// MancheteComFoto
var opopular_assets_layouts_LayoutFeatured_LayoutFeatured = opopular_assets_layouts_LayoutFeatured_objectSpread(opopular_assets_layouts_LayoutFeatured_objectSpread({}, opopular_assets_layouts_LayoutDefault_LayoutDefault), {}, {
  slotConfig: opopular_assets_layouts_LayoutFeatured_objectSpread(opopular_assets_layouts_LayoutFeatured_objectSpread({}, opopular_assets_layouts_LayoutDefault_LayoutDefault === null || opopular_assets_layouts_LayoutDefault_LayoutDefault === void 0 ? void 0 : opopular_assets_layouts_LayoutDefault_LayoutDefault.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeft],
        '0:1': [teasers_teasers.TeaserImageLeft, teasers_teasers.TeaserImageLeftLg],
        '1': [teasers_teasers.TeaserImageLeft, teasers_teasers.TeaserImageLeftLg]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackground, teasers_teasers.TeaserBackgroundLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutFeaturedImage.ts


function opopular_assets_layouts_LayoutFeaturedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function opopular_assets_layouts_LayoutFeaturedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? opopular_assets_layouts_LayoutFeaturedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : opopular_assets_layouts_LayoutFeaturedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var opopular_assets_layouts_LayoutFeaturedImage_LayoutFeaturedImage = opopular_assets_layouts_LayoutFeaturedImage_objectSpread(opopular_assets_layouts_LayoutFeaturedImage_objectSpread({}, opopular_assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: opopular_assets_layouts_LayoutFeaturedImage_objectSpread(opopular_assets_layouts_LayoutFeaturedImage_objectSpread({}, opopular_assets_layouts_LayoutFeatured_LayoutFeatured === null || opopular_assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : opopular_assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackgroundRelated, teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutFeaturedNoImage.ts


function opopular_assets_layouts_LayoutFeaturedNoImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function opopular_assets_layouts_LayoutFeaturedNoImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? opopular_assets_layouts_LayoutFeaturedNoImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : opopular_assets_layouts_LayoutFeaturedNoImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var opopular_assets_layouts_LayoutFeaturedNoImage_LayoutFeaturedNoImage = opopular_assets_layouts_LayoutFeaturedNoImage_objectSpread(opopular_assets_layouts_LayoutFeaturedNoImage_objectSpread({}, opopular_assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: opopular_assets_layouts_LayoutFeaturedNoImage_objectSpread(opopular_assets_layouts_LayoutFeaturedNoImage_objectSpread({}, opopular_assets_layouts_LayoutFeatured_LayoutFeatured === null || opopular_assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : opopular_assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, teasers_teasers.TeaserImageLeft],
        '0:1': [teasers_teasers.TeaserHeadlineSm, teasers_teasers.TeaserHeadlineLg],
        '1': [teasers_teasers.TeaserHeadlineSm, teasers_teasers.TeaserHeadlineLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutFeaturedRelated.ts


function opopular_assets_layouts_LayoutFeaturedRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function opopular_assets_layouts_LayoutFeaturedRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? opopular_assets_layouts_LayoutFeaturedRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : opopular_assets_layouts_LayoutFeaturedRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// SuperManchete
var opopular_assets_layouts_LayoutFeaturedRelated_LayoutFeaturedRelated = opopular_assets_layouts_LayoutFeaturedRelated_objectSpread(opopular_assets_layouts_LayoutFeaturedRelated_objectSpread({}, opopular_assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: opopular_assets_layouts_LayoutFeaturedRelated_objectSpread(opopular_assets_layouts_LayoutFeaturedRelated_objectSpread({}, opopular_assets_layouts_LayoutFeatured_LayoutFeatured === null || opopular_assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : opopular_assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    TemplateSuperManchete: {
      slotLeft: {
        "default": [teasers_teasers.TeaserBackgroundRelated, teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutGrid3.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var opopular_assets_layouts_LayoutGrid3_TeaserCard = opopular_assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 2)) / 3)');
var opopular_assets_layouts_LayoutGrid3_TeaserImageTop = opopular_assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var opopular_assets_layouts_LayoutGrid3_LayoutGrid3 = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template100100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, opopular_assets_layouts_LayoutGrid3_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, opopular_assets_layouts_LayoutGrid3_TeaserCard]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutGrid4.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var opopular_assets_layouts_LayoutGrid4_TeaserCard = opopular_assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 3)) / 4)');
var opopular_assets_layouts_LayoutGrid4_LayoutGrid4 = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserCard, opopular_assets_layouts_LayoutGrid4_TeaserCard]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeftSq],
        '0:1': [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeftSq]
      }
    },
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [teasers_teasers.TeaserColumnist, teasers_teasers.TeaserColumnist],
        '0:1': [teasers_teasers.TeaserColumnist, teasers_teasers.TeaserColumnist]
      }
    },
    TemplateSideBoxNoTitle: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeftSm],
        '0:1': [teasers_teasers.TeaserImageLeftSq, teasers_teasers.TeaserImageLeftSm],
        '1': [teasers_teasers.TeaserImageTop, teasers_teasers.TeaserImageTop]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutGridInfocom.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var assets_layouts_LayoutGridInfocom_TeaserCardBold = opopular_assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserCardBold, 'calc(calc(100% - calc(24px * 2)) / 3)');
var assets_layouts_LayoutGridInfocom_TeaserImageTop = opopular_assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var layouts_LayoutGridInfocom_LayoutGridInfocom = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template100100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageLeftSm, assets_layouts_LayoutGridInfocom_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [teasers_teasers.TeaserImageTop, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserImageTop, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserImageTop, assets_layouts_LayoutGridInfocom_TeaserCardBold]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutPodcast.tsx
// @ts-nocheck




var opopular_assets_layouts_LayoutPodcast_renderWrapComponent = function renderWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '200px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

var opopular_assets_layouts_LayoutPodcast_LayoutPodcast = {
  wrapperContent: {
    enabled: true,
    component: opopular_assets_layouts_LayoutPodcast_renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxPodcast: {
      slotLeft: {
        "default": [teasers_teasers.TeaserPodcast, teasers_teasers.TeaserPodcast]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutRadio.tsx
// @ts-nocheck

var opopular_assets_layouts_LayoutRadio_LayoutRadio = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      px: '$0',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxRadio: {
      slotLeft: {
        "default": [teasers_teasers.TeaserRadio, teasers_teasers.TeaserRadio]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutSearch.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var opopular_assets_layouts_LayoutSearch_LayoutSearch = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [teasers_teasers.TeaserEditorialSm, teasers_teasers.TeaserEditorial]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutStories.tsx
// @ts-nocheck

var opopular_assets_layouts_LayoutStories_LayoutStories = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxStories: {
      slotLeft: {
        "default": [teasers_teasers.TeaserStories, teasers_teasers.TeaserStories]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutMostRead.ts
// eslint-disable-next-line
// @ts-nocheck

var opopular_assets_layouts_LayoutMostRead_LayoutMostRead = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [teasers_teasers.TeaserMostRead, teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [teasers_teasers.TeaserMostRead, teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBoxFixed: {
      slotLeft: {
        "default": [teasers_teasers.TeaserMostReadFixed, teasers_teasers.TeaserMostReadFixed]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserMostReadFixed, teasers_teasers.TeaserMostReadFixed]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutVideoFeatured.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var assets_layouts_LayoutVideoFeatured_LayoutVideoFeatured = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [teasers_teasers.TeaserVideoFeatured, teasers_teasers.TeaserVideoFeatSm],
        '0:1': [teasers_teasers.TeaserVideoFeatLg, teasers_teasers.TeaserVideoFeatLg],
        '0:2': [teasers_teasers.TeaserVideoFeatured, teasers_teasers.TeaserVideoFeatMd],
        '0:3': [teasers_teasers.TeaserVideoFeatured, teasers_teasers.TeaserVideoFeatMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutVideoHome.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var opopular_assets_layouts_LayoutVideoHome_TeaserVideoTop = opopular_assets_layouts_utils_addRelativeWidthToTeaser(teasers_teasers.TeaserVideoTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var opopular_assets_layouts_LayoutVideoHome_LayoutVideoHome = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        width: '100%' // columnGap: '24px'

      }
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [teasers_teasers.TeaserVideoTop, opopular_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop],
        '2': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft],
        '0:1': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop],
        '0:2': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserVideoTop, opopular_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop],
        '2': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft],
        '0:1': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop],
        '0:2': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      },
      slotRight: {
        "default": [teasers_teasers.TeaserVideoTop, opopular_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop],
        '2': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft],
        '0:1': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop],
        '0:2': [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/opopular/assets/layouts/LayoutVideoLive.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var opopular_assets_layouts_LayoutVideoLive_LayoutVideoLive = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [teasers_teasers.TeaserVideoTop, teasers_teasers.TeaserVideoLeft]
      }
    },
    TemplateVideoLive: {
      slotLeft: {
        "default": [teasers_teasers.TeaserMostRead, teasers_teasers.TeaserMostRead],
        '0:1': [teasers_teasers.TeaserMostRead, teasers_teasers.TeaserMostRead]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/layouts.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck






















var opopular_assets_layouts_slotLayouts = {
  LayoutCharge: layouts_LayoutCharge_LayoutCharge,
  LayoutColumnist: opopular_assets_layouts_LayoutColumnist_LayoutColumnist,
  LayoutColumnistDesktop: opopular_assets_layouts_LayoutColumnist_LayoutColumnistDesktop,
  LayoutColumnistSideBox: opopular_assets_layouts_LayoutColumnistSideBox_LayoutColumnistSideBox,
  LayoutDefault: opopular_assets_layouts_LayoutDefault_LayoutDefault,
  LayoutEditais: assets_layouts_LayoutEditais_LayoutEditais,
  LayoutEditorial: layouts_LayoutEditorial_LayoutEditorial,
  LayoutFeatured: opopular_assets_layouts_LayoutFeatured_LayoutFeatured,
  LayoutFeaturedImage: opopular_assets_layouts_LayoutFeaturedImage_LayoutFeaturedImage,
  LayoutFeaturedNoImage: opopular_assets_layouts_LayoutFeaturedNoImage_LayoutFeaturedNoImage,
  LayoutFeaturedRelated: opopular_assets_layouts_LayoutFeaturedRelated_LayoutFeaturedRelated,
  LayoutGrid3: opopular_assets_layouts_LayoutGrid3_LayoutGrid3,
  LayoutGrid4: opopular_assets_layouts_LayoutGrid4_LayoutGrid4,
  LayoutGridInfocom: layouts_LayoutGridInfocom_LayoutGridInfocom,
  LayoutPodcast: opopular_assets_layouts_LayoutPodcast_LayoutPodcast,
  LayoutRadio: opopular_assets_layouts_LayoutRadio_LayoutRadio,
  LayoutSearch: opopular_assets_layouts_LayoutSearch_LayoutSearch,
  LayoutStories: opopular_assets_layouts_LayoutStories_LayoutStories,
  LayoutMostRead: opopular_assets_layouts_LayoutMostRead_LayoutMostRead,
  LayoutVideoFeatured: assets_layouts_LayoutVideoFeatured_LayoutVideoFeatured,
  LayoutVideoHome: opopular_assets_layouts_LayoutVideoHome_LayoutVideoHome,
  LayoutVideoLive: opopular_assets_layouts_LayoutVideoLive_LayoutVideoLive
};
var opopular_assets_layouts_slotLayoutsArray = Object.keys(opopular_assets_layouts_slotLayouts);

;// CONCATENATED MODULE: ./brands/opopular/assets/menus.tsx
var opopular_assets_menus_accordionStyle = {
  accordionItemGroup: {
    accordionContent: {
      backgroundColor: '#EAEAEA',
      pl: '$8',
      pr: '$18'
    },
    accordionTitle: {
      title: {
        fontFamily: '$primary',
        fontSize: '$caption5',
        fontWeight: '$caption5',
        lineHeight: '$caption5',
        m: '0px',
        py: '$2',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px'
      },
      iconButton: {
        height: '24px',
        width: '24px'
      }
    }
  }
};
var opopular_assets_menus_sideMenuLeft = {
  sectionHeader: {
    enabled: true,
    subscriberInfo: {
      enabled: true,
      amountLeft: 5
    },
    advertiseSection: {
      enabled: true,
      color: '#A7DCFE',
      href: 'https://opopular.com.br/popstore',
      target: '_blank'
    },
    variants: {
      anonymous: {
        logo: {
          id: 'assine-agora-menu',
          name: 'BannerAnuncie',
          href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania"
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#A7DCFE',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      DEGUSTADOR: {
        logo: {
          name: 'BannerAnuncie',
          href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania"
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#A7DCFE',
            height: '149px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      ASSINANTE: {
        logo: {
          name: 'BannerAnuncie',
          href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania"
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#A7DCFE',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      advertiser_subscriber: {
        logo: {
          name: 'BannerAnuncie',
          id: 'anuncie-menu'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#A7DCFE',
            height: '149px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      club_subscriber: {
        logo: {
          name: 'BannerClube',
          href: '/',
          id: 'banner-clube'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundImage: 'url(assets/opopular/banners/BannerClubeBackground.png)',
            height: '149px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicWhite'
        }
      }
    }
  },
  sectionContent: {
    enabled: true,
    searchInput: {
      enabled: true
    },
    advertiseSection: {
      enabled: true,
      color: '$secondaryMain',
      href: 'https://opopular.com.br/popstore',
      target: '_blank'
    },
    serviceButtons: {
      enabled: true,
      items: [{
        id: 'whatsapp',
        variant: 'WhatsApp',
        href: 'https://api.whatsapp.com/send?phone=5562999952795',
        target: '_blank'
      }, {
        id: 'jornaldigital',
        href: 'https://opopular.com.br/digital',
        variant: 'JornalDigital',
        target: '_blank'
      }]
    },
    navigationAccordions: {
      enabled: true,
      css: opopular_assets_menus_accordionStyle,
      items: [
      /*         {
                id: 'publicidade',
                title: 'Publicidade',
                items: [
                  {
                    id: '1',
                    title: 'Infomercial',
                    href: '/infomercial',
                  },
                  {
                    id: '2',
                    title: 'Publicidade Legal',
                    href: '/publicidade-legal',
                  },
                ],
                css: accordionStyle,
              }, */
      {
        id: 'sac',
        title: 'SAC',
        items: [{
          id: '1',
          title: 'Fale Conosco',
          href: '/fale-conosco'
        }, {
          id: '2',
          title: 'Expediente',
          href: '/expediente'
        }, {
          id: '3',
          title: 'Política de privacidade',
          href: '/politica-de-privacidade'
        }, {
          id: '4',
          title: 'Termos de uso',
          href: '/termos-de-uso'
        }],
        css: opopular_assets_menus_accordionStyle
      }, {
        id: 'grupoojc',
        title: 'Grupo Jaime Câmara',
        items: [{
          id: '1',
          title: 'Classi',
          href: 'https://www.classi.com.br'
        }
        /* 
        {
        id: '2',
        title: 'Clube O Popular',
        href: 'https://clube.opopular.com.br'
        }, */
        , {
          id: '2',
          title: 'Jornal Daqui',
          href: 'https://daqui.opopular.com.br'
        }, {
          id: '3',
          title: 'Jornal do Tocantins',
          href: 'https://www.jornaldotocantins.com.br'
        }],
        css: opopular_assets_menus_accordionStyle
      }]
    }
  },
  sectionFooter: {
    enabled: true,
    advertiseSection: {
      enabled: true,
      color: '#A7DCFE',
      href: 'https://estrategia.negociosjaimecamara.com.br/anuncie-o-popular.opopular.com.br/anuncie-pop',
      target: '_blank'
    },
    socialmediasSection: {
      enabled: true,
      color: '#F7F7F7',
      content: [{
        id: 'facebook',
        href: 'https://www.facebook.com/opopular',
        icon: 'IcBotaoFacebookCinza'
      }, {
        id: 'twitter',
        href: 'https://twitter.com/jornal_opopular',
        icon: 'IcBotaoTwitterCinza'
      }, {
        id: 'instagram',
        href: 'https://instagram.com/jornal_opopular',
        icon: 'IcBotaoInstagramCinza'
      }, {
        id: 'whatsapp',
        href: 'https://api.whatsapp.com/send?phone=5562999952795',
        icon: 'IcBotaoWhatsAppCinza'
      }]
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/Template100.ts
var opopular_assets_templates_Template100_Template100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/Template100100.ts
var templates_Template100100_Template100100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['column', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/Template1005050.ts
var opopular_assets_templates_Template1005050_Template1005050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      '.Column.Left': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Center': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Right': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column.Left': {
          mb: '$0'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          borderBottom: 'none',
          gridColumn: 'span 2',
          width: '100%'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/Template5050.ts
var opopular_assets_templates_Template5050_Template5050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/Template5050100.ts
var opopular_assets_templates_Template5050100_Template5050100 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          gridColumn: 'span 2',
          width: '100%'
        }
      }
    }
  },
  customProps: {
    container: {
      className: 'AlignToLeft'
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateColumnist.ts
var opopular_assets_templates_TemplateColumnist_TemplateColumnist = {
  css: {
    container: {
      backgroundColor: '#f4f4f4',
      pt: '$4',
      mb: '$4',
      '@lg': {
        pb: '$0',
        mb: '$4'
      }
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '.Column:nth-child(1)': {
        '@lg': {
          display: 'none'
        }
      },
      '.Column:nth-child(2)': {
        display: 'none',
        '@lg': {
          display: 'flex'
        }
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Teaser.mobile:not(:nth-child(1))': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%'
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSideBox.ts
var opopular_assets_templates_TemplateSideBox_TemplateSideBox = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        px: '$3',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle'],
        borderBottom: '1px solid #e6e6e6',
        pt: '$4',
        pb: '$0',
        px: '$2',
        mb: '$5'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSideBoxGeneric.ts
var assets_templates_TemplateSideBoxGeneric_TemplateSideBoxGeneric = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSideBoxFixed.ts
var opopular_assets_templates_TemplateSideBoxFixed_TemplateSideBoxFixed = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      mt: '$6',
      '@lg': {
        pb: '$0',
        px: '$0',
        mt: '$6',
        mb: '$8',
        position: 'sticky',
        top: '200px'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ExtraTop .ColumnContent': {
        align: ['row', 'left', 'bottom'],
        mb: '0px',
        width: '100%',
        '.pds-Button-root': {
          backgroundColor: '#FFFFFF'
        }
      },
      '.Center .ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderTop: 'unset',
        borderBottomLeftRadius: '$alternative',
        borderBottomRightRadius: '$alternative',
        overflow: 'hidden',
        py: '$0',
        width: '100%'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSideBoxPodcast.ts
var opopular_assets_templates_TemplateSideBoxPodcast_TemplateSideBoxPodcast = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        borderRadius: '10px',
        mt: '$6',
        mx: '$3',
        width: '290px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .Teaser:nth-child(2),.Teaser:nth-child(1)': {
        position: 'relative',
        top: '-30px',
        'img': {
          height: '190px',
          width: '190px'
        },
        '.TeaserImage': {
          width: '180px'
        }
      },
      '.ColumnBottom': {
        mb: '$4',
        mx: '$4',
        width: 'calc(100% - $8)',
        'audio': {
          width: 'calc(100% - $8)'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '-$6',
        px: '$0',
        mt: '$1',
        overflowX: 'clip',
        py: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSideBoxRadio.ts
var opopular_assets_templates_TemplateSideBoxRadio_TemplateSideBoxRadio = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        px: '$0'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .slide.selected .Teaser': {
        'img': {
          height: '124px',
          width: '124px'
        },
        '.TeaserSubtitleText': {
          maxWidth: '124px'
        },
        '.TeaserTitleText': {
          maxWidth: '124px'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        overflowY: 'inherit',
        overflowX: 'clip',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSideBoxStories.ts
var opopular_assets_templates_TemplateSideBoxStories_TemplateSideBoxStories = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      width: 'calc(100% - $4)',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8',
        width: '100%'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left': {
        overflowX: 'clip'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '$3',
        px: '$0',
        mt: '$1',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSideBoxColumnist.ts
var opopular_assets_templates_TemplateSideBoxColumnist_TemplateSideBoxColumnist = {
  css: {
    container: {
      pt: '$0',
      '@lg': {
        pb: '$0',
        mb: '$0'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        backgroundColor: '#f4f4f4',
        mb: '$4',
        px: '$2',
        py: '$8',
        width: '100%'
      },
      '.Extra .ColumnContent': {
        backgroundImage: 'none',
        px: '$3',
        py: '$0',
        mb: '$0',
        width: '100%'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.ExtraTop .ColumnContent': {
        backgroundImage: 'none',
        py: '$0',
        px: '$3',
        mt: '$1',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      }
    },
    item: {}
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSideBoxNoTitle.ts
var opopular_assets_templates_TemplateSideBoxNoTitle_TemplateSideBoxNoTitle = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$3',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2',
        '.TeaserWrap': {
          py: '$3'
        },
        '.TeaserSubject': {
          px: '$6'
        },
        '.TeaserTitle': {
          px: '$6'
        },
        '.TeaserImage img': {
          borderRadius: '10px 10px 0px 0px'
        }
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$3',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSidebarLeft.ts
var opopular_assets_templates_TemplateSidebarLeft_TemplateSidebarLeft = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      flexDirection: 'column-reverse',
      marginTop: '$2',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none',
          marginTop: '24px',
          width: '300px'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          marginTop: '36px',
          width: 'calc(100% - 340px)'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          flexDirection: 'unset',
          align: ['row', 'between', 'middle']
        },
        '.Column.ExtraTop': {
          width: '100%'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateSuperManchete.ts
var opopular_assets_templates_TemplateSuperManchete_TemplateSuperManchete = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateVideosLive.ts
var opopular_assets_templates_TemplateVideosLive_TemplateVideoLive = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$0',
        px: '$3',
        width: '100%'
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates/TemplateVideos.ts
var opopular_assets_templates_TemplateVideos_TemplateVideos = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        mb: '$0',
        px: '$3',
        width: '100%',
        '@lg': {
          align: ['row', 'between', 'top']
        }
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2) .ColumnContent': {
        align: ['column', 'center', 'top']
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column.Left': {
          minWidth: 'calc(50% - $3)',
          width: 'auto'
        },
        '.Column.Center': {
          maxWidth: 'calc(50% - $3)',
          width: 'auto'
        },
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/opopular/assets/templates.ts


















var opopular_assets_templates_templates = {
  Template100: opopular_assets_templates_Template100_Template100,
  Template100100: templates_Template100100_Template100100,
  Template1005050: opopular_assets_templates_Template1005050_Template1005050,
  Template5050: opopular_assets_templates_Template5050_Template5050,
  Template5050100: opopular_assets_templates_Template5050100_Template5050100,
  TemplateColumnist: opopular_assets_templates_TemplateColumnist_TemplateColumnist,
  TemplateSideBox: opopular_assets_templates_TemplateSideBox_TemplateSideBox,
  TemplateSideBoxGeneric: assets_templates_TemplateSideBoxGeneric_TemplateSideBoxGeneric,
  TemplateSideBoxFixed: opopular_assets_templates_TemplateSideBoxFixed_TemplateSideBoxFixed,
  TemplateSideBoxPodcast: opopular_assets_templates_TemplateSideBoxPodcast_TemplateSideBoxPodcast,
  TemplateSideBoxRadio: opopular_assets_templates_TemplateSideBoxRadio_TemplateSideBoxRadio,
  TemplateSideBoxStories: opopular_assets_templates_TemplateSideBoxStories_TemplateSideBoxStories,
  TemplateSideBoxColumnist: opopular_assets_templates_TemplateSideBoxColumnist_TemplateSideBoxColumnist,
  TemplateSideBoxNoTitle: opopular_assets_templates_TemplateSideBoxNoTitle_TemplateSideBoxNoTitle,
  TemplateSidebarLeft: opopular_assets_templates_TemplateSidebarLeft_TemplateSidebarLeft,
  TemplateSuperManchete: opopular_assets_templates_TemplateSuperManchete_TemplateSuperManchete,
  TemplateVideoLive: opopular_assets_templates_TemplateVideosLive_TemplateVideoLive,
  TemplateVideos: opopular_assets_templates_TemplateVideos_TemplateVideos
};
var opopular_assets_templates_templatesArray = Object.keys(opopular_assets_templates_templates);

;// CONCATENATED MODULE: ./brands/opopular/assets/topbar.tsx

var opopular_assets_topbar_topbar = {
  topbarMobile: {
    mainLogo: 'LogoOPopularMobile',
    css: {
      cssContainer: {
        background: '#F7F7F7',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)',
        height: '52px',
        position: 'sticky',
        top: 0,
        width: '100%',
        zIndex: 9
      },
      cssContainerMiddleHolder: {
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        paddingLeft: '18px',
        width: '80px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'right', 'middle'],
        paddingRight: '18px',
        width: '80px'
      },
      cssContainerBottom: {
        display: 'none'
      }
    },
    slotMiddleLeft: TopbarMobileSlotLeft,
    slotMiddleRight: TopbarMobileSlotRight
  },
  topbarDesktop: {
    mainLogo: 'LogoOPopularDesktop',
    css: {
      cssContainerTopHolder: {
        align: ['row', 'center', 'middle'],
        background: '$primaryMain',
        px: '$4',
        width: '100%'
      },
      cssContainer: {
        position: 'relative',
        top: 0,
        zIndex: 9
      },
      cssContainerTop: {
        align: ['row', 'between', 'middle'],
        height: '32px',
        maxWidth: '1280px'
      },
      cssContainerTopSlotRight: {
        align: ['row', 'right', 'middle']
      },
      cssContainerMiddleHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '110px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        minWidth: '400px',
        ' > div': {
          align: ['row', 'center', 'middle']
        }
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'between', 'middle'],
        minWidth: '400px'
      },
      cssContainerBottomHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%',
        ' > div': {
          align: ['row', 'between', 'middle'],
          borderTop: '1px solid #E6E6E6'
        }
      },
      cssContainerBottom: {
        align: ['row', 'between', 'middle'],
        background: '#F7F7F7',
        height: '40px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerBottomLeft: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      cssContainerBottomRight: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      topbarItems: {
        item: {
          label: {
            color: '#202020',
            fontSize: '14px',
            fontFamily: '$primary',
            fontWeight: 500,
            textTransform: 'uppercase',
            width: 'max-content'
          },
          li: {
            'a': {
              borderBottom: '4px solid transparent',
              cursor: 'pointer',
              display: 'block',
              height: '100%',
              width: '100%',
              pb: '6px',
              px: '$4',
              pt: '10px'
            }
          }
        }
      }
    },
    slotTopLeft: TopbarTopSlotLeft,
    slotTopRight: TopbarTopSlotRight,
    slotMiddleLeft: TopbarDesktopSlotLeft,
    slotMiddleRight: TopbarDesktopSlotRight,
    slotBottomRight: TopbarExtraSlotRight
  }
};
/* harmony default export */ var opopular_assets_topbar = ((/* unused pure expression or super */ null && (opopular_assets_topbar_topbar)));
;// CONCATENATED MODULE: ./brands/opopular/assets/index.ts












var opopular_assets_banners = opopular_indexes_banners_namespaceObject.k;
var opopular_assets_favicons = opopular_indexes_favicons_namespaceObject.k;
var opopular_assets_logos = opopular_indexes_logos_namespaceObject.k;
var opopular_assets_icons = opopular_indexes_icons_namespaceObject.k;
var opopular_assets_splashScreens = opopular_indexes_splashScreens_namespaceObject.k;
var OPopularAssets = {
  article: opopular_assets_article_article,
  banners: opopular_assets_banners,
  favicons: opopular_assets_favicons,
  footer: opopular_assets_footer_FooterConfig,
  logos: opopular_assets_logos,
  icons: opopular_assets_icons,
  menus: {
    sideMenuLeft: opopular_assets_menus_sideMenuLeft
  },
  slotLayouts: opopular_assets_layouts_slotLayouts,
  splashScreens: opopular_assets_splashScreens,
  teasers: teasers_teasers,
  templates: opopular_assets_templates_templates,
  topbar: opopular_assets_topbar_topbar
};
;// CONCATENATED MODULE: ./brands/opopular/indexes/colors.json
var opopular_indexes_colors_namespaceObject = JSON.parse('{"vU":{"neutral":" #989898","primaryMain":"#194392","primary900":"#194392","primary800":"#235FB1","primary700":"#2970C2","primary600":"#2F82D5","primary500":"#338FE3","primary400":"#4C9FE7","primary300":"#68AFEB","primary200":"#92C6F0","primary100":"#BBDCF6","primary50":"#E4F1FC","secondaryMain":"#CDEB7C","secondary900":"#787A1B","secondary800":"#90A12D","secondary700":"#9FB936","secondary600":"#AECF41","secondary500":"#B9E048","secondary400":"#C2E561","secondary300":"#CDEB7C","secondary200":"#DBF1A1","secondary100":"#E9F5C6","secondary50":"#F6FCE8","tertiaryMain":"#F5CE5E","tertiary900":"#EA6F2C","tertiary800":"#EC8C34","tertiary700":"#ED9C38","tertiary600":"#EFAC3C","tertiary500":"#F0B941","tertiary400":"#F2C34F","tertiary300":"#F4CE67","tertiary200":"#F7DB8F","tertiary100":"#FAE9BA","tertiary50":"#FDF7E4"},"T9":{"headlineTextMain":"#000000","paragraphTextMain":"#333333","backgroundMain":"#F7F7F7"},"Dh":{"politicaMain":"#4597BC","politica900":"#2A5574","politica800":"#367497","politica700":"#3B85AA","politica600":"#4597BC","politica500":"#4CA5C9","politica400":"#59B1D0","politica300":"#6DBED7","politica200":"#8FD0E2","politica100":"#B9E3ED","politica50":"#E3F4F8","mundoMain":"#8BCAC8","mundo900":"#174D45","mundo800":"#206961","mundo700":"#247971","mundo600":"#288981","mundo500":"#2C968F","mundo400":"#40A5A0","mundo300":"#5FB5B1","mundo200":"#8BCAC8","mundo100":"#B8DEDD","mundo50":"#E3F2F2","economiaMain":"#589B72","economia900":"#2A5E26","economia800":"#4A8039","economia700":"#5C9443","economia600":"#6EA84E","economia500":"#7CB856","economia400":"#8FC26E","economia300":"#A2CC86","economia200":"#BCDAA8","economia100":"#D7EAC9","economia50":"#EFF7EA","cidadeMain":"#8FC26E","cidade900":"#3E5847","cidade800":"#49785B","cidade700":"#4F8966","cidade600":"#589B72","cidade500":"#60AA7E","cidade400":"#75B690","cidade300":"#8BC3A3","cidade200":"#ABD4BC","cidade100":"#CBE5D6","cidade50":"#EAF4EE","especiaisMain":"#AFAC83","especiais900":"#8A877A","especiais800":"#AFAC83","especiais700":"#C3C28A","especiais600":"#D7D895","especiais500":"#E3E89B","especiais400":"#E8EDA6","especiais300":"#ECF1B3","especiais200":"#F1F5C5","especiais100":"#F6F9DC","especiais50":"#FBFDF1","colunistaMain":"#AF8F7F","colunista900":"#4D2D25","colunista800":"#5D3B30","colunista700":"#6B4839","colunista600":"#7B5443","colunista500":"#875E4A","colunista400":"#9B7665","colunista300":"#AF8F7F","colunista200":"#CAAEA2","colunista100":"#E3CEC4","colunista50":"#F9EBE2","esporteMain":"#FB814C","esporte900":"#BC4D1B","esporte800":"#D45A23","esporte700":"#E26126","esporte600":"#F0682B","esporte500":"#FB6F2F","esporte400":"#FB814C","esporte300":"#FC976B","esporte200":"#FDB395","esporte100":"#FDD1BF","esporte50":"#FBEBE8","infomercialMain":"#4D4D4D","infomercial900":"#4D4D4D","infomercial800":"#4D4D4D","infomercial700":"#4D4D4D","infomercial600":"#4D4D4D","infomercial500":"#4D4D4D","infomercial400":"#4D4D4D","infomercial300":"#4D4D4D","infomercial200":"#4D4D4D","infomercial100":"#4D4D4D","infomercial50":"#4D4D4D","videoMain":"#EE6D6F","video900":"#BE071A","video800":"#CE1525","video700":"#DB1E2C","video600":"#ED2B32","video500":"#FB3733","video400":"#F9484C","video300":"#EE6D6F","video200":"#F69797","video100":"#FECCD1","video50":"#FFEAED","vida-urbanaMain":"#69a840","magazineMain":"#E982B0","magazine900":"#760649","magazine800":"#9A0952","magazine700":"#AF0B58","magazine600":"#C50D5D","magazine500":"#D50F60","magazine400":"#DB1B78","magazine300":"#E14D90","magazine200":"#E982B0","magazine100":"#F1B4D0","magazine50":"#FAE1EC"},"yT":{"semanticError":"#F9484C","semanticSuccess":"#A2CC86"}}');
;// CONCATENATED MODULE: ./brands/opopular/assets/colors.ts


function opopular_assets_colors_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function opopular_assets_colors_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? opopular_assets_colors_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : opopular_assets_colors_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var opopular_assets_colors_colors = opopular_assets_colors_objectSpread(opopular_assets_colors_objectSpread(opopular_assets_colors_objectSpread(opopular_assets_colors_objectSpread({}, opopular_indexes_colors_namespaceObject.vU), opopular_indexes_colors_namespaceObject.Dh), opopular_indexes_colors_namespaceObject.yT), opopular_indexes_colors_namespaceObject.T9);
;// CONCATENATED MODULE: ./brands/opopular/indexes/type-system.json
var opopular_indexes_type_system_namespaceObject = JSON.parse('{"CH":{"caption3":"16px","headline3":"36px","caption1":"14px","headline6":"20px","headline2":"43px","paragraph4":"18px","paragraph3":"18px","headline4":"25px","paragraphPaywall":"14px","widget5":"18px","headline5":"20px","retrancaWidget":"18px","widgetMaisLidas":"18px","widgetEsporteDestaque":"12px","widgetEsporte":"12px","headlineDestaqueEditoria2":"22px","caption4":"14px","retrancaHamburger":"18px","caption5":"14px","headlineStories":"16px","headlineDestaqueEditoria1":"28px","destaquePaywall":"14px","subtitle":"24px","caption2":"14px","paragraph2":"22px","paragraph2Link":"22px","paragraph1":"22px","headline1":"60px","retrancaEBook":"20px","headlinePaywall":"30px","preOAssinatura":"75px","widgetUdioTime":"14px","paragraph5":"16px","paragraph6":"20px"},"vC":{"caption3":500,"headline3":700,"caption1":700,"headline6":400,"headline2":700,"paragraph4":400,"paragraph3":500,"headline4":600,"paragraphPaywall":400,"widget5":400,"headline5":500,"retrancaWidget":500,"widgetMaisLidas":500,"widgetEsporteDestaque":600,"widgetEsporte":400,"headlineDestaqueEditoria2":700,"caption4":500,"retrancaHamburger":600,"caption5":400,"headlineStories":500,"headlineDestaqueEditoria1":600,"destaquePaywall":700,"subtitle":400,"caption2":400,"paragraph2":400,"paragraph2Link":400,"paragraph1":500,"headline1":700,"retrancaEBook":700,"headlinePaywall":700,"preOAssinatura":700,"widgetUdioTime":300,"paragraph5":400,"paragraph6":400},"tO":{"caption3":"19.2px","headline3":"43px","caption1":"20.8px","headline6":"25px","headline2":"50px","paragraph4":"23px","paragraph3":"25px","headline4":"30px","paragraphPaywall":"16.4px","widget5":"21.6px","headline5":"24px","retrancaWidget":"32.5px","widgetMaisLidas":"21.6px","widgetEsporteDestaque":"14.4px","widgetEsporte":"14.4px","headlineDestaqueEditoria2":"24px","caption4":"16.8px","retrancaHamburger":"21.6px","caption5":"16.8px","headlineStories":"19.2px","headlineDestaqueEditoria1":"30px","destaquePaywall":"16.4px","subtitle":"30px","caption2":"16.8px","paragraph2":"35px","paragraph2Link":"35px","paragraph1":"35px","headline1":"70px","retrancaEBook":"20px","headlinePaywall":"43px","preOAssinatura":"90px","widgetUdioTime":"16.94px","paragraph5":"22px","paragraph6":"23.4px"}}');
;// CONCATENATED MODULE: ./brands/opopular/theme.ts


function opopular_theme_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function opopular_theme_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? opopular_theme_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : opopular_theme_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck



var opopular_theme_fontSizes = opopular_indexes_type_system_namespaceObject.CH,
    opopular_theme_fontWeights = opopular_indexes_type_system_namespaceObject.vC,
    opopular_theme_lineHeights = opopular_indexes_type_system_namespaceObject.tO;
var OPopularTheme = prensa/* PrensaEngine.createTheme */.u7.createTheme('opopular', {
  colors: opopular_theme_objectSpread({}, opopular_assets_colors_colors),
  fonts: {
    primary: 'Fira Sans Condensed',
    secondary: 'Inter'
  },
  fontSizes: opopular_theme_fontSizes,
  fontWeights: opopular_theme_fontWeights,
  lineHeights: opopular_theme_lineHeights,
  radii: {
    unset: '0px',
    "default": '4px',
    alternative: '10px',
    rounded: '99px',
    circle: '50%'
  }
});
;// CONCATENATED MODULE: ./brands/tocantins/indexes/banners.json
var tocantins_indexes_banners_namespaceObject = JSON.parse('{"k":[{"fullName":"BannerAnuncie.svg","name":"BannerAnuncie","url":"/assets/tocantins/banners/BannerAnuncie.svg","height":"68","width":"200"},{"fullName":"BannerAnuncieAqui.svg","name":"BannerAnuncieAqui","url":"/assets/tocantins/banners/BannerAnuncieAqui.svg","height":"13","width":"96"},{"fullName":"BannerAssineAgora.svg","name":"BannerAssineAgora","url":"/assets/tocantins/banners/BannerAssineAgora.svg","height":"32","width":"215","target":"blank"},{"fullName":"BannerAssineAgoraCondensado.svg","name":"BannerAssineAgoraCondensado","url":"/assets/tocantins/banners/BannerAssineAgoraCondensado.svg","height":"32","width":"165"},{"fullName":"BannerClube.svg","name":"BannerClube","url":"/assets/tocantins/banners/BannerClube.svg","height":"50","width":"84"},{"fullName":"BannerClubeBackground.png","name":"BannerClubeBackground","url":"/assets/tocantins/banners/BannerClubeBackground.png","height":"","width":""},{"fullName":"BannerWhatsApp.svg","name":"BannerWhatsApp","url":"/assets/tocantins/banners/BannerWhatsApp.svg","height":"150","width":"301"}]}');
;// CONCATENATED MODULE: ./brands/tocantins/indexes/favicons.json
var tocantins_indexes_favicons_namespaceObject = JSON.parse('{"k":[{"fullName":"128x128.png","name":"128x128","url":"/assets/tocantins/favicons/128x128.png","height":"","width":""},{"fullName":"16x16.png","name":"16x16","url":"/assets/tocantins/favicons/16x16.png","height":"","width":""},{"fullName":"192x192.png","name":"192x192","url":"/assets/tocantins/favicons/192x192.png","height":"","width":""},{"fullName":"32x32.png","name":"32x32","url":"/assets/tocantins/favicons/32x32.png","height":"","width":""},{"fullName":"48x48.png","name":"48x48","url":"/assets/tocantins/favicons/48x48.png","height":"","width":""},{"fullName":"96x96.png","name":"96x96","url":"/assets/tocantins/favicons/96x96.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/tocantins/indexes/icons.json
var tocantins_indexes_icons_namespaceObject = JSON.parse('{"k":[{"fullName":"IcAbrirAzul.svg","name":"IcAbrirAzul","url":"/assets/tocantins/icons/IcAbrirAzul.svg","height":"16","width":"16"},{"fullName":"IcAbrirCinza.svg","name":"IcAbrirCinza","url":"/assets/tocantins/icons/IcAbrirCinza.svg","height":"16","width":"16"},{"fullName":"IcArrowDown.svg","name":"IcArrowDown","url":"/assets/opopular/icons/IcArrowDown.svg","height":"24","width":"24"},{"fullName":"IcArrowUp.svg","name":"IcArrowUp","url":"/assets/opopular/icons/IcArrowUp.svg","height":"24","width":"24"},{"fullName":"IcAudio.svg","name":"IcAudio","url":"/assets/tocantins/icons/IcAudio.svg","height":"13","width":"17"},{"fullName":"IcAudioDescricao.svg","name":"IcAudioDescricao","url":"/assets/tocantins/icons/IcAudioDescricao.svg","height":"13","width":"18"},{"fullName":"IcAudioMobile.svg","name":"IcAudioMobile","url":"/assets/tocantins/icons/IcAudioMobile.svg","height":"16","width":"20"},{"fullName":"IcAudiodescricaoCinza.svg","name":"IcAudiodescricaoCinza","url":"/assets/tocantins/icons/IcAudiodescricaoCinza.svg","height":"15","width":"19"},{"fullName":"IcAvancarCinza.svg","name":"IcAvancarCinza","url":"/assets/tocantins/icons/IcAvancarCinza.svg","height":"16","width":"8"},{"fullName":"IcBotaoFacebook.svg","name":"IcBotaoFacebook","url":"/assets/tocantins/icons/IcBotaoFacebook.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookBranco.svg","name":"IcBotaoFacebookBranco","url":"/assets/tocantins/icons/IcBotaoFacebookBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoFacebookCinza.svg","name":"IcBotaoFacebookCinza","url":"/assets/tocantins/icons/IcBotaoFacebookCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoFacebookPreto.svg","name":"IcBotaoFacebookPreto","url":"/assets/tocantins/icons/IcBotaoFacebookPreto.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagram.svg","name":"IcBotaoInstagram","url":"/assets/tocantins/icons/IcBotaoInstagram.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramBranco.svg","name":"IcBotaoInstagramBranco","url":"/assets/tocantins/icons/IcBotaoInstagramBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoInstagramCinza.svg","name":"IcBotaoInstagramCinza","url":"/assets/tocantins/icons/IcBotaoInstagramCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoInstagramPreto.svg","name":"IcBotaoInstagramPreto","url":"/assets/tocantins/icons/IcBotaoInstagramPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoLinkedin.svg","name":"IcBotaoLinkedin","url":"/assets/tocantins/icons/IcBotaoLinkedin.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinBranco.svg","name":"IcBotaoLinkedinBranco","url":"/assets/tocantins/icons/IcBotaoLinkedinBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoLinkedinCinza.svg","name":"IcBotaoLinkedinCinza","url":"/assets/tocantins/icons/IcBotaoLinkedinCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoLinkedinPreto.svg","name":"IcBotaoLinkedinPreto","url":"/assets/tocantins/icons/IcBotaoLinkedinPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoTwitter.svg","name":"IcBotaoTwitter","url":"/assets/tocantins/icons/IcBotaoTwitter.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterBranco.svg","name":"IcBotaoTwitterBranco","url":"/assets/tocantins/icons/IcBotaoTwitterBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoTwitterCinza.svg","name":"IcBotaoTwitterCinza","url":"/assets/tocantins/icons/IcBotaoTwitterCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoTwitterPreto.svg","name":"IcBotaoTwitterPreto","url":"/assets/tocantins/icons/IcBotaoTwitterPreto.svg","height":"33","width":"34"},{"fullName":"IcBotaoWhatsApp.svg","name":"IcBotaoWhatsApp","url":"/assets/tocantins/icons/IcBotaoWhatsApp.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppBranco.svg","name":"IcBotaoWhatsAppBranco","url":"/assets/tocantins/icons/IcBotaoWhatsAppBranco.svg","height":"26","width":"26"},{"fullName":"IcBotaoWhatsAppCinza.svg","name":"IcBotaoWhatsAppCinza","url":"/assets/tocantins/icons/IcBotaoWhatsAppCinza.svg","height":"33","width":"33"},{"fullName":"IcBotaoWhatsAppPreto.svg","name":"IcBotaoWhatsAppPreto","url":"/assets/tocantins/icons/IcBotaoWhatsAppPreto.svg","height":"33","width":"34"},{"fullName":"IcBuscar.svg","name":"IcBuscar","url":"/assets/tocantins/icons/IcBuscar.svg","height":"15","width":"15"},{"fullName":"IcChave.svg","name":"IcChave","url":"/assets/tocantins/icons/IcChave.svg","height":"14","width":"25"},{"fullName":"IcChaveAzul.svg","name":"IcChaveAzul","url":"/assets/tocantins/icons/IcChaveAzul.svg","height":"14","width":"25"},{"fullName":"IcCheckAzul.svg","name":"IcCheckAzul","url":"/assets/tocantins/icons/IcCheckAzul.svg","height":"10","width":"13"},{"fullName":"IcCidade.svg","name":"IcCidade","url":"/assets/tocantins/icons/IcCidade.svg","height":"17","width":"10"},{"fullName":"IcClose.svg","name":"IcClose","url":"/assets/tocantins/icons/IcClose.svg","height":"14","width":"14"},{"fullName":"IcComunicado.svg","name":"IcComunicado","url":"/assets/tocantins/icons/IcComunicado.svg","height":"15","width":"18"},{"fullName":"IcEconomia.svg","name":"IcEconomia","url":"/assets/tocantins/icons/IcEconomia.svg","height":"16","width":"14"},{"fullName":"IcEdital.svg","name":"IcEdital","url":"/assets/tocantins/icons/IcEdital.svg","height":"16","width":"13"},{"fullName":"IcEspecial.svg","name":"IcEspecial","url":"/assets/tocantins/icons/IcEspecial.svg","height":"14","width":"14"},{"fullName":"IcEsporte.svg","name":"IcEsporte","url":"/assets/tocantins/icons/IcEsporte.svg","height":"16","width":"13"},{"fullName":"IcFecharBranco.svg","name":"IcFecharBranco","url":"/assets/tocantins/icons/IcFecharBranco.svg","height":"16","width":"13"},{"fullName":"IcFecharPreto.svg","name":"IcFecharPreto","url":"/assets/tocantins/icons/IcFecharPreto.svg","height":"15","width":"13"},{"fullName":"IcHamburger.svg","name":"IcHamburger","url":"/assets/tocantins/icons/IcHamburger.svg","height":"15","width":"22"},{"fullName":"IcHamburguerMobile.svg","name":"IcHamburguerMobile","url":"/assets/tocantins/icons/IcHamburguerMobile.svg","height":"13","width":"19"},{"fullName":"IcMagazine.svg","name":"IcMagazine","url":"/assets/tocantins/icons/IcMagazine.svg","height":"16","width":"14"},{"fullName":"IcMundo.svg","name":"IcMundo","url":"/assets/tocantins/icons/IcMundo.svg","height":"15","width":"15"},{"fullName":"IcOjc.svg","name":"IcOjc","url":"/assets/tocantins/icons/IcOjc.svg","height":"17","width":"24"},{"fullName":"IcOpiniao.svg","name":"IcOpiniao","url":"/assets/tocantins/icons/IcOpiniao.svg","height":"12","width":"13"},{"fullName":"IcOpiniaoGrande.svg","name":"IcOpiniaoGrande","url":"/assets/tocantins/icons/IcOpiniaoGrande.svg","height":"19","width":"22"},{"fullName":"IcPlayAudioMateria.svg","name":"IcPlayAudioMateria","url":"/assets/tocantins/icons/IcPlayAudioMateria.svg","height":"15","width":"15"},{"fullName":"IcPlayAudioMateriaAzul.svg","name":"IcPlayAudioMateriaAzul","url":"/assets/tocantins/icons/IcPlayAudioMateriaAzul.svg","height":"23","width":"22"},{"fullName":"IcPodcast.svg","name":"IcPodcast","url":"/assets/tocantins/icons/IcPodcast.svg","height":"19","width":"11"},{"fullName":"IcPolitica.svg","name":"IcPolitica","url":"/assets/tocantins/icons/IcPolitica.svg","height":"16","width":"16"},{"fullName":"IcRadio.svg","name":"IcRadio","url":"/assets/tocantins/icons/IcRadio.svg","height":"20","width":"18"},{"fullName":"IcSetaAbrir.svg","name":"IcSetaAbrir","url":"/assets/tocantins/icons/IcSetaAbrir.svg","height":"6","width":"9"},{"fullName":"IcSetaCidade.svg","name":"IcSetaCidade","url":"/assets/tocantins/icons/IcSetaCidade.svg","height":"9","width":"15"},{"fullName":"IcSetaEconomia.svg","name":"IcSetaEconomia","url":"/assets/tocantins/icons/IcSetaEconomia.svg","height":"9","width":"15"},{"fullName":"IcSetaEspecial.svg","name":"IcSetaEspecial","url":"/assets/tocantins/icons/IcSetaEspecial.svg","height":"9","width":"15"},{"fullName":"IcSetaEsporte.svg","name":"IcSetaEsporte","url":"/assets/tocantins/icons/IcSetaEsporte.svg","height":"9","width":"15"},{"fullName":"IcSetaFechar.svg","name":"IcSetaFechar","url":"/assets/tocantins/icons/IcSetaFechar.svg","height":"7","width":"10"},{"fullName":"IcSetaMagazine.svg","name":"IcSetaMagazine","url":"/assets/tocantins/icons/IcSetaMagazine.svg","height":"9","width":"15"},{"fullName":"IcSetaMundo.svg","name":"IcSetaMundo","url":"/assets/tocantins/icons/IcSetaMundo.svg","height":"9","width":"15"},{"fullName":"IcSetaOpiniao.svg","name":"IcSetaOpiniao","url":"/assets/tocantins/icons/IcSetaOpiniao.svg","height":"9","width":"15"},{"fullName":"IcSetaPolitica.svg","name":"IcSetaPolitica","url":"/assets/tocantins/icons/IcSetaPolitica.svg","height":"9","width":"15"},{"fullName":"IcSetaRosa.svg","name":"IcSetaRosa","url":"/assets/tocantins/icons/IcSetaRosa.svg","height":"9","width":"15"},{"fullName":"IcStories.svg","name":"IcStories","url":"/assets/tocantins/icons/IcStories.svg","height":"21","width":"17"},{"fullName":"IcVersaoDigital.svg","name":"IcVersaoDigital","url":"/assets/tocantins/icons/IcVersaoDigital.svg","height":"14","width":"16"},{"fullName":"IcVersaoDigitalCinza.svg","name":"IcVersaoDigitalCinza","url":"/assets/tocantins/icons/IcVersaoDigitalCinza.svg","height":"16","width":"18"},{"fullName":"IcVersaoDigitalCinzaClaro.svg","name":"IcVersaoDigitalCinzaClaro","url":"/assets/tocantins/icons/IcVersaoDigitalCinzaClaro.svg","height":"15","width":"16"},{"fullName":"IcVoltarCinza.svg","name":"IcVoltarCinza","url":"/assets/tocantins/icons/IcVoltarCinza.svg","height":"16","width":"8"},{"fullName":"IcWhatsAppCinza.svg","name":"IcWhatsAppCinza","url":"/assets/tocantins/icons/IcWhatsAppCinza.svg","height":"18","width":"17"}]}');
;// CONCATENATED MODULE: ./brands/tocantins/indexes/logos.json
var tocantins_indexes_logos_namespaceObject = JSON.parse('{"k":[{"fullName":"LogoTocantinsDesktop.svg","name":"LogoTocantinsDesktop","url":"/assets/tocantins/logos/LogoTocantinsDesktop.svg","height":"37","width":"287"},{"fullName":"LogoTocantinsMobile.svg","name":"LogoTocantinsMobile","url":"/assets/tocantins/logos/LogoTocantinsMobile.svg","height":"20","width":"153"}]}');
;// CONCATENATED MODULE: ./brands/tocantins/indexes/splashScreens.json
var tocantins_indexes_splashScreens_namespaceObject = JSON.parse('{"k":[{"fullName":"ipad.png","name":"ipad","url":"/assets/tocantins/splashScreens/ipad.png","height":"","width":""},{"fullName":"ipadpro1.png","name":"ipadpro1","url":"/assets/tocantins/splashScreens/ipadpro1.png","height":"","width":""},{"fullName":"ipadpro2.png","name":"ipadpro2","url":"/assets/tocantins/splashScreens/ipadpro2.png","height":"","width":""},{"fullName":"ipadpro3.png","name":"ipadpro3","url":"/assets/tocantins/splashScreens/ipadpro3.png","height":"","width":""},{"fullName":"iphone5.png","name":"iphone5","url":"/assets/tocantins/splashScreens/iphone5.png","height":"","width":""},{"fullName":"iphone6.png","name":"iphone6","url":"/assets/tocantins/splashScreens/iphone6.png","height":"","width":""},{"fullName":"iphoneplus.png","name":"iphoneplus","url":"/assets/tocantins/splashScreens/iphoneplus.png","height":"","width":""},{"fullName":"iphonex.png","name":"iphonex","url":"/assets/tocantins/splashScreens/iphonex.png","height":"","width":""},{"fullName":"iphonexsmax.png","name":"iphonexsmax","url":"/assets/tocantins/splashScreens/iphonexsmax.png","height":"","width":""}]}');
;// CONCATENATED MODULE: ./brands/tocantins/assets/article.tsx


function tocantins_assets_article_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_article_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_article_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_article_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var tocantins_assets_article_BylineRightSectionComponent = function BylineRightSectionComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_OuvirMateriaButton, {
    icon: tocantins_assets_article_objectSpread({}, (0,hooks_useIcon/* useIcon */.b)('IcPlayAudioMateriaAzul')),
    onClick: function onClick(e) {
      return console.log('play audio materia', e);
    }
  });
};

var tocantins_assets_article_bylineProps = {
  author: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 700,
      letterSpacing: 0.4,
      lineHeight: '18px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      }
    }
  },
  authorImage: {
    enabled: true
  },
  customCss: {
    align: ['column', 'left', 'middle'],
    mb: '$6',
    width: '100%',
    '@lg': {
      align: ['row', 'between', 'middle'],
      mb: '$8',
      width: '100$'
    }
  },
  customCssLeft: {
    align: ['row', 'left', 'middle'],
    width: '100%',
    '@lg': {
      width: 'calc(100% - 320px)'
    }
  },
  customCssContent: {
    width: 'calc(100% - 80px)'
  },
  customCssRight: {
    align: ['row', 'between', 'middle'],
    mt: '$3',
    width: '100%',
    '@lg': {
      align: ['row', 'right', 'middle'],
      mt: '$0',
      width: '320px'
    }
  },
  publishedDate: {
    enabled: true,
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '15px',
      fontWeight: 400,
      letterSpacing: 0.2,
      lineHeight: '16px',
      mt: '$0',
      mb: '$0',
      textAlign: 'left',
      '@lg': {
        fontSize: '18px',
        lineHeight: '23px'
      }
    }
  },
  rightSlot: {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(tocantins_assets_article_BylineRightSectionComponent, {})
  }
};
var tocantins_assets_article_article = {
  articleContainer: {
    customCss: {
      align: ['row', 'center', 'middle'],
      mt: '$8',
      width: '100%'
    }
  },
  articleContent: {
    customCss: {
      align: ['row', 'center', 'between'],
      my: '$4',
      width: 'calc(100% - calc($4 * 3))',
      maxWidth: '1278px'
    }
  },
  articleContentLeft: {
    customCss: {
      borderTop: '1px solid #E6E6E6',
      width: '100%',
      '@lg': {
        width: 'calc(100% - 332px)'
      }
    }
  },
  articleContentRight: {
    customCss: {
      background: '#707070',
      display: 'none',
      height: '600px',
      width: '300px',
      '@lg': {
        display: 'flex'
      }
    }
  },
  bylineProps: tocantins_assets_article_bylineProps,
  captionProps: {
    customCssWrap: {
      maxWidth: '960px',
      width: '100%',
      mb: '$4',
      mt: '$0'
    },
    customCss: {
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '12px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '14px',
      px: '$0',
      py: '$2',
      m: '$0',
      width: 'calc(100% - 32px)',
      '@lg': {
        fontSize: '14px',
        fontStyle: 'italic',
        lineHeight: '17px'
      }
    }
  },
  textProps: {
    as: 'p',
    customCss: {
      color: '#000000',
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '24px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      width: '100%',
      '@lg': {
        fontSize: '22px',
        fontWeight: 400,
        letterSpacing: 0.2,
        lineHeight: '35px'
      },
      'a': {
        color: '$primaryMain'
      }
    }
  },
  titleProps: {
    as: 'h1',
    customCss: {
      fontFamily: '$primary',
      fontSize: '25px',
      fontWeight: 700,
      lineHeight: '28px',
      mt: '$0',
      mb: '$3',
      '@lg': {
        fontSize: '60px',
        lineHeight: '70px',
        letterSpacing: 0.4
      },
      textAlign: 'left'
    }
  },
  subjectProps: {
    as: 'p',
    customCss: {
      fontFamily: '$primary',
      fontSize: '18px',
      lineHeight: '25px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '25px'
      },
      textAlign: 'left'
    }
  },
  subtitleProps: {
    as: 'h2',
    customCss: {
      color: '#4D4D4D',
      fontFamily: '$primary',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '19px',
      mt: '$0',
      mb: '$6',
      textAlign: 'left',
      display: 'block',
      width: '100%',
      '@lg': {
        fontSize: '22px',
        lineHeight: '35px',
        letterSpacing: 0.2,
        mb: '$6'
      }
    }
  },
  shareSection: {
    enabled: true,
    content: [{
      id: 'facebookShare',
      alt: 'Compartilhar no Facebook',
      icon: 'IcBotaoFacebook',
      href: 'https://www.facebook.com/sharer/sharer.php?u='
    }, {
      id: 'twitterShare',
      alt: 'Compartilhar no Twitter',
      icon: 'IcBotaoTwitter',
      href: 'https://twitter.com/intent/tweet?text='
    }, {
      id: 'whatsappShare',
      alt: 'Compartilhar no WhatsApp',
      icon: 'IcBotaoWhatsApp',
      href: 'https://api.whatsapp.com/send?text='
    }]
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/footer.tsx
var tocantins_assets_footer_currentDate = new Date();
var tocantins_assets_footer_currentYear = tocantins_assets_footer_currentDate.getFullYear();
var tocantins_assets_footer_FooterConfig = {
  css: {
    slotMiddleCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#262626',
      height: 'max-content',
      py: '$7',
      '@xl': {
        height: '82px'
      }
    },
    slotBottomCss: {
      align: ['row', 'center', 'middle'],
      backgroundColor: '#2E2E2E',
      height: '60px',
      '@xl': {
        display: 'none'
      }
    }
  },
  data: {
    leftText: 'Siga o Jornal do Tocantins:',
    navMenu: [{
      id: 'expediente',
      title: 'Expediente',
      href: '/expediente'
    }, {
      id: 'faleConosco',
      title: 'Fale conosco',
      href: '/fale-conosco'
    }, {
      id: 'anuncieEmJornalDoTocantins',
      title: 'Anuncie no Jornal do Tocantins',
      href: 'https://estrategia.negociosjaimecamara.com.br/portal-jornal-do-tocantins'
    }],
    rightText: "Copyright 2001-".concat(tocantins_assets_footer_currentYear, ", J. C\xE2mara e Irm\xE3os S/A."),
    socialNetworks: [{
      id: 'facebookPage',
      href: 'https://www.facebook.com/JornaldoTocantins',
      icon: 'IcBotaoFacebook',
      title: 'Abrir o Jornal do Tocantins no Facebook'
    }, {
      id: 'twitterPage',
      href: 'https://twitter.com/jornaltocantins',
      icon: 'IcBotaoTwitter',
      title: 'Abrir o Jornal do Tocantins no Twitter'
    }]
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserRelated.tsx


function tocantins_assets_teasers_TeaserRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_teasers_TeaserRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_teasers_TeaserRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_teasers_TeaserRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck





var tocantins_assets_teasers_TeaserRelated_handleUseIcon = function handleUseIcon(_ref) {
  var color = _ref.color,
      icon = _ref.icon;
  var iconConfig;
  var sectionSlug = capitalize_default()(color === null || color === void 0 ? void 0 : color.replace('Main', ''));

  if (sectionSlug) {
    var iconSlug = icon === null || icon === void 0 ? void 0 : icon.replace('Especial', sectionSlug);
    var iconParsed = (0,hooks_useIcon/* useIcon */.b)(iconSlug);

    if (iconParsed.src) {
      iconConfig = iconParsed;
    }
  }

  if (!iconConfig) {
    iconConfig = (0,hooks_useIcon/* useIcon */.b)(icon);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Icon_index/* default */.Z, tocantins_assets_teasers_TeaserRelated_objectSpread({}, iconConfig));
};

var tocantins_assets_teasers_TeaserRelated_TeaserRelated = {
  css: {
    p: 0,
    background: 'none !important',
    width: '100%',
    '.TeaserImageContainer': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none !important'
    },
    '.TeaserSubtitle': {
      display: 'none !important'
    },
    'div.TeaserTitle': {
      align: ['row', 'left', 'top'],
      pb: '$0',
      mb: '$0',
      'a': {
        pb: '$0',
        mb: '$0',
        width: '100%'
      },
      'img': {
        pt: '6px',
        height: '15px'
      },
      'p.TeaserTitleText': {
        align: ['row', 'left', 'top'],
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '19px',
        ml: '$3',
        mb: '$0',
        mt: '$0',
        textAlign: 'left',
        width: 'calc(100% - $3)'
      }
    },
    '.TeaserWrap': {
      background: 'none !important',
      pb: '$0',
      mb: '$0'
    }
  },
  className: 'TeaserRelated',
  relatedIcon: {
    enabled: true,
    name: 'IcSetaEspecial',
    useIcon: tocantins_assets_teasers_TeaserRelated_handleUseIcon
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserBackground.ts

var tocantins_assets_teasers_TeaserBackground_TeaserBackground = {
  className: 'TeaserBackground',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '580px'
    },
    '.TeaserImage img': {
      height: '580px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        mb: '$2'
      }
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 90%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserBackgroundLg.ts

var tocantins_assets_teasers_TeaserBackgroundLg_TeaserBackgroundLg = {
  className: 'TeaserBackgroundLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '360px'
    },
    '.TeaserImage img': {
      height: '360px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 500px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 500px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserBackgroundRelated.ts

var tocantins_assets_teasers_TeaserBackgroundRelated_TeaserBackgroundRelated = {
  className: 'TeaserBackgroundRelated',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '780px'
    },
    '.TeaserImage img': {
      height: '680px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: 'black',
      position: 'static',
      pt: '$0',
      pb: '$4',
      px: '$4',
      my: '$0',
      'div.Teaser': {
        mb: '$3'
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 60%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4'
      },
      '> .TeaserSubject': {
        px: '$4'
      },
      '> .TeaserTitle': {
        px: '$4'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserBackgroundRelatedLg.ts

var tocantins_assets_teasers_TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg = {
  className: 'TeaserBackgroundRelatedLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$4',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '536px'
    },
    '.TeaserImage img': {
      height: '536px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: '#282828',
      position: 'absolute',
      height: '536px',
      right: '0px',
      pt: '$0',
      pb: '$4',
      my: '$0',
      width: '328px',
      'div.Teaser': {
        background: 'transparent',
        px: '$8',
        mb: '$0'
      },
      '.TeaserImage': {
        display: 'none'
      },
      'p.TeaserTitleText': {
        fontSize: '18px !important',
        lineHeight: '24px !important',
        m: '$0 !important',
        p: '$0 !important',
        width: '100% !important'
      },
      '.TeaserWrap': {
        background: 'none',
        position: 'static',
        mt: '$0'
      },
      '@lg': {
        align: ['column', 'center', 'evenly'],
        '.TeaserTitle img': {
          display: 'none'
        }
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      ml: '$10',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '18px',
      lineHeight: '24px',
      fontWeight: 400,
      ml: '$10',
      mb: '$10',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700,
      ml: '$10',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 360px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 360px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserChargeLg.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var assets_teasers_TeaserChargeLg_TeaserChargeLg = {
  css: {
    flexDirection: 'column-reverse',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      my: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 500,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      width: '100%'
    }
  },
  className: 'TeaserChargeLg',
  imageDerivative: 'default',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserChargeMd.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var assets_teasers_TeaserChargeMd_TeaserChargeMd = {
  css: {
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      mt: '$4',
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '25px',
      fontWeight: 600,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      width: '100%'
    }
  },
  className: 'TeaserChargeMd',
  imageDerivative: 'default',
  imageVariant: 'top',
  subjectVariant: 'filled',
  subjectColor: 'colunistaMain',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserChargeSm.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var assets_teasers_TeaserChargeSm_TeaserChargeSm = {
  css: {
    // flexDirection: 'column',
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: '100%'
    },
    '.TeaserSubject': {
      mt: '$4',
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '20px',
      fontWeight: 400,
      fontFamily: '$primary',
      letterSpacing: '0.2px',
      lineHeight: '25px',
      width: '100%'
    }
  },
  className: 'TeaserChargeSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectVariant: 'filled',
  subjectColor: 'colunistaMain',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserColumnist.ts
var tocantins_assets_teasers_TeaserColumnist_TeaserColumnist = {
  css: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderRadius: '$alternative',
    p: '$0',
    pt: '$0',
    mb: '$4',
    '.TeaserImage img': {
      borderRadius: '$circle'
    },
    '.TeaserImageContainer': {
      borderRadius: '$circle',
      maxWidth: '80px'
    },
    '.TeaserWrap': {
      pb: '$4',
      pl: '$4',
      pr: '$4'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubject': {
      width: '100%'
    },
    '.TeaserSubjectText': {
      textAlign: 'left',
      color: '#D72027',
      fontSize: '16px',
      lineHeight: '18px',
      fontWeight: 500,
      mb: '$1'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      width: '100%'
    },
    '.TeaserTitleText': {
      fontSize: '16px',
      fontWeight: 400
    }
  },
  className: 'TeaserColumnist',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subjectTextVariant: 'subject-default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-sm'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserEditais.ts
var tocantins_assets_teasers_TeaserEditais_TeaserEditais = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserEditais'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserEditorial.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var assets_teasers_TeaserEditorial_TeaserEditorial = {
  css: {
    padding: '$0',
    mb: '$4',
    minHeight: '120px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: '220px',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 220px - $3)'
    }
  },
  className: 'TeaserEditorial',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserEditorialSm.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
var assets_teasers_TeaserEditorialSm_TeaserEditorialSm = {
  css: {
    padding: '$0',
    mb: '$8',
    minHeight: '80px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(88px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      align: ['column', 'left', 'top'],
      color: '#4d4d4d',
      fontFamily: '$primary',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '17px',
      width: '100%'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      minWidth: 'calc(100% - 88px - $3)'
    }
  },
  className: 'TeaserEditorialSm',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-datetime',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserHeadlineSm.ts


function tocantins_assets_teasers_TeaserHeadlineSm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_teasers_TeaserHeadlineSm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_teasers_TeaserHeadlineSm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_teasers_TeaserHeadlineSm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var tocantins_assets_teasers_TeaserHeadlineSm_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var tocantins_assets_teasers_TeaserHeadlineSm_TeaserHeadlineSm = tocantins_assets_teasers_TeaserHeadlineSm_objectSpread(tocantins_assets_teasers_TeaserHeadlineSm_objectSpread({}, tocantins_assets_teasers_TeaserHeadlineSm_T.TeaserHeadlineSm), {}, {
  css: {
    p: '$0',
    mb: '$6',
    textAlign: 'center',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserTitle': {
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineSm',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-3xl'
});
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserHeadlineLg.ts


var tocantins_assets_teasers_TeaserHeadlineLg_T = prensa/* LayoutProviderDefaults.teasers */.h1.teasers;
var tocantins_assets_teasers_TeaserHeadlineLg_TeaserHeadlineLg = {
  css: {
    textAlign: 'center',
    my: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      align: ['row', 'center', 'top'],
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '18px',
          lineHeight: '23px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitle': {
      align: ['column', 'center', 'top'],
      maxWidth: '980px',
      mb: '$8'
    },
    '.TeaserTitle': {
      align: ['column', 'center', 'top'],
      mb: '$4',
      maxWidth: '980px'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    },
    '.TeaserSubject': {
      align: ['column', 'center', 'top'],
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserWrap': {
      align: ['column', 'center', 'top']
    }
  },
  className: 'TeaserHeadlineLg',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-6xl'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserImageLeft.ts

var tocantins_assets_teasers_TeaserImageLeft_TeaserImageLeft = {
  css: {
    padding: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      lineHeight: '23px',
      width: '100%'
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(100% - 88px - $3)'
    },
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
      textAlign: 'center',
      '.TeaserImageContainer': {
        backgroundColor: 'transparent',
        width: 'auto',
        'img': {
          pr: '$3'
        },
        '@lg': {
          maxWidth: '150px'
        }
      },
      '.TeaserSubjectText': {
        alignItems: 'center',
        align: ['column', 'center', 'top'],
        textTransform: 'uppercase',
        fontSize: '14px'
      },
      '.TeaserSubtitleText': {
        display: 'none'
      },
      '.TeaserSubtitle': {
        align: ['row', 'left', 'middle']
      },
      '.TeaserTitle': {
        my: '$2'
      },
      '.TeaserTitleText': {
        align: ['column', 'left', 'top'],
        color: 'black',
        fontSize: '26px',
        fontWeight: 400,
        letterSpacing: '0.2px',
        lineHeight: '23px',
        width: '100%'
      },
      '.TeaserWrap': {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0px !important',
        width: '100%',
        '.TeaserRelated': {
          'div.Teaser': {
            mb: '$4'
          },
          'div.TeaserTitle': {
            'p.TeaserTitleText': {
              fontSize: '16px',
              lineHeight: '19px',
              letterSpacing: '0.2px'
            }
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserImageLeftSq.ts
var assets_teasers_TeaserImageLeftSq_TeaserImageLeftSq = {
  css: {
    padding: '$0',
    mb: '$3',
    minHeight: '75px',
    width: '100%',
    '@lg': {
      mb: '$3'
    },
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(75px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '75px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 75px - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeftSq',
  imageDerivative: '1x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserImageLeftSm.ts
var tocantins_assets_teasers_TeaserImageLeftSm_TeaserImageLeftSm = {
  css: {
    padding: '$0',
    mb: '$6',
    minHeight: '88px',
    width: '100%',
    '.TeaserImageContainer': {
      backgroundColor: 'transparent',
      maxWidth: 'calc(120px + $3)',
      width: 'auto',
      'img': {
        pr: '$3'
      },
      '@lg': {
        maxWidth: '150px'
      }
    },
    '.TeaserSubjectText': {
      align: ['column', 'left', 'top'],
      textTransform: 'uppercase',
      fontSize: '14px',
      mb: '$2'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'left', 'middle']
    },
    '.TeaserTitle': {
      mb: '$2'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      color: 'black',
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0.2px',
      width: '100%'
    },
    '.TeaserWrap': {
      // maxWidth: 'calc(100% - 88px - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeftSm',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-default',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserImageLeftLg.ts

var tocantins_assets_teasers_TeaserImageLeftLg_TeaserImageLeftLg = {
  css: {
    padding: '$0',
    mb: '$6',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      mb: '$3'
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '36px',
      lineHeight: '43px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      minWidth: 'calc(50% - $3)',
      width: '100%',
      '.TeaserRelated': {
        flexFlow: 'column',
        width: '100%',
        'div.Teaser': {
          mb: '$4',
          width: 'auto'
        },
        'div.TeaserTitle': {
          'p.TeaserTitleText': {
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0.2px'
          }
        }
      }
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserNoImage.ts

var tocantins_assets_teasers_TeaserNoImage_TeaserNoImage = {
  css: {
    p: '$0',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubtitleText': {
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserSubject': {
      mb: '$4'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      align: ['column', 'left', 'top'],
      display: 'none',
      mb: '$4'
    },
    '.TeaserTitle': {
      textAlign: 'left',
      mb: '$4'
    },
    '.TeaserTitleText': {
      color: 'black',
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserNoImage',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserCard.ts
var tocantins_assets_teasers_TeaserCard_TeaserCard = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCard',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserCardBold.ts
var assets_teasers_TeaserCardBold_TeaserCardBold = {
  css: {
    mb: '$3',
    p: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$0',
      width: 'auto'
    },
    '.TeaserSubject': {
      mb: '$0',
      color: '#4D4D4D'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$2'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      letterSpacing: '0.2px',
      lineHeight: '24px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      minHeight: '132px',
      pt: '$3'
    },
    '@lg': {
      mb: '$0'
    }
  },
  className: 'TeaserCardBold',
  imageDerivative: '3x2',
  imageVariant: 'top',
  subjectColor: 'brandPrimary500',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-lg'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserImageTop.ts

var tocantins_assets_teasers_TeaserImageTop_TeaserImageTop = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserImageTopLg.ts

var tocantins_assets_teasers_TeaserImageTopLg_TeaserImageTopLg = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      mb: '$3',
      maxWidth: '1024px',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'middle'],
      fontSize: '26px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserImageTop',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserImageBottom.ts
var tocantins_assets_teasers_TeaserImageBottom_TeaserImageBottom = {
  css: {
    mb: '$3',
    padding: '$0',
    width: '100%',
    '.TeaserSubtitle': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$3'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase'
    },
    '.TeaserTitle': {
      mb: '$3'
    },
    '.TeaserTitleText': {
      color: '$basicBlackAlpha900'
    }
  },
  className: 'TeaserImageBottom',
  imageDerivative: '3x1',
  imageVariant: 'bottom',
  subjectBgColor: 'brandPrimary500',
  subjectColor: 'brandPrimary500',
  subtitleVariant: 'subtitle-default',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  titleVariant: 'newstitle-5xl'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserImageLeftXl.ts
var tocantins_assets_teasers_TeaserImageLeftXl_TeaserImageLeftXl = {
  css: {
    padding: '$0',
    mb: '$5',
    width: '100%',
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400
    },
    '.TeaserTitle': {
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '43px',
      lineHeight: '50px',
      fontWeight: 700
    },
    '.TeaserWrap': {
      ml: '$3',
      width: 'calc(50% - $3)'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '2x1',
  imageVariant: 'left',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserMostRead.ts
var tocantins_assets_teasers_TeaserMostRead_TeaserMostRead = {
  css: {
    align: ['row', 'center', 'middle'],
    p: '$0',
    pb: '$4 !important',
    mb: '$4',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      borderRadius: '50%',
      height: '100%',
      width: '30px',
      pr: '$2'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 500
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: 'calc(100% - 60px)'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserMostReadFixed.ts
var tocantins_assets_teasers_TeaserMostReadFixed_TeaserMostReadFixed = {
  css: {
    align: ['row', 'center', 'middle'],
    borderBottom: '1px solid #E6E6E6',
    borderLeft: '8px solid $basicWhite',
    p: '$0',
    minHeight: '92px',
    width: '100%',
    '.TeaserImage': {
      display: 'none'
    },
    '.TeaserNumber': {
      align: ['row', 'left', 'middle'],
      ml: '$4',
      mr: '$4',
      height: '100%',
      width: 'max-content'
    },
    '.TeaserNumberText': {
      color: '$primaryMain',
      fontFamily: '$primary',
      fontSize: '20px',
      fontWeight: 700,
      lineHeight: '20px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      pb: '$0',
      mb: '$0',
      width: '100%'
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'top'],
      color: 'black',
      fontSize: '$widget5',
      fontWeight: '$widget5',
      lineHeight: '$widget5'
    },
    '.TeaserWrap': {
      mr: '$4',
      width: 'calc(100% - $4)'
    },
    '&:last-child': {
      borderBottom: 'unset'
    },
    '&[data-selected=true]': {
      borderLeft: '8px solid $primaryMain'
    },
    '&[data-viewed=true]': {
      borderLeft: '8px solid #E7E7E7'
    }
  },
  className: 'TeaserNumber',
  numberVariant: 'default'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserPodcast.ts
var tocantins_assets_teasers_TeaserPodcast_TeaserPodcast = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$2',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      width: '160px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 5%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '124px',
      width: '124px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserSubtitleText': {
      display: 'none'
    },
    '.TeaserTitle': {
      display: 'none'
    },
    '.TeaserTitleText': {
      display: 'none'
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserRadio.ts
var tocantins_assets_teasers_TeaserRadio_TeaserRadio = {
  className: 'TeaserStories',
  imageDerivative: '1x1',
  imageVariant: 'background',
  customLinkProps: {
    bypass: 'true'
  },
  css: {
    backgroundColor: 'none',
    cursor: 'pointer',
    p: '$0',
    m: '$0',
    width: '100%',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$3',
      mx: '$4',
      width: '100px'
    },
    '.TeaserImage a': {
      align: ['row', 'center', 'middle'],
      width: '100%'
    },
    '.TeaserImage img': {
      boxShadow: 'rgb(0 0 0 / 25%) 0px 4px 20px',
      borderRadius: '2.5px',
      objectFit: 'cover',
      height: '100px',
      width: '100px'
    },
    '.TeaserSubject': {
      display: 'none'
    },
    '.TeaserSubtitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserSubtitleText': {
      color: '#c6c6c6',
      fontSize: '14px',
      lineHeight: '17px',
      fontWeight: 400,
      mx: '$2',
      mb: '$2',
      textAlign: 'center',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    },
    '.TeaserTitle': {
      align: ['row', 'center', 'middle']
    },
    '.TeaserTitleText': {
      color: '#7c7c7c',
      fontSize: '18px',
      letterSpacing: '0.4px',
      lineHeight: '25px',
      fontWeight: 500,
      mx: '$2',
      mb: '$1',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      maxWidth: '100px'
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserStories.ts
var tocantins_assets_teasers_TeaserStories_TeaserStories = {
  className: 'TeaserStories',
  imageDerivative: '1x3',
  imageVariant: 'background',
  css: {
    cursor: 'pointer',
    position: 'relative',
    p: '$0',
    m: '$0',
    mr: '$4',
    width: 'calc(100% - $4)',
    '.TeaserImageContainer': {
      align: ['row', 'center', 'middle'],
      background: 'transparent',
      aspectRatio: 'auto'
    },
    '.TeaserImage': {
      mb: '$0'
    },
    '.TeaserImage img': {
      borderRadius: '10px',
      height: '354px',
      width: '200px',
      objectFit: 'cover'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '19px',
      fontWeight: 500,
      px: '$4',
      mb: '$2',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      align: ['row', 'left', 'bottom']
    },
    '.TeaserTitleText': {
      align: ['row', 'left', 'bottom'],
      color: '$basicWhite',
      fontSize: '18px',
      letterSpacing: '0.2px',
      lineHeight: '23px',
      fontWeight: 400,
      px: '$4',
      mb: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      'a': {
        textAlign: 'left'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      background: 'linear-gradient(rgba(0, 0, 0, 0) 50%, rgb(0, 0, 0) 100%)',
      borderRadius: '10px',
      position: 'absolute',
      height: '100%',
      width: '100%'
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserVideoFeatured.ts

var assets_teasers_TeaserVideoFeatured_TeaserVideoFeatured = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserVideoFeatured',
  imageDerivative: '2x1',
  imageVariant: 'top',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserVideoFeatSm.ts

var tocantins_assets_teasers_TeaserVideoFeatSm_TeaserVideoFeatSm = {
  css: {
    mb: '$8',
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(calc(100% / 3) - $4)'
    },
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '25px',
      fontWeight: 400,
      width: '100%'
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top'],
      width: '100%'
    }
  },
  className: 'TeaserVideoFeatSm',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserVideoFeatMd.ts

var assets_teasers_TeaserVideoFeatMd_TeaserVideoFeatMd = {
  css: {
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3',
      width: 'auto'
    },
    padding: '$0',
    width: '100%',
    '@lg': {
      width: 'calc(50% - $4)'
    },
    '.TeaserRelated': {
      'div.Teaser': {
        mb: '$4'
      },
      'div.TeaserTitle': {
        'p.TeaserTitleText': {
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0.2px'
        }
      }
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      my: '$0',
      mb: '$4'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0.2px',
      fontWeight: 500,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        fontWeight: 600,
        letterSpacing: '0.2px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      align: ['column', 'left', 'top']
    }
  },
  className: 'TeaserVideoFeatMd',
  imageDerivative: '3x2',
  imageVariant: 'top',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserVideoFeatLg.ts

var assets_teasers_TeaserVideoFeatLg_TeaserVideoFeatLg = {
  className: 'TeaserVideoFeatLg',
  imageDerivative: '3x1',
  imageVariant: 'background',
  relatedLayout: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'default',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    p: '$0',
    mb: '$6',
    ml: '-$3',
    mr: '-$3',
    width: 'calc(100% + $6)',
    '@lg': {
      ml: '$0',
      mr: '$0'
    },
    '.TeaserImage': {
      height: '535px'
    },
    '.TeaserImage img': {
      height: '535px',
      objectFit: 'cover'
    },
    '.TeaserImageContainer': {
      aspectRatio: 'auto',
      width: 'auto'
    },
    '.TeaserRelated': {
      display: 'none'
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '12px',
      ml: '$4',
      mb: '$4',
      textTransform: 'uppercase',
      '@lg': {
        fontSize: '16px',
        ml: '$10',
        mb: '$4'
      }
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      ml: '$4',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 400,
        ml: '$10',
        mb: '$10'
      }
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      color: '$basicWhite',
      fontSize: '28px',
      lineHeight: '33px',
      fontWeight: 700,
      ml: '$4',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px',
      '@lg': {
        fontSize: '43px',
        lineHeight: '50px',
        fontWeight: 700,
        ml: '$10',
        mb: '$4'
      }
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        maxWidth: 'calc(100% - 24px)'
      },
      '> .TeaserTitle': {
        maxWidth: 'calc(100% - 24px)'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserVideoLeft.ts
var tocantins_assets_teasers_TeaserVideoLeft_TeaserVideoLeft = {
  css: {
    backgroundColor: 'transparent',
    padding: '$0',
    mb: '$3',
    width: '100%',
    '@lg': {
      ml: '$8',
      mb: '$8',
      width: 'calc(100% - $8)'
    },
    '.TeaserImageContainer': {
      mr: '$3',
      width: 'calc(50% - $3)'
    },
    '.TeaserSubtitle': {
      display: 'none',
      '@lg': {
        display: 'flex'
      }
    },
    '.TeaserSubjectText': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitleText': {
      color: '#989898',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 400,
      '@lg': {
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: 400
      }
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$3'
    },
    '.TeaserTitleText': {
      fontSize: '20px',
      lineHeight: '25px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%',
      '@lg': {
        fontSize: '25px',
        lineHeight: '30px'
      }
    },
    '.TeaserWrap': {
      ml: '$3',
      maxWidth: 'calc(50% - $3)',
      width: '100%'
    }
  },
  className: 'TeaserImageLeft',
  imageDerivative: '3x2',
  imageVariant: 'left',
  subjectVariant: 'filled',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-md'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers/TeaserVideoTop.ts
var tocantins_assets_teasers_TeaserVideoTop_TeaserVideoTop = {
  css: {
    backgroundColor: 'transparent',
    mb: '$8',
    '.TeaserImageContainer': {
      mb: '$3'
    },
    '.TeaserSubject': {
      mb: '$2'
    },
    '.TeaserSubjectText': {
      color: '#FFFFFF !important',
      textTransform: 'uppercase',
      fontSize: '14px'
    },
    '.TeaserSubtitle': {
      display: 'none'
    },
    '.TeaserTitle': {
      color: '#f5f5f5',
      my: '$0'
    },
    '.TeaserTitleText': {
      align: ['column', 'left', 'top'],
      fontSize: '25px',
      lineHeight: '30px',
      letterSpacing: '0.2px',
      fontWeight: 600,
      width: '100%'
    },
    padding: '$0',
    width: '100%'
  },
  className: 'TeaserImageTop',
  imageDerivative: '2x1',
  imageVariant: 'top',
  subjectTextVariant: 'subject-default',
  subjectVariant: 'default',
  subtitleVariant: 'subtitle-desktop',
  titleVariant: 'newstitle-xl'
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/teasers.ts




































var tocantins_assets_teasers_teasers = {
  TeaserBackground: tocantins_assets_teasers_TeaserBackground_TeaserBackground,
  TeaserBackgroundLg: tocantins_assets_teasers_TeaserBackgroundLg_TeaserBackgroundLg,
  TeaserBackgroundRelatedLg: tocantins_assets_teasers_TeaserBackgroundRelatedLg_TeaserBackgroundRelatedLg,
  TeaserBackgroundRelated: tocantins_assets_teasers_TeaserBackgroundRelated_TeaserBackgroundRelated,
  TeaserChargeLg: assets_teasers_TeaserChargeLg_TeaserChargeLg,
  TeaserChargeMd: assets_teasers_TeaserChargeMd_TeaserChargeMd,
  TeaserChargeSm: assets_teasers_TeaserChargeSm_TeaserChargeSm,
  TeaserEditais: tocantins_assets_teasers_TeaserEditais_TeaserEditais,
  TeaserEditorial: assets_teasers_TeaserEditorial_TeaserEditorial,
  TeaserEditorialSm: assets_teasers_TeaserEditorialSm_TeaserEditorialSm,
  TeaserImageBottom: tocantins_assets_teasers_TeaserImageBottom_TeaserImageBottom,
  TeaserImageLeft: tocantins_assets_teasers_TeaserImageLeft_TeaserImageLeft,
  TeaserImageLeftSq: assets_teasers_TeaserImageLeftSq_TeaserImageLeftSq,
  TeaserImageLeftSm: tocantins_assets_teasers_TeaserImageLeftSm_TeaserImageLeftSm,
  TeaserImageLeftLg: tocantins_assets_teasers_TeaserImageLeftLg_TeaserImageLeftLg,
  TeaserImageLeftXl: tocantins_assets_teasers_TeaserImageLeftXl_TeaserImageLeftXl,
  TeaserImageTop: tocantins_assets_teasers_TeaserImageTop_TeaserImageTop,
  TeaserImageTopLg: tocantins_assets_teasers_TeaserImageTopLg_TeaserImageTopLg,
  TeaserCard: tocantins_assets_teasers_TeaserCard_TeaserCard,
  TeaserCardBold: assets_teasers_TeaserCardBold_TeaserCardBold,
  TeaserColumnist: tocantins_assets_teasers_TeaserColumnist_TeaserColumnist,
  TeaserRelated: tocantins_assets_teasers_TeaserRelated_TeaserRelated,
  TeaserHeadlineSm: tocantins_assets_teasers_TeaserHeadlineSm_TeaserHeadlineSm,
  TeaserHeadlineLg: tocantins_assets_teasers_TeaserHeadlineLg_TeaserHeadlineLg,
  TeaserNoImage: tocantins_assets_teasers_TeaserNoImage_TeaserNoImage,
  TeaserMostRead: tocantins_assets_teasers_TeaserMostRead_TeaserMostRead,
  TeaserMostReadFixed: tocantins_assets_teasers_TeaserMostReadFixed_TeaserMostReadFixed,
  TeaserPodcast: tocantins_assets_teasers_TeaserPodcast_TeaserPodcast,
  TeaserRadio: tocantins_assets_teasers_TeaserRadio_TeaserRadio,
  TeaserStories: tocantins_assets_teasers_TeaserStories_TeaserStories,
  TeaserVideoFeatured: assets_teasers_TeaserVideoFeatured_TeaserVideoFeatured,
  TeaserVideoFeatSm: tocantins_assets_teasers_TeaserVideoFeatSm_TeaserVideoFeatSm,
  TeaserVideoFeatMd: assets_teasers_TeaserVideoFeatMd_TeaserVideoFeatMd,
  TeaserVideoFeatLg: assets_teasers_TeaserVideoFeatLg_TeaserVideoFeatLg,
  TeaserVideoLeft: tocantins_assets_teasers_TeaserVideoLeft_TeaserVideoLeft,
  TeaserVideoTop: tocantins_assets_teasers_TeaserVideoTop_TeaserVideoTop
};
var tocantins_assets_teasers_teasersArray = Object.keys(tocantins_assets_teasers_teasers);

;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutCharge.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var assets_layouts_LayoutCharge_LayoutCharge = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserChargeSm, tocantins_assets_teasers_teasers.TeaserChargeSm],
        '0:1': [tocantins_assets_teasers_teasers.TeaserChargeLg, tocantins_assets_teasers_teasers.TeaserChargeLg],
        '0:2': [tocantins_assets_teasers_teasers.TeaserChargeMd, tocantins_assets_teasers_teasers.TeaserChargeMd],
        '0:3': [tocantins_assets_teasers_teasers.TeaserChargeMd, tocantins_assets_teasers_teasers.TeaserChargeMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/utils.ts


function tocantins_assets_layouts_utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_layouts_utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_layouts_utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_layouts_utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var tocantins_assets_layouts_utils_addRelativeWidthToTeaser = function addRelativeWidthToTeaser(teaser, value) {
  var _teaser$css;

  return tocantins_assets_layouts_utils_objectSpread(tocantins_assets_layouts_utils_objectSpread({}, teaser), {}, {
    css: tocantins_assets_layouts_utils_objectSpread(tocantins_assets_layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : teaser.css), {}, {
      '@lg': tocantins_assets_layouts_utils_objectSpread(tocantins_assets_layouts_utils_objectSpread({}, teaser === null || teaser === void 0 ? void 0 : (_teaser$css = teaser.css) === null || _teaser$css === void 0 ? void 0 : _teaser$css['@lg']), {}, {
        width: value
      })
    })
  });
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutColumnist.tsx
// @ts-nocheck







var tocantins_assets_layouts_LayoutColumnist_TeaserColumnist = tocantins_assets_layouts_utils_addRelativeWidthToTeaser(tocantins_assets_teasers_teasers.TeaserColumnist, '100%');

var tocantins_assets_layouts_LayoutColumnist_renderSlotMobileWrapComponent = function renderSlotMobileWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%'
      },
      controlDots: {
        mt: '$2',
        mb: '$0'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    children: data
  });
};

var tocantins_assets_layouts_LayoutColumnist_renderSlotDesktopWrapComponent = function renderSlotDesktopWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel .slider-wrapper': {
          width: 'calc(100% - 64px)'
        }
      },
      controlDots: {
        mt: '$2',
        mb: '$0',
        visibility: 'hidden'
      },
      controlDotsDot: {
        background: '#c4c4c4',
        boxShadow: 'none',
        height: '8px',
        width: '8px',
        opacity: '1',
        '&.selected': {
          background: 'black'
        }
      }
    },
    renderArrowNext: function renderArrowNext(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcAvancarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            top: 'calc(50% - 20px)',
            right: '0px'
          }
        }
      });
    },
    renderArrowPrev: function renderArrowPrev(onClick, hasArrow) {
      return hasArrow && /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        variant: "ghost",
        onClick: onClick,
        icon: {
          alt: '',
          height: '16px',
          src: '/assets/opopular/icons/IcVoltarCinza.svg',
          width: '16px'
        },
        css: {
          button: {
            position: 'absolute',
            bottom: 'calc(50% - 10px)',
            left: '0px'
          }
        }
      });
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    children: map_default()(chunk_default()(data, 4), function (items, key) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        css: {
          align: ['row', 'left', 'middle'],
          width: 'auto'
        },
        children: map_default()(items, function (item, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
            css: {
              align: ['row', 'left', 'middle'],
              minWidth: '25%',
              width: 'auto'
            },
            children: item
          }, key);
        })
      }, key);
    })
  });
};

var tocantins_assets_layouts_LayoutColumnist_LayoutColumnist = {
  wrapperContent: {
    enabled: true,
    component: tocantins_assets_layouts_LayoutColumnist_renderSlotMobileWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        pt: '$3',
        pb: '$5',
        maxWidth: 'calc(100% - $2)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_layouts_LayoutColumnist_TeaserColumnist, tocantins_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [tocantins_assets_layouts_LayoutColumnist_TeaserColumnist, tocantins_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [tocantins_assets_layouts_LayoutColumnist_TeaserColumnist, tocantins_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [tocantins_assets_layouts_LayoutColumnist_TeaserColumnist, tocantins_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
var tocantins_assets_layouts_LayoutColumnist_LayoutColumnistDesktop = {
  wrapperContent: {
    enabled: true,
    component: tocantins_assets_layouts_LayoutColumnist_renderSlotDesktopWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        py: '$6',
        maxWidth: 'calc(100% - 180px)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: 'calc(100% - $12)'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_layouts_LayoutColumnist_TeaserColumnist, tocantins_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [tocantins_assets_layouts_LayoutColumnist_TeaserColumnist, tocantins_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        "default": [tocantins_assets_layouts_LayoutColumnist_TeaserColumnist, tocantins_assets_layouts_LayoutColumnist_TeaserColumnist]
      },
      slotCenter: {
        "default": [tocantins_assets_layouts_LayoutColumnist_TeaserColumnist, tocantins_assets_layouts_LayoutColumnist_TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutColumnistSideBox.tsx
// @ts-nocheck

var tocantins_assets_layouts_LayoutColumnistSideBox_LayoutColumnistSideBox = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnContent': {
        pt: '$6',
        pb: '$6',
        maxWidth: 'calc(100% - $2)'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserColumnist, tocantins_assets_teasers_teasers.TeaserColumnist]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutDefault.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var tocantins_assets_layouts_LayoutDefault_LayoutDefault = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '0': [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '1': [tocantins_assets_teasers_teasers.TeaserHeadlineSm, tocantins_assets_teasers_teasers.TeaserImageLeftXl]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTopLg, tocantins_assets_teasers_teasers.TeaserImageLeftLg]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserNoImage, tocantins_assets_teasers_teasers.TeaserNoImage]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTopLg, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageTopLg, tocantins_assets_teasers_teasers.TeaserImageTopLg],
        '1': [tocantins_assets_teasers_teasers.TeaserImageTopLg, tocantins_assets_teasers_teasers.TeaserImageTopLg]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageTopLg, tocantins_assets_teasers_teasers.TeaserImageTopLg],
        '1': [tocantins_assets_teasers_teasers.TeaserImageTopLg, tocantins_assets_teasers_teasers.TeaserImageTopLg]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeft, tocantins_assets_teasers_teasers.TeaserImageTop],
        '1': [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_teasers_teasers.TeaserImageTop]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeft, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '1': [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_teasers_teasers.TeaserImageTop]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_teasers_teasers.TeaserImageTop]
      }
    },
    TemplateVideos: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutEditais.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var tocantins_assets_layouts_LayoutEditais_LayoutEditais = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserEditais, tocantins_assets_teasers_teasers.TeaserEditais]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserEditais, tocantins_assets_teasers_teasers.TeaserEditais]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutEditorial.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var assets_layouts_LayoutEditorial_LayoutEditorial = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserEditorialSm, tocantins_assets_teasers_teasers.TeaserEditorial],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageTopLg, tocantins_assets_teasers_teasers.TeaserImageLeftLg]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutFeatured.ts


function tocantins_assets_layouts_LayoutFeatured_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_layouts_LayoutFeatured_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_layouts_LayoutFeatured_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_layouts_LayoutFeatured_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// MancheteComFoto
var tocantins_assets_layouts_LayoutFeatured_LayoutFeatured = tocantins_assets_layouts_LayoutFeatured_objectSpread(tocantins_assets_layouts_LayoutFeatured_objectSpread({}, tocantins_assets_layouts_LayoutDefault_LayoutDefault), {}, {
  slotConfig: tocantins_assets_layouts_LayoutFeatured_objectSpread(tocantins_assets_layouts_LayoutFeatured_objectSpread({}, tocantins_assets_layouts_LayoutDefault_LayoutDefault === null || tocantins_assets_layouts_LayoutDefault_LayoutDefault === void 0 ? void 0 : tocantins_assets_layouts_LayoutDefault_LayoutDefault.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSq, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeft, tocantins_assets_teasers_teasers.TeaserImageLeftLg],
        '1': [tocantins_assets_teasers_teasers.TeaserImageLeft, tocantins_assets_teasers_teasers.TeaserImageLeftLg]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserBackground, tocantins_assets_teasers_teasers.TeaserBackgroundLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutFeaturedImage.ts


function tocantins_assets_layouts_LayoutFeaturedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_layouts_LayoutFeaturedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_layouts_LayoutFeaturedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_layouts_LayoutFeaturedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var tocantins_assets_layouts_LayoutFeaturedImage_LayoutFeaturedImage = tocantins_assets_layouts_LayoutFeaturedImage_objectSpread(tocantins_assets_layouts_LayoutFeaturedImage_objectSpread({}, tocantins_assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: tocantins_assets_layouts_LayoutFeaturedImage_objectSpread(tocantins_assets_layouts_LayoutFeaturedImage_objectSpread({}, tocantins_assets_layouts_LayoutFeatured_LayoutFeatured === null || tocantins_assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : tocantins_assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft]
      }
    },
    TemplateSuperManchete: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserBackgroundRelated, tocantins_assets_teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutFeaturedNoImage.ts


function tocantins_assets_layouts_LayoutFeaturedNoImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_layouts_LayoutFeaturedNoImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_layouts_LayoutFeaturedNoImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_layouts_LayoutFeaturedNoImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



var tocantins_assets_layouts_LayoutFeaturedNoImage_LayoutFeaturedNoImage = tocantins_assets_layouts_LayoutFeaturedNoImage_objectSpread(tocantins_assets_layouts_LayoutFeaturedNoImage_objectSpread({}, tocantins_assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: tocantins_assets_layouts_LayoutFeaturedNoImage_objectSpread(tocantins_assets_layouts_LayoutFeaturedNoImage_objectSpread({}, tocantins_assets_layouts_LayoutFeatured_LayoutFeatured === null || tocantins_assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : tocantins_assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_teasers_teasers.TeaserImageLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserHeadlineSm, tocantins_assets_teasers_teasers.TeaserHeadlineLg],
        '1': [tocantins_assets_teasers_teasers.TeaserHeadlineSm, tocantins_assets_teasers_teasers.TeaserHeadlineLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutFeaturedRelated.ts


function tocantins_assets_layouts_LayoutFeaturedRelated_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_layouts_LayoutFeaturedRelated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_layouts_LayoutFeaturedRelated_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_layouts_LayoutFeaturedRelated_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck



// SuperManchete
var tocantins_assets_layouts_LayoutFeaturedRelated_LayoutFeaturedRelated = tocantins_assets_layouts_LayoutFeaturedRelated_objectSpread(tocantins_assets_layouts_LayoutFeaturedRelated_objectSpread({}, tocantins_assets_layouts_LayoutFeatured_LayoutFeatured), {}, {
  slotConfig: tocantins_assets_layouts_LayoutFeaturedRelated_objectSpread(tocantins_assets_layouts_LayoutFeaturedRelated_objectSpread({}, tocantins_assets_layouts_LayoutFeatured_LayoutFeatured === null || tocantins_assets_layouts_LayoutFeatured_LayoutFeatured === void 0 ? void 0 : tocantins_assets_layouts_LayoutFeatured_LayoutFeatured.slotConfig), {}, {
    TemplateSuperManchete: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserBackgroundRelated, tocantins_assets_teasers_teasers.TeaserBackgroundRelatedLg]
      }
    }
  })
});


;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutGrid3.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var tocantins_assets_layouts_LayoutGrid3_TeaserCard = tocantins_assets_layouts_utils_addRelativeWidthToTeaser(tocantins_assets_teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 2)) / 3)');
var tocantins_assets_layouts_LayoutGrid3_TeaserImageTop = tocantins_assets_layouts_utils_addRelativeWidthToTeaser(tocantins_assets_teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var tocantins_assets_layouts_LayoutGrid3_LayoutGrid3 = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template100100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGrid3_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_layouts_LayoutGrid3_TeaserCard]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutGrid4.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var tocantins_assets_layouts_LayoutGrid4_TeaserCard = tocantins_assets_layouts_utils_addRelativeWidthToTeaser(tocantins_assets_teasers_teasers.TeaserCard, 'calc(calc(100% - calc(24px * 3)) / 4)');
var tocantins_assets_layouts_LayoutGrid4_LayoutGrid4 = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserCard, tocantins_assets_layouts_LayoutGrid4_TeaserCard]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSq, tocantins_assets_teasers_teasers.TeaserImageLeftSq],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeftSq, tocantins_assets_teasers_teasers.TeaserImageLeftSq]
      }
    },
    TemplateSideBoxColumnist: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserColumnist, tocantins_assets_teasers_teasers.TeaserColumnist],
        '0:1': [tocantins_assets_teasers_teasers.TeaserColumnist, tocantins_assets_teasers_teasers.TeaserColumnist]
      }
    },
    TemplateSideBoxNoTitle: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSq, tocantins_assets_teasers_teasers.TeaserImageLeftSm],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeftSq, tocantins_assets_teasers_teasers.TeaserImageLeftSm],
        '1': [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_teasers_teasers.TeaserImageTop]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutGridInfocom.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold = tocantins_assets_layouts_utils_addRelativeWidthToTeaser(tocantins_assets_teasers_teasers.TeaserCardBold, 'calc(calc(100% - calc(24px * 2)) / 3)');
var tocantins_assets_layouts_LayoutGridInfocom_TeaserImageTop = tocantins_assets_layouts_utils_addRelativeWidthToTeaser(tocantins_assets_teasers_teasers.TeaserImageTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var assets_layouts_LayoutGridInfocom_LayoutGridInfocom = {
  css: {
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'left', 'top'],
        flexWrap: 'wrap',
        columnGap: '24px'
      }
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template100100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template1005050: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      }
    },
    Template5050100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold],
        '0:1': [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageLeftSm, tocantins_assets_layouts_LayoutGridInfocom_TeaserImageTop]
      }
    },
    Template5050: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserImageTop, tocantins_assets_layouts_LayoutGridInfocom_TeaserCardBold]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutPodcast.tsx
// @ts-nocheck




var tocantins_assets_layouts_LayoutPodcast_renderWrapComponent = function renderWrapComponent(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Carousel */.lr, {
    axis: "horizontal",
    css: {
      carousel: {
        width: '100%'
      },
      container: {
        width: '100%'
      },
      root: {
        width: '100%',
        '.carousel.carousel-slider': {
          align: ['column', 'center', 'middle'],
          overflow: 'inherit',
          width: 'calc(100% - $8)'
        },
        '.carousel.carousel-slider .slider-wrapper': {
          overflow: 'inherit',
          width: '220px'
        }
      }
    },
    labels: {
      item: '',
      leftArrow: 'Retroceder',
      rightArrow: 'Avançar'
    },
    showArrows: false,
    showIndicators: false,
    children: data
  });
};

var tocantins_assets_layouts_LayoutPodcast_LayoutPodcast = {
  wrapperContent: {
    enabled: true,
    component: tocantins_assets_layouts_LayoutPodcast_renderWrapComponent
  },
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxPodcast: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserPodcast, tocantins_assets_teasers_teasers.TeaserPodcast]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutRadio.tsx
// @ts-nocheck

var tocantins_assets_layouts_LayoutRadio_LayoutRadio = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      px: '$0',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxRadio: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserRadio, tocantins_assets_teasers_teasers.TeaserRadio]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutSearch.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var tocantins_assets_layouts_LayoutSearch_LayoutSearch = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserEditorialSm, tocantins_assets_teasers_teasers.TeaserEditorial]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutStories.tsx
// @ts-nocheck

var tocantins_assets_layouts_LayoutStories_LayoutStories = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      }
    }
  },
  slotConfig: {
    TemplateSideBoxStories: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserStories, tocantins_assets_teasers_teasers.TeaserStories]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutMostRead.ts
// eslint-disable-next-line
// @ts-nocheck

var tocantins_assets_layouts_LayoutMostRead_LayoutMostRead = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSidebarLeft: {
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserMostRead, tocantins_assets_teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBox: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserMostRead, tocantins_assets_teasers_teasers.TeaserMostRead]
      }
    },
    TemplateSideBoxFixed: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserMostReadFixed, tocantins_assets_teasers_teasers.TeaserMostReadFixed]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserMostReadFixed, tocantins_assets_teasers_teasers.TeaserMostReadFixed]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutVideoFeatured.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var tocantins_assets_layouts_LayoutVideoFeatured_LayoutVideoFeatured = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['row', 'between', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserVideoFeatured, tocantins_assets_teasers_teasers.TeaserVideoFeatSm],
        '0:1': [tocantins_assets_teasers_teasers.TeaserVideoFeatLg, tocantins_assets_teasers_teasers.TeaserVideoFeatLg],
        '0:2': [tocantins_assets_teasers_teasers.TeaserVideoFeatured, tocantins_assets_teasers_teasers.TeaserVideoFeatMd],
        '0:3': [tocantins_assets_teasers_teasers.TeaserVideoFeatured, tocantins_assets_teasers_teasers.TeaserVideoFeatMd]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutVideoHome.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck


var tocantins_assets_layouts_LayoutVideoHome_TeaserVideoTop = tocantins_assets_layouts_utils_addRelativeWidthToTeaser(tocantins_assets_teasers_teasers.TeaserVideoTop, 'calc(calc(100% - calc(24px * 2)) / 3)');
var tocantins_assets_layouts_LayoutVideoHome_LayoutVideoHome = {
  css: {
    container: {
      mb: '$0'
    },
    column: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        width: '100%' // columnGap: '24px'

      }
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoTop],
        '2': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoLeft]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoTop],
        '2': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoLeft]
      },
      slotRight: {
        "default": [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_layouts_LayoutVideoHome_TeaserVideoTop],
        '1': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoTop],
        '2': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoLeft],
        '0:1': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoTop],
        '0:2': [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoLeft]
      }
    }
  }
};

;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts/LayoutVideoLive.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

var tocantins_assets_layouts_LayoutVideoLive_LayoutVideoLive = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      flexWrap: 'wrap',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateVideos: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoTop]
      },
      slotCenter: {
        "default": [tocantins_assets_teasers_teasers.TeaserVideoTop, tocantins_assets_teasers_teasers.TeaserVideoLeft]
      }
    },
    TemplateVideoLive: {
      slotLeft: {
        "default": [tocantins_assets_teasers_teasers.TeaserMostRead, tocantins_assets_teasers_teasers.TeaserMostRead],
        '0:1': [tocantins_assets_teasers_teasers.TeaserMostRead, tocantins_assets_teasers_teasers.TeaserMostRead]
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/layouts.ts
// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck






















var tocantins_assets_layouts_slotLayouts = {
  LayoutCharge: assets_layouts_LayoutCharge_LayoutCharge,
  LayoutColumnist: tocantins_assets_layouts_LayoutColumnist_LayoutColumnist,
  LayoutColumnistDesktop: tocantins_assets_layouts_LayoutColumnist_LayoutColumnistDesktop,
  LayoutColumnistSideBox: tocantins_assets_layouts_LayoutColumnistSideBox_LayoutColumnistSideBox,
  LayoutDefault: tocantins_assets_layouts_LayoutDefault_LayoutDefault,
  LayoutEditais: tocantins_assets_layouts_LayoutEditais_LayoutEditais,
  LayoutEditorial: assets_layouts_LayoutEditorial_LayoutEditorial,
  LayoutFeatured: tocantins_assets_layouts_LayoutFeatured_LayoutFeatured,
  LayoutFeaturedImage: tocantins_assets_layouts_LayoutFeaturedImage_LayoutFeaturedImage,
  LayoutFeaturedNoImage: tocantins_assets_layouts_LayoutFeaturedNoImage_LayoutFeaturedNoImage,
  LayoutFeaturedRelated: tocantins_assets_layouts_LayoutFeaturedRelated_LayoutFeaturedRelated,
  LayoutGrid3: tocantins_assets_layouts_LayoutGrid3_LayoutGrid3,
  LayoutGrid4: tocantins_assets_layouts_LayoutGrid4_LayoutGrid4,
  LayoutGridInfocom: assets_layouts_LayoutGridInfocom_LayoutGridInfocom,
  LayoutPodcast: tocantins_assets_layouts_LayoutPodcast_LayoutPodcast,
  LayoutRadio: tocantins_assets_layouts_LayoutRadio_LayoutRadio,
  LayoutSearch: tocantins_assets_layouts_LayoutSearch_LayoutSearch,
  LayoutStories: tocantins_assets_layouts_LayoutStories_LayoutStories,
  LayoutMostRead: tocantins_assets_layouts_LayoutMostRead_LayoutMostRead,
  LayoutVideoFeatured: tocantins_assets_layouts_LayoutVideoFeatured_LayoutVideoFeatured,
  LayoutVideoHome: tocantins_assets_layouts_LayoutVideoHome_LayoutVideoHome,
  LayoutVideoLive: tocantins_assets_layouts_LayoutVideoLive_LayoutVideoLive
};
var tocantins_assets_layouts_slotLayoutsArray = Object.keys(tocantins_assets_layouts_slotLayouts);

;// CONCATENATED MODULE: ./brands/tocantins/assets/menus.tsx
var tocantins_assets_menus_accordionStyle = {
  accordionItemGroup: {
    accordionContent: {
      backgroundColor: '#EAEAEA',
      pl: '$8',
      pr: '$18'
    },
    accordionTitle: {
      title: {
        fontFamily: '$primary',
        fontSize: '$caption5',
        fontWeight: '$caption5',
        lineHeight: '$caption5',
        m: '0px',
        py: '$2',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px'
      },
      iconButton: {
        height: '24px',
        width: '24px'
      }
    }
  }
};
var tocantins_assets_menus_sideMenuLeft = {
  sectionHeader: {
    enabled: true,
    subscriberInfo: {
      enabled: true,
      amountLeft: 5
    },
    advertiseSection: {
      enabled: true,
      color: '#FF767B',
      href: 'https://www.jornaldotocantins.com.br/jtostore',
      target: '_blank'
    },
    variants: {
      anonymous: {
        logo: {
          name: 'BannerAnuncie',
          href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania"
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#081632',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      DEGUSTADOR: {
        logo: {
          name: 'BannerAnuncie',
          href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania"
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#081632',
            height: '149px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      ASSINANTE: {
        logo: {
          name: 'BannerAnuncie',
          href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania"
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '#081632',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      advertiser_subscriber: {
        logo: {
          name: 'BannerAssineAgora',
          href: 'https://estrategia.negociosjaimecamara.com.br/portal-jornal-do-tocantins'
        },
        css: {
          container: {
            align: ["column", "center", "top"],
            backgroundColor: "#081632",
            height: "149px",
            px: "$2",
            width: "100%"
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      },
      club_subscriber: {
        logo: {
          name: 'BannerClube',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundImage: 'url(assets/opopular/banners/BannerClubeBackground.png)',
            height: '149px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicWhite'
        }
      }
    }
  },
  sectionContent: {
    enabled: true,
    searchInput: {
      enabled: true
    },
    advertiseSection: {
      enabled: true,
      color: '#FF767B',
      href: 'https://www.jornaldotocantins.com.br/jtostore',
      target: '_blank'
    },
    serviceButtons: {
      enabled: true,
      items: [{
        id: 'whatsapp',
        href: 'https://api.whatsapp.com/send?phone=5563999785108',
        variant: 'WhatsApp'
      }, {
        id: 'jornaldigital',
        href: 'https://www.jornaldotocantins.com.br/digital/',
        variant: 'JornalDigital'
      }]
    },
    navigationAccordions: {
      enabled: true,
      css: tocantins_assets_menus_accordionStyle,
      items: [
      /*         {
                id: 'publicidade',
                title: 'Publicidade',
                items: [
                  {
                    id: "1",
                    title: "Infomercial",
                    href: "/infomercial",
                  }
                ],
                css: accordionStyle,
              }, */
      {
        id: 'sac',
        title: 'SAC',
        items: [{
          id: '1',
          title: 'Fale Conosco',
          href: '/fale-conosco'
        }, {
          id: "2",
          title: "Expediente",
          href: "/institucional/expediente"
        }, {
          id: "3",
          title: "Política de privacidade",
          href: "/institucional/politica-de-privacidade"
        }, {
          id: "4",
          title: "Termos de uso",
          href: "/institucional/termos-de-uso"
        }],
        css: tocantins_assets_menus_accordionStyle
      }, {
        id: 'grupoojc',
        title: 'Grupo Jaime Câmara',
        items: [{
          id: '1',
          title: 'Classi',
          href: 'https://www.classi.com.br'
        }
        /* 
        {
        id: '2',
        title: 'Clube O Popular',
        href: 'https://clube.opopular.com.br'
        }, */
        , {
          id: '2',
          title: 'Jornal Daqui',
          href: 'https://daqui.opopular.com.br'
        }, {
          id: '3',
          title: 'O Popular',
          href: 'https://opopular.com.br/'
        }],
        css: tocantins_assets_menus_accordionStyle
      }]
    }
  },
  sectionFooter: {
    enabled: true,
    advertiseSection: {
      enabled: true,
      color: "#081632",
      href: "https://estrategia.negociosjaimecamara.com.br/portal-jornal-do-tocantins"
    },
    socialmediasSection: {
      enabled: true,
      color: '#F7F7F7',
      content: [{
        id: 'facebook',
        href: 'https://www.facebook.com/JornaldoTocantins',
        icon: 'IcBotaoFacebookCinza'
      }, {
        id: 'twitter',
        href: 'https://twitter.com/jornaltocantins',
        icon: 'IcBotaoTwitterCinza'
      }, {
        id: 'instagram',
        href: 'https://www.instagram.com/jornaldotocantins/',
        icon: 'IcBotaoInstagramCinza'
      }, {
        id: 'whatsapp',
        href: 'https://api.whatsapp.com/send?phone=5563999785108',
        icon: 'IcBotaoWhatsAppCinza'
      }]
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/Template100.ts
var tocantins_assets_templates_Template100_Template100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/Template100100.ts
var assets_templates_Template100100_Template100100 = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '@lg': {
        align: ['column', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        },
        '.TeaserRelated': {
          align: ['row', 'evenly', 'top'],
          flexWrap: 'wrap',
          width: 'calc(100% - 140px)',
          '.Teaser': {
            width: 'calc(50% - $6)'
          }
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/Template1005050.ts
var tocantins_assets_templates_Template1005050_Template1005050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      '.Column.Left': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Center': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '.Column.Right': {
        borderBottom: '1px solid #E6E6E6',
        mb: '$6'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column.Left': {
          mb: '$0'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          borderBottom: 'none',
          gridColumn: 'span 2',
          width: '100%'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          borderBottom: 'none',
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/Template5050.ts
var tocantins_assets_templates_Template5050_Template5050 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        }
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/Template5050100.ts
var tocantins_assets_templates_Template5050100_Template5050100 = {
  css: {
    container: {
      align: ['column', 'center', 'top'],
      mb: '$0',
      pt: '$0',
      width: 'calc(100% - $6)',
      '@lg': {
        width: '100%'
      }
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        flexWrap: 'wrap',
        maxWidth: '1280px',
        pt: '$4',
        width: '100%',
        '.Column:not(.ExtraTop,.Extra):nth-child(1)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(2)': {
          width: 'calc(calc(100% - $6) / 2)'
        },
        '.Column:not(.ExtraTop,.Extra):nth-child(3)': {
          gridColumn: 'span 2',
          width: '100%'
        }
      }
    }
  },
  customProps: {
    container: {
      className: 'AlignToLeft'
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateColumnist.ts
var tocantins_assets_templates_TemplateColumnist_TemplateColumnist = {
  css: {
    container: {
      backgroundColor: '#f4f4f4',
      pt: '$4',
      mb: '$4',
      '@lg': {
        pb: '$0',
        mb: '$4'
      }
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      '.Column:nth-child(1)': {
        '@lg': {
          display: 'none'
        }
      },
      '.Column:nth-child(2)': {
        display: 'none',
        '@lg': {
          display: 'flex'
        }
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Teaser.mobile:not(:nth-child(1))': {
        display: 'none'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%'
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSideBox.ts
var tocantins_assets_templates_TemplateSideBox_TemplateSideBox = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        px: '$3',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle'],
        borderBottom: '1px solid #e6e6e6',
        pt: '$4',
        pb: '$0',
        px: '$2',
        mb: '$5'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSideBoxGeneric.ts
var tocantins_assets_templates_TemplateSideBoxGeneric_TemplateSideBoxGeneric = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column.Center': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        pb: '$2'
      },
      '.Column.Center .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2'
      },
      '.Column.Center .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Center .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSideBoxFixed.ts
var tocantins_assets_templates_TemplateSideBoxFixed_TemplateSideBoxFixed = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      mt: '$6',
      '@lg': {
        pb: '$0',
        px: '$0',
        mt: '$6',
        mb: '$8',
        position: 'sticky',
        top: '200px'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ExtraTop .ColumnContent': {
        align: ['row', 'left', 'bottom'],
        mb: '0px',
        width: '100%',
        '.pds-Button-root': {
          backgroundColor: '#FFFFFF'
        }
      },
      '.Center .ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$2',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E6E6E6',
        borderTop: 'unset',
        borderBottomLeftRadius: '$alternative',
        borderBottomRightRadius: '$alternative',
        overflow: 'hidden',
        py: '$0',
        width: '100%'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSideBoxPodcast.ts
var tocantins_assets_templates_TemplateSideBoxPodcast_TemplateSideBoxPodcast = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        borderRadius: '10px',
        mt: '$6',
        mx: '$3',
        width: '290px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        pl: '$11',
        pt: '$4'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .Teaser:nth-child(2),.Teaser:nth-child(1)': {
        position: 'relative',
        top: '-30px',
        'img': {
          height: '190px',
          width: '190px'
        },
        '.TeaserImage': {
          width: '180px'
        }
      },
      '.ColumnBottom': {
        mb: '$4',
        mx: '$4',
        width: 'calc(100% - $8)',
        'audio': {
          width: 'calc(100% - $8)'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '-$6',
        px: '$0',
        mt: '$1',
        overflowX: 'clip',
        py: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSideBoxRadio.ts
var tocantins_assets_templates_TemplateSideBoxRadio_TemplateSideBoxRadio = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      '.Column.Left': {
        align: ['column', 'between', 'top'],
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .ColumnContent': {
        px: '$0'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.Column.Left .slide.selected .Teaser': {
        'img': {
          height: '124px',
          width: '124px'
        },
        '.TeaserSubtitleText': {
          maxWidth: '124px'
        },
        '.TeaserTitleText': {
          maxWidth: '124px'
        }
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        overflowY: 'inherit',
        overflowX: 'clip',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSideBoxStories.ts
var tocantins_assets_templates_TemplateSideBoxStories_TemplateSideBoxStories = {
  css: {
    container: {
      align: ['column', 'left', 'top'],
      mb: '$4',
      px: '$3',
      pt: '$0',
      width: 'calc(100% - $4)',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8',
        width: '100%'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      overflow: 'hidden',
      width: '100%',
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left': {
        overflowX: 'clip'
      },
      '.Column.Left .Teaser': {
        py: '$0'
      },
      '.ColumnContent': {
        align: ['row', 'left', 'top'],
        mb: '$3',
        px: '$0',
        mt: '$1',
        py: '$0',
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$0',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSideBoxColumnist.ts
var tocantins_assets_templates_TemplateSideBoxColumnist_TemplateSideBoxColumnist = {
  css: {
    container: {
      pt: '$0',
      '@lg': {
        pb: '$0',
        mb: '$0'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        backgroundColor: '#f4f4f4',
        mb: '$4',
        px: '$2',
        py: '$8',
        width: '100%'
      },
      '.Extra .ColumnContent': {
        backgroundImage: 'none',
        px: '$3',
        py: '$0',
        mb: '$0',
        width: '100%'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.ExtraTop .ColumnContent': {
        backgroundImage: 'none',
        py: '$0',
        px: '$3',
        mt: '$1',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      }
    },
    item: {}
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSideBoxNoTitle.ts
var tocantins_assets_templates_TemplateSideBoxNoTitle_TemplateSideBoxNoTitle = {
  css: {
    container: {
      mb: '$8',
      px: '$3',
      pt: '$0',
      '@lg': {
        pb: '$0',
        px: '$0',
        mb: '$8'
      }
    },
    columnHolder: {
      align: ['row', 'between', 'top'],
      width: '100%',
      '.Column.Left': {
        border: '1px solid #e6e6e6',
        borderRadius: '10px'
      },
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$3',
        px: '$0',
        py: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.Column.Left .Teaser': {
        borderBottom: '1px solid #e6e6e6',
        pb: '$2',
        '.TeaserWrap': {
          py: '$3'
        },
        '.TeaserSubject': {
          px: '$6'
        },
        '.TeaserTitle': {
          px: '$6'
        },
        '.TeaserImage img': {
          borderRadius: '10px 10px 0px 0px'
        }
      },
      '.Column.Left .Teaser:last-child': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.Column.Left .Teaser:nth-last-child(2)': {
        borderBottom: 'none',
        pb: '$0',
        mb: '$0'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '.ExtraTop .ColumnContent': {
        mb: '$0',
        px: '$3',
        py: '$0'
      },
      '.Extra .ColumnContent .Item': {
        align: ['column', 'right', 'top']
      },
      '.Extra .ColumnTop': {
        borderBottom: 'none',
        mb: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSidebarLeft.ts
var tocantins_assets_templates_TemplateSidebarLeft_TemplateSidebarLeft = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: 'calc(100% - $6)',
      flexDirection: 'column-reverse',
      marginTop: '$2',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none',
          marginTop: '24px',
          width: '300px'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          marginTop: '36px',
          width: 'calc(100% - 340px)'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          flexDirection: 'unset',
          align: ['row', 'between', 'middle']
        },
        '.Column.ExtraTop': {
          width: '100%'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateSuperManchete.ts
var tocantins_assets_templates_TemplateSuperManchete_TemplateSuperManchete = {
  css: {
    container: {
      mb: '$0'
    },
    columnHolder: {
      width: '100%',
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column:nth-child(1)': {
          borderBottom: 'none'
        },
        '.Column:nth-child(2)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.Column:nth-child(3)': {
          borderBottom: 'none',
          display: 'none'
        },
        '.ColumnTop': {
          align: ['row', 'between', 'middle']
        },
        '.ColumnTop .Item': {// width: 'auto'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateVideosLive.ts
var tocantins_assets_templates_TemplateVideosLive_TemplateVideoLive = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        align: ['row', 'center', 'top'],
        mb: '$0',
        px: '$3',
        width: '100%'
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2)': {
        display: 'none'
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates/TemplateVideos.ts
var tocantins_assets_templates_TemplateVideos_TemplateVideos = {
  css: {
    container: {
      backgroundColor: '#282828',
      mb: '$6',
      py: '$4',
      '@lg': {
        mb: '$6',
        pb: '$4'
      }
    },
    columnHolder: {
      align: ['column', 'between', 'top'],
      width: '100%',
      '.ColumnContent': {
        mb: '$0',
        px: '$3',
        width: '100%',
        '@lg': {
          align: ['row', 'between', 'top']
        }
      },
      '.ExtraTop .ColumnContent': {
        py: '$0',
        px: '$3',
        mb: '$0',
        width: '100%'
      },
      '.Column:nth-child(2) .ColumnContent': {
        align: ['column', 'center', 'top']
      },
      '.Column:nth-child(3)': {
        display: 'none'
      },
      '.ColumnTop': {
        align: ['row', 'between', 'middle']
      },
      '.ColumnTop .Item': {
        width: 'auto'
      },
      '@lg': {
        align: ['row', 'between', 'top'],
        maxWidth: '1280px',
        width: '100%',
        '.Column.Left': {
          minWidth: 'calc(50% - $3)',
          width: 'auto'
        },
        '.Column.Center': {
          maxWidth: 'calc(50% - $3)',
          width: 'auto'
        },
        '.ColumnContent': {
          px: '$0',
          width: '100%'
        },
        '.Extra .ColumnContent': {
          px: '$0'
        },
        '.ExtraTop .ColumnContent': {
          px: '$0'
        }
      },
      '@xl': {
        px: '$0'
      }
    }
  }
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/templates.ts


















var tocantins_assets_templates_templates = {
  Template100: tocantins_assets_templates_Template100_Template100,
  Template100100: assets_templates_Template100100_Template100100,
  Template1005050: tocantins_assets_templates_Template1005050_Template1005050,
  Template5050: tocantins_assets_templates_Template5050_Template5050,
  Template5050100: tocantins_assets_templates_Template5050100_Template5050100,
  TemplateColumnist: tocantins_assets_templates_TemplateColumnist_TemplateColumnist,
  TemplateSideBox: tocantins_assets_templates_TemplateSideBox_TemplateSideBox,
  TemplateSideBoxGeneric: tocantins_assets_templates_TemplateSideBoxGeneric_TemplateSideBoxGeneric,
  TemplateSideBoxFixed: tocantins_assets_templates_TemplateSideBoxFixed_TemplateSideBoxFixed,
  TemplateSideBoxPodcast: tocantins_assets_templates_TemplateSideBoxPodcast_TemplateSideBoxPodcast,
  TemplateSideBoxRadio: tocantins_assets_templates_TemplateSideBoxRadio_TemplateSideBoxRadio,
  TemplateSideBoxStories: tocantins_assets_templates_TemplateSideBoxStories_TemplateSideBoxStories,
  TemplateSideBoxColumnist: tocantins_assets_templates_TemplateSideBoxColumnist_TemplateSideBoxColumnist,
  TemplateSideBoxNoTitle: tocantins_assets_templates_TemplateSideBoxNoTitle_TemplateSideBoxNoTitle,
  TemplateSidebarLeft: tocantins_assets_templates_TemplateSidebarLeft_TemplateSidebarLeft,
  TemplateSuperManchete: tocantins_assets_templates_TemplateSuperManchete_TemplateSuperManchete,
  TemplateVideoLive: tocantins_assets_templates_TemplateVideosLive_TemplateVideoLive,
  TemplateVideos: tocantins_assets_templates_TemplateVideos_TemplateVideos
};
var tocantins_assets_templates_templatesArray = Object.keys(tocantins_assets_templates_templates);

;// CONCATENATED MODULE: ./brands/tocantins/assets/topbar.styled.tsx



function tocantins_assets_topbar_styled_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_topbar_styled_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_topbar_styled_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_topbar_styled_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var tocantins_assets_topbar_styled_buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7'
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'DIGITAL',
    hideInMobile: false
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black'
    },
    cssContainer: {
      mr: '$4'
    },
    hideInMobile: false
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020'
    },
    hideInMobile: false
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6'
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px'
      }
    },
    value: 'ÁUDIO',
    hideInMobile: false
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0'
      }
    },
    value: 'ENTRAR',
    hideInMobile: false
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite'
    },
    hideInMobile: false
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black'
    },
    hideInMobile: false
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800'
    },
    hideInMobile: false
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none'
      }
    },
    hideInMobile: false
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content'
    },
    hideInMobile: false
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#DAE5FB',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content'
      }
    },
    hideInMobile: false
  }
};
var tocantins_assets_topbar_styled_TopbarMobileSlotLeft = function TopbarMobileSlotLeft() {
  var drawersContext = (0,react.useContext)(DrawersProvider.DrawersContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcHamburguerMobile'),
      onClick: function onClick() {
        return drawersContext.handleSideMenuLeft({
          open: !drawersContext.sideMenuLeftState.open
        });
      }
    })
  });
};
var topbar_styled_TopbarDesktopSlotLeft = function TopbarDesktopSlotLeft() {
  var _assetsContext$assets;

  var router = (0,next_router.useRouter)();
  var drawersContext = (0,react.useContext)(DrawersProvider.DrawersContext);
  var urlParams = new URLSearchParams(window.location.search);
  var termParam = urlParams.get('term') || '';

  var _useState = (0,react.useState)(false),
      showSearch = _useState[0],
      setShowSearch = _useState[1];

  var _useState2 = (0,react.useState)(termParam),
      term = _useState2[0],
      setTerm = _useState2[1];

  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var banners = assetsContext === null || assetsContext === void 0 ? void 0 : (_assetsContext$assets = assetsContext.assets) === null || _assetsContext$assets === void 0 ? void 0 : _assetsContext$assets.banners;
  var bannerAnuncie = banners.find(function (i) {
    return i.name === 'BannerAnuncieAqui';
  });

  var handleSearch = function handleSearch() {
    var url = window.location.origin + "/pesquisa?term=".concat(term);
    window.location.assign(url);
  };

  var handleChange = function handleChange(event) {
    setTerm(event.target.value);
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  var handleBlur = function handleBlur() {
    if (!term) {
      setShowSearch(false);
    }
  };

  var searchIcon = (0,hooks_useIcon/* useIcon */.b)('IcBuscar');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: (0,hooks_useIcon/* useIcon */.b)('IcHamburger'),
      id: "menu-hamburguer",
      onClick: function onClick() {
        return drawersContext.handleSideMenuLeft({
          open: !drawersContext.sideMenuLeftState.open
        });
      }
    }), !showSearch ? /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
      icon: searchIcon,
      id: "busca-menu",
      onClick: function onClick() {
        return setShowSearch(!showSearch);
      }
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SearchInput_index/* default */.Z, {
      id: "ojc-search-input-topbar",
      onChange: handleChange,
      onKeyPress: handleKeyPress,
      onSearch: handleSearch,
      onBlur: handleBlur,
      css: {
        container: {
          mt: '14px',
          mb: '$4',
          maxWidth: '320px'
        },
        input: {
          ml: '$2',
          width: 'calc(100% - $6)'
        },
        icon: {
          button: {
            mr: '$0'
          }
        }
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      css: {
        align: ['row', 'right', 'middle'],
        width: '100%'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_AdvertiseBannerButton, {
        alt: "Anuncie",
        colorSchema: "#A7DCFE",
        href: "https://estrategia.negociosjaimecamara.com.br/radio-cbn-goiania" || 0,
        imgSrc: bannerAnuncie.url,
        imgHeight: "",
        imgWidth: ""
      })
    })]
  });
};
var tocantins_assets_topbar_styled_TopbarDesktopSlotRight = function TopbarDesktopSlotRight() {
  var _assetsContext$assets2, _serverSideContext$si, _serverSideContext$si2, _keycloak$tokenParsed;

  var assetsContext = (0,react.useContext)(Assets.AssetsContext);
  var serverSideContext = (0,react.useContext)(ServerSidePropsContext);
  var router = (0,next_router.useRouter)();
  var sessionData = (0,react.useContext)(Session.SessionDataContext);
  var banners = assetsContext === null || assetsContext === void 0 ? void 0 : (_assetsContext$assets2 = assetsContext.assets) === null || _assetsContext$assets2 === void 0 ? void 0 : _assetsContext$assets2.banners;
  var bannerAssine = banners.find(function (i) {
    return i.name === 'BannerAssineAgora';
  });

  var _useKeycloak = (0,lib.useKeycloak)(),
      keycloak = _useKeycloak.keycloak;

  var isPaywall = serverSideContext === null || serverSideContext === void 0 ? void 0 : (_serverSideContext$si = serverSideContext.site) === null || _serverSideContext$si === void 0 ? void 0 : (_serverSideContext$si2 = _serverSideContext$si.pageConfig) === null || _serverSideContext$si2 === void 0 ? void 0 : _serverSideContext$si2.featureRadioSelectPaywall;

  function keycloakSessionLogOut(_x) {
    return _keycloakSessionLogOut.apply(this, arguments);
  }

  function _keycloakSessionLogOut() {
    _keycloakSessionLogOut = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(id) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return axios_default()["delete"]("/paywall/delete-sessao/".concat(id));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _keycloakSessionLogOut.apply(this, arguments);
  }

  var handleLogin = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              console.log(document.cookie);
              _context.next = 4;
              return keycloak === null || keycloak === void 0 ? void 0 : keycloak.login({
                redirectUri: "".concat(window.location.href)
              });

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error('Error during login:', _context.t0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));

    return function handleLogin() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubscribeNowBannerButton_index, {
      alt: "Assine",
      colorSchema: "secondary",
      href:  false || '',
      imgSrc: bannerAssine.url,
      imgHeight: "",
      imgWidth: ""
    }), isPaywall !== 'DESATIVADO' && /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriberInfo_index, {
      amountLeft: keycloak === null || keycloak === void 0 ? void 0 : (_keycloak$tokenParsed = keycloak.tokenParsed) === null || _keycloak$tokenParsed === void 0 ? void 0 : _keycloak$tokenParsed.exp,
      onAnonymousClick: handleLogin,
      onLogout: function onLogout() {
        if ((sessionData === null || sessionData === void 0 ? void 0 : sessionData.id) == undefined) {
          keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout();
        } else {
          keycloakSessionLogOut(sessionData === null || sessionData === void 0 ? void 0 : sessionData.id).then( /*#__PURE__*/function () {
            var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(res) {
              return regenerator_default().wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (res.status == 200) {
                        keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout();
                        (0,utils/* removeSessionDataCookie */.pR)();
                      } else {
                        console.log('Erro ao fazer login');
                      }

                    case 1:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }());
        }
      },
      onGuestClick: function onGuestClick() {
        var url = window.location.origin + '/perfil';
        window.location.assign(url);
      },
      onSubscriberClick: function onSubscriberClick() {
        var url = window.location.origin + '/perfil';
        window.location.assign(url);
      },
      type: sessionData ? 'ASSINANTE' : 'anonymous'
    })]
  });
};
var tocantins_assets_topbar_styled_TopbarTopSlotLeft = function TopbarTopSlotLeft() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: "https://www.gjccorp.com.br/",
      title: "GJC",
      target: "_blank",
      rel: "noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_index/* default */.Z, {
        icon: (0,hooks_useIcon/* useIcon */.b)('IcOjc')
      })
    })
  });
};
var tocantins_assets_topbar_styled_TopbarTopSlotRight = function TopbarTopSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, tocantins_assets_topbar_styled_objectSpread({
      href: "https://classi.com.br",
      value: "Classi"
    }, tocantins_assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, tocantins_assets_topbar_styled_objectSpread({
      href: "https://daqui.opopular.com.br/",
      value: "Jornal Daqui"
    }, tocantins_assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, tocantins_assets_topbar_styled_objectSpread({
      href: "https://www.cbntocantins.com.br/",
      value: "CBN Tocantins"
    }, tocantins_assets_topbar_styled_buttons.topbarTopItemsRight)), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemButton_index, tocantins_assets_topbar_styled_objectSpread({
      href: "https://opopular.com.br/",
      value: "Jornal O Popular"
    }, tocantins_assets_topbar_styled_buttons.topbarTopItemsRight))]
  });
};
var tocantins_assets_topbar_styled_TopbarExtraSlotRight = function TopbarExtraSlotRight() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
;// CONCATENATED MODULE: ./brands/tocantins/assets/topbar.tsx

var tocantins_assets_topbar_topbar = {
  topbarMobile: {
    mainLogo: 'LogoTocantinsMobile',
    css: {
      cssContainer: {
        background: '#F7F7F7',
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.1)',
        height: '52px',
        width: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 9
      },
      cssContainerMiddleHolder: {
        borderTopColor: '#D83C42',
        borderTopStyle: 'solid',
        borderTopWidth: '3px',
        height: '100%',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '100%',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        paddingLeft: '18px',
        width: '80px'
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'right', 'middle'],
        paddingRight: '18px',
        width: '80px'
      },
      cssContainerBottom: {
        display: 'none'
      }
    },
    slotMiddleLeft: tocantins_assets_topbar_styled_TopbarMobileSlotLeft
  },
  topbarDesktop: {
    mainLogo: 'LogoTocantinsDesktop',
    css: {
      cssContainerTopHolder: {
        align: ['row', 'center', 'middle'],
        background: '$primaryMain',
        borderBottomColor: '#D83C42',
        borderBottomStyle: 'solid',
        borderBottomWidth: '3px',
        px: '$4',
        width: '100%'
      },
      cssContainer: {
        position: 'sticky',
        top: 0,
        zIndex: 9
      },
      cssContainerTop: {
        align: ['row', 'between', 'middle'],
        height: '35px',
        maxWidth: '1280px'
      },
      cssContainerTopSlotRight: {
        align: ['row', 'right', 'middle']
      },
      cssContainerMiddleHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%'
      },
      cssContainerMiddle: {
        align: ['row', 'between', 'middle'],
        height: '110px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerMiddleSlotLeft: {
        align: ['row', 'left', 'middle'],
        minWidth: '400px',
        ' > div': {
          align: ['row', 'center', 'middle']
        }
      },
      cssContainerMiddleSlotRight: {
        align: ['row', 'evenly', 'middle'],
        minWidth: '400px'
      },
      cssContainerBottomHolder: {
        align: ['row', 'center', 'middle'],
        background: '#F7F7F7',
        px: '$4',
        width: '100%',
        ' > div': {
          align: ['row', 'between', 'middle'],
          borderTop: '1px solid #E6E6E6'
        }
      },
      cssContainerBottom: {
        align: ['row', 'between', 'middle'],
        background: '#F7F7F7',
        height: '40px',
        maxWidth: '1280px',
        width: '100%'
      },
      cssContainerBottomLeft: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      cssContainerBottomRight: {
        align: ['row', 'right', 'middle'],
        minWidth: '170px'
      },
      topbarItems: {
        item: {
          label: {
            color: '#202020',
            fontSize: '14px',
            fontFamily: '$primary',
            fontWeight: 500,
            textTransform: 'uppercase',
            width: 'max-content'
          },
          li: {
            'a': {
              borderBottom: '4px solid transparent',
              cursor: 'pointer',
              display: 'block',
              height: '100%',
              width: '100%',
              pb: '6px',
              px: '$4',
              pt: '10px'
            }
          }
        }
      }
    },
    slotTopLeft: tocantins_assets_topbar_styled_TopbarTopSlotLeft,
    slotTopRight: tocantins_assets_topbar_styled_TopbarTopSlotRight,
    slotMiddleLeft: topbar_styled_TopbarDesktopSlotLeft,
    slotMiddleRight: tocantins_assets_topbar_styled_TopbarDesktopSlotRight,
    slotBottomRight: tocantins_assets_topbar_styled_TopbarExtraSlotRight
  }
};
/* harmony default export */ var tocantins_assets_topbar = ((/* unused pure expression or super */ null && (tocantins_assets_topbar_topbar)));
;// CONCATENATED MODULE: ./brands/tocantins/assets/index.ts












var tocantins_assets_banners = tocantins_indexes_banners_namespaceObject.k;
var tocantins_assets_favicons = tocantins_indexes_favicons_namespaceObject.k;
var tocantins_assets_logos = tocantins_indexes_logos_namespaceObject.k;
var tocantins_assets_icons = tocantins_indexes_icons_namespaceObject.k;
var tocantins_assets_splashScreens = tocantins_indexes_splashScreens_namespaceObject.k;
var TocantinsAssets = {
  article: tocantins_assets_article_article,
  banners: tocantins_assets_banners,
  favicons: tocantins_assets_favicons,
  footer: tocantins_assets_footer_FooterConfig,
  logos: tocantins_assets_logos,
  icons: tocantins_assets_icons,
  menus: {
    sideMenuLeft: tocantins_assets_menus_sideMenuLeft
  },
  slotLayouts: tocantins_assets_layouts_slotLayouts,
  splashScreens: tocantins_assets_splashScreens,
  teasers: tocantins_assets_teasers_teasers,
  templates: tocantins_assets_templates_templates,
  topbar: tocantins_assets_topbar_topbar
};
;// CONCATENATED MODULE: ./brands/tocantins/indexes/colors.json
var tocantins_indexes_colors_namespaceObject = JSON.parse('{"vU":{"primaryMain":"#194392","primary900":"#194392","primary800":"#235FB1","primary700":"#2970C2","primary600":"#2F82D5","primary500":"#338FE3","primary400":"#4C9FE7","primary300":"#68AFEB","primary200":"#92C6F0","primary100":"#BBDCF6","primary50":"#E4F1FC","secondaryMain":"#FF767B","secondary900":"#787A1B","secondary800":"#90A12D","secondary700":"#9FB936","secondary600":"#AECF41","secondary500":"#B9E048","secondary400":"#C2E561","secondary300":"#CDEB7C","secondary200":"#DBF1A1","secondary100":"#E9F5C6","secondary50":"#F6FCE8","tertiaryMain":"#F5CE5E","tertiary900":"#EA6F2C","tertiary800":"#EC8C34","tertiary700":"#ED9C38","tertiary600":"#EFAC3C","tertiary500":"#F0B941","tertiary400":"#F2C34F","tertiary300":"#F4CE67","tertiary200":"#F7DB8F","tertiary100":"#FAE9BA","tertiary50":"#FDF7E4"},"T9":{"headlineTextMain":"#000000","paragraphTextMain":"#333333","backgroundMain":"#F7F7F7"},"Dh":{"politicaMain":"#4597BC","politica900":"#2A5574","politica800":"#367497","politica700":"#3B85AA","politica600":"#4597BC","politica500":"#4CA5C9","politica400":"#59B1D0","politica300":"#6DBED7","politica200":"#8FD0E2","politica100":"#B9E3ED","politica50":"#E3F4F8","mundoMain":"#8BCAC8","mundo900":"#174D45","mundo800":"#206961","mundo700":"#247971","mundo600":"#288981","mundo500":"#2C968F","mundo400":"#40A5A0","mundo300":"#5FB5B1","mundo200":"#8BCAC8","mundo100":"#B8DEDD","mundo50":"#E3F2F2","economiaMain":"#589B72","economia900":"#2A5E26","economia800":"#4A8039","economia700":"#5C9443","economia600":"#6EA84E","economia500":"#7CB856","economia400":"#8FC26E","economia300":"#A2CC86","economia200":"#BCDAA8","economia100":"#D7EAC9","economia50":"#EFF7EA","cidadeMain":"#8FC26E","cidade900":"#3E5847","cidade800":"#49785B","cidade700":"#4F8966","cidade600":"#589B72","cidade500":"#60AA7E","cidade400":"#75B690","cidade300":"#8BC3A3","cidade200":"#ABD4BC","cidade100":"#CBE5D6","cidade50":"#EAF4EE","especiaisMain":"#AFAC83","especiais900":"#8A877A","especiais800":"#AFAC83","especiais700":"#C3C28A","especiais600":"#D7D895","especiais500":"#E3E89B","especiais400":"#E8EDA6","especiais300":"#ECF1B3","especiais200":"#F1F5C5","especiais100":"#F6F9DC","especiais50":"#FBFDF1","colunistaMain":"#AF8F7F","colunista900":"#4D2D25","colunista800":"#5D3B30","colunista700":"#6B4839","colunista600":"#7B5443","colunista500":"#875E4A","colunista400":"#9B7665","colunista300":"#AF8F7F","colunista200":"#CAAEA2","colunista100":"#E3CEC4","colunista50":"#F9EBE2","esporteMain":"#FB814C","esporte900":"#BC4D1B","esporte800":"#D45A23","esporte700":"#E26126","esporte600":"#F0682B","esporte500":"#FB6F2F","esporte400":"#FB814C","esporte300":"#FC976B","esporte200":"#FDB395","esporte100":"#FDD1BF","esporte50":"#FBEBE8","videoMain":"#EE6D6F","video900":"#BE071A","video800":"#CE1525","video700":"#DB1E2C","video600":"#ED2B32","video500":"#FB3733","video400":"#F9484C","video300":"#EE6D6F","video200":"#F69797","video100":"#FECCD1","video50":"#FFEAED","vida-urbanaMain":"#69a840","magazineMain":"#E982B0","magazine900":"#760649","magazine800":"#9A0952","magazine700":"#AF0B58","magazine600":"#C50D5D","magazine500":"#D50F60","magazine400":"#DB1B78","magazine300":"#E14D90","magazine200":"#E982B0","magazine100":"#F1B4D0","magazine50":"#FAE1EC"},"yT":{"semanticError":"#F9484C","semanticSuccess":"#A2CC86"}}');
;// CONCATENATED MODULE: ./brands/tocantins/assets/colors.ts


function tocantins_assets_colors_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_assets_colors_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_assets_colors_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_assets_colors_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var tocantins_assets_colors_colors = tocantins_assets_colors_objectSpread(tocantins_assets_colors_objectSpread(tocantins_assets_colors_objectSpread(tocantins_assets_colors_objectSpread({}, tocantins_indexes_colors_namespaceObject.vU), tocantins_indexes_colors_namespaceObject.Dh), tocantins_indexes_colors_namespaceObject.yT), tocantins_indexes_colors_namespaceObject.T9);
;// CONCATENATED MODULE: ./brands/tocantins/indexes/type-system.json
var tocantins_indexes_type_system_namespaceObject = JSON.parse('{"CH":{"caption3":"16px","headline3":"36px","caption1":"14px","headline6":"20px","headline2":"43px","paragraph4":"18px","paragraph3":"18px","headline4":"25px","paragraphPaywall":"14px","widget5":"18px","headline5":"20px","retrancaWidget":"18px","widgetMaisLidas":"18px","widgetEsporteDestaque":"12px","widgetEsporte":"12px","headlineDestaqueEditoria2":"22px","caption4":"14px","retrancaHamburger":"18px","caption5":"14px","headlineStories":"16px","headlineDestaqueEditoria1":"28px","destaquePaywall":"14px","subtitle":"24px","caption2":"14px","paragraph2":"22px","paragraph2Link":"22px","paragraph1":"22px","headline1":"60px","retrancaEBook":"20px","headlinePaywall":"30px","preOAssinatura":"75px","widgetUdioTime":"14px","paragraph5":"16px","paragraph6":"20px"},"vC":{"caption3":500,"headline3":700,"caption1":700,"headline6":400,"headline2":700,"paragraph4":400,"paragraph3":500,"headline4":600,"paragraphPaywall":400,"widget5":400,"headline5":500,"retrancaWidget":500,"widgetMaisLidas":500,"widgetEsporteDestaque":600,"widgetEsporte":400,"headlineDestaqueEditoria2":700,"caption4":500,"retrancaHamburger":600,"caption5":400,"headlineStories":500,"headlineDestaqueEditoria1":600,"destaquePaywall":700,"subtitle":400,"caption2":400,"paragraph2":400,"paragraph2Link":400,"paragraph1":500,"headline1":700,"retrancaEBook":700,"headlinePaywall":700,"preOAssinatura":700,"widgetUdioTime":300,"paragraph5":400,"paragraph6":400},"tO":{"caption3":"19.2px","headline3":"43px","caption1":"20.8px","headline6":"25px","headline2":"50px","paragraph4":"23px","paragraph3":"25px","headline4":"30px","paragraphPaywall":"16.4px","widget5":"21.6px","headline5":"24px","retrancaWidget":"32.5px","widgetMaisLidas":"21.6px","widgetEsporteDestaque":"14.4px","widgetEsporte":"14.4px","headlineDestaqueEditoria2":"24px","caption4":"16.8px","retrancaHamburger":"21.6px","caption5":"16.8px","headlineStories":"19.2px","headlineDestaqueEditoria1":"30px","destaquePaywall":"16.4px","subtitle":"30px","caption2":"16.8px","paragraph2":"35px","paragraph2Link":"35px","paragraph1":"35px","headline1":"70px","retrancaEBook":"20px","headlinePaywall":"43px","preOAssinatura":"90px","widgetUdioTime":"16.94px","paragraph5":"22px","paragraph6":"23.4px"}}');
;// CONCATENATED MODULE: ./brands/tocantins/theme.ts


function tocantins_theme_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tocantins_theme_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tocantins_theme_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tocantins_theme_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-nocheck



var tocantins_theme_fontSizes = tocantins_indexes_type_system_namespaceObject.CH,
    tocantins_theme_fontWeights = tocantins_indexes_type_system_namespaceObject.vC,
    tocantins_theme_lineHeights = tocantins_indexes_type_system_namespaceObject.tO;
var TocantinsTheme = prensa/* PrensaEngine.createTheme */.u7.createTheme('tocantins', {
  colors: tocantins_theme_objectSpread({}, tocantins_assets_colors_colors),
  fonts: {
    primary: 'IBM Plex Sans Condensed',
    secondary: 'Fira Sans Condensed'
  },
  fontSizes: tocantins_theme_fontSizes,
  fontWeights: tocantins_theme_fontWeights,
  lineHeights: tocantins_theme_lineHeights,
  radii: {
    unset: '0px',
    "default": '4px',
    alternative: '10px',
    rounded: '99px',
    circle: '50%'
  }
});
;// CONCATENATED MODULE: ./providers/ServerSideProps/consts.ts












var WEBSITES = [{
  name: 'opopular.d',
  slug: 'opopular',
  theme: OPopularTheme,
  assets: OPopularAssets
}, {
  name: 'cbn.d',
  slug: 'cbn',
  theme: CBNTheme,
  assets: CBNAssets
}, {
  name: 'cbngo.d',
  slug: 'cbngo',
  theme: CBNGOTheme,
  assets: CBNGOAssets
}, {
  name: 'cbnto.d',
  slug: 'cbnto',
  theme: CBNTOTheme,
  assets: CBNTOAssets
}, {
  name: 'daqui.d',
  slug: 'daqui',
  theme: DaquiTheme,
  assets: DaquiAssets
}, {
  name: 'tocantins.d',
  slug: 'tocantins',
  theme: TocantinsTheme,
  assets: TocantinsAssets
}];
;// CONCATENATED MODULE: ./providers/ServerSideProps/index.tsx


function ServerSideProps_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ServerSideProps_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ServerSideProps_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ServerSideProps_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ServerSidePropsContext = /*#__PURE__*/(0,react.createContext)({});

var ServerSideDataProvider = function ServerSideDataProvider(props) {
  var environmentSlug = "cbngo";
  var selectedSite = WEBSITES.find(function (i) {
    var _props$serverSideData;

    return i.slug === (props === null || props === void 0 ? void 0 : (_props$serverSideData = props.serverSideData) === null || _props$serverSideData === void 0 ? void 0 : _props$serverSideData.siteSlug);
  }) || WEBSITES.find(function (i) {
    return i.slug === environmentSlug;
  }) || WEBSITES[0];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ServerSidePropsContext.Provider, {
    value: ServerSideProps_objectSpread(ServerSideProps_objectSpread({}, props.serverSideData), {}, {
      siteConfig: selectedSite
    }),
    children: props.children
  });
};

/* harmony default export */ var ServerSideProps = (ServerSideDataProvider);

/***/ })

}]);